export const MASSIVE_SENTENCES = [
  {
    "id": "s041",
    "jp": "私は毎日パンを食べます。",
    "romaji": "Watashi wa mainichi pan wo tabemasu.",
    "en": "I eat bread every day.",
    "bn": "আমি প্রতিদিন রুটি খাই।",
    "level": "N5"
  },
  {
    "id": "s042",
    "jp": "あそこにスーパーがあります。",
    "romaji": "Asoko ni suupaa ga arimasu.",
    "en": "There is a supermarket over there.",
    "bn": "ওখানে একটি সুপারমার্কেট আছে।",
    "level": "N5"
  },
  {
    "id": "s043",
    "jp": "今日はとても暑いですね。",
    "romaji": "Kyou wa totemo atsui desu ne.",
    "en": "It is very hot today, isn't it?",
    "bn": "আজ খুব গরম, তাই না?",
    "level": "N5"
  },
  {
    "id": "s044",
    "jp": "私はお父さんと買い物をしました。",
    "romaji": "Watashi wa otousan to kaimono wo shimashita.",
    "en": "I went shopping with my father.",
    "bn": "আমি আমার বাবার সাথে কেনাকাটা করতে গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s045",
    "jp": "あなたの国はどこですか？",
    "romaji": "Anata no kuni wa doko desu ka?",
    "en": "Where is your country?",
    "bn": "আপনার দেশ কোথায়?",
    "level": "N5"
  },
  {
    "id": "s046",
    "jp": "日本語の勉強は面白いです。",
    "romaji": "Nihongo no benkyou wa omoshiroi desu.",
    "en": "Studying Japanese is interesting.",
    "bn": "জাপানি ভাষা শেখা আকর্ষণীয়।",
    "level": "N5"
  },
  {
    "id": "s047",
    "jp": "この靴を履いてもいいですか？",
    "romaji": "Kono kutsu wo haite mo ii desu ka?",
    "en": "May I wear these shoes?",
    "bn": "আমি কি এই জুতো পরতে পারি?",
    "level": "N5"
  },
  {
    "id": "s048",
    "jp": "昨日のご飯は何でしたか？",
    "romaji": "Kinou no gohan wa nani deshita ka?",
    "en": "What was yesterday's meal?",
    "bn": "গতকালের খাবার কি ছিল?",
    "level": "N5"
  },
  {
    "id": "s049",
    "jp": "山に登るのが好きです。",
    "romaji": "Yama ni noboru no ga suki desu.",
    "en": "I like climbing mountains.",
    "bn": "আমি পাহাড়ে চড়তে পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s050",
    "jp": "音楽を聞きながら勉強します。",
    "romaji": "Ongaku wo kikinagara benkyou shimasu.",
    "en": "I study while listening to music.",
    "bn": "আমি গান শুনতে শুনতে পড়াশোনা করি।",
    "level": "N5"
  },
  {
    "id": "s051",
    "jp": "彼は日本語がとても上手です。",
    "romaji": "Kare wa nihongo ga totemo jouzu desu.",
    "en": "He is very good at Japanese.",
    "bn": "সে জাপানি ভাষায় খুব ভালো।",
    "level": "N5"
  },
  {
    "id": "s052",
    "jp": "一緒に図書館へ行きませんか。",
    "romaji": "Issho ni toshokan e ikimasen ka.",
    "en": "Would you like to go to the library together?",
    "bn": "একসাথে লাইব্রেরিতে যাবেন কি?",
    "level": "N5"
  },
  {
    "id": "s053",
    "jp": "このパソコンは新しくないです。",
    "romaji": "Kono pasokon wa atarashikunai desu.",
    "en": "This computer is not new.",
    "bn": "এই কম্পিউটারটি নতুন নয়।",
    "level": "N5"
  },
  {
    "id": "s054",
    "jp": "窓を閉めてもいいですか。",
    "romaji": "Mado wo shimete mo ii desu ka.",
    "en": "May I close the window?",
    "bn": "আমি কি জানালাটি বন্ধ করতে পারি?",
    "level": "N5"
  },
  {
    "id": "s055",
    "jp": "昨日は雨が降っていました。",
    "romaji": "Kinou wa ame ga futte imashita.",
    "en": "It was raining yesterday.",
    "bn": "গতকাল বৃষ্টি হচ্ছিল।",
    "level": "N5"
  },
  {
    "id": "s056",
    "jp": "駅の前に大きな公園があります。",
    "romaji": "Eki no mae ni ookina kouen ga arimasu.",
    "en": "There is a large park in front of the station.",
    "bn": "স্টেশনের সামনে একটি বড় পার্ক আছে।",
    "level": "N5"
  },
  {
    "id": "s057",
    "jp": "一週間、休みがほしいです。",
    "romaji": "Isshuukan, yasumi ga hoshii desu.",
    "en": "I want a week-long holiday.",
    "bn": "আমি এক সপ্তাহের ছুটি চাই।",
    "level": "N5"
  },
  {
    "id": "s058",
    "jp": "コーヒーにか砂糖を入れますか。",
    "romaji": "Koohii ni satou wo iremasu ka.",
    "en": "Do you put sugar in your coffee?",
    "bn": "আপনি কি কফিতে চিনি দেন?",
    "level": "N5"
  },
  {
    "id": "s059",
    "jp": "毎日、散歩をすることにしています。",
    "romaji": "Mainichi, sanpo wo suru koto ni shite imasu.",
    "en": "I make it a rule to take a walk every day.",
    "bn": "আমি প্রতিদিন হাঁটাহাঁটি করার নিয়ম করেছি।",
    "level": "N4"
  },
  {
    "id": "s060",
    "jp": "この料理は思ったより安かったです。",
    "romaji": "Kono ryouri wa omotta yori yasukatta desu.",
    "en": "This dish was cheaper than I thought.",
    "bn": "এই খাবারটি আমার ধারণার চেয়ে সস্তা ছিল।",
    "level": "N5"
  },
  {
    "id": "s061",
    "jp": "私の家族は五人です。",
    "romaji": "Watashi no kazoku wa gonin desu.",
    "en": "There are five people in my family.",
    "bn": "আমার পরিবারে পাঁচজন সদস্য।",
    "level": "N5"
  },
  {
    "id": "s062",
    "jp": "明日は六時に起きなければなりません。",
    "romaji": "Ashita wa rokuji ni okinakereba narimasen.",
    "en": "I must get up at six tomorrow.",
    "bn": "আগামীকাল আমাকে ছয়টায় উঠতে হবে।",
    "level": "N4"
  },
  {
    "id": "s063",
    "jp": "田中さんに電話をするのを忘れました。",
    "romaji": "Tanaka-san ni denwa wo suru no wo wasuremashita.",
    "en": "I forgot to call Mr. Tanaka.",
    "bn": "আমি তানাকা-সানকে ফোন করতে ভুলে গেছি।",
    "level": "N4"
  },
  {
    "id": "s064",
    "jp": "もっと日本語を練習したほうがいいです。",
    "romaji": "Motto nihongo wo renshuu shita hou ga ii desu.",
    "en": "You had better practice Japanese more.",
    "bn": "আপনার জাপানি ভাষা আরও অনুশীলন করা উচিত।",
    "level": "N4"
  },
  {
    "id": "s065",
    "jp": "雨が降っても、出かけます。",
    "romaji": "Ame ga futte mo, dekakemasu.",
    "en": "Even if it rains, I will go out.",
    "bn": "বৃষ্টি হলেও আমি বাইরে যাব।",
    "level": "N4"
  },
  {
    "id": "s066",
    "jp": "この仕事は一時間で終わるはずです。",
    "romaji": "Kono shigoto wa ichijikan de owaru hazu desu.",
    "en": "This work is supposed to be finished in one hour.",
    "bn": "এই কাজটি এক ঘণ্টার মধ্যে শেষ হওয়ার কথা।",
    "level": "N4"
  },
  {
    "id": "s067",
    "jp": "昨日の映画はとても怖かったです。",
    "romaji": "Kinou no eiga wa totemo kowakatta desu.",
    "en": "Yesterday's movie was very scary.",
    "bn": "গতকালের সিনেমাটি খুব ভীতিজনক ছিল।",
    "level": "N5"
  },
  {
    "id": "s068",
    "jp": "電車が遅れたので、遅刻しました。",
    "romaji": "Densha ga okureta node, chikoku shimashita.",
    "en": "Because the train was late, I was late.",
    "bn": "ট্রেন দেরি হওয়ায় আমার দেরি হয়ে গেছে।",
    "level": "N4"
  },
  {
    "id": "s069",
    "jp": "日本へ行くのが楽しみです。",
    "romaji": "Nihon e iku no ga tanoshimi desu.",
    "en": "I am looking forward to going to Japan.",
    "bn": "আমি জাপানে যাওয়ার অপেক্ষায় আছি।",
    "level": "N4"
  },
  {
    "id": "s070",
    "jp": "窓を開けても驚かないでください。",
    "romaji": "Mado wo akete mo odorokanai de kudasai.",
    "en": "Please don't be surprised even if I open the window.",
    "bn": "আমি জানালা খুললেও অবাক হবেন না।",
    "level": "N4"
  },
  {
    "id": "s071",
    "jp": "朝ご飯を食べずに学校へ行きました。",
    "romaji": "Asagohan wo tabezu ni gakkou e ikimashita.",
    "en": "I went to school without eating breakfast.",
    "bn": "আমি সকালের নাস্তা না খেয়ে স্কুলে গিয়েছিলাম।",
    "level": "N4"
  },
  {
    "id": "s072",
    "jp": "日本語の手紙が書けるようになりたいです。",
    "romaji": "Nihongo no tegami ga kakeru you ni naritai desu.",
    "en": "I want to be able to write Japanese letters.",
    "bn": "আমি জাপানি ভাষায় চিঠি লিখতে সক্ষম হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s073",
    "jp": "この薬を飲むと、眠くなります。",
    "romaji": "Kono kusuri wo nomu to, nemuku narimasu.",
    "en": "If you take this medicine, you will get sleepy.",
    "bn": "এই ওষুধটি খেলে আপনার ঘুম পাবে।",
    "level": "N4"
  },
  {
    "id": "s074",
    "jp": "試験のために毎日三時間勉強しています。",
    "romaji": "Shiken no tame ni mainichi sanjikan benkyou shite imasu.",
    "en": "I am studying three hours every day for the exam.",
    "bn": "পরীক্ষার জন্য আমি প্রতিদিন তিন ঘণ্টা করে পড়ছি।",
    "level": "N4"
  },
  {
    "id": "s075",
    "jp": "田中さんが結婚したというニュースを聞きました。",
    "romaji": "Tanaka-san ga kekkon shita to iu nyuusu wo kikimashita.",
    "en": "I heard the news that Mr. Tanaka got married.",
    "bn": "আমি তানাকা-সানের বিয়ের খবর শুনেছি।",
    "level": "N4"
  },
  {
    "id": "s076",
    "jp": "明日、一緒にテニスをしませんか。",
    "romaji": "Ashita, issho ni tenisu wo shimasen ka.",
    "en": "Would you like to play tennis together tomorrow?",
    "bn": "আগামীকাল একসাথে টেনিস খেলবেন কি?",
    "level": "N5"
  },
  {
    "id": "s077",
    "jp": "この辞書は使いやすいです。",
    "romaji": "Kono jisho wa tsukaiyasui desu.",
    "en": "This dictionary is easy to use.",
    "bn": "এই ডিকশনারিটি ব্যবহার করা সহজ।",
    "level": "N4"
  },
  {
    "id": "s078",
    "jp": "彼は病気のために昨日休みました。",
    "romaji": "Kare wa byouki no tame ni kinou yasumimashita.",
    "en": "He was absent yesterday because of illness.",
    "bn": "অসুস্থতার কারণে সে গতকাল অনুপস্থিত ছিল।",
    "level": "N4"
  },
  {
    "id": "s079",
    "jp": "このカバンは重すぎて持てません。",
    "romaji": "Kono kaban wa omosugite motemasen.",
    "en": "This bag is too heavy to carry.",
    "bn": "এই ব্যাগটি বহন করার জন্য খুব ভারী।",
    "level": "N4"
  },
  {
    "id": "s080",
    "jp": "もっと野菜を食べるようにしてください。",
    "romaji": "Motto yasai wo taberu you ni shite kudasai.",
    "en": "Please try to eat more vegetables.",
    "bn": "অনুগ্রহ করে আরও বেশি শাকসবজি খাওয়ার চেষ্টা করুন।",
    "level": "N4"
  },
  {
    "id": "s081",
    "jp": "昨日の夜はあまり寝られませんでした。",
    "romaji": "Kinou no yoru wa amari neraremasen deshita.",
    "en": "I couldn't sleep much last night.",
    "bn": "গত রাতে আমি খুব একটা ঘুমাতে পারিনি।",
    "level": "N4"
  },
  {
    "id": "s082",
    "jp": "彼は日本のアニメに興味があります。",
    "romaji": "Kare wa nihon no anime ni kyoumi ga arimasu.",
    "en": "He is interested in Japanese anime.",
    "bn": "তার জাপানি অ্যানিমেতে আগ্রহ আছে।",
    "level": "N4"
  },
  {
    "id": "s083",
    "jp": "新宿へはどの電車に乗ればいいですか。",
    "romaji": "Shinjuku e wa dono densha ni noreba ii desu ka.",
    "en": "Which train should I take to go to Shinjuku?",
    "bn": "শিঞ্জুকু যাওয়ার জন্য কোন ট্রেনে উঠতে হবে?",
    "level": "N5"
  },
  {
    "id": "s084",
    "jp": "お腹が空いたので、何か食べたいです。",
    "romaji": "Onaka ga suita node, nani ka tabetai desu.",
    "en": "Because I am hungry, I want to eat something.",
    "bn": "খিদে পাওয়ায় আমি কিছু খেতে চাই।",
    "level": "N5"
  },
  {
    "id": "s085",
    "jp": "日本語が上手になりたいですね。",
    "romaji": "Nihongo ga jouzu ni naritai desu ne.",
    "en": "I want to become good at Japanese, don't I?",
    "bn": "আমি জাপানি ভাষায় দক্ষ হতে চাই, তাই না?",
    "level": "N5"
  },
  {
    "id": "s086",
    "jp": "窓を開けておいでもらえませんか。",
    "romaji": "Mado wo akete oite moraemasen ka.",
    "en": "Could you please keep the window open?",
    "bn": "আপনি কি জানালাটি খুলে রাখতে পারবেন?",
    "level": "N4"
  },
  {
    "id": "s087",
    "jp": "先生はもう帰られたはずです。",
    "romaji": "Sensei wa mou kaerareta hazu desu.",
    "en": "The teacher should have already gone home.",
    "bn": "শিক্ষক ইতিমধ্যেই বাড়ি ফিরে যাওয়ার কথা।",
    "level": "N4"
  },
  {
    "id": "s088",
    "jp": "日本へ来ることができて、うれしいです。",
    "romaji": "Nihon e kuru koto ga dekite, ureshii desu.",
    "en": "I am happy that I could come to Japan.",
    "bn": "জাপানে আসতে পেরে আমি খুশি।",
    "level": "N4"
  },
  {
    "id": "s089",
    "jp": "この薬は苦いですが、飲んでください。",
    "romaji": "Kono kusuri wa nigai desu ga, nonde kudasai.",
    "en": "This medicine is bitter, but please take it.",
    "bn": "এই ওষুধটি তেতো হলেও খেয়ে নিন।",
    "level": "N5"
  },
  {
    "id": "s090",
    "jp": "日本語を話すチャンスがほしいです。",
    "romaji": "Nihongo wo hanasu chansu ga hoshii desu.",
    "en": "I want a chance to speak Japanese.",
    "bn": "আমি জাপানি ভাষায় কথা বলার সুযোগ চাই।",
    "level": "N4"
  },
  {
    "id": "s091",
    "jp": "明日テストがあるので、勉強しなければ。",
    "romaji": "Ashita tesuto ga aru node, benkyou shinakereba.",
    "en": "I must study because there is a test tomorrow.",
    "bn": "আগামীকাল পরীক্ষা থাকায় আমাকে পড়তে হবে।",
    "level": "N4"
  },
  {
    "id": "s092",
    "jp": "母の手伝いをするのが好きです。",
    "romaji": "Haha no tetsudai wo suru no ga suki desu.",
    "en": "I like helping my mother.",
    "bn": "আমি আমার মাকে সাহায্য করতে পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s093",
    "jp": "これから買い物に行こうと思っています。",
    "romaji": "Kore kara kaimono ni ikou to omotte imasu.",
    "en": "I am thinking of going shopping now.",
    "bn": "আমি এখন কেনাকাটা করতে যাওয়ার চিন্তা করছি।",
    "level": "N4"
  },
  {
    "id": "s094",
    "jp": "この本を読んだことがありますか。",
    "romaji": "Kono hon wo yonda koto ga arimasu ka.",
    "en": "Have you ever read this book?",
    "bn": "আপনি কি এই বইটি কখনও পড়েছেন?",
    "level": "N5"
  },
  {
    "id": "s095",
    "jp": "日本語を勉強し始めてから一年になります。",
    "romaji": "Nihongo wo benkyou shihajimete kara ichinen ni narimasu.",
    "en": "It has been a year since I started studying Japanese.",
    "bn": "জাপানি ভাষা শেখা শুরু করার এক বছর হয়েছে।",
    "level": "N4"
  },
  {
    "id": "s096",
    "jp": "昨日は一日中、寝ていました。",
    "romaji": "Kinou wa ichinichijuu, nete imashita.",
    "en": "I was sleeping all day yesterday.",
    "bn": "গতকাল আমি সারাদিন ঘুমিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s097",
    "jp": "先生に本を貸していただきました。",
    "romaji": "Sensei ni hon wo kashite itadakimashita.",
    "en": "I had the teacher lend me a book.",
    "bn": "আমি শিক্ষকের কাছ থেকে একটি বই ধার নিয়েছি।",
    "level": "N4"
  },
  {
    "id": "s098",
    "jp": "この仕事は思ったほど大変ではありませんでした。",
    "romaji": "Kono shigoto wa omotta hodo taihen dewa arimasen deshita.",
    "en": "This work was not as hard as I thought.",
    "bn": "এই কাজটি আমার ধারণার মতো কঠিন ছিল না।",
    "level": "N4"
  },
  {
    "id": "s099",
    "jp": "明日、新宿で会いましょう。",
    "romaji": "Ashita, Shinjuku de aimashou.",
    "en": "Let's meet in Shinjuku tomorrow.",
    "bn": "আগামীকাল শিঞ্জুকুতে দেখা হবে।",
    "level": "N5"
  },
  {
    "id": "s100",
    "jp": "日本語の歌を歌うのが好きです。",
    "romaji": "Nihongo no uta wo utau no ga suki desu.",
    "en": "I like singing Japanese songs.",
    "bn": "আমি জাপানি ভাষায় গান গাইতে পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s101",
    "jp": "あそこに高いビルがあります。",
    "romaji": "Asoko ni takai biru ga arimasu.",
    "en": "There is a tall building over there.",
    "bn": "ওখানে একটি উঁচু দালান আছে।",
    "level": "N5"
  },
  {
    "id": "s102",
    "jp": "私は毎日お風呂に入ります。",
    "romaji": "Watashi wa mainichi ofuro ni hairimasu.",
    "en": "I take a bath every day.",
    "bn": "আমি প্রতিদিন গোসল করি।",
    "level": "N5"
  },
  {
    "id": "s103",
    "jp": "昨日のテストは難しかったですか。",
    "romaji": "Kinou no tesuto wa muzukashikatta desu ka.",
    "en": "Was yesterday's test difficult?",
    "bn": "গতকালের পরীক্ষাটি কি কঠিন ছিল?",
    "level": "N5"
  },
  {
    "id": "s104",
    "jp": "この靴は少し大きいです。",
    "romaji": "Kono kutsu wa sukoshi ookii desu.",
    "en": "These shoes are a little big.",
    "bn": "এই জুতো জোড়া একটু বড়।",
    "level": "N5"
  },
  {
    "id": "s105",
    "jp": "来週、一緒に旅行に行きませんか。",
    "romaji": "Raishuu, issho ni ryokou ni ikimasen ka.",
    "en": "Would you like to go on a trip together next week?",
    "bn": "আগামী সপ্তাহে একসাথে ভ্রমণে যাবেন কি?",
    "level": "N4"
  },
  {
    "id": "s106",
    "jp": "お腹が痛いので、病院へ行きます。",
    "romaji": "Onaka ga itai node, byouin e ikimasu.",
    "en": "Because my stomach hurts, I will go to the hospital.",
    "bn": "পেটে ব্যথা হওয়ায় আমি হাসপাতালে যাব।",
    "level": "N5"
  },
  {
    "id": "s107",
    "jp": "田中さんに会ったら、よろしくお伝えください。",
    "romaji": "Tanaka-san ni attara, yoroshiku otsutae kudasai.",
    "en": "When you see Mr. Tanaka, please give him my regards.",
    "bn": "তানাকা-সানের সাথে দেখা হলে তাকে আমার সালাম দেবেন।",
    "level": "N4"
  },
  {
    "id": "s108",
    "jp": "日本語を勉強するのは楽しいことですね。",
    "romaji": "Nihongo wo benkyou suru no wa tanoshibi koto desu ne.",
    "en": "Studying Japanese is a fun thing, isn't it?",
    "bn": "জাপানি ভাষা শেখা একটি মজার বিষয়, তাই না?",
    "level": "N5"
  },
  {
    "id": "s109",
    "jp": "明日、雨が降るかもしれません。",
    "romaji": "Ashita, ame ga furu kamoshiremasen.",
    "en": "It might rain tomorrow.",
    "bn": "আগামীকাল বৃষ্টি হতে পারে।",
    "level": "N4"
  },
  {
    "id": "s110",
    "jp": "窓を閉めていただけませんか。",
    "romaji": "Mado wo shimete itadakemasen ka.",
    "en": "Could you please close the window?",
    "bn": "দয়া করে জানালাটি বন্ধ করবেন কি?",
    "level": "N4"
  },
  {
    "id": "s111",
    "jp": "彼は日本に来てから、三年になります。",
    "romaji": "Kare wa nihon ni kite kara, sannen ni narimasu.",
    "en": "It has been three years since he came to Japan.",
    "bn": "সে জাপানে আসার তিন বছর হয়েছে।",
    "level": "N4"
  },
  {
    "id": "s112",
    "jp": "この料理はとてもおいしそうですね。",
    "romaji": "Kono ryouri wa totemo oishisou desu ne.",
    "en": "This dish looks very delicious, doesn't it?",
    "bn": "এই খাবারটি দেখতে খুব সুস্বাদু লাগছে, তাই না?",
    "level": "N4"
  },
  {
    "id": "s113",
    "jp": "駅へ行く道を教えてください。",
    "romaji": "Eki e iku michi wo oshiete kudasai.",
    "en": "Please tell me the way to the station.",
    "bn": "স্টেশনে যাওয়ার পথটি বলে দিন।",
    "level": "N5"
  },
  {
    "id": "s114",
    "jp": "昨日は一日中、忙しかったです。",
    "romaji": "Kinou wa ichinichijuu, isogashikatta desu.",
    "en": "I was busy all day yesterday.",
    "bn": "গতকাল আমি সারাদিন ব্যস্ত ছিলাম।",
    "level": "N5"
  },
  {
    "id": "s115",
    "jp": "先生の話をよく聞いてください。",
    "romaji": "Sensei no hanashi wo yoku kiite kudasai.",
    "en": "Please listen to the teacher carefully.",
    "bn": "শিক্ষকের কথা মন দিয়ে শুনুন।",
    "level": "N5"
  },
  {
    "id": "s116",
    "jp": "お茶をもう一杯いかがですか。",
    "romaji": "Ocha wo mou ippai ikaga desu ka.",
    "en": "Would you like another cup of tea?",
    "bn": "আরেক কাপ চা নেবেন কি?",
    "level": "N4"
  },
  {
    "id": "s117",
    "jp": "母が作った料理は一番おいしいです。",
    "romaji": "Haha ga tsukutta ryouri wa ichiban oishii desu.",
    "en": "The food my mother makes is the best.",
    "bn": "আমার মায়ের হাতের রান্না সবথেকে সুস্বাদু।",
    "level": "N5"
  },
  {
    "id": "s118",
    "jp": "勉強しすぎて、頭が痛くなりました。",
    "romaji": "Benkyou shisugite, atama ga itaku narimashita.",
    "en": "I studied too much and got a headache.",
    "bn": "বেশি পড়াশোনা করে মাথায় ব্যথা শুরু হয়েছে।",
    "level": "N4"
  },
  {
    "id": "s119",
    "jp": "この仕事を終わらせてから、帰ります。",
    "romaji": "Kono shigoto wo owarasete kara, kaerimasu.",
    "en": "I will go home after finishing this work.",
    "bn": "কাজটি শেষ করে আমি বাড়ি যাব।",
    "level": "N4"
  },
  {
    "id": "s120",
    "jp": "明日、晴れたらいいなと思います。",
    "romaji": "Ashita, haretara ii na to omoimasu.",
    "en": "I hope it will be sunny tomorrow.",
    "bn": "আশা করি আগামীকাল আবহাওয়া পরিষ্কার থাকবে।",
    "level": "N4"
  },
  {
    "id": "s121",
    "jp": "彼は日本語だけでなく、英語も話せます。",
    "romaji": "Kare wa nihongo dake de naku, eigo mo hanasemasu.",
    "en": "He can speak not only Japanese but also English.",
    "bn": "সে শুধু জাপানি নয়, ইংরেজিও বলতে পারে।",
    "level": "N4"
  },
  {
    "id": "s122",
    "jp": "田中さんに手伝ってもらいました。",
    "romaji": "Tanaka-san ni tetsudatte moraimashita.",
    "en": "I had Mr. Tanaka help me.",
    "bn": "আমি তানাকা-সানের কাছ থেকে সাহায্য পেয়েছি।",
    "level": "N4"
  },
  {
    "id": "s123",
    "jp": "この本は難しすぎて分かりませんでした。",
    "romaji": "Kono hon wa muzukashisugite wakarimasen deshita.",
    "en": "This book was too difficult to understand.",
    "bn": "বইটি এতই কঠিন ছিল যে আমি বুঝতে পারিনি।",
    "level": "N4"
  },
  {
    "id": "s124",
    "jp": "日本へ行ったら、京都へ行きたいです。",
    "romaji": "Nihon e ittara, kyouto e ikitai desu.",
    "en": "If I go to Japan, I want to go to Kyoto.",
    "bn": "জাপানে গেলে আমি কিয়োটো যেতে চাই।",
    "level": "N4"
  },
  {
    "id": "s125",
    "jp": "もっとゆっくり話してください。",
    "romaji": "Motto yukkuri hanashite kudasai.",
    "en": "Please speak more slowly.",
    "bn": "অনুগ্রহ করে আরও ধীরে কথা বলুন।",
    "level": "N5"
  },
  {
    "id": "s126",
    "jp": "昨日買った野菜は新鮮でした。",
    "romaji": "Kinou katta yasai wa shinsen deshita.",
    "en": "The vegetables I bought yesterday were fresh.",
    "bn": "গতকাল কেনা শাকসবজিগুলো সতেজ ছিল।",
    "level": "N5"
  },
  {
    "id": "s127",
    "jp": "一時間、駅で誰かを待っていました。",
    "romaji": "Ichijikan, eki de dareka wo matte imashita.",
    "en": "I was waiting for someone at the station for an hour.",
    "bn": "আমি স্টেশনে কারো জন্য এক ঘণ্টা অপেক্ষা করছিলাম।",
    "level": "N5"
  },
  {
    "id": "s128",
    "jp": "寝る前に、いつも日記を書きます。",
    "romaji": "Neru mae ni, itsumo nikki wo kakimasu.",
    "en": "I always write a diary before going to bed.",
    "bn": "আমি সব সময় ঘুমানোর আগে ডায়েরি লিখি।",
    "level": "N5"
  },
  {
    "id": "s129",
    "jp": "靴を脱いで、部屋に入ってください。",
    "romaji": "Kutsu wo nuide, heya ni haitte kudasai.",
    "en": "Please take off your shoes and enter the room.",
    "bn": "জুতো খুলে ঘরে প্রবেশ করুন।",
    "level": "N5"
  },
  {
    "id": "s130",
    "jp": "母に怒られて、泣いてしまいました。",
    "romaji": "Haha ni okorarete, naite shimaimashita.",
    "en": "I cried because my mother got angry at me.",
    "bn": "মা রাগ করায় আমি কেঁদে ফেলেছিলাম।",
    "level": "N4"
  },
  {
    "id": "s131",
    "jp": "田中さんは今、会議中だそうです。",
    "romaji": "Tanaka-san wa ima, kaigichuu da sou desu.",
    "en": "I heard Mr. Tanaka is in a meeting now.",
    "bn": "শুনলাম তানাকা-সান এখন মিটিংয়ে আছেন।",
    "level": "N4"
  },
  {
    "id": "s132",
    "jp": "日本へ来る前に、日本語を習いました。",
    "romaji": "Nihon e kuru mae ni, nihongo wo naraimashita.",
    "en": "I learned Japanese before coming to Japan.",
    "bn": "জাপানে আসার আগে আমি জাপানি ভাষা শিখেছিলাম।",
    "level": "N4"
  },
  {
    "id": "s133",
    "jp": "明日までに、このレポートを書かなければなりません。",
    "romaji": "Ashita made ni, kono repooto wo kakanakereba narimasen.",
    "en": "I must write this report by tomorrow.",
    "bn": "আগামীকালের মধ্যে আমাকে এই রিপোর্টটি লিখতে হবে।",
    "level": "N4"
  },
  {
    "id": "s134",
    "jp": "彼に会うために、駅へ行きました。",
    "romaji": "Kare ni au tame ni, eki e ikimashita.",
    "en": "I went to the station to meet him.",
    "bn": "তার সাথে দেখা করতে আমি স্টেশনে গিয়েছিলাম।",
    "level": "N4"
  },
  {
    "id": "s135",
    "jp": "毎日、少しずつ練習することが大切です。",
    "romaji": "Mainichi, sukoshi zutsu renshuu suru koto ga taisetsu desu.",
    "en": "It is important to practice a little bit every day.",
    "bn": "প্রতিদিন অল্প অল্প করে অনুশীলন করা গুরুত্বপূর্ণ।",
    "level": "N4"
  },
  {
    "id": "s136",
    "jp": "日本のお寺はとても静かでした。",
    "romaji": "Nihon no otera wa totemo shizuka deshita.",
    "en": "The Japanese temples were very quiet.",
    "bn": "জাপানি মন্দিরগুলো খুব শান্ত ছিল।",
    "level": "N5"
  },
  {
    "id": "s137",
    "jp": "何か飲み物を持ってきましょうか。",
    "romaji": "Nanika nomimono wo motte kimashou ka.",
    "en": "Shall I bring you something to drink?",
    "bn": "আপনার জন্য কি কোন পানীয় নিয়ে আসব?",
    "level": "N5"
  },
  {
    "id": "s138",
    "jp": "日本語の試験は九時に始まります。",
    "romaji": "Nihongo no shiken wa kuji ni hajimaru desu.",
    "en": "The Japanese test starts at nine.",
    "bn": "জাপানি পরীক্ষা ৯টায় শুরু হবে।",
    "level": "N5"
  },
  {
    "id": "s139",
    "jp": "昨日から風邪を引いています。",
    "romaji": "Kinou kara kaze wo hiite imasu.",
    "en": "I have had a cold since yesterday.",
    "bn": "গতকাল থেকে আমার ঠান্ডা লেগেছে।",
    "level": "N5"
  },
  {
    "id": "s140",
    "jp": "この料理の作り方を教えてください。",
    "romaji": "Kono ryouri no tsukurikata wo oshiete kudasai.",
    "en": "Please tell me how to make this dish.",
    "bn": "এই খাবারটি তৈরির পদ্ধতি বলে দিন।",
    "level": "N5"
  },
  {
    "id": "s141",
    "jp": "彼は医者になることを決めたそうです。",
    "romaji": "Kare wa isha ni naru koto wo kimeta sou desu.",
    "en": "I heard he decided to become a doctor.",
    "bn": "শুনলাম সে ডাক্তার হওয়ার সিদ্ধান্ত নিয়েছে।",
    "level": "N4"
  },
  {
    "id": "s142",
    "jp": "田中さんに会うかどうか、分かりません。",
    "romaji": "Tanaka-san ni au ka dou ka, wakarimasen.",
    "en": "I don't know whether I will meet Mr. Tanaka or not.",
    "bn": "তানাকা-সানের সাথে দেখা হবে কি না আমি জানি না।",
    "level": "N4"
  },
  {
    "id": "s143",
    "jp": "今から出かけるところです。",
    "romaji": "Ima kara dekakeru tokoro desu.",
    "en": "I am just about to go out.",
    "bn": "আমি এখনই বের হতে যাচ্ছি।",
    "level": "N4"
  },
  {
    "id": "s144",
    "jp": "もっと早く寝るようにしています。",
    "romaji": "Motto hayaku neru you ni shite imasu.",
    "en": "I am trying to go to bed earlier.",
    "bn": "আমি আরও তাড়াতাড়ি ঘুমানোর চেষ্টা করছি।",
    "level": "N4"
  },
  {
    "id": "s145",
    "jp": "先生のお宅はどこですか。",
    "romaji": "Sensei no otaku wa doko desu ka.",
    "en": "Where is the teacher's house?",
    "bn": "শিক্ষকের বাড়ি কোথায়?",
    "level": "N5"
  },
  {
    "id": "s146",
    "jp": "あそこに大きな犬がいます。",
    "romaji": "Asoko ni ookina inu ga imasu.",
    "en": "There is a big dog over there.",
    "bn": "ওখানে একটি বড় কুকুর আছে।",
    "level": "N5"
  },
  {
    "id": "s147",
    "jp": "日本へ行ったら、富士山を見たいです。",
    "romaji": "Nihon e ittara, fujisan wo mitai desu.",
    "en": "If I go to Japan, I want to see Mount Fuji.",
    "bn": "জাপানে গেলে আমি ফুজি পাহাড় দেখতে চাই।",
    "level": "N5"
  },
  {
    "id": "s148",
    "jp": "毎日、一時間日本語を勉強します。",
    "romaji": "Mainichi, ichijikan nihongo wo benkyou shimasu.",
    "en": "I study Japanese for an hour every day.",
    "bn": "আমি প্রতিদিন এক ঘণ্টা জাপানি ভাষা পড়ি।",
    "level": "N5"
  },
  {
    "id": "s149",
    "jp": "お母さんに電話をするのを忘れましたか。",
    "romaji": "Okaasan ni denwa wo suru no wo wasuremashita ka.",
    "en": "Did you forget to call your mother?",
    "bn": "আপনি কি মাকে ফোন করতে ভুলে গেছেন?",
    "level": "N4"
  },
  {
    "id": "s150",
    "jp": "もっと上手に日本語が話せるようになりたいです。",
    "romaji": "Motto jouzu ni nihongo ga hanaseru you ni naritai desu.",
    "en": "I want to be able to speak Japanese better.",
    "bn": "আমি আরও ভালোভাবে জাপানি বলতে সক্ষম হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s151",
    "jp": "あそこに郵便局があります。",
    "romaji": "Asoko ni yuubinkyoku ga arimasu.",
    "en": "There is a post office over there.",
    "bn": "ওখানে একটি ডাকঘর আছে।",
    "level": "N5"
  },
  {
    "id": "s152",
    "jp": "今日はとてもいい天気ですね。",
    "romaji": "Kyou wa totemo ii tenki desu ne.",
    "en": "It is very nice weather today, isn't it?",
    "bn": "আজ খুব সুন্দর আবহাওয়া, তাই না?",
    "level": "N5"
  },
  {
    "id": "s153",
    "jp": "日本へ行ったら、京都の古いお寺を見たいです。",
    "romaji": "Nihon e ittara, kyouto no furui otera wo mitai desu.",
    "en": "If I go to Japan, I want to see old temples in Kyoto.",
    "bn": "জাপানে গেলে আমি কিয়োটোর পুরোনো মন্দিরগুলো দেখতে চাই।",
    "level": "N4"
  },
  {
    "id": "s154",
    "jp": "試験のために毎日図書館で勉強しています。",
    "romaji": "Shiken no tame ni mainichi toshokan de benkyou shite imasu.",
    "en": "I am studying in the library every day for the exam.",
    "bn": "পরীক্ষার জন্য আমি প্রতিদিন লাইব্রেরিতে পড়াশোনা করছি।",
    "level": "N4"
  },
  {
    "id": "s155",
    "jp": "朝ご飯を食べてから、学校へ行きます。",
    "romaji": "Asagohan wo tabete kara, gakkou e ikimasu.",
    "en": "I go to school after eating breakfast.",
    "bn": "সকাল বেলা নাস্তা করার পর আমি স্কুলে যাই।",
    "level": "N5"
  },
  {
    "id": "s156",
    "jp": "窓を開けても驚かないでください。",
    "romaji": "Mado wo akete mo odorokanai de kudasai.",
    "en": "Please don't be surprised even if I open the window.",
    "bn": "আমি জানালা খুললেও অবাক হবেন না।",
    "level": "N4"
  },
  {
    "id": "s157",
    "jp": "日本語の新聞が読めるようになりたいです。",
    "romaji": "Nihongo no shinbun ga yomeru you ni naritai desu.",
    "en": "I want to be able to read Japanese newspapers.",
    "bn": "আমি জাপানি সংবাদপত্র পড়তে সক্ষম হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s158",
    "jp": "駅の前で友達を待っています。",
    "romaji": "Eki no mae de tomodachi wo matte imasu.",
    "en": "I am waiting for a friend in front of the station.",
    "bn": "আমি স্টেশনের সামনে বন্ধুর জন্য অপেক্ষা করছি।",
    "level": "N5"
  },
  {
    "id": "s159",
    "jp": "昨日の夜はとても静かでした。",
    "romaji": "Kinou no yoru wa totemo shizuka deshita.",
    "en": "Last night was very quiet.",
    "bn": "গত রাতটি খুব শান্ত ছিল।",
    "level": "N5"
  },
  {
    "id": "s160",
    "jp": "もっと野菜を食べるようにしてください。",
    "romaji": "Motto yasai wo taberu you ni shite kudasai.",
    "en": "Please try to eat more vegetables.",
    "bn": "অনুগ্রহ করে আরও বেশি শাকসবজি খাওয়ার চেষ্টা করুন।",
    "level": "N4"
  },
  {
    "id": "s161",
    "jp": "彼は日本に来てから、ずっと東京に住んでいます。",
    "romaji": "Kare wa nihon ni kite kara, zutto toukyou ni sunde imasu.",
    "en": "He has been living in Tokyo ever since he came to Japan.",
    "bn": "জাপানে আসার পর থেকে সে সব সময় টোকিওতে বসবাস করছে।",
    "level": "N4"
  },
  {
    "id": "s162",
    "jp": "コーヒーを飲みすぎると、寝られなくなります。",
    "romaji": "Koohii wo nomisugiru to, nerarenaku narimasu.",
    "en": "If you drink too much coffee, you won't be able to sleep.",
    "bn": "বেশি কফি খেলে আপনার ঘুম হবে না।",
    "level": "N4"
  },
  {
    "id": "s163",
    "jp": "明日はテストがあるので、早く起きなければなりません。",
    "romaji": "Ashita wa tesuto ga aru node, hayaku okinakereba narimasen.",
    "en": "I must get up early tomorrow because there is a test.",
    "bn": "আগামীকাল পরীক্ষা থাকায় আমাকে তাড়াতাড়ি উঠতে হবে।",
    "level": "N4"
  },
  {
    "id": "s164",
    "jp": "田中さんに電話をするのを忘れました。",
    "romaji": "Tanaka-san ni denwa wo suru no wo wasuremashita.",
    "en": "I forgot to call Mr. Tanaka.",
    "bn": "আমি তানাকা-সানকে ফোন করতে ভুলে গেছি।",
    "level": "N4"
  },
  {
    "id": "s165",
    "jp": "駅へ行く道を教えていただけませんか。",
    "romaji": "Eki e iku michi wo oshiete itadakemasen ka.",
    "en": "Could you please tell me the way to the station?",
    "bn": "স্টেশনে যাওয়ার পথটি দয়াকরে বলে দেবেন কি?",
    "level": "N4"
  },
  {
    "id": "s166",
    "jp": "彼は日本語がとても上手で、驚きました。",
    "romaji": "Kare wa nihongo ga totemo jouzu de, odorokimashita.",
    "en": "I was surprised that his Japanese is so good.",
    "bn": "সে জাপানি ভাষায় এত ভালো দক্ষ দেখে আমি অবাক হয়েছি।",
    "level": "N4"
  },
  {
    "id": "s167",
    "jp": "一緒にテニスをしませんか。",
    "romaji": "Issho ni tenisu wo shimasen ka.",
    "en": "Would you like to play tennis together?",
    "bn": "একসাথে টেনিস খেলবেন কি?",
    "level": "N5"
  },
  {
    "id": "s168",
    "jp": "あそこに高い山が見えます。",
    "romaji": "Asoko ni takai yama ga miemasu.",
    "en": "You can see a tall mountain over there.",
    "bn": "ওখানে একটি উঁচু পাহাড় দেখা যাচ্ছে।",
    "level": "N5"
  },
  {
    "id": "s169",
    "jp": "昨日のご飯はカレーでした。",
    "romaji": "Kinou no gohan wa karee deshita.",
    "en": "Yesterday's meal was curry.",
    "bn": "গতকালের খাবার কারি ছিল।",
    "level": "N5"
  },
  {
    "id": "s170",
    "jp": "この本を貸してもらえませんか。",
    "romaji": "Kono hon wo kashite moraemasen ka.",
    "en": "Could you please lend me this book?",
    "bn": "আপনি কি আমাকে এই বইটি ধার দিতে পারবেন?",
    "level": "N4"
  },
  {
    "id": "s171",
    "jp": "日本語の歌を歌うのが好きです。",
    "romaji": "Nihongo no uta wo utau no ga suki desu.",
    "en": "I like singing Japanese songs.",
    "bn": "আমি জাপানি ভাষায় গান গাইতে পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s172",
    "jp": "朝早く公園を散歩します。",
    "romaji": "Asa hayaku kouen wo sanpo shimasu.",
    "en": "I take a walk in the park early in the morning.",
    "bn": "আমি সকাল বেলা পার্কে হাঁটাহাঁটি করি।",
    "level": "N5"
  },
  {
    "id": "s173",
    "jp": "日本のお菓子はとてもおいしいですね。",
    "romaji": "Nihon no okashi wa totemo oishii desu ne.",
    "en": "Japanese sweets are very delicious, aren't they?",
    "bn": "জাপানি মিষ্টিগুলো খুব সুস্বাদু, তাই না?",
    "level": "N5"
  },
  {
    "id": "s174",
    "jp": "明日は九時にここへ来てください。",
    "romaji": "Ashita wa kuji ni koko e kite kudasai.",
    "en": "Please come here at nine tomorrow.",
    "bn": "আগামীকাল নয়টায় এখানে আসবেন।",
    "level": "N5"
  },
  {
    "id": "s175",
    "jp": "彼は病気のために昨日休みました。",
    "romaji": "Kare wa byouki no tame ni kinou yasumimashita.",
    "en": "He was absent yesterday because of illness.",
    "bn": "অসুস্থতার কারণে সে গতকাল অনুপস্থিত ছিল।",
    "level": "N4"
  },
  {
    "id": "s176",
    "jp": "窓を閉めてもいいですか。",
    "romaji": "Mado wo shimete mo ii desu ka.",
    "en": "May I close the window?",
    "bn": "আমি কি জানালাটি বন্ধ করতে পারি?",
    "level": "N5"
  },
  {
    "id": "s177",
    "jp": "新宿へ行く電車はどれですか。",
    "romaji": "Shinjuku e iku densha wa dore desu ka.",
    "en": "Which train goes to Shinjuku?",
    "bn": "শিঞ্জুকু যাওয়ার ট্রেন কোনটি?",
    "level": "N5"
  },
  {
    "id": "s178",
    "jp": "お腹が空いたので、何か食べたいです。",
    "romaji": "Onaka ga suita node, nani ka tabetai desu.",
    "en": "Because I am hungry, I want to eat something.",
    "bn": "খিদে পাওয়ায় আমি কিছু খেতে চাই।",
    "level": "N5"
  },
  {
    "id": "s179",
    "jp": "昨日の夜はあまり寝られませんでした。",
    "romaji": "Kinou no yoru wa amari neraremasen deshita.",
    "en": "I couldn't sleep much last night.",
    "bn": "গত রাতে আমি খুব একটা ঘুমাতে পারিনি।",
    "level": "N4"
  },
  {
    "id": "s180",
    "jp": "もっとゆっくり話してください。",
    "romaji": "Motto yukkuri hanashite kudasai.",
    "en": "Please speak more slowly.",
    "bn": "অনুগ্রহ করে আরও ধীরে কথা বলুন।",
    "level": "N5"
  },
  {
    "id": "s181",
    "jp": "靴を脱いで、部屋に入ってください。",
    "romaji": "Kutsu wo nuide, heya ni haitte kudasai.",
    "en": "Please take off your shoes and enter the room.",
    "bn": "জুতো খুলে ঘরে প্রবেশ করুন।",
    "level": "N5"
  },
  {
    "id": "s182",
    "jp": "先生の話をよく聞いてください。",
    "romaji": "Sensei no hanashi wo yoku kiite kudasai.",
    "en": "Please listen to the teacher carefully.",
    "bn": "শিক্ষকের কথা মন দিয়ে শুনুন।",
    "level": "N5"
  },
  {
    "id": "s183",
    "jp": "昨日は一日中、忙しかったです。",
    "romaji": "Kinou wa ichinichijuu, isogashikatta desu.",
    "en": "I was busy all day yesterday.",
    "bn": "গতকাল আমি সারাদিন ব্যস্ত ছিলাম।",
    "level": "N5"
  },
  {
    "id": "s184",
    "jp": "日本語の試験は九時に始まります。",
    "romaji": "Nihongo no shiken wa kuji ni hajimaru desu.",
    "en": "The Japanese test starts at nine.",
    "bn": "জাপানি পরীক্ষা ৯টায় শুরু হবে।",
    "level": "N5"
  },
  {
    "id": "s185",
    "jp": "あそこに大きな犬がいます。",
    "romaji": "Asoko ni ookina inu ga imasu.",
    "en": "There is a big dog over there.",
    "bn": "ওখানে একটি বড় কুকুর আছে।",
    "level": "N5"
  },
  {
    "id": "s186",
    "jp": "この本は難しすぎて分かりませんでした。",
    "romaji": "Kono hon wa muzukashisugite wakarimasen deshita.",
    "en": "This book was too difficult to understand.",
    "bn": "বইটি এতই কঠিন ছিল যে আমি বুঝতে পারিনি।",
    "level": "N4"
  },
  {
    "id": "s187",
    "jp": "毎日、少しずつ練習することが大切です。",
    "romaji": "Mainichi, sukoshi zutsu renshuu suru koto ga taisetsu desu.",
    "en": "It is important to practice a little bit every day.",
    "bn": "প্রতিদিন অল্প অল্প করে অনুশীলন করা গুরুত্বপূর্ণ।",
    "level": "N4"
  },
  {
    "id": "s188",
    "jp": "新宿で会いましょう。",
    "romaji": "Shinjuku de aimashou.",
    "en": "Let's meet in Shinjuku.",
    "bn": "শিঞ্জুকুতে দেখা হবে।",
    "level": "N5"
  },
  {
    "id": "s189",
    "jp": "お母さんに電話をするのを忘れましたか。",
    "romaji": "Okaasan ni denwa wo suru no wo wasuremashita ka.",
    "en": "Did you forget to call your mother?",
    "bn": "আপনি কি মাকে ফোন করতে ভুলে গেছেন?",
    "level": "N4"
  },
  {
    "id": "s190",
    "jp": "もっと上手に日本語が話せるようになりたいです。",
    "romaji": "Motto jouzu ni nihongo ga hanaseru you ni naritai desu.",
    "en": "I want to be able to speak Japanese better.",
    "bn": "আমি আরও ভালোভাবে জাপানি বলতে সক্ষম হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s191",
    "jp": "このパソコンは新しくないです。",
    "romaji": "Kono pasokon wa atarashikunai desu.",
    "en": "This computer is not new.",
    "bn": "এই কম্পিউটারটি নতুন নয়।",
    "level": "N5"
  },
  {
    "id": "s192",
    "jp": "昨日のご飯は何でしたか。",
    "romaji": "Kinou no gohan wa nani deshita ka.",
    "en": "What was yesterday's meal?",
    "bn": "গতকালের খাবার কি ছিল?",
    "level": "N5"
  },
  {
    "id": "s193",
    "jp": "音楽を聞きながら勉強します。",
    "romaji": "Ongaku wo kikinagara benkyou shimasu.",
    "en": "I study while listening to music.",
    "bn": "আমি গান শুনতে শুনতে পড়ি।",
    "level": "N5"
  },
  {
    "id": "s194",
    "jp": "一緒に図書館へ行きませんか。",
    "romaji": "Issho ni toshokan e ikimasen ka.",
    "en": "Would you like to go to the library together?",
    "bn": "একসাথে লাইব্রেরিতে যাবেন কি?",
    "level": "N4"
  },
  {
    "id": "s195",
    "jp": "仕事が終わってから、飲みに行きます。",
    "romaji": "Shigoto ga owatte kara, nomi ni ikimasu.",
    "en": "I go for a drink after work.",
    "bn": "কাজ শেষ করে আমি তৃষ্ণার্ত হয়ে যাই।",
    "level": "N4"
  },
  {
    "id": "s196",
    "jp": "窓を開けておいでもらえませんか。",
    "romaji": "Mado wo akete oite moraemasen ka.",
    "en": "Could you please keep the window open?",
    "bn": "আপনি কি জানালাটি খুলে রাখতে পারবেন?",
    "level": "N4"
  },
  {
    "id": "s197",
    "jp": "明日テストがあるので、勉強しなければ。",
    "romaji": "Ashita tesuto ga aru node, benkyou shinakereba.",
    "en": "I must study because there is a test tomorrow.",
    "bn": "আগামীকাল পরীক্ষা থাকায় আমাকে পড়তে হবে।",
    "level": "N4"
  },
  {
    "id": "s198",
    "jp": "母に怒られて、泣いてしまいました。",
    "romaji": "Haha ni okorarete, naite shimaimashita.",
    "en": "I cried because my mother got angry at me.",
    "bn": "মা রাগ করায় আমি কেঁদে ফেলেছিলাম।",
    "level": "N4"
  },
  {
    "id": "s199",
    "jp": "日本へ来る前に、日本語を習いました。",
    "romaji": "Nihon e kuru mae ni, nihongo wo naraimashita.",
    "en": "I learned Japanese before coming to Japan.",
    "bn": "জাপানে আসার আগে আমি জাপানি ভাষা শিখেছিলাম।",
    "level": "N4"
  },
  {
    "id": "s200",
    "jp": "毎日、一時間日本語を勉強します。",
    "romaji": "Mainichi, ichijikan nihongo wo benkyou shimasu.",
    "en": "I study Japanese for an hour every day.",
    "bn": "আমি প্রতিদিন এক ঘণ্টা জাপানি ভাষা পড়ি।",
    "level": "N5"
  },
  {
    "id": "s201",
    "jp": "この漢字の読み方を教えてください。",
    "romaji": "Kono kanji no yomikata wo oshiete kudasai.",
    "en": "Please tell me how to read this kanji.",
    "bn": "দয়া করে এই কাঞ্জি পড়ার নিয়মটি শিখিয়ে দিন।",
    "level": "N5"
  },
  {
    "id": "s202",
    "jp": "日本に来てから、三年になります。",
    "romaji": "Nihon ni kite kara, sannen ni narimasu.",
    "en": "It has been three years since I came to Japan.",
    "bn": "জাপানে আসার পর তিন বছর হয়েছে।",
    "level": "N4"
  },
  {
    "id": "s203",
    "jp": "明日、友達と映画を見に行くつもりです。",
    "romaji": "Ashita, tomodachi to eiga wo mi ni iku tsumori desu.",
    "en": "I plan to go see a movie with a friend tomorrow.",
    "bn": "আগামীকাল বন্ধুর সাথে সিনেমা দেখতে যাওয়ার পরিকল্পনা আছে।",
    "level": "N5"
  },
  {
    "id": "s204",
    "jp": "毎日、三時間日本語を勉強するようにしています。",
    "romaji": "Mainichi, sanjikan nihongo wo benkyou suru you ni shite imasu.",
    "en": "I make an effort to study Japanese for three hours every day.",
    "bn": "প্রতিদিন তিন ঘণ্টা জাপানি ভাষা পড়ার চেষ্টা করি।",
    "level": "N4"
  },
  {
    "id": "s205",
    "jp": "この料理はとても美味しいですが、少し高いです。",
    "romaji": "Kono ryouri wa totemo oishii desu ga, sukoshi takai desu.",
    "en": "This food is very delicious, but it is a little expensive.",
    "bn": "এই খাবারটি খুব সুস্বাদু, কিন্তু কিছুটা দামী।",
    "level": "N5"
  },
  {
    "id": "s206",
    "jp": "京都には古いお寺がたくさんあります。",
    "romaji": "Kyoto ni wa furui otera ga takusan arimasu.",
    "en": "There are many old temples in Kyoto.",
    "bn": "কিয়োটোতে অনেক পুরনো মন্দির আছে।",
    "level": "N5"
  },
  {
    "id": "s207",
    "jp": "道が混んでいたので、約束の時間に遅れてしまいました。",
    "romaji": "Michi ga konde ita node, yakusoku no jikan ni okurete shimaimashita.",
    "en": "Because the road was crowded, I was late for the appointment.",
    "bn": "রাস্তায় ভিড় থাকার কারণে আমি অ্যাপয়েন্টমেন্টের সময়ে দেরি করে ফেলেছি।",
    "level": "N4"
  },
  {
    "id": "s208",
    "jp": "将来、日本で働きたいと思っています。",
    "romaji": "Shourai, nihon de hatarakitai to omotte imasu.",
    "en": "I want to work in Japan in the future.",
    "bn": "ভবিষ্যতে জাপানে কাজ করার ইচ্ছা আছে।",
    "level": "N4"
  },
  {
    "id": "s209",
    "jp": "来週の土曜日にパーティーを開くつもりです。",
    "romaji": "Raishuu no doyoubi ni paatii wo hiraku tsumori desu.",
    "en": "I plan to hold a party next Saturday.",
    "bn": "আগামী শনিবার একটি পার্টির আয়োজন করার পরিকল্পনা আছে।",
    "level": "N4"
  },
  {
    "id": "s210",
    "jp": "昨日は一日中雨が降っていました。",
    "romaji": "Kinou wa ichinichijuu ame ga futte imashita.",
    "en": "It was raining all day yesterday.",
    "bn": "গতকাল সারাদিন বৃষ্টি হচ্ছিল।",
    "level": "N5"
  },
  {
    "id": "s211",
    "jp": "この本を読み終わったら、貸してあげます。",
    "romaji": "Kono hon wo yomiowattara, kashite agemasu.",
    "en": "When I finish reading this book, I will lend it to you.",
    "bn": "এই বইটি পড়া শেষ হলে আমি তোমাকে ধার দেব।",
    "level": "N4"
  },
  {
    "id": "s212",
    "jp": "日本の生活にはもう慣れましたか。",
    "romaji": "Nihon no seikatsu ni wa mou naremashita ka?",
    "en": "Have you already gotten used to life in Japan?",
    "bn": "জাপানের জীবনে কি আপনি ইতিমধ্যে অভ্যস্ত হয়ে গেছেন?",
    "level": "N4"
  },
  {
    "id": "s213",
    "jp": "風邪をひいたので、今日は仕事を休みます。",
    "romaji": "Kaze wo hiita node, kyou wa shigoto wo yasumimasu.",
    "en": "I have a cold, so I will take a day off from work today.",
    "bn": "ঠান্ডা লেগেছে, তাই আজ কাজ থেকে ছুটি নিচ্ছি।",
    "level": "N5"
  },
  {
    "id": "s214",
    "jp": "駅の前に新しいデパートができました。",
    "romaji": "Eki no mae ni atarashii depaato ga dekimashita.",
    "en": "A new department store was built in front of the station.",
    "bn": "স্টেশনের সামনে একটি নতুন ডিপার্টমেন্টাল স্টোর তৈরি হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s215",
    "jp": "子供の時、よくこの公園で遊びました。",
    "romaji": "Kodomo no toki, yoku kono kouen de asobimashita.",
    "en": "When I was a child, I often played in this park.",
    "bn": "ছোটবেলায় আমি প্রায়ই এই পার্কে খেলতাম।",
    "level": "N5"
  },
  {
    "id": "s216",
    "jp": "日本語が上手になりたいので、一生懸命練習しています。",
    "romaji": "Nihongo ga jouzu ni naritai node, isshoukenmei renshuu shite imasu.",
    "en": "I want to be good at Japanese, so I am practicing hard.",
    "bn": "জাপানিতে দক্ষ হতে চাই, তাই কঠোর পরিশ্রম করছি।",
    "level": "N4"
  },
  {
    "id": "s217",
    "jp": "明日までにこのレポートを書かなければなりません。",
    "romaji": "Ashita made ni kono repooto wo kakanakereba narisen.",
    "en": "I must write this report by tomorrow.",
    "bn": "আগামীকালের মধ্যে আমাকে এই রিপোর্টটি লিখতে হবে।",
    "level": "N4"
  },
  {
    "id": "s218",
    "jp": "日本のアニメを見るのが大好きです。",
    "romaji": "Nihon no anime wo miru no ga daisuki desu.",
    "en": "I love watching Japanese anime.",
    "bn": "জাপানি অ্যানিমে দেখতে আমি খুব পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s219",
    "jp": "兄は東京の大学に通っています。",
    "romaji": "Ani wa Toukyou no daigaku ni kayotte imasu.",
    "en": "My older brother goes to a university in Tokyo.",
    "bn": "আমার বড় ভাই টোকিওর একটি বিশ্ববিদ্যালয়ে পড়ে।",
    "level": "N5"
  },
  {
    "id": "s220",
    "jp": "天気が良かったら、ハイキングに行きましょう。",
    "romaji": "Tenki ga yokattara, haikingu ni ikimashou.",
    "en": "If the weather is good, let's go hiking.",
    "bn": "আবহাওয়া ভালো থাকলে চলুন হাইকিংয়ে যাই।",
    "level": "N4"
  },
  {
    "id": "s221",
    "jp": "最近、仕事がとても忙しいです。",
    "romaji": "Saikin, shigoto ga totemo isogashii desu.",
    "en": "Recently, work has been very busy.",
    "bn": "সম্প্রতি কাজ খুব ব্যস্ত হয়ে গেছে।",
    "level": "N5"
  },
  {
    "id": "s222",
    "jp": "この辞書は使いやすくて便利ですよ。",
    "romaji": "Kono jisho wa tsukaiyasukute benri desu yo.",
    "en": "This dictionary is easy to use and convenient.",
    "bn": "এই অভিধানটি ব্যবহার করা সহজ এবং সুবিধাজনক।",
    "level": "N4"
  },
  {
    "id": "s223",
    "jp": "家族に会えなくて、少し寂しいです。",
    "romaji": "Kazoku ni aenakute, sukoshi sabishii desu.",
    "en": "I am a little lonely because I can't see my family.",
    "bn": "পরিবারের সাথে দেখা করতে পারছি না বলে কিছুটা খারাপ লাগছে।",
    "level": "N4"
  },
  {
    "id": "s224",
    "jp": "もうすぐ日本語能力試験があります。",
    "romaji": "Mousugu Nihongo Nourvoku Shiken ga arimasu.",
    "en": "There is a JLPT exam soon.",
    "bn": "শীঘ্রই জাপানি ভাষা দক্ষতা পরীক্ষা আছে।",
    "level": "N5"
  },
  {
    "id": "s225",
    "jp": "毎朝六時に起きることにしています。",
    "romaji": "Maiasa rokuji ni okiru koto ni shite imasu.",
    "en": "I make it a rule to wake up at 6 every morning.",
    "bn": "আমি প্রতিদিন সকাল ৬টায় ওঠার নিয়ম করেছি।",
    "level": "N4"
  },
  {
    "id": "s226",
    "jp": "この歌は有名ので、みんな知っています。",
    "romaji": "Kono uta wa yuumei na node, minna shitte imasu.",
    "en": "Because this song is famous, everyone knows it.",
    "bn": "এই গানটি জনপ্রিয় হওয়ার কারণে সবাই এটি চেনে।",
    "level": "N5"
  },
  {
    "id": "s227",
    "jp": "明日晴れるといいですね。",
    "romaji": "Ashita hareru to ii desu ne.",
    "en": "I hope it clears up tomorrow.",
    "bn": "আশা করি আগামীকাল আকাশ পরিষ্কার থাকবে।",
    "level": "N4"
  },
  {
    "id": "s228",
    "jp": "日本に来る前に、ひらがなを覚えました。",
    "romaji": "Nihon ni kuru mae ni, hiragana wo oboemashita.",
    "en": "Before coming to Japan, I learned Hiragana.",
    "bn": "জাপানে আসার আগে আমি হিরাগানা শিখেছিলাম।",
    "level": "N5"
  },
  {
    "id": "s229",
    "jp": "何か飲み物を持ってきましょうか。",
    "romaji": "Nanika nomimono wo motte kimashou ka?",
    "en": "Shall I bring something to drink?",
    "bn": "আমি কি পানের জন্য কিছু আনব?",
    "level": "N5"
  },
  {
    "id": "s230",
    "jp": "今日はとても寒いですから、コートを着てください。",
    "romaji": "Kyou wa totemo samui desu kara, kooto wo kite kudasai.",
    "en": "Because it is very cold today, please wear a coat.",
    "bn": "আজ খুব শীত, তাই দয়া করে কোট পরুন।",
    "level": "N5"
  },
  {
    "id": "s231",
    "jp": "辞書を忘れたので、隣の人に見せてもらいました。",
    "romaji": "Jisho wo wasureta node, tonari no hito ni misete moraimashita.",
    "en": "I forgot my dictionary, so I had the person next to me show me theirs.",
    "bn": "অভিধান ভুলে গেছি, তাই পাশের জনের থেকে দেখে নিয়েছি।",
    "level": "N4"
  },
  {
    "id": "s232",
    "jp": "この問題の答えを教えていただけませんか。",
    "romaji": "Kono mondai no kotae wo oshiete itadakemasen ka?",
    "en": "Could you please tell me the answer to this problem?",
    "bn": "দয়া করে এই সমস্যার সমাধানটি কি আমাকে বলতে পারেন?",
    "level": "N4"
  },
  {
    "id": "s233",
    "jp": "図書館では静かにしなければなりません。",
    "romaji": "Toshokan de wa shizuka ni shinakereba narimasen.",
    "en": "You must be quiet in the library.",
    "bn": "লাইব্রেরিতে শান্ত থাকতে হবে।",
    "level": "N5"
  },
  {
    "id": "s234",
    "jp": "あの人は日本語だけでなく、中国語も話せます。",
    "romaji": "Ano hito wa nihongo dake denaku, chuugokugo mo hanasemasu.",
    "en": "That person can speak not only Japanese but also Chinese.",
    "bn": "ওই ব্যক্তি শুধু জাপানি নয়, চীনা ভাষাতেও কথা বলতে পারেন।",
    "level": "N4"
  },
  {
    "id": "s235",
    "jp": "週末はゆっくり休むことができました。",
    "romaji": "Shuumatsu wa yukkuri yasumu koto ga dekimashita.",
    "en": "I was able to rest well on the weekend.",
    "bn": "সপ্তাহান্তে খুব ভালো বিশ্রাম নিতে পেরেছি।",
    "level": "N5"
  },
  {
    "id": "s236",
    "jp": "ここから駅まで歩いて十分くらいかかります。",
    "romaji": "Koko kara eki made aruite juppun kurai kakarimasu.",
    "en": "It takes about ten minutes to walk from here to the station.",
    "bn": "এখান থেকে স্টেশনে পৌঁছাতে হাঁটলে ১০ মিনিট সময় লাগে।",
    "level": "N5"
  },
  {
    "id": "s237",
    "jp": "部屋を掃除してから、テレビを見ます。",
    "romaji": "Heya wo souji shite kara, terebi wo mimasu.",
    "en": "After cleaning the room, I will watch TV.",
    "bn": "ঘর পরিষ্কার করার পর আমি টিভি দেখি।",
    "level": "N5"
  },
  {
    "id": "s238",
    "jp": "富士山に一度登ってみたいです。",
    "romaji": "Fujisan ni ichido nobotte mitai desu.",
    "en": "I want to try climbing Mt. Fuji once.",
    "bn": "মাউন্ট ফুজি একবার চড়তে চাই।",
    "level": "N4"
  },
  {
    "id": "s239",
    "jp": "日本語の勉強を始めてから、一年が経ちました。",
    "romaji": "Nihongo no benkyou wo hajimete kara, ichinen ga tachimashita.",
    "en": "One year has passed since I started studying Japanese.",
    "bn": "জাপানি পড়া শুরু করার পর এক বছর পার হয়েছে।",
    "level": "N4"
  },
  {
    "id": "s240",
    "jp": "お腹が空いたので、何か食べましょう。",
    "romaji": "Onaka ga suita node, nanika tabemashou.",
    "en": "I am hungry, so let's eat something.",
    "bn": "খিদে পেয়েছে, চলুন কিছু খেয়ে নিই।",
    "level": "N5"
  },
  {
    "id": "s241",
    "jp": "弟はテニスをするのが上手です。",
    "romaji": "Otouto wa tenisu wo suru no ga jouzu desu.",
    "en": "My younger brother is good at playing tennis.",
    "bn": "আমার ছোট ভাই টেনিস খেলায় খুব দক্ষ।",
    "level": "N5"
  },
  {
    "id": "s242",
    "jp": "日本に来るのが私の夢でした。",
    "romaji": "Nihon ni kuru no ga watashi no yume deshita.",
    "en": "Coming to Japan was my dream.",
    "bn": "জাপানে আসা ছিল আমার স্বপ্ন।",
    "level": "N4"
  },
  {
    "id": "s243",
    "jp": "雨が降っているのに、傘を持たずに出かけました。",
    "romaji": "Ame ga futte iru noni, kasa wo motazu ni dekakemashita.",
    "en": "Even though it was raining, I went out without an umbrella.",
    "bn": "বৃষ্টি হওয়ার পরেও আমি ছাতা ছাড়াই বাইরে গেছি।",
    "level": "N4"
  },
  {
    "id": "s244",
    "jp": "この辞書を使ってもいいですか。",
    "romaji": "Kono jisho wo tsukatte mo ii desu ka?",
    "en": "May I use this dictionary?",
    "bn": "আমি কি এই অভিধানটি ব্যবহার করতে পারি?",
    "level": "N5"
  },
  {
    "id": "s245",
    "jp": "日本語の手紙の書き方を練習しましょう。",
    "romaji": "Nihongo no tegami no kakikata wo renshuu shimashou.",
    "en": "Let's practice how to write letters in Japanese.",
    "bn": "জাপানি ভাষায় চিঠি লেখার নিয়ম অনুশীলন করা যাক।",
    "level": "N4"
  },
  {
    "id": "s246",
    "jp": "あのレストランの料理は美味しいと思います。",
    "romaji": "Ano resutoran no ryouri wa oishii to omoimasu.",
    "en": "I think that restaurant's food is delicious.",
    "bn": "আমি মনে করি ওই রেস্তোরাঁর খাবার খুব সুস্বাদু।",
    "level": "N5"
  },
  {
    "id": "s247",
    "jp": "先生の話は分かりやすくて面白いです。",
    "romaji": "Sensei no hanashi wa wakariyasukute omoshiroi desu.",
    "en": "The teacher's talk is easy to understand and interesting.",
    "bn": "শিক্ষকের কথা বোঝা সহজ এবং মজাদার।",
    "level": "N5"
  },
  {
    "id": "s248",
    "jp": "将来、世界中を旅行したいです。",
    "romaji": "Shourai, sekaijuu wo ryokou shitai desu.",
    "en": "I want to travel around the world in the future.",
    "bn": "ভবিষ্যতে আমি সারা বিশ্ব ভ্রমণ করতে চাই।",
    "level": "N4"
  },
  {
    "id": "s249",
    "jp": "この本は昨日図書館で借りました。",
    "romaji": "Kono hon wa kinou toshokan de karimashita.",
    "en": "I borrowed this book from the library yesterday.",
    "bn": "এই বইটি গতকাল লাইব্রেরি থেকে ধার নিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s250",
    "jp": "日本語で自分の名前を書くことができます。",
    "romaji": "Nihongo de jibun no namae wo kaku koto ga dekimasu.",
    "en": "I can write my name in Japanese.",
    "bn": "আমি জাপানি ভাষায় নিজের নাম লিখতে পারি।",
    "level": "N5"
  },
  {
    "id": "s251",
    "jp": "今日はとても天気がいいですから、散歩に行きませんか。",
    "romaji": "Kyou wa totemo tenki ga ii desu kara, sanpo ni ikimasen ka?",
    "en": "The weather is very good today, so why don't we go for a walk?",
    "bn": "আজ আবহাওয়া খুব ভালো, চলুন একটু হেঁটে আসি।",
    "level": "N5"
  },
  {
    "id": "s252",
    "jp": "この靴は少し小さいので、もっと大きいのはありませんか。",
    "romaji": "Kono kutsu wa sukoshi chiisai node, motto ookii no wa arimasen ka?",
    "en": "These shoes are a little small, do you have larger ones?",
    "bn": "এই জুতোজোড়া কিছুটা ছোট, বড় সাইজের হবে কি?",
    "level": "N5"
  },
  {
    "id": "s253",
    "jp": "昨日のテストは思っていたより難しくなかったです。",
    "romaji": "Kinou no tesuto wa omotte ita yori muzukashikunakatta desu.",
    "en": "Yesterday's test was not as difficult as I thought.",
    "bn": "গতকালের পরীক্ষাটি আমি যতটা ভেবেছিলাম ততটা কঠিন ছিল না।",
    "level": "N4"
  },
  {
    "id": "s254",
    "jp": "電車を降りるとき、傘を忘れないように気をつけてください。",
    "romaji": "Densha wo oriru toki, kasa wo wasurenai you ni ki wo tsukete kudasai.",
    "en": "Please be careful not to forget your umbrella when getting off the train.",
    "bn": "ট্রেন থেকে নামার সময় ছাতাটি নিতে ভুলবেন না যেন।",
    "level": "N5"
  },
  {
    "id": "s255",
    "jp": "日本に来てから、納豆が食べられるようになりました。",
    "romaji": "Nihon ni kite kara, nattou ga taberareru you ni narimashita.",
    "en": "I have become able to eat natto since coming to Japan.",
    "bn": "জাপানে আসার পর আমি নাট্টো খেতে শিখে গেছি।",
    "level": "N4"
  },
  {
    "id": "s256",
    "jp": "週末は家でゆっくり本を読んだり、音楽を聞いたりします。",
    "romaji": "Shuumatsu wa ie de yukkuri hon wo yondari, ongaku wo kikitari shimasu.",
    "en": "On weekends, I relax at home reading books or listening to music.",
    "bn": "সপ্তাহান্তে আমি বাড়িতে বই পড়ে বা গান শুনে সময় কাটাই।",
    "level": "N5"
  },
  {
    "id": "s257",
    "jp": "あのビルの中にレストランやカフェなどがたくさんあります。",
    "romaji": "Ano biru no naka ni resutoran ya kafe nado ga takusan arimasu.",
    "en": "There are many restaurants and cafes inside that building.",
    "bn": "ওই বিল্ডিংয়ের ভেতর অনেক রেস্তোরাঁ এবং ক্যাফে আছে।",
    "level": "N5"
  },
  {
    "id": "s258",
    "jp": "明日、六時に起こしてくれませんか。",
    "romaji": "Ashita, rokuji ni okoshite kuremasen ka?",
    "en": "Could you wake me up at six tomorrow?",
    "bn": "আগামীকাল সকাল ৬টায় আমাকে একটু জাগিয়ে দেবেন কি?",
    "level": "N5"
  },
  {
    "id": "s259",
    "jp": "日本語の新聞が読めるようになるのが私の目標です。",
    "romaji": "Nihongo no shinbun ga yomeru you ni naru no ga watashi no mokuhyou desu.",
    "en": "My goal is to be able to read Japanese newspapers.",
    "bn": "জাপানি সংবাদপত্র পড়তে পারাই আমার লক্ষ্য।",
    "level": "N4"
  },
  {
    "id": "s260",
    "jp": "風邪がなかなか治らないので、今日もう一度病院へ行きます。",
    "romaji": "Kaze ga nakanaka naoranai node, kyou mou ichido byouin e ikimasu.",
    "en": "Since the cold isn't going away, I'll go to the hospital again today.",
    "bn": "ঠান্ডাটা সরছে না, তাই আজ আবারও হাসপাতালে যাব।",
    "level": "N5"
  },
  {
    "id": "s261",
    "jp": "田中さんは昨日、お酒を飲みすぎたと言っていました。",
    "romaji": "Tanaka-san wa kinou, osake wo nomisugita to itte imashita.",
    "en": "Mr. Tanaka said he drank too much yesterday.",
    "bn": "তানাকা সাহেব বললেন যে তিনি গতকাল অনেক বেশি পান করেছিলেন।",
    "level": "N4"
  },
  {
    "id": "s262",
    "jp": "この映画はとても感動的ですから、ぜひ見てください。",
    "romaji": "Kono eiga wa totemo kandouteki desu kara, zehi mite kudasai.",
    "en": "This movie is very touching, so please watch it.",
    "bn": "এই সিনেমাটি খুব আবেগপ্রবণ, আপনি অবশ্যই দেখবেন।",
    "level": "N4"
  },
  {
    "id": "s263",
    "jp": "窓を閉めてもいいですか。外が少しうるさいですから。",
    "romaji": "Mado wo shimete mo ii desu ka? Soto ga sukoshi urusai desu kara.",
    "en": "May I close the window? Because it's a little noisy outside.",
    "bn": "আমি কি জানালাটি বন্ধ করতে পারি? বাইরে খুব আওয়াজ হচ্ছে।",
    "level": "N5"
  },
  {
    "id": "s264",
    "jp": "日本料理の中では、お寿司が一番好きです。",
    "romaji": "Nihon ryouri no naka de wa, osushi ga ichiban suki desu.",
    "en": "Among Japanese foods, I like sushi the best.",
    "bn": "জাপানি খাবারের মধ্যে সুশি আমার সবচেয়ে প্রিয়।",
    "level": "N5"
  },
  {
    "id": "s265",
    "jp": "駅から私の家まで、歩いて十五分くらいかかります。",
    "romaji": "Eki kara watashi no ie made, aruite juugofun kurai kakarimasu.",
    "en": "It takes about fifteen minutes to walk from the station to my house.",
    "bn": "স্টেশন থেকে আমার বাড়িতে হেঁটে যেতে ১৫ মিনিট সময় লাগে।",
    "level": "N5"
  },
  {
    "id": "s266",
    "jp": "最近、運動不足なので、毎日走ることにしました。",
    "romaji": "Saikin, undou busoku node, mainichi hashiru koto ni shimaimashita.",
    "en": "Because of lack of exercise recently, I decided to run every day.",
    "bn": "সম্প্রতি শরীরচর্চার অভাবে আমি প্রতিদিন দৌড়ানোর সিদ্ধান্ত নিয়েছি।",
    "level": "N4"
  },
  {
    "id": "s267",
    "jp": "この薬を飲めば、すぐに良くなると思いますよ。",
    "romaji": "Kono kusuri wo nomeba, sugu ni yoku naru to omoimasu yo.",
    "en": "I think you will get better soon if you take this medicine.",
    "bn": "আমি মনে করি এই ওষুধটি খেলে আপনি দ্রুত সুস্থ হয়ে উঠবেন।",
    "level": "N4"
  },
  {
    "id": "s268",
    "jp": "兄は去年からアメリカの大学で勉強しています。",
    "romaji": "Ani wa kyonen kara amerika no daigaku de benkyou shite imasu.",
    "en": "My brother has been studying at an American university since last year.",
    "bn": "আমার ভাই গত বছর থেকে আমেরিকার একটি বিশ্ববিদ্যালয়ে পড়াশোনা করছে।",
    "level": "N4"
  },
  {
    "id": "s269",
    "jp": "どこかで財布を落としてしまったようです。",
    "romaji": "Dokoka de saifu wo otoshite shimatta you desu.",
    "en": "It seems I dropped my wallet somewhere.",
    "bn": "মনে হচ্ছে কোথাও আমি আমার ওয়ালেটটি ফেলে দিয়েছি।",
    "level": "N4"
  },
  {
    "id": "s270",
    "jp": "明日、暇だったら一緒に買い物に行きませんか。",
    "romaji": "Ashita, hima dattara issho ni kaimono ni ikimasen ka?",
    "en": "If you are free tomorrow, wouldn't you like to go shopping together?",
    "bn": "আগামীকাল যদি আপনি ফ্রি থাকেন, তবে কি একসাথে কেনাকাটা করতে যাবেন?",
    "level": "N4"
  },
  {
    "id": "s271",
    "jp": "日本語の先生はとても親切で、教え方が上手です。",
    "romaji": "Nihongo no sensei wa totemo shinsetsu de, oshiekata ga jouzu desu.",
    "en": "The Japanese teacher is very kind and good at teaching.",
    "bn": "জাপানি শিক্ষক খুব দয়ালু এবং তাঁর পড়ানোর ধরন খুব ভালো।",
    "level": "N5"
  },
  {
    "id": "s272",
    "jp": "この本、読まないなら私に貸してください。",
    "romaji": "Kono hon, yomanai nara watashi ni kashite kudasai.",
    "en": "If you don't read this book, please lend it to me.",
    "bn": "আপনি যদি এই বইটি না পড়েন তবে আমাকে ধার দিন।",
    "level": "N5"
  },
  {
    "id": "s273",
    "jp": "将来の夢は、自分の会社を作ることです。",
    "romaji": "Shourai no yume wa, jibun no kaisha wo tsukuru koto desu.",
    "en": "My future dream is to start my own company.",
    "bn": "আমার ভবিষ্যতের স্বপ্ন হলো নিজের একটি কোম্পানি খোলা।",
    "level": "N4"
  },
  {
    "id": "s274",
    "jp": "この問題の解き方が全然分かりません。",
    "romaji": "Kono mondai no tokikata ga zenzen wakarimasen.",
    "en": "I don't understand how to solve this problem at all.",
    "bn": "আমি এই সমস্যার সমাধান করার নিয়ম কিছুই বুঝতে পারছি না।",
    "level": "N4"
  },
  {
    "id": "s275",
    "jp": "子供たちが公園で元気に遊んでいます。",
    "romaji": "Kodomotachi ga kouen de genki ni asonde imasu.",
    "en": "Children are playing energetically in the park.",
    "bn": "শিশুরা পার্কে প্রাণবন্তভাবে খেলা করছে।",
    "level": "N5"
  },
  {
    "id": "s276",
    "jp": "冷蔵庫の中に牛乳も卵もありません。",
    "romaji": "Reizouko no naka ni gyuunyuu mo tamago mo arimasen.",
    "en": "There is neither milk nor eggs in the refrigerator.",
    "bn": "ফ্রিজের ভেতর দুধ বা ডিম কিছুই নেই।",
    "level": "N5"
  },
  {
    "id": "s277",
    "jp": "父は毎日忙しくて、夜遅く帰ってきます。",
    "romaji": "Chichi wa mainichi isogashikute, yoru osoku kaette kimasu.",
    "en": "My father is busy every day and comes home late at night.",
    "bn": "বাবা প্রতিদিন খুব ব্যস্ত থাকেন এবং রাতে দেরিতে বাড়ি ফেরেন।",
    "level": "N5"
  },
  {
    "id": "s278",
    "jp": "日本の歌をもっとたくさん覚えたいです。",
    "romaji": "Nihon no uta wo motto takusan oboetai desu.",
    "en": "I want to learn many more Japanese songs.",
    "bn": "আমি আরও অনেক জাপানি গান শিখতে চাই।",
    "level": "N4"
  },
  {
    "id": "s279",
    "jp": "このレポートは今週金曜日までに提出してください。",
    "romaji": "Kono repooto wa konshuu kinyoubi made ni teishutsu shite kudasai.",
    "en": "Please submit this report by this Friday.",
    "bn": "দয়া করে এই শুক্রবারের মধ্যে রিপোর্টটি জমা দিন।",
    "level": "N4"
  },
  {
    "id": "s280",
    "jp": "駅のホームで友達に会いました。",
    "romaji": "Eki no hoomu de tomodachi ni aimashita.",
    "en": "I met a friend on the station platform.",
    "bn": "স্টেশন প্ল্যাটফর্মে আমার এক বন্ধুর সাথে দেখা হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s281",
    "jp": "あそこに止まっている車は私のです。",
    "romaji": "Asoko ni tomatte iru kuruma wa watashi no desu.",
    "en": "The car parked over there is mine.",
    "bn": "ঐখানে দাঁড়িয়ে থাকা গাড়িটি আমার।",
    "level": "N5"
  },
  {
    "id": "s282",
    "jp": "日本語の会話がもっと上手になりたいです。",
    "romaji": "Nihongo no kaiwa ga motto jouzu ni naritai desu.",
    "en": "I want to be better at Japanese conversation.",
    "bn": "আমি জাপানি কথোপকথনে আরও দক্ষ হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s283",
    "jp": "今日は朝からずっと頭が痛いです。",
    "romaji": "Kyou wa asa kara zutto atama ga itai desu.",
    "en": "My head has been hurting all day since morning.",
    "bn": "আজ সকাল থেকে আমার খুব মাথা ব্যথা করছে।",
    "level": "N5"
  },
  {
    "id": "s284",
    "jp": "この鞄は重すぎますから、一つ持ってあげます。",
    "romaji": "Kono kaban wa omosugimasu kara, hitotsu motte agemasu.",
    "en": "Since this bag is too heavy, I will carry one for you.",
    "bn": "এই ব্যাগটি খুব ভারী, আমি একটি ধরছি।",
    "level": "N4"
  },
  {
    "id": "s285",
    "jp": "昨日の晩、三時間しか寝られませんでした。",
    "romaji": "Kinou no ban, sanjikan shika neraremasen deshita.",
    "en": "Last night, I could only sleep for three hours.",
    "bn": "গতকাল রাতে আমি মাত্র তিন ঘণ্টা ঘুমাতে পেরেছি।",
    "level": "N4"
  },
  {
    "id": "s286",
    "jp": "部屋を片付けてから、宿題をします。",
    "romaji": "Heya wo katazukete kara, shukudai wo shimasu.",
    "en": "I will do my homework after tidying up the room.",
    "bn": "ঘর গোছানোর পর আমি আমার হোমওয়ার্ক করব।",
    "level": "N5"
  },
  {
    "id": "s287",
    "jp": "先生、この言葉の意味を教えてくれませんか。",
    "romaji": "Sensei, kono kotoba no imi wo oshiete kuremasen ka?",
    "en": "Teacher, could you tell me the meaning of this word?",
    "bn": "শিক্ষক, দয়া করে এই শব্দটির অর্থ কি আমাকে বলবেন?",
    "level": "N5"
  },
  {
    "id": "s288",
    "jp": "来週の月曜日、暇だったら遊びに来てください。",
    "romaji": "Raishuu no getsuyoubi, hima dattara asobi ni kite kudasai.",
    "en": "Next Monday, if you are free, please come over.",
    "bn": "আগামী সোমবার আপনি ফ্রি থাকলে আমাদের ওদিকে আসবেন।",
    "level": "N4"
  },
  {
    "id": "s289",
    "jp": "日本語の漫画を読むのが大好きです。",
    "romaji": "Nihongo no manga wo miru no ga daisuki desu.",
    "en": "I love reading Japanese manga.",
    "bn": "জাপানি মাঙ্গা পড়তে আমি খুব পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s290",
    "jp": "どこかいいレストランを教えていただけませんか。",
    "romaji": "Dokoka ii resutoran wo oshiete itadakemasen ka?",
    "en": "Could you please tell me about a good restaurant somewhere?",
    "bn": "দয়া করে ভালো কোনো রেস্তোরাঁর কথা আমাকে কি বলতে পারবেন?",
    "level": "N4"
  },
  {
    "id": "s291",
    "jp": "兄は去年からずっと東京に住んでいます。",
    "romaji": "Ani wa kyonen kara zutto Toukyou ni sunde imasu.",
    "en": "My brother has been living in Tokyo since last year.",
    "bn": "আমার ভাই গত বছর থেকে টোকিওতে বসবাস করছে।",
    "level": "N5"
  },
  {
    "id": "s292",
    "jp": "日本の生活にもう慣れましたか。",
    "romaji": "Nihon no seikatsu ni wa mou naremashita ka?",
    "en": "Have you already gotten used to life in Japan?",
    "bn": "জাপানের জীবনে কি আপনি ইতিমধ্যে অভ্যস্ত হয়ে গেছেন?",
    "level": "N4"
  },
  {
    "id": "s293",
    "jp": "雨が降りそうなので、洗濯物を取り込みます。",
    "romaji": "Ame ga furisou na node, sentakumono wo torikomimasu.",
    "en": "It looks like it will rain, so I'll bring in the laundry.",
    "bn": "বৃষ্টি হতে পারে মনে হচ্ছে, তাই কাপড়গুলো ভেতরে নিয়ে আসছি।",
    "level": "N4"
  },
  {
    "id": "s294",
    "jp": "明日は、朝早く起きなければなりません。",
    "romaji": "Ashita wa, asa hayaku okinakereba narisen.",
    "en": "I must get up early tomorrow morning.",
    "bn": "আগামীকাল আমাকে খুব সকালে উঠতে হবে।",
    "level": "N4"
  },
  {
    "id": "s295",
    "jp": "日本語の小説が読めるようになるのが夢です。",
    "romaji": "Nihongo no shousetsu ga yomeru you ni naru no ga yume desu.",
    "en": "My dream is to be able to read Japanese novels.",
    "bn": "জাপানি উপন্যাস পড়তে পারাই আমার স্বপ্ন।",
    "level": "N4"
  },
  {
    "id": "s296",
    "jp": "家族に手紙を書くために、切手を買いました。",
    "romaji": "Kazoku ni tegami wo kaku tame ni, kitte wo kaimashita.",
    "en": "I bought stamps to write a letter to my family.",
    "bn": "পরিবারে চিঠি লেখার জন্য আমি ডাকটিকিট কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s297",
    "jp": "この料理は思ったより辛くなくて美味しいです。",
    "romaji": "Kono ryouri wa omotta yori karakunakute oishii desu.",
    "en": "This food is not as spicy as I thought and is delicious.",
    "bn": "এই খাবারটি আমি যতটা ভেবেছিলাম ততটা ঝাল নয় এবং সুস্বাদু।",
    "level": "N4"
  },
  {
    "id": "s298",
    "jp": "来年の春、日本へ行く予定です。",
    "romaji": "Rainen no haru, nihon e iku yotei desu.",
    "en": "I plan to go to Japan next spring.",
    "bn": "আগামী বছরের বসন্তে আমার জাপানে যাওয়ার পরিকল্পনা আছে।",
    "level": "N4"
  },
  {
    "id": "s299",
    "jp": "駅の近くに新しいカフェができました。",
    "romaji": "Eki no chikaku ni atarashii kafe ga dekimashita.",
    "en": "A new cafe has opened near the station.",
    "bn": "স্টেশনের কাছে একটি নতুন ক্যাফে তৈরি হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s300",
    "jp": "毎日、少しずつ日本語を勉強するようにしています。",
    "romaji": "Mainichi, sukoshizutsu nihongo wo benkyou suru you ni shite imasu.",
    "en": "I try to study Japanese little by little every day.",
    "bn": "আমি প্রতিদিন অল্প অল্প করে জাপানি ভাষা পড়ার চেষ্টা করি।",
    "level": "N4"
  },
  {
    "id": "s301",
    "jp": "すみません、この近くにポストはありませんか。",
    "romaji": "Sumimasen, kono chikaku ni posuto wa arimasen ka?",
    "en": "Excuse me, is there a mailbox near here?",
    "bn": "মাফ করবেন, কাছেপিঠে কি কোনো পোস্টবক্স আছে?",
    "level": "N5"
  },
  {
    "id": "s302",
    "jp": "日本に来る前に、日本の文化について少し勉強しました。",
    "romaji": "Nihon ni kuru mae ni, nihon no bunka ni tsuite sukoshi benkyou shimashita.",
    "en": "Before coming to Japan, I studied a little about Japanese culture.",
    "bn": "জাপানে আসার আগে আমি জাপানি সংস্কৃতি সম্পর্কে কিছুটা পড়াশোনা করেছিলাম।",
    "level": "N4"
  },
  {
    "id": "s303",
    "jp": "明日、友達と京都へ行こうと思っています。",
    "romaji": "Ashita, tomodachi to Kyouto e ikou to omotte imasu.",
    "en": "I am thinking of going to Kyoto with a friend tomorrow.",
    "bn": "আগামীকাল বন্ধুর সাথে কিয়োটো যাওয়ার কথা ভাবছি।",
    "level": "N4"
  },
  {
    "id": "s304",
    "jp": "お腹が痛いので、今日は何も食べたくありません。",
    "romaji": "Onaka ga itai node, kyou wa nani mo tabetakuarimasen.",
    "en": "My stomach hurts, so I don't want to eat anything today.",
    "bn": "পেট ব্যথা করছে, তাই আজ আমি কিছুই খেতে চাইছি না।",
    "level": "N5"
  },
  {
    "id": "s305",
    "jp": "日本語の単語を覚えるのは大変ですが、面白いです。",
    "romaji": "Nihongo no tango wo oboeru no wa taihen desu ga, omoshiroi desu.",
    "en": "Memorizing Japanese words is hard but interesting.",
    "bn": "জাপানি শব্দ মনে রাখা কঠিন হলেও বেশ মজাদার।",
    "level": "N5"
  },
  {
    "id": "s306",
    "jp": "田中さんは、明日のパーティーに来られないそうです。",
    "romaji": "Tanaka-san wa, ashita no paatii ni korarenai sou desu.",
    "en": "I heard that Mr. Tanaka cannot come to the party tomorrow.",
    "bn": "শুনলাম তানাকা সাহেব আগামীকালের পার্টিতে আসতে পারবেন না।",
    "level": "N4"
  },
  {
    "id": "s307",
    "jp": "駅の前に新しい図書館ができて、とても便利になりました。",
    "romaji": "Eki no mae ni atarashii toshokan ga dekite, totemo benri ni narimashita.",
    "en": "A new library was built in front of the station, and it has become very convenient.",
    "bn": "স্টেশনের সামনে নতুন লাইব্রেরি হওয়ায় খুব সুবিধা হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s308",
    "jp": "外国語を勉強するとき、たくさん話すことが大切です。",
    "romaji": "Gaikokugo wo benkyou suru toki, takusan hanasu koto ga taisetsu desu.",
    "en": "When studying a foreign language, it is important to talk a lot.",
    "bn": "বিদেশী ভাষা শেখার সময় অনেক বেশি কথা বলা খুব গুরুত্বপূর্ণ।",
    "level": "N4"
  },
  {
    "id": "s309",
    "jp": "最近、仕事が忙しくて、全然休んでいません。",
    "romaji": "Saikin, shigoto ga isogashikute, zenzen yasundeimasen.",
    "en": "Recently, work has been busy, and I haven't rested at all.",
    "bn": "সম্প্রতি কাজের চাপে আমি একদমই বিশ্রাম নিতে পারছি না।",
    "level": "N5"
  },
  {
    "id": "s310",
    "jp": "このレポートを書き終わったら、一緒に飲みに行きませんか。",
    "romaji": "Kono repooto wo kakiowattara, issho ni nomi ni ikimasen ka?",
    "en": "When I finish writing this report, why don't we go for a drink together?",
    "bn": "এই রিপোর্টটি লেখা শেষ হলে চলুন একসাথে একটু পান করে আসি।",
    "level": "N4"
  },
  {
    "id": "s311",
    "jp": "日本の山の中で、富士山が一番有名です。",
    "romaji": "Nihon no yama no naka de, Fujisan ga ichiban yuumei desu.",
    "en": "Among Japan's mountains, Mt. Fuji is the most famous.",
    "bn": "জাপানের পাহাড়গুলোর মধ্যে মাউন্ট ফুজি সবচেয়ে বিখ্যাত।",
    "level": "N5"
  },
  {
    "id": "s312",
    "jp": "毎朝、コーヒーを飲みながら新聞を読みます。",
    "romaji": "Maiasa, koohii wo nominagara shinbun wo yomimasu.",
    "en": "Every morning, I read the newspaper while drinking coffee.",
    "bn": "প্রতিদিন সকালে আমি কফি খেতে খেতে খবরের কাগজ পড়ি।",
    "level": "N5"
  },
  {
    "id": "s313",
    "jp": "日本語の会話をもっと練習しなければなりません。",
    "romaji": "Nihongo no kaiwa wo motto renshuu shinakereba narisen.",
    "en": "I must practice Japanese conversation more.",
    "bn": "আমাকে জাপানি কথোপকথন আরও বেশি অনুশীলন করতে হবে।",
    "level": "N4"
  },
  {
    "id": "s314",
    "jp": "すみません、もう少しゆっくり話していただけませんか。",
    "romaji": "Sumimasen, mou sukoshi yukkuri hanashite itadakemasen ka?",
    "en": "Excuse me, could you please speak a little more slowly?",
    "bn": "মাফ করবেন, আপনি কি আর একটু ধীরে কথা বলতে পারেন?",
    "level": "N5"
  },
  {
    "id": "s315",
    "jp": "将来、日本で自分の店を持ちたいと思っています。",
    "romaji": "Shourai, nihon de jibun no mise wo motitai to omotte imasu.",
    "en": "I want to have my own shop in Japan in the future.",
    "bn": "ভবিষ্যতে জাপানে আমার নিজের একটি দোকান খোলার ইচ্ছা আছে।",
    "level": "N4"
  },
  {
    "id": "s316",
    "jp": "昨日の晩、とてもうるさくて、よく寝られませんでした。",
    "romaji": "Kinou no ban, totemo urusakute, yoku neraremasen deshita.",
    "en": "Last night was very noisy, and I couldn't sleep well.",
    "bn": "গতকাল রাতে খুব গোলমাল ছিল, তাই আমি ঠিকমতো ঘুমাতে পারিনি।",
    "level": "N5"
  },
  {
    "id": "s317",
    "jp": "日本の生活で、困ったことがあったら教えてください。",
    "romaji": "Nihon no seikatsu de, komatta koto ga attara oshiete kudasai.",
    "en": "If you have any trouble in Japan, please tell me.",
    "bn": "জাপানের জীবনে কোনো সমস্যায় পড়লে আমাকে অবশ্যই জানাবেন।",
    "level": "N4"
  },
  {
    "id": "s318",
    "jp": "この本、とても面白いですから、読んでみてください。",
    "romaji": "Kono hon, totemo omoshiroi desu kara, yonde mite kudasai.",
    "en": "This book is very interesting, so please try reading it.",
    "bn": "এই বইটি খুব মজাদার, আপনি একবার পড়ে দেখতে পারেন।",
    "level": "N5"
  },
  {
    "id": "s319",
    "jp": "明日、雨が降らなかったら、テニスをしましょう。",
    "romaji": "Ashita, ame ga furanakattara, tenisu wo shimashou.",
    "en": "If it doesn't rain tomorrow, let's play tennis.",
    "bn": "আগামীকাল বৃষ্টি না হলে চলুন টেনিস খেলি।",
    "level": "N4"
  },
  {
    "id": "s320",
    "jp": "駅のホームで、偶然昔の友達に会いました。",
    "romaji": "Eki no hoomu de, guuzen mukashi no tomodachi ni aimashita.",
    "en": "I met an old friend by chance on the station platform.",
    "bn": "স্টেশন প্ল্যাটফর্মে হঠাৎ পুরনো এক বন্ধুর সাথে দেখা হয়ে গেল।",
    "level": "N4"
  },
  {
    "id": "s321",
    "jp": "日本語の手紙を書くのは、まだ少し難しいです。",
    "romaji": "Nihongo no tegami wo kaku no wa, mada sukoshi muzukashii desu.",
    "en": "It is still a little difficult for me to write letters in Japanese.",
    "bn": "জাপানি ভাষায় চিঠি লেখা আমার জন্য এখনও কিছুটা কঠিন।",
    "level": "N4"
  },
  {
    "id": "s322",
    "jp": "今から友達の家へ遊びに行くところです。",
    "romaji": "Ima kara tomodachi no ie e asobi ni iku tokoro desu.",
    "en": "I am about to go over to a friend's house now.",
    "bn": "আমি এখন বন্ধুর বাড়ি বেড়াতে যাওয়ার জন্য তৈরি হচ্ছি।",
    "level": "N4"
  },
  {
    "id": "s323",
    "jp": "この料理の作り方を教えていただけませんか。",
    "romaji": "Kono ryouri no tsukurikata wo oshiete itadakemasen ka?",
    "en": "Could you please tell me how to make this dish?",
    "bn": "আপনি কি আমাকে এই খাবারটি তৈরির নিয়ম শিখিয়ে দেবেন?",
    "level": "N4"
  },
  {
    "id": "s324",
    "jp": "子供のころ、よくこの川で泳ぎました。",
    "romaji": "Kodomo no koro, yoku kono kawa de oyogimashita.",
    "en": "When I was a child, I often swam in this river.",
    "bn": "ছোটবেলায় আমি প্রায়ই এই নদীতে সাঁতার কাটতাম।",
    "level": "N5"
  },
  {
    "id": "s325",
    "jp": "来週の会議について、資料を読んでおいてください。",
    "romaji": "Raishuu no kaigi ni tsuite, shiryou wo yonde oite kudasai.",
    "en": "Please read the materials for next week's meeting in advance.",
    "bn": "আগামী সপ্তাহের মিটিংয়ের কাগজপত্রগুলো আগে থেকেই পড়ে রাখবেন।",
    "level": "N4"
  },
  {
    "id": "s326",
    "jp": "部屋を片付けてから、ゆっくりお茶を飲みます。",
    "romaji": "Heya wo katazukete kara, yukkuri ocha wo nomimasu.",
    "en": "After cleaning the room, I will relax and have some tea.",
    "bn": "ঘর গোছানোর পর আমি শান্তিতে চা খাব।",
    "level": "N5"
  },
  {
    "id": "s327",
    "jp": "日本語の漫画を読むのが大好きで、たくさん持っています。",
    "romaji": "Nihongo no manga wo yomu no ga daisuki de, takusan motte imasu.",
    "en": "I love reading Japanese manga and have many of them.",
    "bn": "আমি জাপানি মাঙ্গা পড়তে খুব ভালোবাসি এবং আমার কাছে অনেক সংগ্রহ আছে।",
    "level": "N5"
  },
  {
    "id": "s328",
    "jp": "将来、世界中を旅行するのが夢です。",
    "romaji": "Shourai, sekaijuu wo ryokou suru no ga yume desu.",
    "en": "My dream is to travel around the world in the future.",
    "bn": "ভবিষ্যতে সারা পৃথিবী ভ্রমণ করাই আমার স্বপ্ন।",
    "level": "N4"
  },
  {
    "id": "s329",
    "jp": "風邪をひかないように、気をつけてください。",
    "romaji": "Kaze wo hikanai you ni, ki wo tsukete kudasai.",
    "en": "Please be careful not to catch a cold.",
    "bn": "সাবধানে থাকবেন যেন ঠান্ডা না লাগে।",
    "level": "N4"
  },
  {
    "id": "s330",
    "jp": "昨日、図書館でこの本を借りました。",
    "romaji": "Kinou, toshokan de kono hon wo karimashita.",
    "en": "I borrowed this book from the library yesterday.",
    "bn": "গতকাল লাইব্রেরি থেকে এই বইটি ধার নিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s331",
    "jp": "あそこに止まっている白い車は、私のです。",
    "romaji": "Asoko ni tomatte iru shiroi kuruma wa, watashi no desu.",
    "en": "The white car parked over there is mine.",
    "bn": "ঐখানে দাঁড়িয়ে থাকা সাদা গাড়িটি আমার।",
    "level": "N5"
  },
  {
    "id": "s332",
    "jp": "日本語の会話が、もっと上手になりたいです。",
    "romaji": "Nihongo no kaiwa ga, motto jouzu ni naritai desu.",
    "en": "I want to be better at Japanese conversation.",
    "bn": "আমি জাপানি কথোপকথনে আরও দক্ষ হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s333",
    "jp": "辞書を忘れたので、友達に見せてもらいました。",
    "romaji": "Jisho wo wasureta node, tomodachi ni misete moraimashita.",
    "en": "I forgot my dictionary, so my friend showed me theirs.",
    "bn": "অভিধান ভুলে গেছি, তাই বন্ধুর থেকে দেখে নিয়েছি।",
    "level": "N4"
  },
  {
    "id": "s334",
    "jp": "この靴は、歩きやすくて気に入っています。",
    "romaji": "Kono kutsu wa, arukiyasukute kiniitte imasu.",
    "en": "I like these shoes because they are easy to walk in.",
    "bn": "এই জুতোজোড়া হাঁটতে খুব আরামদায়ক, তাই আমার পছন্দ।",
    "level": "N4"
  },
  {
    "id": "s335",
    "jp": "明日は朝早く起きなければなりません。",
    "romaji": "Ashita wa asa hayaku okinakereba narisen.",
    "en": "I must get up early tomorrow morning.",
    "bn": "আগামীকাল আমাকে খুব সকালে উঠতে হবে।",
    "level": "N4"
  },
  {
    "id": "s336",
    "jp": "冷蔵庫の中に、卵も牛乳もありません。",
    "romaji": "Reizouko no naka ni, tamago mo gyuunyuu mo arisen.",
    "en": "There are neither eggs nor milk in the refrigerator.",
    "bn": "ফ্রিজের ভেতর ডিম বা দুধ কিছুই নেই।",
    "level": "N5"
  },
  {
    "id": "s337",
    "jp": "昨日の晩、三時間しか寝られませんでした。",
    "romaji": "Kinou no ban, sanjikan shika neraremasen deshita.",
    "en": "Last night, I could only sleep for three hours.",
    "bn": "গতকাল রাতে আমি মাত্র তিন ঘণ্টা ঘুমাতে পেরেছি।",
    "level": "N4"
  },
  {
    "id": "s338",
    "jp": "日本語のテレビ番組を見て、勉強しています。",
    "romaji": "Nihongo no terebi bangumi wo mite, benkyou shite imasu.",
    "en": "I am studying by watching Japanese TV programs.",
    "bn": "জাপানি টিভি প্রোগ্রাম দেখে আমি পড়াশোনা করছি।",
    "level": "N4"
  },
  {
    "id": "s339",
    "jp": "どこかいいレストランを教えてくださいませんか。",
    "romaji": "Dokoka ii resutoran wo oshiete kudasaimasen ka?",
    "en": "Could you please tell me about a good restaurant somewhere?",
    "bn": "দয়া করে ভালো কোনো রেস্তোরাঁর কথা আমাকে কি বলতে পারবেন?",
    "level": "N4"
  },
  {
    "id": "s340",
    "jp": "兄は、去年から東京の大学に通っています。",
    "romaji": "Ani wa, kyonen kara Toukyou no daigaku ni kayotte imasu.",
    "en": "My brother has been attending university in Tokyo since last year.",
    "bn": "আমার ভাই গত বছর থেকে টোকিওর একটি বিশ্ববিদ্যালয়ে পড়ছে।",
    "level": "N5"
  },
  {
    "id": "s341",
    "jp": "日本語を勉強し始めてから、一年になります。",
    "romaji": "Nihongo wo benkyou shihajimete kara, ichinen ni narimasu.",
    "en": "It has been a year since I started studying Japanese.",
    "bn": "জাপানি পড়া শুরু করার পর এক বছর হয়েছে।",
    "level": "N4"
  },
  {
    "id": "s342",
    "jp": "お腹が空いたので、何か食べに行きましょう。",
    "romaji": "Onaka ga suita node, nanika tabe ni ikimashou.",
    "en": "I'm hungry, so let's go grab something to eat.",
    "bn": "খিদে পেয়েছে, চলুন কিছু খেয়ে আসি।",
    "level": "N5"
  },
  {
    "id": "s343",
    "jp": "毎日、寝る前に日記を書くことにしています。",
    "romaji": "Mainichi, neru mae ni nikki wo kaku koto ni shite imasu.",
    "en": "I make it a rule to write in my diary every day before bed.",
    "bn": "আমি প্রতিদিন ঘুমানোর আগে ডায়েরি লেখার নিয়ম করেছি।",
    "level": "N4"
  },
  {
    "id": "s344",
    "jp": "この問題の解き方が、全然分かりません。",
    "romaji": "Kono mondai no tokikata ga, zenzen wakarimasen.",
    "en": "I don't understand how to solve this problem at all.",
    "bn": "আমি এই সমস্যার সমাধান করার নিয়ম কিছুই বুঝতে পারছি না।",
    "level": "N4"
  },
  {
    "id": "s345",
    "jp": "日本に来るのが、私の長年の夢でした。",
    "romaji": "Nihon ni kuru no ga, watashi no nanganen no yume deshita.",
    "en": "Coming to Japan has been my dream for many years.",
    "bn": "জাপানে আসা ছিল আমার দীর্ঘদিনের স্বপ্ন।",
    "level": "N4"
  },
  {
    "id": "s346",
    "jp": "雨が降っているのに、傘を持たずに出かけました。",
    "romaji": "Ame ga futte iru noni, kasa wo motazu ni dekakemashita.",
    "en": "Even though it was raining, I went out without an umbrella.",
    "bn": "বৃষ্টি হওয়ার পরেও আমি ছাতা ছাড়াই বাইরে গেছি।",
    "level": "N4"
  },
  {
    "id": "s347",
    "jp": "この辞書を、ちょっと使ってもいいですか。",
    "romaji": "Kono jisho wo, chotto tsukatte mo ii desu ka?",
    "en": "May I use this dictionary for a moment?",
    "bn": "আমি কি আপনার এই অভিধানটি একটু ব্যবহার করতে পারি?",
    "level": "N5"
  },
  {
    "id": "s348",
    "jp": "日本語の手紙の書き方を練習しましょう。",
    "romaji": "Nihongo no tegami no kakikata wo renshuu shimashou.",
    "en": "Let's practice how to write letters in Japanese.",
    "bn": "জাপানি ভাষায় চিঠি লেখার নিয়ম অনুশীলন করা যাক।",
    "level": "N4"
  },
  {
    "id": "s349",
    "jp": "あのレストランの料理は、とても美味しいと思います。",
    "romaji": "Ano resutoran no ryouri wa, totemo oishii to omoimasu.",
    "en": "I think that restaurant's food is very delicious.",
    "bn": "আমি মনে করি ওই রেস্তোরাঁর খাবার খুব সুস্বাদু।",
    "level": "N5"
  },
  {
    "id": "s350",
    "jp": "日本語で自分の名前を、上手に書くことができます。",
    "romaji": "Nihongo de jibun no namae wo, jouzu ni kaku koto ga dekimasu.",
    "en": "I can write my name well in Japanese.",
    "bn": "আমি জাপানি ভাষায় সুন্দর করে নিজের নাম লিখতে পারি।",
    "level": "N5"
  },
  {
    "id": "s351",
    "jp": "ごめんなさい、約束を忘れてしまいました。",
    "romaji": "Gomen nasai, yakusoku wo wasurete shimaimashita.",
    "en": "I'm sorry, I forgot our promise.",
    "bn": "মাফ করবেন, আমি কথাটি ভুলে গেছি।",
    "level": "N5"
  },
  {
    "id": "s352",
    "jp": "日本に来てから、半年が経ちました。",
    "romaji": "Nihon ni kite kara, hantoshi ga tachimashita.",
    "en": "Six months have passed since I came to Japan.",
    "bn": "জাপানে আসার পর ছয় মাস হয়ে গেছে।",
    "level": "N4"
  },
  {
    "id": "s353",
    "jp": "将来の夢を実現するために、毎日努力しています。",
    "romaji": "Shourai no yume wo jitsugen suru tame ni, mainichi doryoku shite imasu.",
    "en": "I am making efforts every day to realize my future dream.",
    "bn": "ভবিষ্যতের স্বপ্ন পূরণের জন্য আমি প্রতিদিন পরিশ্রম করছি।",
    "level": "N4"
  },
  {
    "id": "s354",
    "jp": "すみません、この漢字の読み方を教えてください。",
    "romaji": "Sumimasen, kono kanji no yomikata wo oshiete kudasai.",
    "en": "Excuse me, please tell me how to read this kanji.",
    "bn": "মাফ করবেন, এই কাঞ্জিটি পড়ার নিয়ম কি আমাকে বলতে পারবেন?",
    "level": "N5"
  },
  {
    "id": "s355",
    "jp": "昨日のテストは、難しかったけれど頑張りました。",
    "romaji": "Kinou no tesuto wa, muzukashikatta keredo ganbarimashita.",
    "en": "Yesterday's test was difficult, but I did my best.",
    "bn": "গতকালের পরীক্ষাটি কঠিন ছিল, তবে আমি আমার সেরাটা দিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s356",
    "jp": "駅から私の家まで、自転車で十分くらいです。",
    "romaji": "Eki kara watashi no ie made, jitensha de juppun kurai desu.",
    "en": "It takes about ten minutes by bicycle from the station to my house.",
    "bn": "স্টেশন থেকে আমার বাড়িতে সাইকেলে যেতে ১০ মিনিট লাগে।",
    "level": "N5"
  },
  {
    "id": "s357",
    "jp": "日本の食べ物の中で、おにぎりが一番好きです。",
    "romaji": "Nihon no tabemono no naka de, onigiri ga ichiban suki desu.",
    "en": "Among Japanese foods, I like onigiri the best.",
    "bn": "জাপানি খাবারের মধ্যে ওনিগিরি আমার সবচেয়ে প্রিয়।",
    "level": "N5"
  },
  {
    "id": "s358",
    "jp": "明日、暇だったら映画を見に行きませんか。",
    "romaji": "Ashita, hima dattara eiga wo mi ni ikimasen ka?",
    "en": "If you are free tomorrow, wouldn't you like to go see a movie?",
    "bn": "আগামীকাল যদি আপনি ফ্রি থাকেন, তবে কি সিনেমা দেখতে যাবেন?",
    "level": "N5"
  },
  {
    "id": "s359",
    "jp": "日本語の先生は、とても優しくて教え方が上手です。",
    "romaji": "Nihongo no sensei wa, totemo yasashikute oshiekata ga jouzu desu.",
    "en": "The Japanese teacher is very kind and good at teaching.",
    "bn": "জাপানি শিক্ষক খুব দয়ালু এবং তাঁর পড়ানোর ধরন খুব ভালো।",
    "level": "N5"
  },
  {
    "id": "s360",
    "jp": "風邪をひいてしまったので、今日はお休みします。",
    "romaji": "Kaze wo hiite shimatta node, kyou wa oyasumi shimasu.",
    "en": "Because I caught a cold, I will take the day off today.",
    "bn": "ঠান্ডা লাগার কারণে আজ আমি ছুটি নিচ্ছি।",
    "level": "N5"
  },
  {
    "id": "s361",
    "jp": "田中さんに、この資料を渡しておいてください。",
    "romaji": "Tanaka-san ni, kono shiryou wo watashite oite kudasai.",
    "en": "Please hand these materials to Mr. Tanaka in advance.",
    "bn": "এই কাগজপত্রগুলো তানাকা সাহেবের কাছে পৌঁছে দেবেন।",
    "level": "N4"
  },
  {
    "id": "s362",
    "jp": "日本語のクラスは、毎週月曜日と木曜日にあります。",
    "romaji": "Nihongo no kurasu wa, maishuu getsuyoubi to mokuyoubi ni arimasu.",
    "en": "Japanese classes are held every Monday and Thursday.",
    "bn": "জাপানি ক্লাস প্রতি সোমবার এবং বৃহস্পতিবার হয়।",
    "level": "N5"
  },
  {
    "id": "s363",
    "jp": "将来は、日本で仕事をしたいと思っています。",
    "romaji": "Shourai wa, nihon de shigoto wo shitai to omotte imasu.",
    "en": "I want to work in Japan in the future.",
    "bn": "ভবিষ্যতে জাপানে কাজ করার ইচ্ছা আছে।",
    "level": "N4"
  },
  {
    "id": "s364",
    "jp": "ここから富士山がとてもきれいに見えます。",
    "romaji": "Koko kara Fujisan ga totemo kirei ni miemasu.",
    "en": "Mt. Fuji can be seen very beautifully from here.",
    "bn": "এখান থেকে মাউন্ট ফুজি খুব সুন্দরভাবে দেখা যায়।",
    "level": "N5"
  },
  {
    "id": "s365",
    "jp": "毎日、寝る前に一時間くらい本を読みます。",
    "romaji": "Mainichi, neru mae ni ichijikan kurai hon wo yomimasu.",
    "en": "Every day, I read a book for about an hour before bed.",
    "bn": "প্রতিদিন ঘুমানোর আগে আমি প্রায় এক ঘণ্টা বই পড়ি।",
    "level": "N5"
  },
  {
    "id": "s366",
    "jp": "すみません、もう少しゆっくり言ってください。",
    "romaji": "Sumimasen, mou sukoshi yukkuri itte kudasai.",
    "en": "Excuse me, please say it a little more slowly.",
    "bn": "মাফ করবেন, আর একটু ধীরে বলুন।",
    "level": "N5"
  },
  {
    "id": "s367",
    "jp": "日本語の漫画を読むのは、とても楽しいです。",
    "romaji": "Nihongo no manga wo yomu no wa, totemo tanoshii desu.",
    "en": "Reading Japanese manga is very fun.",
    "bn": "জাপানি মাঙ্গা পড়া খুব মজাদার।",
    "level": "N5"
  },
  {
    "id": "s368",
    "jp": "昨日の晩、どこで晩ごはんを食べましたか。",
    "romaji": "Kinou no ban, doko de bangohan wo tabemashita ka?",
    "en": "Where did you eat dinner last night?",
    "bn": "গত রাতে আপনি কোথায় ডিনার করেছিলেন?",
    "level": "N5"
  },
  {
    "id": "s369",
    "jp": "日本に来て、初めて雪を見ました。",
    "romaji": "Nihon ni kite, hajimete yuki wo mimashita.",
    "en": "Coming to Japan, I saw snow for the first time.",
    "bn": "জাপানে এসে আমি প্রথমবারের মতো তুষার দেখেছি।",
    "level": "N4"
  },
  {
    "id": "s370",
    "jp": "このレポートを、明日までに提出しなければなりません。",
    "romaji": "Kono repooto wo, ashita made ni teishutsu shinakereba narisen.",
    "en": "I must submit this report by tomorrow.",
    "bn": "আগামীকালের মধ্যে রিপোর্টটি জমা দিতেই হবে।",
    "level": "N4"
  },
  {
    "id": "s371",
    "jp": "駅の近くに、新しいスーパーができました。",
    "romaji": "Eki no chikaku ni, atarashii suupaa ga dekimashita.",
    "en": "A new supermarket has opened near the station.",
    "bn": "স্টেশনের কাছে একটি নতুন সুপার মার্কেট তৈরি হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s372",
    "jp": "日本語の歌を歌うのが、とても上手ですね。",
    "romaji": "Nihongo no uta wo utau no ga, totemo jouzu desu ne.",
    "en": "You are very good at singing Japanese songs.",
    "bn": "আপনি জাপানি গান খুব সুন্দর গাইতে পারেন।",
    "level": "N4"
  },
  {
    "id": "s373",
    "jp": "明日、六時に起こしてくれませんか。",
    "romaji": "Ashita, rokuji ni okoshite kuremasen ka?",
    "en": "Could you wake me up at six tomorrow?",
    "bn": "আগামীকাল সকাল ৬টায় আমাকে একটু জাগিয়ে দেবেন কি?",
    "level": "N5"
  },
  {
    "id": "s374",
    "jp": "部屋を片付けてから、散歩に行きます。",
    "romaji": "Heya wo katazukete kara, sanpo ni ikimasu.",
    "en": "After tidying up the room, I will go for a walk.",
    "bn": "ঘর গোছানোর পর আমি হাঁটতে যাব।",
    "level": "N5"
  },
  {
    "id": "s375",
    "jp": "日本料理の中では、お寿司が一番有名です。",
    "romaji": "Nihon ryouri no naka de wa, osushi ga ichiban yuumei desu.",
    "en": "Among Japanese foods, sushi is the most famous.",
    "bn": "জাপানি খাবারের মধ্যে সুশি সবচেয়ে বিখ্যাত।",
    "level": "N5"
  },
  {
    "id": "s376",
    "jp": "毎日、少しずつ日本語を勉強するようにしています。",
    "romaji": "Mainichi, sukoshizutsu nihongo wo benkyou suru you ni shite imasu.",
    "en": "I try to study Japanese little by little every day.",
    "bn": "আমি প্রতিদিন অল্প অল্প করে জাপানি ভাষা পড়ার চেষ্টা করি।",
    "level": "N4"
  },
  {
    "id": "s377",
    "jp": "すみません、この言葉の意味を教えていただけませんか。",
    "romaji": "Sumimasen, kono kotoba no imi wo oshiete itadakemasen ka?",
    "en": "Excuse me, could you please tell me the meaning of this word?",
    "bn": "মাফ করবেন, দয়া করে এই শব্দটির অর্থ কি আমাকে বলবেন?",
    "level": "N4"
  },
  {
    "id": "s378",
    "jp": "将来の夢は、自分の会社を作ることです。",
    "romaji": "Shourai no yume wa, jibun no kaisha wo tsukuru koto desu.",
    "en": "My future dream is to start my own company.",
    "bn": "আমার ভবিষ্যতের স্বপ্ন হলো নিজের একটি কোম্পানি খোলা।",
    "level": "N4"
  },
  {
    "id": "s379",
    "jp": "この映画は、とても感動的でした。",
    "romaji": "Kono eiga wa, totemo kandouteki deshita.",
    "en": "This movie was very moving.",
    "bn": "এই সিনেমাটি খুব আবেগপ্রবণ ছিল।",
    "level": "N4"
  },
  {
    "id": "s380",
    "jp": "昨日の晩、コーヒーを飲みすぎて寝られませんでした。",
    "romaji": "Kinou no ban, koohii wo nomisugite neraremasen deshita.",
    "en": "Last night, I drank too much coffee and couldn't sleep.",
    "bn": "গত রাতে বেশি কফি নেওয়ার কারণে ঘুমাতে পারিনি।",
    "level": "N4"
  },
  {
    "id": "s381",
    "jp": "日本語の小説が読めるようになるのが、目標です。",
    "romaji": "Nihongo no shousetsu ga yomeru you ni naru no ga, mokuhyou desu.",
    "en": "My goal is to be able to read Japanese novels.",
    "bn": "জাপানি উপন্যাস পড়তে পারাই আমার লক্ষ্য।",
    "level": "N4"
  },
  {
    "id": "s382",
    "jp": "田中さんは、今日お休みだと言っていました。",
    "romaji": "Tanaka-san wa, kyou oyasumi da to itte imashita.",
    "en": "Mr. Tanaka said he is taking the day off today.",
    "bn": "তানাকা সাহেব বললেন যে তিনি আজ ছুটিতে আছেন।",
    "level": "N4"
  },
  {
    "id": "s383",
    "jp": "この辞書は、とても使いやすくて便利です。",
    "romaji": "Kono jisho wa, totemo tsukaiyasukute benri desu.",
    "en": "This dictionary is very easy to use and convenient.",
    "bn": "এই অভিধানটি ব্যবহার করা খুব সহজ এবং সুবিধাজনক।",
    "level": "N4"
  },
  {
    "id": "s384",
    "jp": "日本に来てから、納豆が食べられるようになりました。",
    "romaji": "Nihon ni kite kara, nattou ga taberareru you ni narimashita.",
    "en": "I have become able to eat natto since coming to Japan.",
    "bn": "জাপানে আসার পর আমি নাট্টো খেতে শিখে গেছি।",
    "level": "N4"
  },
  {
    "id": "s385",
    "jp": "明日、暇だったら一緒に買い物に行きませんか。",
    "romaji": "Ashita, hima dattara issho ni kaimono ni ikimasen ka?",
    "en": "If you are free tomorrow, wouldn't you like to go shopping together?",
    "bn": "আগামীকাল যদি আপনি ফ্রি থাকেন, তবে কি একসাথে কেনাকাটা করতে যাবেন?",
    "level": "N4"
  },
  {
    "id": "s386",
    "jp": "日本語の会話をもっと練習したいと思います。",
    "romaji": "Nihongo no kaiwa wo motto renshuu shitai to omoimasu.",
    "en": "I want to practice Japanese conversation more.",
    "bn": "আমি জাপানি কথোপকথন আরও বেশি অনুশীলন করতে চাই।",
    "level": "N4"
  },
  {
    "id": "s387",
    "jp": "辞書を引いても、この言葉の意味が分かりませんでした。",
    "romaji": "Jisho wo hiite mo, kono kotoba no imi ga wakarimasen deshita.",
    "en": "Even looking in the dictionary, I didn't understand the meaning of this word.",
    "bn": "ডিকশনারি দেখেও আমি এই শব্দটির অর্থ বুঝতে পারিনি।",
    "level": "N4"
  },
  {
    "id": "s388",
    "jp": "この料理は、思ったより辛くなくて美味しいです。",
    "romaji": "Kono ryouri wa, omotta yori karakunakute oishii desu.",
    "en": "This food is not as spicy as I thought and is delicious.",
    "bn": "এই খাবারটি আমি যতটা ভেবেছিলাম ততটা ঝাল নয় এবং সুস্বাদু।",
    "level": "N4"
  },
  {
    "id": "s389",
    "jp": "来週の会議について、資料を読んでおいてください。",
    "romaji": "Raishuu no kaigi ni tsuite, shiryou wo yonde oite kudasai.",
    "en": "Please read the materials for next week's meeting in advance.",
    "bn": "আগামী সপ্তাহের মিটিংয়ের কাগজপত্রগুলো আগে থেকেই পড়ে রাখবেন।",
    "level": "N4"
  },
  {
    "id": "s390",
    "jp": "部屋を片付けてから、友達と遊びに行きます。",
    "romaji": "Heya wo katazukete kara, tomodachi to asobi ni ikimasu.",
    "en": "After tidying up the room, I will go play with friends.",
    "bn": "ঘর গোছানোর পর আমি বন্ধুদের সাথে বাইরে যাব।",
    "level": "N4"
  },
  {
    "id": "s391",
    "jp": "日本語の漫画を読むのが大好きで、たくさん持っています。",
    "romaji": "Nihongo no manga wo yomu no ga daisuki de, takusan motte imasu.",
    "en": "I love reading Japanese manga and have many of them.",
    "bn": "আমি জাপানি মাঙ্গা পড়তে খুব ভালোবাসি এবং আমার কাছে অনেক সংগ্রহ আছে।",
    "level": "N5"
  },
  {
    "id": "s393",
    "jp": "風邪をひかないように、暖かくしてください。",
    "romaji": "Kaze wo hikanai you ni, atatakaku shite kudasai.",
    "en": "Please keep yourself warm so you don't catch a cold.",
    "bn": "সাবধানে থাকবেন যেন ঠান্ডা না লাগে, নিজেকে উষ্ণ রাখুন।",
    "level": "N4"
  },
  {
    "id": "s394",
    "jp": "昨日、駅で偶然昔の友達に会いました。",
    "romaji": "Kinou, eki de guuzen mukashi no tomodachi ni aimashita.",
    "en": "I met an old friend by chance at the station yesterday.",
    "bn": "গতকাল স্টেশনে হঠাৎ পুরনো এক বন্ধুর সাথে দেখা হয়ে গেল।",
    "level": "N4"
  },
  {
    "id": "s395",
    "jp": "あそこに止まっている青い車は、田中さんのです。",
    "romaji": "Asoko ni tomatte iru aoi kuruma wa, Tanaka-san no desu.",
    "en": "The blue car parked over there belongs to Mr. Tanaka.",
    "bn": "ঐখানে দাঁড়িয়ে থাকা নীল গাড়িটি তানাকা সাহেবের।",
    "level": "N5"
  },
  {
    "id": "s396",
    "jp": "日本語の会話が、もっと上手になりたいと頑張っています。",
    "romaji": "Nihongo no kaiwa ga, motto jouzu ni naritai to ganbatte imasu.",
    "en": "I am doing my best to become better at Japanese conversation.",
    "bn": "আমি জাপানি কথোপকথনে আরও দক্ষ হওয়ার জন্য চেষ্টা করছি।",
    "level": "N4"
  },
  {
    "id": "s397",
    "jp": "辞書を忘れたので、隣の人に見せてもらいました。",
    "romaji": "Jisho wo wasureta node, tonari no hito ni misete moraimashita.",
    "en": "I forgot my dictionary, so I had the person next to me show me theirs.",
    "bn": "অভিধান ভুলে গেছি, তাই পাশের জনের থেকে দেখে নিয়েছি।",
    "level": "N4"
  },
  {
    "id": "s398",
    "jp": "この靴は、とても軽くて歩きやすいです。",
    "romaji": "Kono kutsu wa, totemo karukute arukiyasu desu.",
    "en": "These shoes are very light and easy to walk in.",
    "bn": "এই জুতোজোড়া খুব হালকা এবং হাঁটতে আরামদায়ক।",
    "level": "N4"
  },
  {
    "id": "s399",
    "jp": "明日は、朝早く起きなければなりません。",
    "romaji": "Ashita wa, asa hayaku okinakereba narisen.",
    "en": "I must get up early tomorrow morning.",
    "bn": "আগামীকাল আমাকে খুব সকালে উঠতে হবে।",
    "level": "N4"
  },
  {
    "id": "s400",
    "jp": "日本語を毎日勉強して、上達したいです。",
    "romaji": "Nihongo wo mainichi benkyou shite, joutatsu shitai desu.",
    "en": "I want to study Japanese every day and improve.",
    "bn": "আমি প্রতিদিন জাপানি পড়াশোনা করে আরও উন্নতি করতে চাই।",
    "level": "N4"
  },
  {
    "id": "s401",
    "jp": "明日のパーティー、誰が来るか知っていますか。",
    "romaji": "Ashita no paatii, dare ga kuru ka shitte imasu ka?",
    "en": "Do you know who is coming to tomorrow's party?",
    "bn": "আগামীকালের পার্টিতে কে কে আসবে আপনি কি জানেন?",
    "level": "N5"
  },
  {
    "id": "s402",
    "jp": "この本は、読みやすくて内容も面白いです。",
    "romaji": "Kono hon wa, yomiyasukute naiyou mo omoshiroi desu.",
    "en": "This book is easy to read and the content is interesting.",
    "bn": "এই বইটি পড়া খুব সহজ এবং এর বিষয়বস্তুও খুব চমৎকার।",
    "level": "N4"
  },
  {
    "id": "s403",
    "jp": "風が強いので、窓を閉めておいてください。",
    "romaji": "Kaze ga tsuyoi node, mado wo shimete oite kudasai.",
    "en": "Because the wind is strong, please keep the windows closed.",
    "bn": "বাতাস খুব বেশি হওয়ার কারণে জানালাগুলো বন্ধ রাখুন।",
    "level": "N5"
  },
  {
    "id": "s404",
    "jp": "日本のお土産に、何を買ったらいいでしょうか。",
    "romaji": "Nihon no omiyage ni, nani wo kattara ii deshou ka?",
    "en": "What should I buy as a souvenir from Japan?",
    "bn": "জাপানের স্মৃতিচিহ্ন (স্যুভেনিয়ার) হিসেবে আমার কী কেনা উচিত?",
    "level": "N4"
  },
  {
    "id": "s405",
    "jp": "毎日、三十分くらい運動することにしています。",
    "romaji": "Mainichi, sanjuppun kurai undou suru koto ni shite imasu.",
    "en": "I make it a rule to exercise for about thirty minutes every day.",
    "bn": "আমি প্রতিদিন প্রায় ৩০ মিনিট ব্যায়াম করার নিয়ম করেছি।",
    "level": "N4"
  },
  {
    "id": "s406",
    "jp": "すみません、もう少し安くしてもらえませんか。",
    "romaji": "Sumimasen, mou sukoshi yasuku shite moraemasen ka?",
    "en": "Excuse me, could you make it a little cheaper?",
    "bn": "মাফ করবেন, আর একটু কম রাখা যাবে কি?",
    "level": "N5"
  },
  {
    "id": "s407",
    "jp": "日本語のテストで、いい点数が取れて嬉しかったです।",
    "romaji": "Nihongo no tesuto de, ii tensuu ga torete ureshikatta desu.",
    "en": "I was happy to get a good score on the Japanese test.",
    "bn": "জাপানি পরীক্ষায় ভালো নম্বর পেয়ে আমি খুব খুশি।",
    "level": "N5"
  },
  {
    "id": "s408",
    "jp": "将来のことは、まだよく分かりません。",
    "romaji": "Shourai no koto wa, mada yoku wakarimasen.",
    "en": "I don't know about the future well yet.",
    "bn": "ভবিষ্যৎ সম্পর্কে আমি এখনও ঠিকমতো জানি না।",
    "level": "N5"
  },
  {
    "id": "s409",
    "jp": "田中さんは、テニスがとても上手だそうですね。",
    "romaji": "Tanaka-san wa, tenisu ga totemo jouzu da sou desu ne.",
    "en": "I heard Mr. Tanaka is very good at tennis.",
    "bn": "শুনলাম তানাকা সাহেব টেনিসে খুব দক্ষ।",
    "level": "N4"
  },
  {
    "id": "s410",
    "jp": "このレポートは、今日中に完成させなければなりません。",
    "romaji": "Kono repooto wa, kyoujuu ni kansei sasenakereba narisen.",
    "en": "This report must be finished by the end of today.",
    "bn": "আজকের মধ্যেই রিপোর্টটি শেষ করতে হবে।",
    "level": "N4"
  },
  {
    "id": "s411",
    "jp": "駅の前に、きれいな花がたくさん咲いています。",
    "romaji": "Eki no mae ni, kirei na hana ga takusan saite imasu.",
    "en": "Many beautiful flowers are blooming in front of the station.",
    "bn": "স্টেশনের সামনে অনেক সুন্দর ফুল ফুটে আছে।",
    "level": "N5"
  },
  {
    "id": "s412",
    "jp": "日本語の勉強を始めてから、一年が経ちました。",
    "romaji": "Nihongo no benkyou wo hajimete kara, ichinen ga tachimashita.",
    "en": "One year has passed since I started studying Japanese.",
    "bn": "জাপানি ভাষা শেখা শুরু করার পর এক বছর কেটে গেছে।",
    "level": "N4"
  },
  {
    "id": "s413",
    "jp": "来週の旅行、とても楽しみにしています。",
    "romaji": "Raishuu no ryokou, totemo tanoshimi ni shite imasu.",
    "en": "I am looking forward to next week's trip.",
    "bn": "আগামী সপ্তাহের ভ্রমণ নিয়ে আমি খুব আগ্রহী।",
    "level": "N5"
  },
  {
    "id": "s414",
    "jp": "すみません、この漢字の書き方を教えてください。",
    "romaji": "Sumimasen, kono kanji no kakikata wo oshiete kudasai.",
    "en": "Excuse me, please tell me how to write this kanji.",
    "bn": "মাফ করবেন, দয়া করে এই কাঞ্জিটি লেখার নিয়ম শিখিয়ে দেবেন কি?",
    "level": "N5"
  },
  {
    "id": "s415",
    "jp": "毎日、朝食をしっかり食べるようにしています。",
    "romaji": "Mainichi, choushoku wo shikkari taberu you ni shite imasu.",
    "en": "I try to eat a solid breakfast every day.",
    "bn": "আমি প্রতিদিন সকালে পেট ভরে খাওয়ার চেষ্টা করি।",
    "level": "N4"
  },
  {
    "id": "s416",
    "jp": "日本に来て、日本の文化に興味を持ちました。",
    "romaji": "Nihon ni kite, nihon no bunka ni kyoumi wo mochimashita.",
    "en": "Coming to Japan, I became interested in Japanese culture.",
    "bn": "জাপানে আসার পর জাপানি সংস্কৃতির প্রতি আমার আগ্রহ বেড়েছে।",
    "level": "N4"
  },
  {
    "id": "s417",
    "jp": "この問題は、思ったより難しいですね。",
    "romaji": "Kono mondai wa, omotta yori muzukashii desu ne.",
    "en": "This problem is more difficult than I thought.",
    "bn": "এই সমস্যাটি আমি যতটা ভেবেছিলাম তার চেয়েও কঠিন।",
    "level": "N5"
  },
  {
    "id": "s418",
    "jp": "明日、九時に駅で会いましょう。",
    "romaji": "Ashita, kuji ni eki de aimashou.",
    "en": "Let's meet at the station at nine tomorrow.",
    "bn": "আগামীকাল সকাল ৯টায় স্টেশনে দেখা করি।",
    "level": "N5"
  },
  {
    "id": "s419",
    "jp": "田中さんに、この本を返しておいてください。",
    "romaji": "Tanaka-san ni, kono hon wo kaeshite oite kudasai.",
    "en": "Please return this book to Mr. Tanaka in advance.",
    "bn": "দয়া করে এই বইটি তানাকা সাহেবকে ফেরত দিয়ে দেবেন।",
    "level": "N4"
  },
  {
    "id": "s420",
    "jp": "日本語の会話が、少しずつできるようになってきました。",
    "romaji": "Nihongo no kaiwa ga, sukoshizutsu dekiru you ni natte kimashita.",
    "en": "I have gradually become able to converse in Japanese.",
    "bn": "আমি ধীরে ধীরে জাপানি ভাষায় কথা বলতে শিখছি।",
    "level": "N4"
  },
  {
    "id": "s421",
    "jp": "ここから海がとてもきれいに見えますね。",
    "romaji": "Koko kara umi ga totemo kirei ni miemasu ne.",
    "en": "The sea looks very beautiful from here.",
    "bn": "এখান থেকে সমুদ্র খুব সুন্দর দেখা যাচ্ছে।",
    "level": "N5"
  },
  {
    "id": "s422",
    "jp": "昨日の晩、どこかへ行きましたか。",
    "romaji": "Kinou no ban, dokoka e ikimashita ka?",
    "en": "Did you go anywhere last night?",
    "bn": "গত রাতে আপনি কোথাও গিয়েছিলেন কি?",
    "level": "N5"
  },
  {
    "id": "s423",
    "jp": "日本語の漫画を読むのが、私の趣味です。",
    "romaji": "Nihongo no manga wo yomu no ga, watashi no shumi desu.",
    "en": "Reading Japanese manga is my hobby.",
    "bn": "জাপানি মাঙ্গা পড়া আমার শখ।",
    "level": "N5"
  },
  {
    "id": "s424",
    "jp": "この辞書は、とても役に立つと思います。",
    "romaji": "Kono jisho wa, totemo yaku ni tatsu to omoimasu.",
    "en": "I think this dictionary will be very useful.",
    "bn": "আমার মনে হয় এই ডিকশনারিটি খুব কাজে আসবে।",
    "level": "N5"
  },
  {
    "id": "s425",
    "jp": "明日、雨が降ったら行きません。",
    "romaji": "Ashita, ame ga futtara ikimasen.",
    "en": "If it rains tomorrow, I won't go.",
    "bn": "আগামীকাল বৃষ্টি হলে আমি যাব না।",
    "level": "N5"
  },
  {
    "id": "s426",
    "jp": "日本語の歌を練習して、上手になりたいです。",
    "romaji": "Nihongo no uta wo renshuu shite, jouzu ni naritai desu.",
    "en": "I want to practice Japanese songs and become good at them.",
    "bn": "আমি জাপানি গান প্র্যাকটিস করে আরও ভালো গাইতে চাই।",
    "level": "N4"
  },
  {
    "id": "s427",
    "jp": "すみません、お水を一杯いただけますか。",
    "romaji": "Sumimasen, omizu wo ippai itadakemasu ka?",
    "en": "Excuse me, could I have a glass of water?",
    "bn": "মাফ করবেন, এক গ্লাস জল পেতে পারি কি?",
    "level": "N5"
  },
  {
    "id": "s428",
    "jp": "田中さんは、もうすぐ来るはずです。",
    "romaji": "Tanaka-san wa, mou sugu kuru hazu desu.",
    "en": "Mr. Tanaka should be coming soon.",
    "bn": "তানাকা সাহেবের এই সময়ের মধ্যেই আসার কথা।",
    "level": "N4"
  },
  {
    "id": "s429",
    "jp": "このレポートを、明日までにまとめてください。",
    "romaji": "Kono repooto wo, ashita made ni matomete kudasai.",
    "en": "Please summarize this report by tomorrow.",
    "bn": "আগামীকালের মধ্যে রিপোর্টটি গুছিয়ে ফেলুন।",
    "level": "N4"
  },
  {
    "id": "s430",
    "jp": "部屋を明るくするために、電気をつけました。",
    "romaji": "Heya wo akaruku suru tame ni, denki wo tsukemashita.",
    "en": "I turned on the lights to make the room bright.",
    "bn": "ঘরটি উজ্জ্বল করার জন্য আমি আলো জ্বালিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s431",
    "jp": "日本語を勉強するのは、とても楽しいです。",
    "romaji": "Nihongo wo benkyou suru no wa, totemo tanoshii desu.",
    "en": "Studying Japanese is very fun.",
    "bn": "জাপানি পড়া খুব মজাদার।",
    "level": "N5"
  },
  {
    "id": "s432",
    "jp": "将来は、日本の大学で勉強したいです。",
    "romaji": "Shourai wa, nihon no daigaku de benkyou shitai desu.",
    "en": "I want to study at a Japanese university in the future.",
    "bn": "ভবিষ্যতে আমি জাপানের কোনো বিশ্ববিদ্যালয়ে পড়তে চাই।",
    "level": "N4"
  },
  {
    "id": "s433",
    "jp": "すみません、もう少しゆっくり話していただけませんか。",
    "romaji": "Sumimasen, mou sukoshi yukkuri hanashite itadakemasen ka?",
    "en": "Excuse me, could you please speak a little more slowly?",
    "bn": "মাফ করবেন, দয়া করে একটু ধীরে কথা বলবেন কি?",
    "level": "N4"
  },
  {
    "id": "s434",
    "jp": "毎日、寝る前に日記を書くことにしています。",
    "romaji": "Mainichi, neru mae ni nikki wo kaku koto ni shite imasu.",
    "en": "I make it a rule to write in my diary every night before bed.",
    "bn": "ঘুমানোর আগে প্রতিদিন ডায়েরি লেখার নিয়ম করেছি।",
    "level": "N4"
  },
  {
    "id": "s435",
    "jp": "日本に来てから、納豆が大好きになりました。",
    "romaji": "Nihon ni kite kara, nattou ga daisuki ni narimashita.",
    "en": "Since coming to Japan, I have come to love natto.",
    "bn": "জাপানে আসার পর নাট্টো আমার খুব পছন্দ হয়ে গেছে।",
    "level": "N4"
  },
  {
    "id": "s436",
    "jp": "この靴は、歩きやすくて全然疲れません。",
    "romaji": "Kono kutsu wa, arukiyasukute zenzen tsukaremasen.",
    "en": "These shoes are easy to walk in and I don't get tired at all.",
    "bn": "এই জুতোজোড়া পরে হাঁটতে সুবিধা হয় এবং একদম ক্লান্তি লাগে না।",
    "level": "N4"
  },
  {
    "id": "s437",
    "jp": "明日、暇だったら一緒に映画を見にいきませんか。",
    "romaji": "Ashita, hima dattara issho ni eiga wo mi ni ikimasen ka?",
    "en": "If you are free tomorrow, wouldn't you like to go see a movie together?",
    "bn": "আগামীকাল ফ্রি থাকলে চলো একসাথে সিনেমা দেখতে যাই?",
    "level": "N5"
  },
  {
    "id": "s438",
    "jp": "日本語の会話をもっと練習して、上手になりたいです。",
    "romaji": "Nihongo no kaiwa wo motto renshuu shite, jouzu ni naritai desu.",
    "en": "I want to practice Japanese conversation more and get better.",
    "bn": "জাপানি কথোপকথন আরও প্র্যাকটিস করে আরও দক্ষ হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s439",
    "jp": "辞書を引いても、この漢字の読み方が分かりませんでした。",
    "romaji": "Jisho wo hiite mo, kono kanji no yomikata wo wakarimasen deshita.",
    "en": "Even looking in the dictionary, I didn't understand how to read this kanji.",
    "bn": "ডিকশনারি দেখেও এই কাঞ্জিটি পড়ার নিয়ম বুঝতে পারছি না।",
    "level": "N4"
  },
  {
    "id": "s440",
    "jp": "この料理は、思ったより辛くなくて美味しいです。",
    "romaji": "Kono ryouri wa, omotta yori karakunakute oishii desu.",
    "en": "This dish is not as spicy as I thought and is delicious.",
    "bn": "এই খাবারটি প্রত্যাশার চেয়ে কম ঝাল এবং বেশ সুস্বাদু।",
    "level": "N4"
  },
  {
    "id": "s441",
    "jp": "来週の会議の資料、もう読みましたか。",
    "romaji": "Raishuu no kaigi no shiryou, mou yomimashita ka?",
    "en": "Have you already read the materials for next week's meeting?",
    "bn": "আগামী সপ্তাহের মিটিংয়ের কাগজপত্রগুলো কি আপনি পড়া শুরু করেছেন?",
    "level": "N4"
  },
  {
    "id": "s442",
    "jp": "部屋を片付けてから、友達が遊びに来ました。",
    "romaji": "Heya wo katazukete kara, tomodachi ga asobi ni kimashita.",
    "en": "Friend came over after I tidied up the room.",
    "bn": "ঘর গোছানোর পর বন্ধু দেখা করতে এল।",
    "level": "N4"
  },
  {
    "id": "s443",
    "jp": "日本語の漫画を読むのが大好きで、毎日読んでいます。",
    "romaji": "Nihongo no manga wo yomu no ga daisuki de, mainichi yonde imasu.",
    "en": "I love reading Japanese manga and read them every day.",
    "bn": "আমি জাপানি মাঙ্গা পড়তে খুব ভালোবাসি এবং প্রতিদিন তা পড়ি।",
    "level": "N5"
  },
  {
    "id": "s445",
    "jp": "風邪をひかないように、気をつけてください。",
    "romaji": "Kaze wo hikanai you ni, ki wo tsukete kudasai.",
    "en": "Please be careful not to catch a cold.",
    "bn": "সাবধানে থেকো যেন ঠান্ডা না লেগে যায়।",
    "level": "N4"
  },
  {
    "id": "s446",
    "jp": "昨日、駅で偶然友達に会いました。",
    "romaji": "Kinou, eki de guuzen tomodachi ni aimashita.",
    "en": "I met a friend by chance at the station yesterday.",
    "bn": "গতকাল স্টেশনে হঠাৎ এক বন্ধুর সাথে দেখা হয়ে গেল।",
    "level": "N4"
  },
  {
    "id": "s447",
    "jp": "あそこに止まっている白い車は、私のです。",
    "romaji": "Asoko ni tomatte iru shiroi kuruma wa, watashi no desu.",
    "en": "The white car parked over there is mine.",
    "bn": "ঐখানে দাঁড়িয়ে থাকা সাদা গাড়িটি আমার।",
    "level": "N5"
  },
  {
    "id": "s448",
    "jp": "日本語の会話が、もっと上手になりたいです。",
    "romaji": "Nihongo no kaiwa ga, motto jouzu ni naritai desu.",
    "en": "I want to become better at Japanese conversation.",
    "bn": "জাপানি কথোপকথনে আমি আরও ভালো হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s449",
    "jp": "辞書を忘れたので、見せてもらってもいいですか。",
    "romaji": "Jisho wo wasureta node, misete moratte mo ii desu ka?",
    "en": "I forgot my dictionary, so may I see yours?",
    "bn": "আমি ডিকশনারি ভুলে গেছি, আপনারটা কি একটু দেখতে পারি?",
    "level": "N4"
  },
  {
    "id": "s450",
    "jp": "この靴は、とても軽くて歩きやすいです。",
    "romaji": "Kono kutsu wa, totemo karukute arukiyasu desu.",
    "en": "These shoes are very light and easy to walk in.",
    "bn": "এই জুতোজোড়া খুব হালকা এবং পরলে আরামদায়ক লাগে।",
    "level": "N4"
  },
  {
    "id": "s451",
    "jp": "このスープは、まだ熱いので気をつけてください。",
    "romaji": "Kono suupu wa, mada atsui node ki wo tsukete kudasai.",
    "en": "This soup is still hot, so please be careful.",
    "bn": "সুপটা এখনও বেশ গরম, তাই সাবধানে খাবেন।",
    "level": "N5"
  },
  {
    "id": "s452",
    "jp": "あの新しいビルは、とても高いですね。",
    "romaji": "Ano atarashii biru wa, totemo takai desu ne.",
    "en": "That new building is very tall, isn't it?",
    "bn": "ঐ নতুন দালানটি খুব উঁচু, তাই না?",
    "level": "N5"
  },
  {
    "id": "s453",
    "jp": "安くて美味しい料理を、毎日作りたいです。",
    "romaji": "Yasukute oishii ryouri wo, mainichi tsukuritai desu.",
    "en": "I want to cook cheap and delicious food every day.",
    "bn": "আমি প্রতিদিন সস্তা এবং সুস্বাদু খাবার রান্না করতে চাই।",
    "level": "N5"
  },
  {
    "id": "s454",
    "jp": "この鞄は重すぎて、一人で持てません。",
    "romaji": "Kono kaban wa omosugite, hitori de motemasen.",
    "en": "This bag is too heavy to carry alone.",
    "bn": "এই ব্যাগটি একা বহন করার জন্য খুব ভারী।",
    "level": "N5"
  },
  {
    "id": "s455",
    "jp": "風が吹いて、木の葉が落ちました。",
    "romaji": "Kaze ga fuite, ki no ha ga ochimashita.",
    "en": "The wind blew and the leaves fell.",
    "bn": "বাতাস বইছে এবং পাতাগুলো ঝরছে।",
    "level": "N5"
  },
  {
    "id": "s456",
    "jp": "昨日のテストは、思ったより難しかったです。",
    "romaji": "Kinou no tesuto wa, omotta yori muzukashikatta desu.",
    "en": "Yesterday's test was more difficult than I thought.",
    "bn": "গতকাল ছুটির দিন ছিল, তাই আমি পরিবারের সাথে চিড়িয়াখানায় গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s457",
    "jp": "この問題は、誰でも分かるほど易しいです。",
    "romaji": "Kono mondai wa, dare demo wakaru hodo yasashii desu.",
    "en": "This problem is so easy that anyone can understand it.",
    "bn": "এই সমস্যাটি এতই সহজ যে যেকেউ বুঝতে পারবে।",
    "level": "N5"
  },
  {
    "id": "s458",
    "jp": "日本のアニメを見るのは、とても面白いです。",
    "romaji": "Nihon no anime wo miru no wa, totemo omoshiroi desu.",
    "en": "Watching Japanese anime is very interesting.",
    "bn": "জাপানি অ্যানিমে দেখা খুব মজার।",
    "level": "N5"
  },
  {
    "id": "s459",
    "jp": "父は忙しくて、夜遅く家に帰ります。",
    "romaji": "Chichi wa isogashikute, yoru osoku ie ni kaerimasu.",
    "en": "My father is busy and returns home late at night.",
    "bn": "আমার বাবা খুব ব্যস্ত এবং গভীর রাতে বাড়ি ফেরেন।",
    "level": "N5"
  },
  {
    "id": "s460",
    "jp": "図書館は、静かで勉強しやすい場所です。",
    "romaji": "Toshokan wa, shizuka de benkyou yasui basho desu.",
    "en": "The library is a quiet and easy place to study.",
    "bn": "লাইব্রেরি পড়াশোনার জন্য একটি শান্ত এবং সহজ জায়গা।",
    "level": "N5"
  },
  {
    "id": "s461",
    "jp": "スマートフォンの地図は、とても便利です。",
    "romaji": "Sumaatofon no chizu wa, totemo benri desu.",
    "en": "Smartphone maps are very convenient.",
    "bn": "স্মার্টফোনের ম্যাপ খুব সুবিধাজনক।",
    "level": "N5"
  },
  {
    "id": "s462",
    "jp": "あの人は、世界中で有名な歌手です。",
    "romaji": "Ano hito wa, sekaijuu de yuumei na kashu desu.",
    "en": "That person is a singer famous all over the world.",
    "bn": "ঐ ব্যক্তিটি বিশ্বজুড়ে পরিচিত একজন গায়ক।",
    "level": "N5"
  },
  {
    "id": "s463",
    "jp": "私は、甘いお菓子が大好きです。",
    "romaji": "Watashi wa, amai okashi ga daisuki desu.",
    "en": "I love sweet snacks.",
    "bn": "আমি মিষ্টি খাবার খুব পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s464",
    "jp": "賑やかな街より、静かな村が好きです。",
    "romaji": "Nigiyaka na machi yori, shizuka na mura ga suki desu.",
    "en": "I like quiet villages more than lively towns.",
    "bn": "আমি কোলাহলপূর্ণ শহরের চেয়ে শান্ত গ্রাম বেশি পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s465",
    "jp": "田中さんは、ピアノを弾くのが上手です。",
    "romaji": "Tanaka-san wa, piano wo hiku no ga jouzu desu.",
    "en": "Mr. Tanaka is good at playing the piano.",
    "bn": "তানাকা-সান পিয়ানো বাজাতে খুব দক্ষ।",
    "level": "N5"
  },
  {
    "id": "s466",
    "jp": "私は絵を描くのが下手ですが、描くのは楽しいです。",
    "romaji": "Watashi wa e wo kaku no ga heta desu ga, kaku no wa tanoshii desu.",
    "en": "I am bad at drawing, but it is fun to do.",
    "bn": "আমি ছবি আঁকায় কাঁচা, তবে এটি করতে মজা লাগে।",
    "level": "N5"
  },
  {
    "id": "s467",
    "jp": "お母さんの料理は、いつも美味しいです。",
    "romaji": "Okaasan no ryouri wa, itsumo oishii desu.",
    "en": "My mother's cooking is always delicious.",
    "bn": "আমার মা তার রান্নার জন্য গর্ববোধ করেন।",
    "level": "N5"
  },
  {
    "id": "s468",
    "jp": "部屋を綺麗にして、気持ちがよくなりました。",
    "romaji": "Heya wo kirei ni shite, kimochi ga yokunarimashita.",
    "en": "I felt better after cleaning the room.",
    "bn": "ঘর পরিষ্কার করার পর আমার ভালো লাগছে।",
    "level": "N5"
  },
  {
    "id": "s469",
    "jp": "駅の前は、いつも人が多くて賑やかです。",
    "romaji": "Eki no mae wa, itsumo hito ga ookute nigiyaka desu.",
    "en": "The area in front of the station is always crowded and lively.",
    "bn": "স্টেশনের সামনের জায়গাটি সবসময় জনাকীর্ণ এবং প্রাণবন্ত থাকে।",
    "level": "N5"
  },
  {
    "id": "s470",
    "jp": "庭に、綺麗な花がたくさん咲いています。",
    "romaji": "Niwa ni, kirei na hana ga takusan saite imasu.",
    "en": "Many beautiful flowers are blooming in the garden.",
    "bn": "বাগানে অনেক সুন্দর ফুল ফুটেছে।",
    "level": "N5"
  },
  {
    "id": "s471",
    "jp": "明日は休みなので、一日中暇です。",
    "romaji": "Ashita wa yasumi na node, ichinichijuu hima desu.",
    "en": "Tomorrow is a holiday, so I will be free all day.",
    "bn": "আগামীকাল ছুটির দিন, তাই আমি সারাদিন অবসর থাকব।",
    "level": "N5"
  },
  {
    "id": "s472",
    "jp": "困っている時に、親切な人に助けられました。",
    "romaji": "Komatte iru toki ni, shinsetsu na hito ni tasukeraremashita.",
    "en": "When I was in trouble, a kind person helped me.",
    "bn": "আমি যখন বিপদে পড়েছিলাম, একজন দয়ালু মানুষ আমাকে সাহায্য করেছিলেন।",
    "level": "N5"
  },
  {
    "id": "s473",
    "jp": "おじいさんは、毎日散歩をしていて元気です。",
    "romaji": "Ojiisan wa, mainichi sanpo wo shite ite genki desu.",
    "en": "My grandfather is energetic and goes for a walk every day.",
    "bn": "আমার দাদা খুব উদ্যমী এবং প্রতিদিন হাঁটতে যান।",
    "level": "N5"
  },
  {
    "id": "s474",
    "jp": "机の上に、新しい本が三冊あります。",
    "romaji": "Tsukue no ue ni, atarashii hon ga sansatsu arimasu.",
    "en": "There are three new books on the desk.",
    "bn": "ডেস্কের উপর তিনটি নতুন বই আছে।",
    "level": "N5"
  },
  {
    "id": "s475",
    "jp": "公園のベンチに、椅子が四つ並んでいます。",
    "romaji": "Kouen no benchi ni, isu ga yottsu narande imasu.",
    "en": "Four chairs are lined up on the park bench.",
    "bn": "পার্কের বেঞ্চে চারটি চেয়ার সারিবদ্ধভাবে রাখা আছে।",
    "level": "N5"
  },
  {
    "id": "s476",
    "jp": "私の家には、可愛い猫が一匹います。",
    "romaji": "Watashi no ie ni wa, kawaii neko ga ippiki imasu.",
    "en": "There is one cute cat in my house.",
    "bn": "আমার বাড়িতে একটি কিউট বিড়াল আছে।",
    "level": "N5"
  },
  {
    "id": "s477",
    "jp": "近所の庭で、犬が二匹走っています。",
    "romaji": "Kinjo no niwa de, inu ga nihiki hashitte imasu.",
    "en": "Two dogs are running in the neighbor's garden.",
    "bn": "প্রতিবেশীর বাগানে দুটি কুকুর দৌড়াদৌড়ি করছে।",
    "level": "N5"
  },
  {
    "id": "s478",
    "jp": "冷蔵庫の中に、リンゴが六つ入っています。",
    "romaji": "Reizouko no naka ni, ringo ga muttsu haitte imasu.",
    "en": "There are six apples in the refrigerator.",
    "bn": "ফ্রিজে ছয়টি আপেল আছে।",
    "level": "N5"
  },
  {
    "id": "s479",
    "jp": "毎朝、六時半にアラームが鳴ります。",
    "romaji": "Maiasa, rokujihan ni araamu ga narimasu.",
    "en": "The alarm goes off at 6:30 every morning.",
    "bn": "প্রতিদিন সকাল ৬:৩০ মিনিটে অ্যালার্ম বাজে।",
    "level": "N5"
  },
  {
    "id": "s480",
    "jp": "朝ご飯は、いつもパンとコーヒーです。",
    "romaji": "Asagohan wa, itsumo pan to koohii desu.",
    "en": "Breakfast is always bread and coffee.",
    "bn": "সকালর নাস্তা সবসময় পাউরুটি এবং কফি হয়।",
    "level": "N5"
  },
  {
    "id": "s481",
    "jp": "急いで家を出ましたが、電車に間に合いませんでした。",
    "romaji": "Isoide ie wo demashita ga, densha ni maniaimasen deshita.",
    "en": "I left home in a hurry, but I didn't make it in time for the train.",
    "bn": "আমি তাড়াহুড়ো করে বাড়ি থেকে বের হয়েছি, কিন্তু কিছুই ভুলিনি।",
    "level": "N5"
  },
  {
    "id": "s482",
    "jp": "九時のバスに乗って、学校へ行きます。",
    "romaji": "Kuji no basu ni notte, gakkou e ikimasu.",
    "en": "I take the 9 o'clock bus to school.",
    "bn": "আমি প্রতিদিন সকাল ৯টার ট্রেনে উঠি।",
    "level": "N5"
  },
  {
    "id": "s483",
    "jp": "お昼休みは、いつも友達とお喋りします。",
    "romaji": "Ohiruyasumi wa, itsumo tomodachi to oshaberi shimasu.",
    "en": "During lunch break, I always chat with friends.",
    "bn": "দুপুরের খাবারের বিরতিতে আমি সবসময় বন্ধুদের সাথে আড্ডা দিই।",
    "level": "N5"
  },
  {
    "id": "s484",
    "jp": "今日の仕事は、予定より早く終わりました。",
    "romaji": "Kyou no shigoto wa, yotei yori hayaku owarimashita.",
    "en": "Today's work finished earlier than planned.",
    "bn": "আজকের আবহাওয়া হাঁটার জন্য খুব মনোরম।",
    "level": "N5"
  },
  {
    "id": "s485",
    "jp": "夕食の前に、スーパーへ買い物に行きます。",
    "romaji": "Yuushoku no mae ni, suupaa e kaimono ni ikimasu.",
    "en": "I go shopping at the supermarket before dinner.",
    "bn": "আমি রাতের খাবারের আগে সুপারমার্কেট থেকে কেনাকাটা করি।",
    "level": "N5"
  },
  {
    "id": "s486",
    "jp": "夜は、ゆっくりお風呂に入って休みます。",
    "romaji": "Yoru wa, yukkuri ofuro ni haitte yasumimasu.",
    "en": "At night, I take a long bath and rest.",
    "bn": "রাতে আমি দীর্ঘক্ষণ গোসল করি এবং বিশ্রাম নিই।",
    "level": "N5"
  },
  {
    "id": "s487",
    "jp": "日本に来てから、半年が経ちました。",
    "romaji": "Nihon ni kite kara, hantoshi ga tachimashita.",
    "en": "Half a year has passed since I came to Japan.",
    "bn": "আমি জাপানে আসার পর ছয় মাস হয়ে গেছে।",
    "level": "N5"
  },
  {
    "id": "s488",
    "jp": "来週の月曜日に、日本語の試験があります。",
    "romaji": "Raishuu no getsuyoubi ni, nihongo no shiken ga arimasu.",
    "en": "There is a Japanese exam next Monday.",
    "bn": "আগামী সোমবার জাপানি পরীক্ষা আছে।",
    "level": "N5"
  },
  {
    "id": "s489",
    "jp": "暇な時は、よく音楽を聴きながら散歩します。",
    "romaji": "Hima na toki wa, yoku ongaku wo kikinagara sanpo shimasu.",
    "en": "When I am free, I often take a walk while listening to music.",
    "bn": "অবসর সময়ে আমি প্রায়ই গান শুনতে শুনতে হাঁটি।",
    "level": "N5"
  },
  {
    "id": "s490",
    "jp": "週末は、家で映画を見たり本を読んだりします。",
    "romaji": "Shuumatsu wa, ie de eiga wo mitari hon wo yondari shimasu.",
    "en": "On weekends, I do things like watch movies and read books at home.",
    "bn": "সপ্তাহান্তে আমি বাড়িতে সিনেমা দেখি এবং বই পড়ি।",
    "level": "N5"
  },
  {
    "id": "s491",
    "jp": "来年の夏、国へ帰るつもりです。",
    "romaji": "Rainen no natsu, kuni e kaeru tsumori desu.",
    "en": "I intend to return to my country next summer.",
    "bn": "আমি আগামী গ্রীষ্মে দেশে ফেরার পরিকল্পনা করছি।",
    "level": "N5"
  },
  {
    "id": "s492",
    "jp": "誕生日に、兄に時計をもらいました。",
    "romaji": "Tanjoubi ni, ani ni tokei wo moraimashita.",
    "en": "I received a watch from my older brother for my birthday.",
    "bn": "জন্মদিনে বড় ভাইয়ের কাছ থেকে একটি ঘড়ি পেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s493",
    "jp": "友達に、日本の切手をあげました。",
    "romaji": "Tomodachi ni, nihon no kitte wo agemashita.",
    "en": "I gave my friend some Japanese stamps.",
    "bn": "আমি আমার বন্ধুকে কিছু জাপানি স্ট্যাম্প দিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s494",
    "jp": "この漢字の書き方を、教えてくれませんか。",
    "romaji": "Kono kanji no kakikata wo, oshiete kuremasen ka?",
    "en": "Could you please teach me how to write this kanji?",
    "bn": "আপনি কি দয়া করে আমাকে এই কাঞ্জিটি লেখার নিয়ম শিখিয়ে দেবেন?",
    "level": "N5"
  },
  {
    "id": "s495",
    "jp": "外は雨が降っているので、気をつけてください。",
    "romaji": "Soto wa ame ga futte iru node, ki wo tsukete kudasai.",
    "en": "It is raining outside, so please be careful.",
    "bn": "বাইরে বৃষ্টি পড়ছে, তাই সাবধানে থাকবেন।",
    "level": "N5"
  },
  {
    "id": "s496",
    "jp": "明日、一緒に図書館へ行きませんか。",
    "romaji": "Ashita, issho ni toshokan e ikimasen ka?",
    "en": "Would you like to go to the library together tomorrow?",
    "bn": "আগামীকাল কি আমার সাথে লাইব্রেরিতে যাবেন?",
    "level": "N5"
  },
  {
    "id": "s497",
    "jp": "この鞄は、昨日デパートで買いました。",
    "romaji": "Kono kaban wa, kinou depaato de kaimashita.",
    "en": "I bought this bag yesterday at the department store.",
    "bn": "আমি এই ব্যাগটি গতকাল ডিপার্টমেন্টাল স্টোর থেকে কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s498",
    "jp": "日本語はまだ下手ですが、話すのは楽しいです。",
    "romaji": "Nihongo wa mada heta desu ga, hanasu no wa tanoshii desu.",
    "en": "My Japanese is still bad, but it is fun to speak.",
    "bn": "আমার জাপানি এখনও কাঁচা, তবে কথা বলতে ভালো লাগে।",
    "level": "N5"
  },
  {
    "id": "s499",
    "jp": "毎晩、寝る前に日記を書いています。",
    "romaji": "Maiban, neru mae ni nikki wo kaite imasu.",
    "en": "Every night, I write in my diary before going to bed.",
    "bn": "প্রতি রাতে ঘুমনোর আগে আমি ডায়েরি লিখি।",
    "level": "N5"
  },
  {
    "id": "s500",
    "jp": "日本での生活は、とても充実していて楽しいです。",
    "romaji": "Nihon de no seikatsu wa, totemo juujitsu shite ite tanoshii desu.",
    "en": "Life in Japan is very fulfilling and fun.",
    "bn": "জাপানের জীবন খুবই ঘটনাবহুল এবং মনোরম।",
    "level": "N5"
  },
  {
    "id": "s501",
    "jp": "毎日、漢字を練習しなければなりません。",
    "romaji": "Mainichi, kanji wo renshuu shinakereba narimasen.",
    "en": "I must practice kanji every day.",
    "bn": "প্রতিদিন কাঞ্জি অনুশীলন করতে হবে।",
    "level": "N4"
  },
  {
    "id": "s502",
    "jp": "宿題を忘れて、先生に叱られました。",
    "romaji": "Shukudai wo wasurete, sensei ni shikararemashita.",
    "en": "I forgot my homework and was scolded by the teacher.",
    "bn": "হোমওয়ার্ক ভুলে যাওয়ায় শিক্ষক বকা দিয়েছেন।",
    "level": "N4"
  },
  {
    "id": "s503",
    "jp": "雨が降りそうなので、傘を持って行きます。",
    "romaji": "Ame ga furisou na node, kasa wo motte ikimasu.",
    "en": "It looks like it will rain, so I will take an umbrella.",
    "bn": "বৃষ্টি হতে পারে মনে হচ্ছে, তাই ছাতা সাথে নিচ্ছি।",
    "level": "N4"
  },
  {
    "id": "s504",
    "jp": "日本食の中で、寿司が一番好きです。",
    "romaji": "Nihonshoku no naka de, sushi ga ichiban suki desu.",
    "en": "Among Japanese food, I like sushi the most.",
    "bn": "জাপানি খাবারের মধ্যে সুশি আমার সবচেয়ে প্রিয়।",
    "level": "N5"
  },
  {
    "id": "s505",
    "jp": "テレビを消してもいいですか。",
    "romaji": "Terebi wo keshite mo ii desu ka?",
    "en": "May I turn off the TV?",
    "bn": "টিভিটা কি বন্ধ করতে পারি?",
    "level": "N5"
  },
  {
    "id": "s506",
    "jp": "窓を開けると、涼しい風が入ってきました。",
    "romaji": "Mado wo akeru to, suzushii kaze ga haitte kimashita.",
    "en": "When I opened the window, a cool breeze came in.",
    "bn": "জানালা খুলতেই ঠান্ডা বাতাস ভেতরে এল।",
    "level": "N4"
  },
  {
    "id": "s507",
    "jp": "駅まで歩いて、十五分くらいかかります。",
    "romaji": "Eki made aruite, juugofun kurai kakarimasu.",
    "en": "It takes about 15 minutes to walk to the station.",
    "bn": "স্টেশন পর্যন্ত হেঁটে যেতে প্রায় ১৫ মিনিট লাগে।",
    "level": "N5"
  },
  {
    "id": "s508",
    "jp": "試験のために、一生懸命勉強しました。",
    "romaji": "Shiken no tame ni, isshoukenmei benkyou shimashita.",
    "en": "I studied very hard for the exam.",
    "bn": "পরীক্ষার জন্য আমি প্রাণপণ পড়াশোনা করেছি।",
    "level": "N4"
  },
  {
    "id": "s509",
    "jp": "この本を読んだら、返してください。",
    "romaji": "Kono hon wo yondara, kaeshite kudasai.",
    "en": "When you finish reading this book, please return it.",
    "bn": "বইটি পড়া শেষ হলে দয়া করে ফেরত দেবেন।",
    "level": "N4"
  },
  {
    "id": "s510",
    "jp": "辞書を使わずに、新聞を読みたいです。",
    "romaji": "Jisho wo tsukawazu ni, shinbun wo yomitai desu.",
    "en": "I want to read the newspaper without using a dictionary.",
    "bn": "ডিকশনারি ছাড়াই আমি সংবাদপত্র পড়তে চাই।",
    "level": "N4"
  },
  {
    "id": "s511",
    "jp": "昨日の夜は、星がとても綺麗でした。",
    "romaji": "Kinou no yoru wa, hoshi ga totemo kirei deshita.",
    "en": "The stars were very beautiful last night.",
    "bn": "কাল রাতে তারাগুলো খুব চমৎকার লাগছিল।",
    "level": "N5"
  },
  {
    "id": "s512",
    "jp": "公園で、子供たちが元気に遊んでいます。",
    "romaji": "Kouen de, kodomotachi ga genki ni asonde imasu.",
    "en": "Children are playing energetically in the park.",
    "bn": "পার্কে বাচ্চারা খুব আনন্দ সহকারে খেলা করছে।",
    "level": "N5"
  },
  {
    "id": "s513",
    "jp": "日本の冬は、とても寒くて空気が乾燥しています。",
    "romaji": "Nihon no fuyu wa, totemo samukute kuuki ga kansou shite imasu.",
    "en": "Winter in Japan is very cold and the air is dry.",
    "bn": "জাপানে শীত বেশ জাঁকিয়ে পড়ে এবং বাতাস খুব শুষ্ক থাকে।",
    "level": "N4"
  },
  {
    "id": "s514",
    "jp": "忙しくて、昼ご飯を食べる時間がありませんでした。",
    "romaji": "Isogashikute, hirugohan wo taberu jikan ga arimasen deshita.",
    "en": "I was busy and didn't have time to eat lunch.",
    "bn": "ব্যস্ততার কারণে দুপুরে খাওয়ার সময় পাইনি।",
    "level": "N5"
  },
  {
    "id": "s515",
    "jp": "将来、世界旅行をしたいと思っています。",
    "romaji": "Shourai, sekai ryokou wo shitai to omotte imasu.",
    "en": "I want to travel around the world in the future.",
    "bn": "ভবিষ্যতে আমার বিশ্বভ্রমণের ইচ্ছা আছে।",
    "level": "N4"
  },
  {
    "id": "s516",
    "jp": "財布を落として、困っています。",
    "romaji": "Saifu wo otoshite, komatte imasu.",
    "en": "I dropped my wallet and am in trouble.",
    "bn": "মানিব্যাগ হারিয়ে আমি খুব বিপদে পড়েছি।",
    "level": "N5"
  },
  {
    "id": "s517",
    "jp": "お腹が空いたので、何か食べましょう。",
    "romaji": "Onaka ga suita node, nanika tabemashou.",
    "en": "I'm hungry, so let's eat something.",
    "bn": "লক্ষী খিদে পেয়েছে, চলুন কিছু খেয়ে নিই।",
    "level": "N5"
  },
  {
    "id": "s518",
    "jp": "風邪の時は、温かい飲み物を飲んで寝るのが一番です。",
    "romaji": "Kaze no toki wa, atatakai nomimono wo nonde neru no ga ichiban desu.",
    "en": "When you have a cold, it's best to drink warm drinks and sleep.",
    "bn": "ঠান্ডা লাগলে গরম পানীয় খেয়ে ঘুমিয়ে থাকা সবচেয়ে ভালো।",
    "level": "N4"
  },
  {
    "id": "s519",
    "jp": "あの映画は、とても感動的でした。",
    "romaji": "Ano eiga wa, totemo kandouteki deshita.",
    "en": "That movie was very moving.",
    "bn": "সিনেমাটি মন ছুঁয়ে যাওয়ার মতো ছিল।",
    "level": "N4"
  },
  {
    "id": "s520",
    "jp": "朝、鳥の鳴き声で目が覚めました。",
    "romaji": "Asa, tori no nakigoe de me ga samemashita.",
    "en": "I woke up in the morning to the sound of birds singing.",
    "bn": "ভোরে পাখির কিচিরমিচির শব্দে আমার ঘুম ভাঙল।",
    "level": "N5"
  },
  {
    "id": "s521",
    "jp": "新しい靴を買ったので、散歩に行くのが楽しみです。",
    "romaji": "Atarashii kutsu wo katta node, sanpo ni iku no ga tanoshimi desu.",
    "en": "Since I bought new shoes, I'm looking forward to going for a walk.",
    "bn": "নতুন জুতো কিনেছি, তাই এখন হাঁটতে যাওয়ার জন্য উৎসাহ পাচ্ছি।",
    "level": "N5"
  },
  {
    "id": "s522",
    "jp": "日本語の会話が、もっと上手になりたいです。",
    "romaji": "Nihongo no kaiwa ga, motto jouzu ni naritai desu.",
    "en": "I want to become better at Japanese conversation.",
    "bn": "জাপানি কথোপকথনে আমি আরও দক্ষ হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s523",
    "jp": "母に頼まれて、買い物に行きました。",
    "romaji": "Haha ni tanomarete, kaimono ni ikimashita.",
    "en": "Requested by my mother, I went shopping.",
    "bn": "মায়ের কথামতো আমি বাজারে গিয়েছি।",
    "level": "N4"
  },
  {
    "id": "s524",
    "jp": "デパートへ行けば、何でも揃います。",
    "romaji": "Depaato e ikeba, nandemo soroimasu.",
    "en": "If you go to the department store, you can find everything.",
    "bn": "ডিপার্টমেন্টাল স্টোরে গেলে সব কিছুই পাওয়া যায়।",
    "level": "N4"
  },
  {
    "id": "s525",
    "jp": "地震の時は、慌てずに外へ出てください。",
    "romaji": "Jishin no toki wa, awatezu ni soto e dete kudasai.",
    "en": "In case of an earthquake, please go outside without panicking.",
    "bn": "ভূমিকম্পের সময় আতঙ্কিত না হয়ে বাইরে বেরিয়ে আসুন।",
    "level": "N4"
  },
  {
    "id": "s526",
    "jp": "あの人は、いつも笑顔で親切です。",
    "romaji": "Ano hito wa, itsumo egao de shinsetsu desu.",
    "en": "That person is always smiling and kind.",
    "bn": "ঐ মানুষটি সবসময় হাসিমুখে থাকেন এবং দয়ালু।",
    "level": "N5"
  },
  {
    "id": "s527",
    "jp": "美味しいケーキの作り方を、教えてください。",
    "romaji": "Oishii keeki no tsukurikata wo, oshiete kudasai.",
    "en": "Please teach me how to make a delicious cake.",
    "bn": "চমৎকার কেক তৈরির নিয়মটা কি একটু শেখাবেন?",
    "level": "N5"
  },
  {
    "id": "s528",
    "jp": "来週の週末、一緒に海へ行きませんか。",
    "romaji": "Raishuu no shuumatsu, issho ni umi e ikimasen ka?",
    "en": "Would you like to go to the sea together next weekend?",
    "bn": "আগামী সপ্তাহের ছুটিতে কি আমার সাথে সমুদ্রতীরে যাবেন?",
    "level": "N5"
  },
  {
    "id": "s529",
    "jp": "弟は、スポーツが得意で足が速いです。",
    "romaji": "Otouto wa, supootsu ga tokui de ashi ga hayai desu.",
    "en": "My younger brother is good at sports and can run fast.",
    "bn": "আমার ছোট ভাই খেলাধুলায় পটু এবং বেশ জোরে দৌড়াতে পারে।",
    "level": "N4"
  },
  {
    "id": "s530",
    "jp": "写真を撮ってもいいですが、フラッシュは使わないでください。",
    "romaji": "Shashin wo totte mo ii desu ga, furasshu wa tsukawanai de kudasai.",
    "en": "You may take photos, but please do not use flash.",
    "bn": "ছবি তোলা যাবে, তবে দয়া করে ফ্ল্যাশ ব্যবহার করবেন না।",
    "level": "N4"
  },
  {
    "id": "s531",
    "jp": "日本語を勉強し始めて、もう三年になります。",
    "romaji": "Nihongo wo benkyou shihajimete, mou sannen ni narimasu.",
    "en": "It has been three years since I started studying Japanese.",
    "bn": "জাপানি ভাষা শেখা শুরু করার এখন তিন বছর হতে চলল।",
    "level": "N4"
  },
  {
    "id": "s532",
    "jp": "駅の前にあるパン屋は、いつも混んでいます。",
    "romaji": "Eki no mae ni aru panya wa, itsumo konde imasu.",
    "en": "The bakery in front of the station is always crowded.",
    "bn": "স্টেশনের সামনের পাউরুটির দোকানে সবসময় ভিড় থাকে।",
    "level": "N5"
  },
  {
    "id": "s533",
    "jp": "健康のために、毎朝野菜ジュースを飲んでいます。",
    "romaji": "Kenkou no tame ni, maiasa yasai juusu wo nonde imasu.",
    "en": "For my health, I drink vegetable juice every morning.",
    "bn": "স্বাস্থ্যের কথা ভেবে আমি রোজ সকালে সবজির রস খাই।",
    "level": "N4"
  },
  {
    "id": "s534",
    "jp": "あの赤い服を着ている人は、私の姉です。",
    "romaji": "Ano akai fuku wo kite iru hito wa, watashi no ane desu.",
    "en": "The person wearing that red dress is my older sister.",
    "bn": "ঐ লাল পোশাক পরা মানুষটি আমার বড় বোন।",
    "level": "N5"
  },
  {
    "id": "s535",
    "jp": "料理が上手になりたいので、料理教室に通っています。",
    "romaji": "Ryouri ga jouzu ni naritai node, ryourikyoushitsu ni kayotte imasu.",
    "en": "I want to be good at cooking, so I am attending a cooking class.",
    "bn": "রান্নায় দক্ষ হওয়ার জন্য আমি এখন কুকিং ক্লাসে যাচ্ছি।",
    "level": "N4"
  },
  {
    "id": "s536",
    "jp": "昨日の散歩の時に、綺麗な花を見つけました。",
    "romaji": "Kinou no sanpo no toki ni, kirei na hana wo mitsukemashita.",
    "en": "During yesterday's walk, I found a beautiful flower.",
    "bn": "গতকাল হাঁটার সময় একটি চমৎকার ফুল দেখতে পেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s537",
    "jp": "コーヒーを飲みながら、ゆっくり本を読むのが好きです。",
    "romaji": "Koohii wo nominagara, yukkuri hon wo yomu no ga suki desu.",
    "en": "I like reading a book leisurely while drinking coffee.",
    "bn": "কফি খেতে খেতে সময় নিয়ে বই পড়তে আমি ভালোবাসি।",
    "level": "N4"
  },
  {
    "id": "s538",
    "jp": "学校の近くに、新しい図書館ができました。",
    "romaji": "Gakkou no chikaku ni, atarashii toshokan ga dekimashita.",
    "en": "A new library was built near the school.",
    "bn": "স্কুলের কাছে একটি নতুন লাইব্রেরি তৈরি হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s539",
    "jp": "おじいさんは、昔の話をよくしてくれます。",
    "romaji": "Ojiisan wa, mukashi no hanashi wo yoku shite kuremasu.",
    "en": "My grandfather often tells me stories from the past.",
    "bn": "দাদা আমাকে প্রায়ই পুরনো দিনের গল্প শোনান।",
    "level": "N5"
  },
  {
    "id": "s540",
    "jp": "この問題について、どう思いますか。",
    "romaji": "Kono mondai ni tsuite, dou omoimasu ka?",
    "en": "What do you think about this problem?",
    "bn": "এই সমস্যাটি সম্পর্কে আপনার অভিমত কী?",
    "level": "N4"
  },
  {
    "id": "s541",
    "jp": "日本へ行く前に、お土産を買っておきました。",
    "romaji": "Nihon e iku mae ni, omiyage wo katte okimashita.",
    "en": "I bought some souvenirs before going to Japan.",
    "bn": "জাপান যাওয়ার আগেই আমি কিছু উপহার কিনে রেখেছি।",
    "level": "N4"
  },
  {
    "id": "s542",
    "jp": "外で遊んでいた子供たちが、家に戻ってきました。",
    "romaji": "Soto de asonde ita kodomotachi ga, ie ni modotte kimashita.",
    "en": "The children who were playing outside returned home.",
    "bn": "বাইরে খেলা করা বাচ্চারা ঘরে ফিরে এসেছে।",
    "level": "N5"
  },
  {
    "id": "s543",
    "jp": "この仕事は、一人でするには大変すぎます。",
    "romaji": "Kono shigoto wa, hitori de suru ni wa taihensugimasu.",
    "en": "This job is too tough to do alone.",
    "bn": "একলা করার জন্য এই কাজটি বেশ কঠিন।",
    "level": "N4"
  },
  {
    "id": "s544",
    "jp": "天気が良ければ、明日山に登りに行くつもりです。",
    "romaji": "Tenki ga yokereba, ashita yama ni nobori ni iku tsumori desu.",
    "en": "If the weather is good, I intend to go mountain climbing tomorrow.",
    "bn": "আবহাওয়া ভালো থাকলে আগামীকাল পাহাড়ে ওঠার পরিকল্পনা আছে।",
    "level": "N4"
  },
  {
    "id": "s545",
    "jp": "日本語の歌を歌うのが、最近の趣味です。",
    "romaji": "Nihongo no uta wo utau no ga, saikin no shumi desu.",
    "en": "Singing Japanese songs is my recent hobby.",
    "bn": "জাপানি গান গাওয়া এখন আমার সাম্প্রতিক শখ।",
    "level": "N5"
  },
  {
    "id": "s546",
    "jp": "疲れたら、無理をしないで休んでください。",
    "romaji": "Tsukaretara, muri wo shinaide yasunde kudasai.",
    "en": "If you are tired, please rest without overdoing it.",
    "bn": "ক্লান্ত লাগলে জোর না করে একটু জিরিয়ে নিন।",
    "level": "N4"
  },
  {
    "id": "s547",
    "jp": "美味しいお寿司の店を、知っていますか。",
    "romaji": "Oishii osushi no mise wo, shitte imasu ka?",
    "en": "Do you know a good sushi restaurant?",
    "bn": "ভালো সুশি পাওয়া যায় এমন কোনো দোকানের নাম জানেন?",
    "level": "N5"
  },
  {
    "id": "s548",
    "jp": "先生の説明は、とても分かりやすかったです。",
    "romaji": "Sensei no setsumei wa, totemo wakariyasukatta desu.",
    "en": "The teacher's explanation was very clear.",
    "bn": "শিক্ষকের ব্যাখ্যাটি খুব সহজবোধ্য ছিল।",
    "level": "N5"
  },
  {
    "id": "s549",
    "jp": "日本の生活に、だんだん慣れてきました。",
    "romaji": "Nihon no seikatsu ni, dandan narete kimashita.",
    "en": "I am gradually getting used to life in Japan.",
    "bn": "জাপানের জীবনের সাথে আমি ধীরে ধীরে মানিয়ে নিচ্ছি।",
    "level": "N4"
  },
  {
    "id": "s550",
    "jp": "感謝の気持ちを込めて、プレゼントを贈りました。",
    "romaji": "Kansha no kimochi wo komete, purezento wo okurimashita.",
    "en": "I sent a gift with a feeling of gratitude.",
    "bn": "কৃতজ্ঞতা স্বরূপ আমি একটি উপহার পাঠিয়েছি।",
    "level": "N4"
  },
  {
    "id": "s551",
    "jp": "外は暗いので、一人で出かけないでください。",
    "romaji": "Soto wa kurai node, hitori de dekakenai de kudasai.",
    "en": "It is dark outside, so please do not go out alone.",
    "bn": "বাইরে অন্ধকার, তাই একা বেরোবেন না।",
    "level": "N5"
  },
  {
    "id": "s552",
    "jp": "私の夢は、日本の大学で勉強することです。",
    "romaji": "Watashi no yume wa, nihon no daigaku de benkyou suru koto desu.",
    "en": "My dream is to study at a Japanese university.",
    "bn": "আমার স্বপ্ন হলো জাপানি বিশ্ববিদ্যালয়ে পড়াশোনা করা।",
    "level": "N5"
  },
  {
    "id": "s553",
    "jp": "この靴は、軽くてとても歩きやすいです।",
    "romaji": "Kono kutsu wa, karukute totemo arukiyasui desu.",
    "en": "These shoes are light and very easy to walk in.",
    "bn": "এই জুতোগুলো হালকা এবং হাঁটতে খুব আরামদায়ক।",
    "level": "N5"
  },
  {
    "id": "s554",
    "jp": "明日の朝七時に、駅の改札口で待ち合わせましょう。",
    "romaji": "Ashita no asa shichiji ni, eki no kaisatsuguchi de machiawasemashou.",
    "en": "Let's meet at the station ticket gate at 7 AM tomorrow.",
    "bn": "আগামীকাল সকাল ৭টায় স্টেশনের টিকেট গেটের সামনে দেখা করা যাক।",
    "level": "N4"
  },
  {
    "id": "s555",
    "jp": "日本の食べ物の中で、天ぷらが一番好きです。",
    "romaji": "Nihon no tabemono no naka de, tenpura ga ichiban suki desu.",
    "en": "Among Japanese foods, I like Tempura the best.",
    "bn": "জাপানি খাবারের মধ্যে তেনপুরা আমার সবচেয়ে প্রিয়।",
    "level": "N5"
  },
  {
    "id": "s556",
    "jp": "風邪をひいた時は、ゆっくり休むのが一番です。",
    "romaji": "Kaze wo hiita toki wa, yukkuri yasumu no ga ichiban desu.",
    "en": "When you catch a cold, resting well is the best thing.",
    "bn": "ঠান্ডা লাগলে ভালোমতো বিশ্রাম নেওয়া সবচেয়ে জরুরি।",
    "level": "N5"
  },
  {
    "id": "s557",
    "jp": "将来、エンジニアになりたいと思っています。",
    "romaji": "Shourai, enjinia ni naritai to omotte imasu.",
    "en": "I want to become an engineer in the future.",
    "bn": "ভবিষ্যতে আমি একজন ইঞ্জিনিয়ার হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s558",
    "jp": "この本を読み終わったら、図書館に返します。",
    "romaji": "Kono hon wo yomiowattara, toshokan ni kaeshimasu.",
    "en": "When I finish reading this book, I will return it to the library.",
    "bn": "বইটি পড়া শেষ হলে আমি লাইব্রেরিতে ফেরত দেব।",
    "level": "N4"
  },
  {
    "id": "s559",
    "jp": "昨日のテストは、思ったより難しかったです。",
    "romaji": "Kinou no tesuto wa, omotta yori muzukashikatta desu.",
    "en": "Yesterday's test was harder than I thought.",
    "bn": "কালকের পরীক্ষাটি ধারণার চেয়ে বেশি কঠিন ছিল।",
    "level": "N4"
  },
  {
    "id": "s560",
    "jp": "父は、毎日遅くまで仕事をしています。",
    "romaji": "Chichi wa, mainichi osoku made shigoto wo shite imasu.",
    "en": "My father works late every day.",
    "bn": "আমার বাবা প্রতিদিন রাত পর্যন্ত কাজ করেন।",
    "level": "N5"
  },
  {
    "id": "s561",
    "jp": "美味しいケーキの作り方を教えてください。",
    "romaji": "Oishii keeki no tsukurikata wo oshiete kudasai.",
    "en": "Please teach me how to make a delicious cake.",
    "bn": "চমৎকার কেক তৈরির নিয়মটা কি আমাকে শেখাবেন?",
    "level": "N5"
  },
  {
    "id": "s562",
    "jp": "日本語の授業は、月曜日から金曜日まであります。",
    "romaji": "Nihongo no jugyou wa, getsuyoubi kara kinyoubi made arimasu.",
    "en": "Japanese classes are held from Monday to Friday.",
    "bn": "সোমবার থেকে শুক্রবার পর্যন্ত জাপানি ভাষার ক্লাস হয়।",
    "level": "N5"
  },
  {
    "id": "s563",
    "jp": "公園で、子供たちが楽しそうに遊んでいます。",
    "romaji": "Kouen de, kodomotachi ga tanoshisou ni asonde imasu.",
    "en": "Children are playing happily in the park.",
    "bn": "পার্কে বাচ্চারা খুব আনন্দের সাথে খেলা করছে।",
    "level": "N5"
  },
  {
    "id": "s564",
    "jp": "部屋を掃除してから、テレビを見ます。",
    "romaji": "Heya wo souji shite kara, terebi wo mimasu.",
    "en": "After cleaning the room, I will watch TV.",
    "bn": "ঘর পরিষ্কার করার পর আমি টিভি দেখব।",
    "level": "N5"
  },
  {
    "id": "s565",
    "jp": "日本へ行ったら、本物の桜を見たいです。",
    "romaji": "Nihon e ittara, honmono no sakura wo mitai desu.",
    "en": "If I go to Japan, I want to see real cherry blossoms.",
    "bn": "জাপানে গেলে আমি আসল সাকুরা ফুল দেখতে চাই।",
    "level": "N4"
  },
  {
    "id": "s566",
    "jp": "この料理は、少し辛いですが美味しいです。",
    "romaji": "Kono ryouri wa, sukoshi karai desu ga oishii desu.",
    "en": "This dish is a bit spicy but delicious.",
    "bn": "এই খাবারটি সামান্য ঝাল হলেও খুব সুস্বাদু।",
    "level": "N5"
  },
  {
    "id": "s567",
    "jp": "弟とテニスをするために、ラケットを買いました।",
    "romaji": "Otouto to tenisu wo suru tame ni, rakketto wo kaimashita.",
    "en": "I bought a racket to play tennis with my younger brother.",
    "bn": "ছোট ভাইয়ের সাথে টেনিস খেলার জন্য আমি একটি র‍্যাকেট কিনেছি।",
    "level": "N4"
  },
  {
    "id": "s568",
    "jp": "図書館では、静かにしなければなりません。",
    "romaji": "Toshokan dewa, shizuka ni shinakereba narimasen.",
    "en": "In the library, you must be quiet.",
    "bn": "লাইব্রেরিতে শান্ত থাকতে হবে।",
    "level": "N5"
  },
  {
    "id": "s569",
    "jp": "宿題を忘れないように、メモを書いておきました。",
    "romaji": "Shukudai wo wasurenai you ni, memo wo kaite okimashita.",
    "en": "I wrote a note so I wouldn't forget my homework.",
    "bn": "হোমওয়ার্ক যেন না ভুলি, সেজন্য আমি লিখে রেখেছি।",
    "level": "N4"
  },
  {
    "id": "s570",
    "jp": "雨が降っていたので、家でゆっくり本を読みました。",
    "romaji": "Ame ga futte ita node, ie de yukkuri hon wo yomimashita.",
    "en": "Since it was raining, I stayed home and read a book leisurely.",
    "bn": "বৃষ্টি হওয়ার কারণে আমি বাড়িতে সময় নিয়ে বই পড়েছি।",
    "level": "N5"
  },
  {
    "id": "s571",
    "jp": "駅の前にあるパン屋さんは、いつも混んでいます。",
    "romaji": "Eki no mae ni aru panyasan wa, itsumo konde imasu.",
    "en": "The bakery in front of the station is always crowded.",
    "bn": "স্টেশনের ধারের পাউরুটির দোকানে সবসময় ভিড় থাকে।",
    "level": "N5"
  },
  {
    "id": "s572",
    "jp": "日本に住んでいる友達から、手紙が届きました。",
    "romaji": "Nihon ni sunde iru tomodachi kara, tegami ga todokimashita.",
    "en": "I received a letter from a friend living in Japan.",
    "bn": "জাপানে থাকা এক বন্ধুর থেকে আমি চিঠি পেয়েছি।",
    "level": "N4"
  },
  {
    "id": "s573",
    "jp": "お腹が空いたので、何か食べに行きませんか।",
    "romaji": "Onaka ga suita node, nanika tabe ni ikimasen ka?",
    "en": "I'm hungry, would you like to go get something to eat?",
    "bn": "খিদে পেয়েছে, চলুন কিছু খেয়ে আসি।",
    "level": "N5"
  },
  {
    "id": "s574",
    "jp": "お誕生日、おめでとうございます。",
    "romaji": "Otanjoubi, omedetou gozaimasu.",
    "en": "Happy birthday!",
    "bn": "শুভ জন্মদিন!",
    "level": "N5"
  },
  {
    "id": "s575",
    "jp": "この問題について、グループで話し合ってください。",
    "romaji": "Kono mondai ni tsuite, guruupu de hanashiatte kudasai.",
    "en": "Please discuss this problem in your group.",
    "bn": "এই সমস্যাটি নিয়ে আপনাদের গ্রুপে আলোচনা করুন।",
    "level": "N4"
  },
  {
    "id": "s576",
    "jp": "健康のために、毎日ウォーキングをしています।",
    "romaji": "Kenkou no tame ni, mainichi uookingu wo shite imasu.",
    "en": "For my health, I go walking every day.",
    "bn": "সুস্থ থাকার জন্য আমি প্রতিদিন হাঁটি।",
    "level": "N5"
  },
  {
    "id": "s577",
    "jp": "先生の説明は、とても分かりやすかったです。",
    "romaji": "Sensei no setsumei wa, totemo wakariyasukatta desu.",
    "en": "The teacher's explanation was very easy to understand.",
    "bn": "শিক্ষকের ব্যাখ্যাটি খুব সহজবোধ্য ছিল।",
    "level": "N5"
  },
  {
    "id": "s578",
    "jp": "地震の時は、慌てずに外へ出てください।",
    "romaji": "Jishin no toki wa, awatezu ni soto e dete kudasai.",
    "en": "In the event of an earthquake, please go outside without panicking.",
    "bn": "ভূমিকম্পের সময় আতঙ্কিত না হয়ে বাইরে বেরিয়ে আসুন।",
    "level": "N4"
  },
  {
    "id": "s579",
    "jp": "日本語の会話が、もっと上手になりたいです。",
    "romaji": "Nihongo no kaiwa ga, motto jouzu ni naritai desu.",
    "en": "I want to become better at Japanese conversation.",
    "bn": "আমি জাপানি কথোপকথনে আরও দক্ষ হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s580",
    "jp": "朝早く起きて、散歩するのは気持ちがいいです。",
    "romaji": "Asa hayaku okite, sanpo suru no wa kimochi ga ii desu.",
    "en": "It feels good to wake up early and take a walk.",
    "bn": "ভোরে উঠে হাঁটাহাঁটি করা খুব সতেজ লাগে।",
    "level": "N5"
  },
  {
    "id": "s581",
    "jp": "日本の冬は、とても寒くて空気が乾燥しています。",
    "romaji": "Nihon no fuyu wa, totemo samukute kuuki ga kansou shite imasu.",
    "en": "Winter in Japan is very cold and the air is dry.",
    "bn": "জাপানে শীতকালে খুব ঠান্ডা পড়ে এবং বাতাস শুষ্ক থাকে।",
    "level": "N4"
  },
  {
    "id": "s582",
    "jp": "新しいカメラを買ったので、写真を撮るのが楽しみです。",
    "romaji": "Atarashii kamera wo katta node, shashin wo toru no ga tanoshimi desu.",
    "en": "Since I bought a new camera, I'm looking forward to taking photos.",
    "bn": "নতুন ক্যামেরা কিনেছি, তাই এখন ছবি তুলতে খুব ইচ্ছে করছে।",
    "level": "N5"
  },
  {
    "id": "s583",
    "jp": "風邪をひかないように、気をつけてください。",
    "romaji": "Kaze wo hikanai you ni, ki wo tsukete kudasai.",
    "en": "Please take care so you don't catch a cold.",
    "bn": "সাবধানে থাকবেন যেন ঠান্ডা না লেগে যায়।",
    "level": "N5"
  },
  {
    "id": "s584",
    "jp": "明日は雨が降るかもしれないので、傘を持って行きます।",
    "romaji": "Ashita wa ame ga furu kamo shirenai node, kasa wo motte ikimasu.",
    "en": "Since it might rain tomorrow, I will take an umbrella.",
    "bn": "কাল বৃষ্টি হতে পারে, তাই আমি ছাতা সাথে নিয়ে যাব।",
    "level": "N4"
  },
  {
    "id": "s585",
    "jp": "日本語を勉強し始めてから、もう三年になります。",
    "romaji": "Nihongo wo benkyou shihajimete kara, mou sannen ni narimasu.",
    "en": "It has been three years since I started studying Japanese.",
    "bn": "জাপানি পড়া শুরু করার এখন তিন বছর হতে চলল।",
    "level": "N4"
  },
  {
    "id": "s586",
    "jp": "おじいさんは、いつも笑顔で親切です。",
    "romaji": "Ojiisan wa, itsumo egao de shinsetsu desu.",
    "en": "My grandfather is always smiling and kind.",
    "bn": "আমার দাদু সবসময় হাসিমুখে থাকেন এবং দয়ালু।",
    "level": "N5"
  },
  {
    "id": "s587",
    "jp": "料理が上手になりたいので、料理教室に通っています।",
    "romaji": "Ryouri ga jouzu ni naritai node, ryourikyoushitsu ni kayotte imasu.",
    "en": "I want to be good at cooking, so I am attending a cooking class.",
    "bn": "রান্নায় পটু হওয়ার জন্য আমি কুকিং ক্লাসে ভর্তি হয়েছি।",
    "level": "N4"
  },
  {
    "id": "s588",
    "jp": "昨日の散歩の時に、綺麗な花を見つけました。",
    "romaji": "Kinou no sanpo no toki ni, kirei na hana wo mitsukemashita.",
    "en": "During yesterday's walk, I found a beautiful flower.",
    "bn": "কালকে হাঁটাহাঁটির সময় আমি একটি চমৎকার ফুল দেখতে পেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s589",
    "jp": "コーヒーを飲みながら、ゆっくり本を読みました。",
    "romaji": "Koohii wo nominagara, yukkuri hon wo yomimashita.",
    "en": "I read a book leisurely while drinking coffee.",
    "bn": "কফি খেতে খেতে আমি সময় নিয়ে বই পড়েছি।",
    "level": "N4"
  },
  {
    "id": "s590",
    "jp": "学校の近くに、新しい図書館ができました।",
    "romaji": "Gakkou no chikaku ni, atarashii toshokan ga dekimashita.",
    "en": "A new library was built near the school.",
    "bn": "স্কুলের পাশে একটি নতুন লাইব্রেরি তৈরি হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s591",
    "jp": "日本の生活に、だんだん慣れてきました。",
    "romaji": "Nihon no seikatsu ni, dandan narete kimashita.",
    "en": "I have gradually gotten used to life in Japan.",
    "bn": "জাপানের জীবনের সাথে আমি ধীরে ধীরে মানিয়ে নিচ্ছি।",
    "level": "N4"
  },
  {
    "id": "s592",
    "jp": "感謝の気持ちを込めて、プレゼントを贈ります।",
    "romaji": "Kansha no kimochi wo komete, purezento wo okurimasu.",
    "en": "I will send a gift with feelings of gratitude.",
    "bn": "কৃতজ্ঞতা স্বরূপ আমি একটি উপহার পাঠাব।",
    "level": "N4"
  },
  {
    "id": "s593",
    "jp": "美味しいお寿司の店を、知っていますか।",
    "romaji": "Oishii osushi no mise wo, shitte imasu ka?",
    "en": "Do you know a good sushi restaurant?",
    "bn": "ভালো সুশি পাওয়া যায় এমন কোনো দোকানের নাম জানেন?",
    "level": "N5"
  },
  {
    "id": "s594",
    "jp": "外で遊んでいた子供たちが、家に戻ってきました。",
    "romaji": "Soto de asonde ita kodomotachi ga, ie ni modotte kimashita.",
    "en": "The children who were playing outside returned home.",
    "bn": "বাইরে খেলা করা বাচ্চারা ঘরে ফিরে এসেছে।",
    "level": "N5"
  },
  {
    "id": "s595",
    "jp": "この仕事は、一人でするには大変すぎます।",
    "romaji": "Kono shigoto wa, hitori de suru ni wa taihensugimasu.",
    "en": "This job is too much to handle alone.",
    "bn": "একলা করার জন্য এই কাজটি বেশ কঠিন।",
    "level": "N4"
  },
  {
    "id": "s596",
    "jp": "天気が良ければ、明日山に登りに行くつもりです。",
    "romaji": "Tenki ga yokereba, ashita yama ni nobori ni iku tsumori desu.",
    "en": "If the weather is good, I intend to go mountain climbing tomorrow.",
    "bn": "আবহাওয়া ভালো থাকলে আগামীকাল পাহাড়ে ওঠার পরিকল্পনা আছে।",
    "level": "N4"
  },
  {
    "id": "s597",
    "jp": "日本語の歌を歌うのが、最近の趣味です।",
    "romaji": "Nihongo no uta wo utau no ga, saikin no shumi desu.",
    "en": "Singing Japanese songs is my recent hobby.",
    "bn": "জাপানি গান গাওয়া এখন আমার সাম্প্রতিক শখ।",
    "level": "N5"
  },
  {
    "id": "s598",
    "jp": "疲れたら、無理をしないで休んでください。",
    "romaji": "Tsukaretara, muri wo shinaide yasunde kudasai.",
    "en": "When you're tired, please rest without overdoing it.",
    "bn": "ক্লান্ত লাগলে জোর না করে বিশ্রাম নিন।",
    "level": "N4"
  },
  {
    "id": "s599",
    "jp": "窓を開けると、涼しい風が入ってきました।",
    "romaji": "Mado wo akeru to, suzushii kaze ga haitte kimashita.",
    "en": "When I opened the window, a cool breeze came in.",
    "bn": "জানালা খুলতেই ঠান্ডা বাতাস ভেতরে এল।",
    "level": "N4"
  },
  {
    "id": "s600",
    "jp": "日本語で日記を書くのは、とても勉強になります。",
    "romaji": "Nihongo de nikki wo kaku no wa, totemo benkyou ni narimasu.",
    "en": "Writing a diary in Japanese is very educational.",
    "bn": "জাপানি ভাষায় ডায়েরি লেখা শেখার জন্য খুব কার্যকর।",
    "level": "N4"
  },
  {
    "id": "s601",
    "jp": "この本は難しすぎて、今の私には読めません。",
    "romaji": "Kono hon wa muzukashisugite, ima no watashi ni wa yomemasen.",
    "en": "This book is too difficult; I cannot read it yet.",
    "bn": "এই বইটি অনেক কঠিন, এটি পড়ার মতো জ্ঞান আমার এখনো হয়নি।",
    "level": "N4"
  },
  {
    "id": "s602",
    "jp": "旅行の準備は、もう全部終わりましたか。",
    "romaji": "Ryokou no junbi wa, mou zenbu owarimashita ka?",
    "en": "Are all the preparations for the trip finished?",
    "bn": "ভ্রমণের সব প্রস্তুতি কি শেষ হয়েছে?",
    "level": "N5"
  },
  {
    "id": "s603",
    "jp": "友達と一緒に、映画を見に行くつもりです。",
    "romaji": "Tomodachi to issho ni, eiga wo mi ni iku tsumori desu.",
    "en": "I intend to go see a movie with my friend.",
    "bn": "আমি বন্ধুর সাথে সিনেমা দেখতে যাওয়ার পরিকল্পনা করছি।",
    "level": "N5"
  },
  {
    "id": "s604",
    "jp": "昨日から風邪をひいて、学校を休みました。",
    "romaji": "Kinou kara kaze wo hiite, gakkou wo yasumimashita.",
    "en": "I caught a cold yesterday and was absent from school.",
    "bn": "গতকাল থেকে ঠান্ডা লাগার কারণে আমি স্কুলে যেতে পারিনি।",
    "level": "N5"
  },
  {
    "id": "s605",
    "jp": "将来、日本で働きたいと思っています。",
    "romaji": "Shourai, Nihon de hatarakitai to omotte imasu.",
    "en": "I hope to work in Japan in the future.",
    "bn": "আমি ভবিষ্যতে জাপানে কাজ করতে চাই।",
    "level": "N4"
  },
  {
    "id": "s606",
    "jp": "この料理は、少し辛いですが美味しいです。",
    "romaji": "Kono ryouri wa, sukoshi karai desu ga oishii desu.",
    "en": "This dish is a bit spicy but delicious.",
    "bn": "এই খাবারটি সামান্য ঝাল হলেও খুব সুস্বাদু।",
    "level": "N5"
  },
  {
    "id": "s607",
    "jp": "駅の前に、大きいスーパーができました।",
    "romaji": "Eki no mae ni, ookii su-pa- ga dekimashita.",
    "en": "A big supermarket was built in front of the station.",
    "bn": "স্টেশনের সামনে একটি বড় সুপারমার্কেট তৈরি হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s608",
    "jp": "毎日、漢字を10個覚えるようにしています。",
    "romaji": "Mainichi, kanji wo jukko oboeru you ni shite imasu.",
    "en": "I make an effort to memorize 10 kanji every day.",
    "bn": "আমি প্রতিদিন ১০টি করে কাঞ্জি মুখস্থ করার চেষ্টা করি।",
    "level": "N4"
  },
  {
    "id": "s609",
    "jp": "誕生日に、兄から時計をもらいました。",
    "romaji": "Tanjoubi ni, ani kara tokei wo moraimashita.",
    "en": "I received a watch from my older brother on my birthday.",
    "bn": "জন্মদিনে বড় ভাই আমাকে একটি ঘড়ি উপহার দিয়েছেন।",
    "level": "N5"
  },
  {
    "id": "s610",
    "jp": "雨が降っているから、傘を持っていきなさい।",
    "romaji": "Ame ga futte iru kara, kasa wo motte ikinasai.",
    "en": "It's raining, so take an umbrella with you.",
    "bn": "বৃষ্টি পড়ছে, তাই সাথে একটি ছাতা নিয়ে যাও।",
    "level": "N5"
  },
  {
    "id": "s611",
    "jp": "この靴は、歩きやすくてとてもいいです。",
    "romaji": "Kono kutsu wa, arukiyasukute totemo ii desu.",
    "en": "These shoes are very easy to walk in.",
    "bn": "এই জুতোজোড়া পরে হাঁটতে খুব আরামদায়ক।",
    "level": "N5"
  },
  {
    "id": "s612",
    "jp": "分からないことがあれば、いつでも聞いてください।",
    "romaji": "Wakaranai koto ga areba, itsudemo kiite kudasai.",
    "en": "If there's anything you don't understand, please ask anytime.",
    "bn": "কিছু বুঝতে না পারলে যেকোনো সময় আমাকে জিজ্ঞাসা করতে পারেন।",
    "level": "N5"
  },
  {
    "id": "s613",
    "jp": "部屋を掃除して、とてもきれいになりました。",
    "romaji": "Heya wo souji shite, totemo kirei ni narimashita.",
    "en": "I cleaned the room and it became very tidy.",
    "bn": "ঘরটি পরিষ্কার করার পর তা খুব ঝকঝকে হয়ে গেছে।",
    "level": "N5"
  },
  {
    "id": "s614",
    "jp": "健康のために、毎朝走るようにしています।",
    "romaji": "Kenkou no tame ni, maiasa hashiru you ni shite imasu.",
    "en": "For my health, I make an effort to run every morning.",
    "bn": "সুস্থ থাকার জন্য আমি প্রতিদিন সকালে দৌড়ানোর চেষ্টা করি।",
    "level": "N4"
  },
  {
    "id": "s615",
    "jp": "昨日のテストは、思っていたより簡単でした。",
    "romaji": "Kinou no tesuto wa, omotte ita yori kantan deshita.",
    "en": "Yesterday's test was easier than I thought.",
    "bn": "গতকালের পরীক্ষাটি আমার ধারণার চেয়েও সহজ ছিল।",
    "level": "N5"
  },
  {
    "id": "s616",
    "jp": "日本へ行く前に、日本語を少し習いました।",
    "romaji": "Nihon e iku mae ni, Nihongo wo sukoshi naraimashita.",
    "en": "Before going to Japan, I learned a little Japanese.",
    "bn": "জাপানে যাওয়ার আগে আমি সামান্য জাপানি ভাষা শিখেছিলাম।",
    "level": "N5"
  },
  {
    "id": "s617",
    "jp": "この写真は、去年の夏休みに撮ったものです。",
    "romaji": "Kono shashin wa, kyonen no natsuyasumi ni totta mono desu.",
    "en": "This photo was taken during last year's summer vacation.",
    "bn": "এই ছবিটি গত বছরের গরমের ছুটিতে তোলা হয়েছিল।",
    "level": "N5"
  },
  {
    "id": "s618",
    "jp": "バスがなかなか来ないので、歩いて帰りました।",
    "romaji": "Basu ga nakanaka konai node, aruite kaerimashita.",
    "en": "The bus wasn't coming, so I walked home.",
    "bn": "বাস আসছিল না বিধায় আমি হেঁটেই বাড়ি ফিরেছি।",
    "level": "N5"
  },
  {
    "id": "s619",
    "jp": "あの先生は、教え方がとても上手で有名です。",
    "romaji": "Ano sensei wa, oshiekata ga totemo jouzu de yuumei desu.",
    "en": "That teacher is famous for being very good at teaching.",
    "bn": "ঐ শিক্ষক তার চমৎকার পাঠদানের জন্য বেশ পরিচিত।",
    "level": "N4"
  },
  {
    "id": "s620",
    "jp": "おじいさんは、今も元気に働いています।",
    "romaji": "Ojiisan wa, ima mo genki ni hataraite imasu.",
    "en": "The old man is still working energetically today.",
    "bn": "বৃদ্ধ লোকটি এখনো বেশ উদ্যম নিয়ে কাজ করে যাচ্ছেন।",
    "level": "N5"
  },
  {
    "id": "s621",
    "jp": "この漢字の読み方を、教えていただけませんか。",
    "romaji": "Kono kanji no yomikata wo, oshiete itadakemasen ka?",
    "en": "Could you please teach me how to read this kanji?",
    "bn": "আপনি কি দয়া করে আমাকে এই কাঞ্জিটি পড়ার নিয়ম শিখিয়ে দেবেন?",
    "level": "N4"
  },
  {
    "id": "s622",
    "jp": "今日は忙しすぎて、昼ご飯を食べる時間がありませんでした।",
    "romaji": "Kyou wa isogashisugite, hirugohan wo taberu jikan ga arimasen deshita.",
    "en": "I was so busy today that I didn't have time for lunch.",
    "bn": "আজ আমি এতটাই ব্যস্ত ছিলাম যে দুপুরে খাওয়ার সময় পাইনি।",
    "level": "N4"
  },
  {
    "id": "s623",
    "jp": "来週の土曜日に、パーティーをする予定です。",
    "romaji": "Raishuu no doyoubi ni, pa-ti- wo suru yotei desu.",
    "en": "We plan to have a party next Saturday.",
    "bn": "আগামী শনিবার আমাদের একটি পার্টি করার পরিকল্পনা আছে।",
    "level": "N5"
  },
  {
    "id": "s624",
    "jp": "お腹が空いたから、何か食べに行きましょう।",
    "romaji": "Onaka ga suita kara, nanika tabe ni ikimashou.",
    "en": "I'm hungry, so let's go eat something.",
    "bn": "আমার খুব খিদে পেয়েছে, চলুন কিছু খেয়ে আসি।",
    "level": "N5"
  },
  {
    "id": "s625",
    "jp": "この辞書は、単語が多くてとても役に立ちます。",
    "romaji": "Kono jisho wa, tango ga ookute totemo yaku ni tachimasu.",
    "en": "This dictionary has many words and is very useful.",
    "bn": "এই ডিকশনারিটিতে অনেক শব্দ রয়েছে যা খুব উপকারে আসে।",
    "level": "N5"
  },
  {
    "id": "s626",
    "jp": "日本に来てから、半年が経ちました।",
    "romaji": "Nihon ni kite kara, hantoshi ga tachimashita.",
    "en": "Six months have passed since I came to Japan.",
    "bn": "জাপানে আসার পর ছয় মাস অতিবাহিত হয়ে গেছে।",
    "level": "N4"
  },
  {
    "id": "s627",
    "jp": "暗くなったから、電気をつけましょう。",
    "romaji": "Kuraku natta kara, denki wo tsukemashou.",
    "en": "It's getting dark, so let's turn on the lights.",
    "bn": "অন্ধকার হয়ে এসেছে, চলুন লাইট জ্বালিয়ে দেই।",
    "level": "N5"
  },
  {
    "id": "s628",
    "jp": "あの人は、日本語がとても上手に話せます।",
    "romaji": "Ano hito wa, Nihongo ga totemo jouzu ni hanasemasu.",
    "en": "That person can speak Japanese very well.",
    "bn": "ঐ ব্যক্তিটি খুব সুন্দরভাবে জাপানি বলতে পারেন।",
    "level": "N4"
  },
  {
    "id": "s629",
    "jp": "風が強くて、帽子が飛んでいきました。",
    "romaji": "Kaze ga tsuyokute, boushi ga tonde ikimashita.",
    "en": "The wind was so strong that my hat blew away.",
    "bn": "বাতাস এত প্রবল ছিল যে আমার টুপিটি উড়ে গেছে।",
    "level": "N5"
  },
  {
    "id": "s630",
    "jp": "もっとゆっくり、話してくれませんか।",
    "romaji": "Motto yukkuri, hanashite kuremasen ka?",
    "en": "Could you please speak a bit more slowly?",
    "bn": "আপনি কি দয়া করে আরেকটু ধীরে কথা বলবেন?",
    "level": "N5"
  },
  {
    "id": "s631",
    "jp": "この映画は、本当に感動しました。",
    "romaji": "Kono eiga wa, hontou ni kandou shimashita.",
    "en": "I was truly moved by this movie.",
    "bn": "এই সিনেমাটি দেখে আমি সত্যিই অভিভূত হয়েছি।",
    "level": "N4"
  },
  {
    "id": "s632",
    "jp": "夜遅くに、電話をかけないでください।",
    "romaji": "Yoru osoku ni, denwa wo kakenaide kudasai.",
    "en": "Please do not make phone calls late at night.",
    "bn": "দয়া করে গভীর রাতে ফোন করবেন না।",
    "level": "N5"
  },
  {
    "id": "s633",
    "jp": "あそこに座っている人は、誰ですか。",
    "romaji": "Asoko ni suwatte iru hito wa, dare desu ka?",
    "en": "Who is that person sitting over there?",
    "bn": "ঐখানে বসে থাকা মানুষটি কে?",
    "level": "N5"
  },
  {
    "id": "s634",
    "jp": "雨が降っていても、散歩に行きます।",
    "romaji": "Ame ga futte itemo, sanpo ni ikimasu.",
    "en": "Even if it's raining, I go for a walk.",
    "bn": "বৃষ্টি হলেও আমি হাঁটতে বের হই।",
    "level": "N4"
  },
  {
    "id": "s635",
    "jp": "お母さんに、花をプレゼントしました。",
    "romaji": "Okaasan ni, hana wo purezento shimashita.",
    "en": "I gave flowers as a gift to my mother.",
    "bn": "আমি মাকে ফুল উপহার দিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s636",
    "jp": "日本語の勉強を、これからも続けます।",
    "romaji": "Nihongo no benkyou wo, korekara mo tsuzukemasu.",
    "en": "I will continue studying Japanese from now on.",
    "bn": "আমি এখন থেকে জাপানি ভাষা শেখা চালিয়ে যাব।",
    "level": "N4"
  },
  {
    "id": "s637",
    "jp": "仕事が終わってから、飲みに行きましょう。",
    "romaji": "Shigoto ga owatte kara, nomi ni ikimashou.",
    "en": "Let's go for a drink after work.",
    "bn": "কাজ শেষ করে চলুন পান করতে যাই।",
    "level": "N5"
  },
  {
    "id": "s638",
    "jp": "昨日は一日中、うちにいました।",
    "romaji": "Kinou wa ichinichijuu, uchi ni imashita.",
    "en": "I was at home all day yesterday.",
    "bn": "গতকাল সারাদিন আমি বাড়িতেই ছিলাম।",
    "level": "N5"
  },
  {
    "id": "s639",
    "jp": "日本語が上手になるために、毎日練習しています。",
    "romaji": "Nihongo ga jouzu ni naru tame ni, mainichi renshuu shite imasu.",
    "en": "I practice every day in order to improve my Japanese.",
    "bn": "জাপানি ভাষায় দক্ষ হওয়ার জন্য আমি প্রতিদিন অনুশীলন করি।",
    "level": "N4"
  },
  {
    "id": "s640",
    "jp": "すみませんが、塩を取ってください।",
    "romaji": "Sumimasen ga, shio wo totte kudasai.",
    "en": "Excuse me, but please pass the salt.",
    "bn": "মাফ করবেন, দয়া করে লবণটা বাড়িয়ে দেবেন?",
    "level": "N5"
  },
  {
    "id": "s641",
    "jp": "週末は、山に登ったり海に行ったりします。",
    "romaji": "Shuumatsu wa, yama ni nobottari umi ni ittari shimasu.",
    "en": "On weekends, I do things like mountain climbing and going to the sea.",
    "bn": "সাপ্তাহিক ছুটির দিনে আমি পাহাড়ে চড়ি অথবা সমুদ্রে যাই।",
    "level": "N4"
  },
  {
    "id": "s642",
    "jp": "この問題は、とても難しくて分かりません।",
    "romaji": "Kono mondai wa, totemo muzukashikute wakarimasen.",
    "en": "This problem is so difficult that I don't understand it.",
    "bn": "এই সমস্যাটি এতই কঠিন যে আমি বুঝতে পারছি না।",
    "level": "N4"
  },
  {
    "id": "s643",
    "jp": "もう一度、言ってください。",
    "romaji": "Mou ichido, itte kudasai.",
    "en": "Please say it once more.",
    "bn": "দয়া করে আরেকবার বলুন।",
    "level": "N5"
  },
  {
    "id": "s644",
    "jp": "明日の朝は、7時に起きるつもりです।",
    "romaji": "Ashita no asa wa, shichiji ni okiru tsumori desu.",
    "en": "I intend to wake up at 7:00 tomorrow morning.",
    "bn": "আমি আগামীকাল সকাল ৭টায় ওঠার পরিকল্পনা করছি।",
    "level": "N5"
  },
  {
    "id": "s645",
    "jp": "このカバンは、軽くて使いやすいです。",
    "romaji": "Kono kaban wa, karukute tsukaiyasui desu.",
    "en": "This bag is light and easy to use.",
    "bn": "এই ব্যাগটি ওজনে হালকা এবং ব্যবহার করা খুব সহজ।",
    "level": "N5"
  },
  {
    "id": "s646",
    "jp": "あの人は、歌を歌いながら歩いています।",
    "romaji": "Ano hito wa, uta wo utainagara aruite imasu.",
    "en": "That person is walking while singing a song.",
    "bn": "ঐ মানুষটি গান গাইতে গাইতে হাঁটছেন।",
    "level": "N4"
  },
  {
    "id": "s647",
    "jp": "日本の冬は、とても寒いです。",
    "romaji": "Nihon no fuyu wa, totemo samui desu.",
    "en": "Winter in Japan is very cold.",
    "bn": "জাপানের শীতকাল খুব ঠান্ডা।",
    "level": "N5"
  },
  {
    "id": "s648",
    "jp": "この薬を飲めば、すぐに良くなりますよ।",
    "romaji": "Kono kusuri wo nomeba, sugu ni yoku narimasu yo.",
    "en": "If you take this medicine, you will get better soon.",
    "bn": "এই ওষুধটি খেলে আপনি দ্রুত সুস্থ হয়ে উঠবেন।",
    "level": "N4"
  },
  {
    "id": "s649",
    "jp": "新しい仕事に、まだ慣れていません。",
    "romaji": "Atarashii shigoto ni, mada narete imasen.",
    "en": "I am not yet used to my new job.",
    "bn": "আমি এখনো আমার নতুন কাজের সাথে মানিয়ে নিতে পারিনি।",
    "level": "N4"
  },
  {
    "id": "s650",
    "jp": "感謝の気持ちを、忘れないようにしています।",
    "romaji": "Kansha no kimochi wo, wasurenai you ni shite imasu.",
    "en": "I make an effort not to forget feelings of gratitude.",
    "bn": "আমি কৃতজ্ঞতা বোধ কখনো না ভোলার চেষ্টা করি।",
    "level": "N4"
  },
  {
    "id": "s651",
    "jp": "宿題を忘れました。",
    "romaji": "Shukudai wo wasuremashita.",
    "en": "I forgot my homework.",
    "bn": "আমি আমার বাড়ির কাজ ভুলে গেছি।",
    "level": "N5"
  },
  {
    "id": "s652",
    "jp": "これをコピーしてください。",
    "romaji": "Kore wo kopii shite kudasai.",
    "en": "Please copy this.",
    "bn": "এটি কপি করুন।",
    "level": "N5"
  },
  {
    "id": "s653",
    "jp": "公園で散歩します。",
    "romaji": "Kouen de sanpo shimasu.",
    "en": "I take a walk in the park.",
    "bn": "আমি পার্কে হাঁটাহাঁটি করি।",
    "level": "N5"
  },
  {
    "id": "s654",
    "jp": "声が大きいです。",
    "romaji": "Koe ga ookii desu.",
    "en": "Your voice is loud.",
    "bn": "আপনার গলার স্বর উঁচু।",
    "level": "N5"
  },
  {
    "id": "s655",
    "jp": "コーヒーを飲みます।",
    "romaji": "Koohii wo nomimasu.",
    "en": "I drink coffee.",
    "bn": "আমি কফি খাই।",
    "level": "N5"
  },
  {
    "id": "s656",
    "jp": "午後から雨が降ります。",
    "romaji": "Gogo kara ame ga furimasu.",
    "en": "It will rain from the afternoon.",
    "bn": "বিকাল থেকে বৃষ্টি হবে।",
    "level": "N5"
  },
  {
    "id": "s657",
    "jp": "九日に会いましょう।",
    "romaji": "Kokonoka ni aimashou.",
    "en": "Let's meet on the 9th.",
    "bn": "নয় তারিখে দেখা করা যাক।",
    "level": "N5"
  },
  {
    "id": "s658",
    "jp": "午前中に終わります。",
    "romaji": "Gozenchuu ni owarimasu.",
    "en": "It will finish in the morning.",
    "bn": "সকালের মধ্যে শেষ হবে।",
    "level": "N5"
  },
  {
    "id": "s659",
    "jp": "質問に答えてください।",
    "romaji": "Shitsumon ni kotaete kudasai.",
    "en": "Please answer the question.",
    "bn": "প্রশ্নের উত্তর দিন।",
    "level": "N5"
  },
  {
    "id": "s660",
    "jp": "こちらへどうぞ。",
    "romaji": "Kochira he douzo.",
    "en": "This way, please.",
    "bn": "এই দিকে আসুন।",
    "level": "N5"
  },
  {
    "id": "s661",
    "jp": "この靴は高いです।",
    "romaji": "Kono kutsu wa takai desu.",
    "en": "These shoes are expensive.",
    "bn": "এই জুতোজোড়া দামি।",
    "level": "N5"
  },
  {
    "id": "s662",
    "jp": "今年、日本へ行きます。",
    "romaji": "Kotoshi, Nihon he ikimasu.",
    "en": "I will go to Japan this year.",
    "bn": "এই বছর আমি জাপান যাবো।",
    "level": "N5"
  },
  {
    "id": "s663",
    "jp": "言葉を覚えます।",
    "romaji": "Kotoba wo oboemasu.",
    "en": "I memorize words.",
    "bn": "আমি শব্দ মুখস্থ করি।",
    "level": "N5"
  },
  {
    "id": "s664",
    "jp": "子供が公園で遊んでいます。",
    "romaji": "Kodomo ga kouen de asonde imasu.",
    "en": "Children are playing in the park.",
    "bn": "শিশুরা পার্কে খেলছে।",
    "level": "N5"
  },
  {
    "id": "s665",
    "jp": "この本は面白いです।",
    "romaji": "Kono hon wa omoshiroi desu.",
    "en": "This book is interesting.",
    "bn": "এই বইটি মজাদার।",
    "level": "N5"
  },
  {
    "id": "s666",
    "jp": "ご飯を食べました。",
    "romaji": "Gohan wo tabemashita.",
    "en": "I ate a meal.",
    "bn": "আমি খাবার খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s667",
    "jp": "お困りですか？",
    "romaji": "O-komari desu ka?",
    "en": "Are you in trouble?",
    "bn": "আপনি কি কোনো সমস্যায় পড়েছেন?",
    "level": "N5"
  },
  {
    "id": "s668",
    "jp": "これを見せでください।",
    "romaji": "Kore wo misete kudasai.",
    "en": "Please show me this.",
    "bn": "এটি আমাকে দেখান।",
    "level": "N5"
  },
  {
    "id": "s669",
    "jp": "五時ごろに来てください。",
    "romaji": "Goji goro ni kite kudasai.",
    "en": "Please come around 5 o'clock.",
    "bn": "পাঁচটা নাগাদ আসুন।",
    "level": "N5"
  },
  {
    "id": "s670",
    "jp": "今月は忙しいです।",
    "romaji": "Kongetsu wa isogashii desu.",
    "en": "I am busy this month.",
    "bn": "এই মাস আমি ব্যস্ত।",
    "level": "N5"
  },
  {
    "id": "s671",
    "jp": "今週の土曜日は暇です。",
    "romaji": "Konshuu no doyoubi wa hima desu.",
    "en": "I am free this Saturday.",
    "bn": "এই সপ্তাহের শনিবার আমি অবসর।",
    "level": "N5"
  },
  {
    "id": "s672",
    "jp": "こんな家がいいです।",
    "romaji": "Konna ie ga ii desu.",
    "en": "I like a house like this.",
    "bn": "এরকম বাড়ি ভালো।",
    "level": "N5"
  },
  {
    "id": "s673",
    "jp": "今晩、電話します。",
    "romaji": "Konban, denwa shimasu.",
    "en": "I will call tonight.",
    "bn": "আজ রাতে ফোন করবো।",
    "level": "N5"
  },
  {
    "id": "s674",
    "jp": "財布をなくしました।",
    "romaji": "Saifu wo nakushimashita.",
    "en": "I lost my wallet.",
    "bn": "আমি আমার মানিব্যাগ হারিয় ফেলেছি।",
    "level": "N5"
  },
  {
    "id": "s675",
    "jp": "魚が好きですか？",
    "romaji": "Sakana ga suki desu ka?",
    "en": "Do you like fish?",
    "bn": "আপনি কি মাছ পছন্দ করেন?",
    "level": "N5"
  },
  {
    "id": "s676",
    "jp": "お先に失礼します।",
    "romaji": "O-saki ni shitsurei shimasu.",
    "en": "Excuse me for leaving ahead of you.",
    "bn": "আমি আগে যাচ্ছি (বিদায়)।",
    "level": "N5"
  },
  {
    "id": "s677",
    "jp": "桜が咲きました。",
    "romaji": "Sakura ga sakimashita.",
    "en": "The cherry blossoms bloomed.",
    "bn": "সাকুরা ফুল ফুটেছে।",
    "level": "N5"
  },
  {
    "id": "s678",
    "jp": "作文を書きました।",
    "romaji": "Sakubun wo kakimashita.",
    "en": "I wrote an essay.",
    "bn": "আমি একটি রচনা লিখেছি।",
    "level": "N5"
  },
  {
    "id": "s679",
    "jp": "雑誌を読んでいます。",
    "romaji": "Zasshi wo yonde imasu.",
    "en": "I am reading a magazine.",
    "bn": "আমি একটি ম্যাগাজিন পড়ছি।",
    "level": "N5"
  },
  {
    "id": "s680",
    "jp": "砂糖を入れますか？",
    "romaji": "Satou wo iremasu ka?",
    "en": "Will you put in sugar?",
    "bn": "চিনি দেবেন কি?",
    "level": "N5"
  },
  {
    "id": "s681",
    "jp": "今日はとても寒いです।",
    "romaji": "Kyou wa totemo samui desu.",
    "en": "It is very cold today.",
    "bn": "আজ খুব শীত।",
    "level": "N5"
  },
  {
    "id": "s682",
    "jp": "さようなら、また明日。",
    "romaji": "Sayounara, mata ashita.",
    "en": "Goodbye, see you tomorrow.",
    "bn": "বিদায়, আগামীকাল দেখা হবে।",
    "level": "N5"
  },
  {
    "id": "s683",
    "jp": "お皿を洗ってください।",
    "romaji": "Osara wo aratte kudasai.",
    "en": "Please wash the plates.",
    "bn": "থালাগুলো ধুয়ে দিন।",
    "level": "N5"
  },
  {
    "id": "s684",
    "jp": "来年、卒業します।",
    "romaji": "Rainen, sotsugyou shimasu.",
    "en": "I will graduate next year.",
    "bn": "আগামী বছর আমি গ্র্যাজুয়েশন করবো।",
    "level": "N5"
  },
  {
    "id": "s685",
    "jp": "ラジオを聞きます。",
    "romaji": "Rajio wo kikimasu.",
    "en": "I listen to the radio.",
    "bn": "আমি রেডিও শুনি।",
    "level": "N5"
  },
  {
    "id": "s686",
    "jp": "立派な建物ですね।",
    "romaji": "Rippa na tatemono desu ne.",
    "en": "It's a splendid building, isn't it?",
    "bn": "এটি খুব চমৎকার ভবন, তাই না?",
    "level": "N5"
  },
  {
    "id": "s687",
    "jp": "留学生はどこですか？",
    "romaji": "Ryuugakusei wa doko desu ka?",
    "en": "Where is the foreign student?",
    "bn": "বিদেশি ছাত্রটি কোথায়?",
    "level": "N5"
  },
  {
    "id": "s688",
    "jp": "料理が上手ですね।",
    "romaji": "Ryouri ga jouzu desu ne.",
    "en": "You are good at cooking, aren't you?",
    "bn": "আপনি তো খুব ভালো রান্না করেন, তাই না?",
    "level": "N5"
  },
  {
    "id": "s689",
    "jp": "旅行に行きたいです。",
    "romaji": "Ryokou ni ikitai desu.",
    "en": "I want to go on a trip.",
    "bn": "আমি ভ্রমণে যেতে চাই।",
    "level": "N5"
  },
  {
    "id": "s690",
    "jp": "急行に乗ります।",
    "romaji": "Kyuukou ni norimasu.",
    "en": "I take the express train.",
    "bn": "আমি এক্সপ্রেস ট্রেনে চলি।",
    "level": "N4"
  },
  {
    "id": "s691",
    "jp": "急に雨が降りました。",
    "romaji": "Kyuuni ame ga furimashita.",
    "en": "Suddenly it rained.",
    "bn": "হঠাৎ বৃষ্টি নামলো।",
    "level": "N5"
  },
  {
    "id": "s692",
    "jp": "今日は休日です।",
    "romaji": "Kyou wa kyuujitsu desu.",
    "en": "Today is a holiday.",
    "bn": "আজ ছুটির দিন।",
    "level": "N5"
  },
  {
    "id": "s693",
    "jp": "十分間、休憩しましょう。",
    "romaji": "Juppun-kan, kyuukei shimashou.",
    "en": "Let's take a 10-minute break.",
    "bn": "চলুন ১০ মিনিটের বিরতি নেই।",
    "level": "N5"
  },
  {
    "id": "s694",
    "jp": "給料をもらいました।",
    "romaji": "Kyuuryou wo moraimashita.",
    "en": "I received my salary.",
    "bn": "আমি বেতন পেয়েছি।",
    "level": "N4"
  },
  {
    "id": "s695",
    "jp": "教育は大切です。",
    "romaji": "Kyouiku wa taisetsu desu.",
    "en": "Education is important.",
    "bn": "শিক্ষা গুরুত্বপূর্ণ।",
    "level": "N4"
  },
  {
    "id": "s696",
    "jp": "教会へ行きます।",
    "romaji": "Kyoukai he ikimasu.",
    "en": "I go to church.",
    "bn": "আমি গির্জায় যাই।",
    "level": "N5"
  },
  {
    "id": "s697",
    "jp": "兄弟は何人ですか？",
    "romaji": "Kyoudai wa nannin desu ka?",
    "en": "How many siblings do you have?",
    "bn": "আপনার কতজন ভাইবোন?",
    "level": "N5"
  },
  {
    "id": "s698",
    "jp": "面白い曲ですね।",
    "romaji": "Omoshiroi kyoku desu ne.",
    "en": "It's an interesting song, isn't it?",
    "bn": "এটি একটি মজার সুর, তাই না?",
    "level": "N5"
  },
  {
    "id": "s699",
    "jp": "靴を磨きます。",
    "romaji": "Kutsu wo migakimasu.",
    "en": "I polish my shoes.",
    "bn": "আমি আমার জুতো পালিশ করি।",
    "level": "N5"
  },
  {
    "id": "s700",
    "jp": "首が痛いです।",
    "romaji": "Kubi ga itai desu.",
    "en": "My neck hurts.",
    "bn": "আমার ঘাড় ব্যথা করছে।",
    "level": "N5"
  },
  {
    "id": "s701",
    "jp": "工夫して作りました。",
    "romaji": "Kufuu shite tsukurimashita.",
    "en": "I made it with some ingenuity.",
    "bn": "আমি বুদ্ধি খাটিয়ে এটি তৈরি করেছি।",
    "level": "N4"
  },
  {
    "id": "s702",
    "jp": "雲が出てきました।",
    "romaji": "Kumo ga dete kimashita.",
    "en": "Clouds have appeared.",
    "bn": "আকাশে মেঘ দেখা দিয়েছে।",
    "level": "N5"
  },
  {
    "id": "s703",
    "jp": "暗いから気をつけてください。",
    "romaji": "Kurai kara ki wo tsukete kudasai.",
    "en": "It's dark, so please be careful.",
    "bn": "অন্ধকার, তাই সাবধানে থাকবেন।",
    "level": "N5"
  },
  {
    "id": "s704",
    "jp": "他の人と比べないでください।",
    "romaji": "Hoka no hito to kurabenaide kudasai.",
    "en": "Please don't compare yourself with others.",
    "bn": "দয়া করে অন্য কারও সাথে তুলনা করবেন না।",
    "level": "N4"
  },
  {
    "id": "s705",
    "jp": "毎日、仕事が苦しいです。",
    "romaji": "Mainichi, shigoto ga kurushii desu.",
    "en": "Work is painful every day.",
    "bn": "প্রতিদিন কাজ করা খুব কষ্টকর।",
    "level": "N4"
  },
  {
    "id": "s706",
    "jp": "日が暮れてきました।",
    "romaji": "Hi ga kurete kimashita.",
    "en": "The sun is setting.",
    "bn": "সূর্য ডুবে আসছে।",
    "level": "N4"
  },
  {
    "id": "s707",
    "jp": "詳しい説明をお願いします。",
    "romaji": "Kuwashii setsumei wo Onegaishimasu.",
    "en": "Please give a detailed explanation.",
    "bn": "দয়া করে বিস্তারিত ব্যাখ্যা দিন।",
    "level": "N4"
  },
  {
    "id": "s708",
    "jp": "新しいメンバーが加わりました।",
    "romaji": "Atarashii menbaa ga kuwarimashita.",
    "en": "A new member has joined.",
    "bn": "একজন নতুন সদস্য যুক্ত হয়েছেন।",
    "level": "N4"
  },
  {
    "id": "s709",
    "jp": "敬語は難しいですね。",
    "romaji": "Keigo wa muzukashii desu ne.",
    "en": "Honorific language is difficult, isn't it?",
    "bn": "বিনম্র ভাষা বেশ কঠিন, তাই না?",
    "level": "N4"
  },
  {
    "id": "s710",
    "jp": "携帯電話を忘れました।",
    "romaji": "Keitai denwa wo wasuremashita.",
    "en": "I forgot my cell phone.",
    "bn": "আমি আমার মোবাইল ফোনটি ভুলে গেছি।",
    "level": "N5"
  },
  {
    "id": "s711",
    "jp": "景色がきれいですね。",
    "romaji": "Keshiki ga kirei desu ne.",
    "en": "The scenery is beautiful, isn't it?",
    "bn": "দৃশ্যটি খুব সুন্দর, তাই না?",
    "level": "N5"
  },
  {
    "id": "s712",
    "jp": "決してあきらめないでください।",
    "romaji": "Kesshite akiramenaide kudasai.",
    "en": "Please never give up.",
    "bn": "কখনোই হাল ছাড়বেন না।",
    "level": "N4"
  },
  {
    "id": "s713",
    "jp": "今日は学校を欠席しました。",
    "romaji": "Kyou wa gakkou wo kesseki shimashita.",
    "en": "I was absent from school today.",
    "bn": "আজ আমি স্কুলে অনুপস্থিত ছিলাম।",
    "level": "N4"
  },
  {
    "id": "s714",
    "jp": "決心がつきました।",
    "romaji": "Kesshin ga tsukimashita.",
    "en": "I have made up my mind.",
    "bn": "আমি মনস্থির করেছি।",
    "level": "N4"
  },
  {
    "id": "s715",
    "jp": "結論から言いましょう。",
    "romaji": "Ketsuron kara iimashou.",
    "en": "Let's start with the conclusion.",
    "bn": "উপসংহার দিয়েই শুরু করা যাক।",
    "level": "N4"
  },
  {
    "id": "s716",
    "jp": "いい気配がします।",
    "romaji": "Ii kehai ga shimasu.",
    "en": "I have a good feeling.",
    "bn": "একটি ভালো আভাস পাচ্ছি।",
    "level": "N4"
  },
  {
    "id": "s717",
    "jp": "原因を調べましょう。",
    "romaji": "Gen-in wo shirabemashou.",
    "en": "Let's investigate the cause.",
    "bn": "চলুন কারণটি অনুসন্ধান করি।",
    "level": "N4"
  },
  {
    "id": "s718",
    "jp": "健康に注意してください।",
    "romaji": "Kenkou ni chuui shite kudasai.",
    "en": "Please be careful with your health.",
    "bn": "আপনার স্বাস্থ্যের প্রতি যত্নশীল হোন।",
    "level": "N5"
  },
  {
    "id": "s719",
    "jp": "現在は東京に住んでいます。",
    "romaji": "Genzai wa Toukyou ni sunde imasu.",
    "en": "Currently, I live in Tokyo.",
    "bn": "বর্তমানে আমি টোকিওতে বসবাস করছি।",
    "level": "N4"
  },
  {
    "id": "s720",
    "jp": "見物に行きましょう।",
    "romaji": "Kenbutsu ni ikimashou.",
    "en": "Let's go sightseeing.",
    "bn": "চলুন দেখাশোনা (ভ্রমণ) করতে যাই।",
    "level": "N4"
  },
  {
    "id": "s721",
    "jp": "憲法を学びます。",
    "romaji": "Kenpou wo manabimasu.",
    "en": "I study the constitution.",
    "bn": "আমি সংবিধান নিয়ে পড়ছি।",
    "level": "N4"
  },
  {
    "id": "s722",
    "jp": "権利を守りましょう।",
    "romaji": "Kenri wo mamorishou.",
    "en": "Let's protect our rights.",
    "bn": "আমাদের অধিকার রক্ষা করা উচিত।",
    "level": "N4"
  },
  {
    "id": "s723",
    "jp": "恋をしています。",
    "romaji": "Koi wo shite imasu.",
    "en": "I am in love.",
    "bn": "আমি প্রেমে পড়েছি।",
    "level": "N4"
  },
  {
    "id": "s724",
    "jp": "濃いお茶を飲みます।",
    "romaji": "Koi o-cha wo nomimasu.",
    "en": "I drink strong tea.",
    "bn": "আমি কড়া চা খাই।",
    "level": "N4"
  },
  {
    "id": "s725",
    "jp": "公園の近くです。",
    "romaji": "Kouen no chikaku desu.",
    "en": "It's near the park.",
    "bn": "এটি পার্কের কাছেই।",
    "level": "N5"
  },
  {
    "id": "s726",
    "jp": "講義を聞いています।",
    "romaji": "Kougi wo kiite imasu.",
    "en": "I am listening to a lecture.",
    "bn": "আমি লেকচার শুনছি।",
    "level": "N4"
  },
  {
    "id": "s727",
    "jp": "工業が盛んです。",
    "romaji": "Kougyou ga sakan desu.",
    "en": "Industry is flourishing.",
    "bn": "শিল্পক্ষেত্র সমৃদ্ধ হচ্ছে।",
    "level": "N4"
  },
  {
    "id": "s728",
    "jp": "航空便で送ります।",
    "romaji": "Koukuubin de okurimasu.",
    "en": "I will send it by airmail.",
    "bn": "আমি এটি এয়ারমেইলে পাঠাব।",
    "level": "N4"
  },
  {
    "id": "s729",
    "jp": "光栄に思います。",
    "romaji": "Kouei ni omoimasu.",
    "en": "I feel honored.",
    "bn": "আমি সম্মানিত বোধ করছি।",
    "level": "N4"
  },
  {
    "id": "s730",
    "jp": "行動しましょう।",
    "romaji": "Koudou shimashou.",
    "en": "Let's take action.",
    "bn": "চলুন উদ্যোগ গ্রহণ করি।",
    "level": "N4"
  },
  {
    "id": "s731",
    "jp": "幸福になりたいです。",
    "romaji": "Koufuuku ni naritai desu.",
    "en": "I want to be happy.",
    "bn": "আমি সুখী হতে চাই।",
    "level": "N4"
  },
  {
    "id": "s732",
    "jp": "公平に分けましょう।",
    "romaji": "Kouhei ni wakemashou.",
    "en": "Let's divide it fairly.",
    "bn": "চলুন এটি সমানভাবে ভাগ করি।",
    "level": "N4"
  },
  {
    "id": "s733",
    "jp": "候補者が多いです。",
    "romaji": "Kouhosha ga ooi desu.",
    "en": "There are many candidates.",
    "bn": "প্রার্থীর সংখ্যা অনেক।",
    "level": "N4"
  },
  {
    "id": "s734",
    "jp": "声をかけてください।",
    "romaji": "Koe wo kakete kudasai.",
    "en": "Please speak up / call out to me.",
    "bn": "দয়া করে আমাকে ডাকবেন।",
    "level": "N5"
  },
  {
    "id": "s735",
    "jp": "氷を入れてください。",
    "romaji": "Koori wo irete kudasai.",
    "en": "Please put some ice in.",
    "bn": "কিছু বরফ দিন।",
    "level": "N5"
  },
  {
    "id": "s736",
    "jp": "ここに来てください।",
    "romaji": "Koko ni kite kudasai.",
    "en": "Please come here.",
    "bn": "এখানে আসুন।",
    "level": "N5"
  },
  {
    "id": "s737",
    "jp": "心地がいいです。",
    "romaji": "Kokochi ga ii desu.",
    "en": "It feels comfortable.",
    "bn": "খুব আরামদায়ক লাগছে।",
    "level": "N4"
  },
  {
    "id": "s738",
    "jp": "試してみましょう।",
    "romaji": "Tameshite mimashou.",
    "en": "Let's give it a try.",
    "bn": "চলুন একবার চেষ্টা করে দেখি।",
    "level": "N4"
  },
  {
    "id": "s739",
    "jp": "細かいお金がありますか？",
    "romaji": "Komakai okane ga arimasu ka?",
    "en": "Do you have small change?",
    "bn": "আপনার কাছে কি খুচরো টাকা আছে?",
    "level": "N4"
  },
  {
    "id": "s740",
    "jp": "困ったことがありました।",
    "romaji": "Komatta koto ga arimashita.",
    "en": "Something troublesome happened.",
    "bn": "একটি সমস্যা হয়েছিল।",
    "level": "N4"
  },
  {
    "id": "s741",
    "jp": "これをください。",
    "romaji": "Kore wo kudasai.",
    "en": "I'll take this, please.",
    "bn": "দয়া করে এটি দিন।",
    "level": "N5"
  },
  {
    "id": "s742",
    "jp": "殺さないでください।",
    "romaji": "Korosanaide kudasai.",
    "en": "Please don't kill.",
    "bn": "দয়া করে হত্যা করবেন না।",
    "level": "N4"
  },
  {
    "id": "s743",
    "jp": "怖い夢を見ました。",
    "romaji": "Kowai yume wo mimashita.",
    "en": "I had a scary dream.",
    "bn": "আমি একটি ভয়ংকর স্বপ্ন দেখেছি।",
    "level": "N5"
  },
  {
    "id": "s744",
    "jp": "壊れた時計を直します।",
    "romaji": "Kowareta tokei wo naoshimasu.",
    "en": "I will fix the broken watch.",
    "bn": "আমি ভাঙা ঘড়িটি ঠিক করবো।",
    "level": "N5"
  },
  {
    "id": "s745",
    "jp": "今度、遊びに行きましょう。",
    "romaji": "Kondo, asobi ni ikimashou.",
    "en": "Let's go out together next time.",
    "bn": "পরের বার চলুন কোথাও ঘুরতে যাই।",
    "level": "N5"
  },
  {
    "id": "s746",
    "jp": "困難に立ち向かいましょう।",
    "romaji": "Konnan ni tachimukaishou.",
    "en": "Let's face the difficulties.",
    "bn": "চলুন প্রতিকূলতার মোকাবিলা করি।",
    "level": "N4"
  },
  {
    "id": "s747",
    "jp": "混乱しています。",
    "romaji": "Konran shite imasu.",
    "en": "I am confused.",
    "bn": "আমি কিছুটা বিভ্রান্ত।",
    "level": "N4"
  },
  {
    "id": "s748",
    "jp": "差出人を書きましょう।",
    "romaji": "Sashidashinin wo kakimashou.",
    "en": "Let's write the sender's name.",
    "bn": "প্রেরকের নাম লিখুন।",
    "level": "N4"
  },
  {
    "id": "s749",
    "jp": "誘いを断りました。",
    "romaji": "Sasoi wo kotowarimashita.",
    "en": "I declined the invitation.",
    "bn": "আমি আমন্ত্রণ প্রত্যাখ্যান করেছি।",
    "level": "N4"
  },
  {
    "id": "s750",
    "jp": "砂漠は広いです।",
    "romaji": "Sabaku wa hiroi desu.",
    "en": "The desert is vast.",
    "bn": "মরুভূমিটি অনেক বিশাল।",
    "level": "N4"
  },
  {
    "id": "s751",
    "jp": "三月に卒業します。",
    "romaji": "Sangatsu ni sotsugyou shimasu.",
    "en": "I will graduate in March.",
    "bn": "মার্চ মাসে আমি গ্র্যাজুয়েশন করবো।",
    "level": "N5"
  },
  {
    "id": "s752",
    "jp": "山田さんは先生です।",
    "romaji": "Yamada-san wa sensei desu.",
    "en": "Mr. Yamada is a teacher.",
    "bn": "মিস্টার ইয়ামাদা একজন শিক্ষক।",
    "level": "N5"
  },
  {
    "id": "s753",
    "jp": "散歩に行きましょう。",
    "romaji": "Sanpo ni ikimashou.",
    "en": "Let's go for a walk.",
    "bn": "চলুন হাঁটতে যাই।",
    "level": "N5"
  },
  {
    "id": "s754",
    "jp": "四時に会いましょう।",
    "romaji": "Yoji ni aimashou.",
    "en": "Let's meet at 4:00.",
    "bn": "চারটায় দেখা করা যাক।",
    "level": "N5"
  },
  {
    "id": "s755",
    "jp": "時間はありますか？",
    "romaji": "Jikan wa arimasu ka?",
    "en": "Do you have time?",
    "bn": "আপনার কি সময় আছে?",
    "level": "N5"
  },
  {
    "id": "s756",
    "jp": "仕事は大変ですが、面白いです।",
    "romaji": "Shigoto wa taihen desu ga, omoshiroi desu.",
    "en": "The work is hard, but interesting.",
    "bn": "কাজটি বেশ কঠিন, তবে মজার।",
    "level": "N5"
  },
  {
    "id": "s757",
    "jp": "辞書を引いてください。",
    "romaji": "Jisho wo hiite kudasai.",
    "en": "Please look it up in the dictionary.",
    "bn": "দয়া করে অভিধানে দেখে নিন।",
    "level": "N5"
  },
  {
    "id": "s758",
    "jp": "この部屋は静かですね।",
    "romaji": "Kono heya wa shizuka desu ne.",
    "en": "This room is quiet, isn't it?",
    "bn": "এই ঘরটি খুব শান্ত, তাই না?",
    "level": "N5"
  },
  {
    "id": "s759",
    "jp": "机の下に猫がいます。",
    "romaji": "Tsukue no shita ni neko ga imasu.",
    "en": "There is a cat under the desk.",
    "bn": "টেবিলের নিচে একটি বিড়াল আছে।",
    "level": "N5"
  },
  {
    "id": "s760",
    "jp": "質問はありますか？",
    "romaji": "Shitsumon wa arimasu ka?",
    "en": "Do you have any questions?",
    "bn": "আপনার কি কোনো প্রশ্ন আছে?",
    "level": "N5"
  },
  {
    "id": "s761",
    "jp": "自転車で学校へ行きます।",
    "romaji": "Jitensha de gakkou he ikimasu.",
    "en": "I go to school by bicycle.",
    "bn": "আমি সাইকেলে করে স্কুলে যাই।",
    "level": "N5"
  },
  {
    "id": "s762",
    "jp": "自動車を洗ってください。",
    "romaji": "Jidousha wo aratte kudasai.",
    "en": "Please wash the car.",
    "bn": "দয়া করে গাড়িটি ধুয়ে দিন।",
    "level": "N5"
  },
  {
    "id": "s763",
    "jp": "自分を信じてください।",
    "romaji": "Jibun wo shinjite kudasai.",
    "en": "Please believe in yourself.",
    "bn": "নিজের ওপর বিশ্বাস রাখুন।",
    "level": "N4"
  },
  {
    "id": "s764",
    "jp": "ドアが閉まりました。",
    "romaji": "Doa ga shimarimashita.",
    "en": "The door closed.",
    "bn": "দরজাটি বন্ধ হয়ে গেছে।",
    "level": "N5"
  },
  {
    "id": "s765",
    "jp": "窓を閉めてください।",
    "romaji": "Mado wo shimete kudasai.",
    "en": "Please close the window.",
    "bn": "জানালাটি বন্ধ করে দিন।",
    "level": "N5"
  },
  {
    "id": "s766",
    "jp": "ネクタイを締めます。",
    "romaji": "Nekutai wo shimemasu.",
    "en": "I tie a necktie.",
    "bn": "আমি নেকটাই বাঁধি।",
    "level": "N5"
  },
  {
    "id": "s767",
    "jp": "じゃあ、また。",
    "romaji": "Jaa, mata.",
    "en": "Well then, see you.",
    "bn": "তাহলে আবার দেখা হবে।",
    "level": "N5"
  },
  {
    "id": "s768",
    "jp": "写真を撮りましょう।",
    "romaji": "Shashin wo torimashou.",
    "en": "Let's take a photo.",
    "bn": "চলুন একটি ছবি তুলি।",
    "level": "N5"
  },
  {
    "id": "s769",
    "jp": "シャツを洗いました。",
    "romaji": "Shatsu wo araimashita.",
    "en": "I washed the shirt.",
    "bn": "আমি শার্টটি ধুয়েছি।",
    "level": "N5"
  },
  {
    "id": "s770",
    "jp": "シャワーを浴びます।",
    "romaji": "Shawaa wo abimasu.",
    "en": "I take a shower.",
    "bn": "আমি গোসল করি।",
    "level": "N5"
  },
  {
    "id": "s771",
    "jp": "自由がほしいです。",
    "romaji": "Jiyuu ga hoshii desu.",
    "en": "I want freedom.",
    "bn": "আমি স্বাধীনতা চাই।",
    "level": "N4"
  },
  {
    "id": "s772",
    "jp": "授業は九時に始まります।",
    "romaji": "Jugyou wa kuji ni hajimarimasu.",
    "en": "The class starts at 9:00.",
    "bn": "ক্লাস ন’টায় শুরু হয়।",
    "level": "N5"
  },
  {
    "id": "s773",
    "jp": "宿題はもう終わりましたか？",
    "romaji": "Shukudai wa mou owarimashita ka?",
    "en": "Have you finished the homework already?",
    "bn": "বাড়ির কাজ কি শেষ হয়েছে?",
    "level": "N5"
  },
  {
    "id": "s774",
    "jp": "料理が上手ですね।",
    "romaji": "Ryouri ga jouzu desu ne.",
    "en": "You are good at cooking, aren't you?",
    "bn": "আপনি তো খুব ভালো রান্না করেন, তাই না?",
    "level": "N5"
  },
  {
    "id": "s775",
    "jp": "丈夫な靴がほしいです。",
    "romaji": "Joubu na kutsu ga hoshii desu.",
    "en": "I want strong shoes.",
    "bn": "আমি মজবুত জুতো চাই।",
    "level": "N5"
  },
  {
    "id": "s776",
    "jp": "醤油を取ってください।",
    "romaji": "Shouyu wo totte kudasai.",
    "en": "Please pass the soy sauce.",
    "bn": "দয়া করে সয়া সসটি দিন।",
    "level": "N5"
  },
  {
    "id": "s777",
    "jp": "食堂でご飯を食べます。",
    "romaji": "Shokudou de gohan wo tabemasu.",
    "en": "I eat at the cafeteria.",
    "bn": "আমি ভোজনালয়ে খাবার খাই।",
    "level": "N5"
  },
  {
    "id": "s778",
    "jp": "日本語の歌を知っていますか।",
    "romaji": "Nihongo no uta wo shitte imasu ka?",
    "en": "Do you know any Japanese songs?",
    "bn": "আপনি কি কোনো জাপানি গান জানেন?",
    "level": "N5"
  },
  {
    "id": "s779",
    "jp": "白いシャツを着ています。",
    "romaji": "Shiroi shatsu wo kite imasu.",
    "en": "I am wearing a white shirt.",
    "bn": "আমি একটি সাদা শার্ট পরে আছি।",
    "level": "N5"
  },
  {
    "id": "s780",
    "jp": "人参を食べなさい।",
    "romaji": "Ninjin wo tabenasai.",
    "en": "Eat your carrots.",
    "bn": "গাজর খাও।",
    "level": "N5"
  },
  {
    "id": "s781",
    "jp": "猫を飼っています。",
    "romaji": "Neko wo katte imasu.",
    "en": "I have a cat.",
    "bn": "আমার একটি পোষা বিড়াল আছে।",
    "level": "N5"
  },
  {
    "id": "s782",
    "jp": "早く寝てください।",
    "romaji": "Hayaku nete kudasai.",
    "en": "Please go to sleep early.",
    "bn": "দয়া করে তাড়াতাড়ি ঘুমিয়ে পড়ুন।",
    "level": "N5"
  },
  {
    "id": "s783",
    "jp": "山に登りたいです。",
    "romaji": "Yama ni noboritai desu.",
    "en": "I want to climb a mountain.",
    "bn": "আমি পাহাড়ে চড়তে চাই।",
    "level": "N5"
  },
  {
    "id": "s784",
    "jp": "冷たい飲み物がほしいです।",
    "romaji": "Tsumetai nomimono ga hoshii desu.",
    "en": "I want a cold drink.",
    "bn": "আমি একটি ঠান্ডা পানীয় চাই।",
    "level": "N5"
  },
  {
    "id": "s785",
    "jp": "お酒を飲みます。",
    "romaji": "Osake wo nomimasu.",
    "en": "I drink sake.",
    "bn": "আমি মদ পান করি।",
    "level": "N5"
  },
  {
    "id": "s786",
    "jp": "電車を乗り換えます।",
    "romaji": "Densha wo norikaemasu.",
    "en": "I transfer trains.",
    "bn": "আমি গাড়ি বদলাব।",
    "level": "N5"
  },
  {
    "id": "s787",
    "jp": "乗り物が好きです。",
    "romaji": "Norimono ga suki desu.",
    "en": "I like vehicles.",
    "bn": "আমি যানবাহন পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s788",
    "jp": "バスに乗ります।",
    "romaji": "Basu ni norimasu.",
    "en": "I board the bus.",
    "bn": "আমি বাসে উঠি।",
    "level": "N5"
  },
  {
    "id": "s789",
    "jp": "歯を磨きました。",
    "romaji": "Ha wo migakimashita.",
    "en": "I brushed my teeth.",
    "bn": "আমি দাঁত মেজেছি।",
    "level": "N5"
  },
  {
    "id": "s790",
    "jp": "はい、分かりました।",
    "romaji": "Hai, wakarimashita.",
    "en": "Yes, I understand.",
    "bn": "হ্যাঁ, আমি বুঝতে পেরেছি।",
    "level": "N5"
  },
  {
    "id": "s791",
    "jp": "ビールを三杯飲みました。",
    "romaji": "Biiru wo sanbai nomimashita.",
    "en": "I drank three glasses of beer.",
    "bn": "আমি তিন গ্লাস বিয়ার খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s792",
    "jp": "灰皿はどこですか？",
    "romaji": "Haizara wa doko desu ka?",
    "en": "Where is the ashtray?",
    "bn": "ছাইদানি কোথায়?",
    "level": "N5"
  },
  {
    "id": "s793",
    "jp": "部屋に入ってください।",
    "romaji": "Heya ni haitte kudasai.",
    "en": "Please enter the room.",
    "bn": "দয়া করে ঘরে প্রবেশ করুন।",
    "level": "N5"
  },
  {
    "id": "s794",
    "jp": "葉書を書きましょう。",
    "romaji": "Hagaki wo kakimashou.",
    "en": "Let's write a postcard.",
    "bn": "চলুন একটি পোস্টকার্ড লিখি।",
    "level": "N5"
  },
  {
    "id": "s795",
    "jp": "ズボンを履きます।",
    "romaji": "Zubon wo hakimasu.",
    "en": "I put on trousers.",
    "bn": "আমি প্যান্ট পরছি।",
    "level": "N5"
  },
  {
    "id": "s796",
    "jp": "箱の中に何がありますか？",
    "romaji": "Hako no naka ni nani ga arimasu ka?",
    "en": "What is inside the box?",
    "bn": "বাক্সের ভেতরে কী আছে?",
    "level": "N5"
  },
  {
    "id": "s797",
    "jp": "箸を使いましょう।",
    "romaji": "Hashi wo tsukaimashou.",
    "en": "Let's use chopsticks.",
    "bn": "চলুন চপস্টিক ব্যবহার করি।",
    "level": "N5"
  },
  {
    "id": "s798",
    "jp": "初めて日本に行きました。",
    "romaji": "Hajimete Nihon ni ikimashita.",
    "en": "I went to Japan for the first time.",
    "bn": "আমি প্রথমবারের মতো জাপানে গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s799",
    "jp": "春が来ました।",
    "romaji": "Haru ga kimashita.",
    "en": "Spring has come.",
    "bn": "বসন্ত এসেছে।",
    "level": "N5"
  },
  {
    "id": "s800",
    "jp": "切手を貼ってください।",
    "romaji": "Kitte wo hatte kudasai.",
    "en": "Please paste the stamp.",
    "bn": "দয়া করে ডাকটিকিটটি লাগান।",
    "level": "N5"
  },
  {
    "id": "s801",
    "jp": "晴れた日は気持ちがいいです。",
    "romaji": "Hareta hi wa kimochi ga ii desu.",
    "en": "Sunny days feel good.",
    "bn": "রৌদ্রোজ্জ্বল দিনগুলো খুব মনোরম লাগে।",
    "level": "N5"
  },
  {
    "id": "s802",
    "jp": "空が晴れてきました।",
    "romaji": "Sora ga harete kimashita.",
    "en": "The sky has cleared up.",
    "bn": "আকাশ পরিষ্কার হয়ে আসছে।",
    "level": "N5"
  },
  {
    "id": "s803",
    "jp": "一時間半待ちました।",
    "romaji": "Ichijikan han machimashita.",
    "en": "I waited for an hour and a half.",
    "bn": "আমি দেড় ঘণ্টা অপেক্ষা করেছি।",
    "level": "N5"
  },
  {
    "id": "s804",
    "jp": "晩ご飯は何ですか？",
    "romaji": "Bangohan wa nani desu ka?",
    "en": "What is for dinner?",
    "bn": "রাতের খাবারে কী আছে?",
    "level": "N5"
  },
  {
    "id": "s805",
    "jp": "一番好きな人は誰ですか？",
    "romaji": "Ichiban suki na hito wa dare desu ka?",
    "en": "Who is your favorite person?",
    "bn": "আপনার সবচেয়ে প্রিয় মানুষ কে?",
    "level": "N5"
  },
  {
    "id": "s806",
    "jp": "パンを食べました।",
    "romaji": "Pan wo tabemashita.",
    "en": "I ate bread.",
    "bn": "আমি রুটি খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s807",
    "jp": "ハンカチを貸してください。",
    "romaji": "Hankachi wo kashite kudasai.",
    "en": "Please lend me a handkerchief.",
    "bn": "দয়া করে আমাকে একটি রুমাল ধার দিন।",
    "level": "N5"
  },
  {
    "id": "s808",
    "jp": "電話番号を教えてください।",
    "romaji": "Denwabangou wo oshiete kudasai.",
    "en": "Please tell me your phone number.",
    "bn": "দয়া করে আপনার ফোন নম্বরটি বলুন।",
    "level": "N5"
  },
  {
    "id": "s809",
    "jp": "ご飯を半分食べました।",
    "romaji": "Gohan wo hanbun tabemashita.",
    "en": "I ate half of the meal.",
    "bn": "আমি অর্ধেক খাবার খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s810",
    "jp": "火に気をつけてください।",
    "romaji": "Hi ni ki wo tsukete kudasai.",
    "en": "Please be careful with fire.",
    "bn": "আগুন থেকে সাবধান থাকবেন।",
    "level": "N5"
  },
  {
    "id": "s811",
    "jp": "今日はいい日ですね।",
    "romaji": "Kyou wa ii hi desu ne.",
    "en": "Today is a good day, isn't it?",
    "bn": "আজ খুব ভালো একটি দিন, তাই না?",
    "level": "N5"
  },
  {
    "id": "s812",
    "jp": "猫を五匹飼っています।",
    "romaji": "Neko wo gohiki katte imasu.",
    "en": "I have five cats.",
    "bn": "আমার পাঁচটি পোষা বিড়াল আছে।",
    "level": "N5"
  },
  {
    "id": "s813",
    "jp": "ギターを弾きます。",
    "romaji": "Gitaa wo hikimasu.",
    "en": "I play the guitar.",
    "bn": "আমি গিটার বাজাই।",
    "level": "N5"
  },
  {
    "id": "s814",
    "jp": "手を引いてください।",
    "romaji": "Te wo hiite kudasai.",
    "en": "Please pull my hand.",
    "bn": "দয়া করে আমার হাতটি ধরুন (টানুন)।",
    "level": "N5"
  },
  {
    "id": "s815",
    "jp": "背が低いです।",
    "romaji": "Se ga hikui desu.",
    "en": "I am short.",
    "bn": "আমি খাটো।",
    "level": "N5"
  },
  {
    "id": "s816",
    "jp": "飛行機で日本へ行きます।",
    "romaji": "Hikouki de Nihon he ikimasu.",
    "en": "I go to Japan by airplane.",
    "bn": "আমি বিমানে করে জাপান যাব।",
    "level": "N5"
  },
  {
    "id": "s817",
    "jp": "左に曲がってください।",
    "romaji": "Hidari ni magatte kudasai.",
    "en": "Please turn left.",
    "bn": "দয়া করে বামে মোড় নিন।",
    "level": "N5"
  },
  {
    "id": "s818",
    "jp": "东から日が昇ります।",
    "romaji": "Higashi kara hi ga noborimasu.",
    "en": "The sun rises in the east.",
    "bn": "পূর্ব দিকে সূর্য ওঠে।",
    "level": "N5"
  },
  {
    "id": "s819",
    "jp": "一本の線を引きました।",
    "romaji": "Ippon no sen wo hikimashita.",
    "en": "I drew a line.",
    "bn": "আমি একটি দাগ টেনেছি।",
    "level": "N5"
  },
  {
    "id": "s820",
    "jp": "ピアノを弾くのが好きです।",
    "romaji": "Piano wo hiku no ga suki desu.",
    "en": "I like playing the piano.",
    "bn": "আমি পিয়ানো বাজাতে পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s821",
    "jp": "有名な人に会いました।",
    "romaji": "Yuumei na hito ni aimashita.",
    "en": "I met a famous person.",
    "bn": "আমি একজন বিখ্যাত মানুষের সাথে দেখা করেছি।",
    "level": "N5"
  },
  {
    "id": "s822",
    "jp": "りんごを一つください।",
    "romaji": "Ringo wo hitotsu kudasai.",
    "en": "Give me one apple, please.",
    "bn": "দয়া করে একটি আপেল দিন।",
    "level": "N5"
  },
  {
    "id": "s823",
    "jp": "一ヶ月休みました।",
    "romaji": "Ikkagetsu yasumimashita.",
    "en": "I took a month off.",
    "bn": "আমি এক মাস বিরতি নিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s824",
    "jp": "一人の時間は大切です।",
    "romaji": "Hitori no jikan wa taisetsu desu.",
    "en": "Time alone is important.",
    "bn": "একান্ত সময় কাটানো গুরুত্বপূর্ণ।",
    "level": "N5"
  },
  {
    "id": "s825",
    "jp": "今日は暇ですか？",
    "romaji": "Kyou wa hima desu ka?",
    "en": "Are you free today?",
    "bn": "আপনি কি আজ অবসর আছেন?",
    "level": "N5"
  },
  {
    "id": "s826",
    "jp": "テストで百分を取りました।",
    "romaji": "Tesuto de hyakuten wo torimashita.",
    "en": "I got 100 points on the test.",
    "bn": "আমি পরীক্ষায় ১০০ নম্বর পেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s827",
    "jp": "病院へ行きました।",
    "romaji": "Byouin he ikimashita.",
    "en": "I went to the hospital.",
    "bn": "আমি হাসপাতালে গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s828",
    "jp": "病気になりました।",
    "romaji": "Byouki ni narimashita.",
    "en": "I became ill.",
    "bn": "আমি অসুস্থ হয়ে পড়েছি।",
    "level": "N5"
  },
  {
    "id": "s829",
    "jp": "ひらがなを書けますか？",
    "romaji": "Hiragana wo kakemasu ka?",
    "en": "Can you write hiragana?",
    "bn": "আপনি কি হিরাগানা লিখতে পারেন?",
    "level": "N5"
  },
  {
    "id": "s830",
    "jp": "お昼に会いましょう।",
    "romaji": "O-hiru ni aimashou.",
    "en": "Let's meet at noon.",
    "bn": "দুপুরে দেখা করা যাক।",
    "level": "N5"
  },
  {
    "id": "s831",
    "jp": "昼ご飯を食べましたか？",
    "romaji": "Hirugohan wo tabemashita ka?",
    "en": "Did you eat lunch?",
    "bn": "আপনি কি দুপুরের খাবার খেয়েছেন?",
    "level": "N5"
  },
  {
    "id": "s832",
    "jp": "この部屋は広いですね।",
    "romaji": "Kono heya wa hiroi desu ne.",
    "en": "This room is spacious, isn't it?",
    "bn": "এই ঘরটি বেশ বড়, তাই না?",
    "level": "N5"
  },
  {
    "id": "s833",
    "jp": "封筒に手紙を入れました।",
    "romaji": "Fuutou ni tegami wo iremashita.",
    "en": "I put the letter in the envelope.",
    "bn": "আমি খামের ভেতরে চিঠিটি রেখেছি।",
    "level": "N5"
  },
  {
    "id": "s834",
    "jp": "プールで泳ぎます।",
    "romaji": "Puuru de oyogimasu.",
    "en": "I swim in the pool.",
    "bn": "আমি সুইমিং পুলে সাঁতার কাটি।",
    "level": "N5"
  },
  {
    "id": "s835",
    "jp": "フォークを使ってください।",
    "romaji": "Fooku wo tsukatte kudasai.",
    "en": "Please use a fork.",
    "bn": "কাঁটাচামচ ব্যবহার করুন।",
    "level": "N5"
  },
  {
    "id": "s836",
    "jp": "風が吹いています।",
    "romaji": "Kaze ga fuite imasu.",
    "en": "The wind is blowing.",
    "bn": "বাতাস বইছে।",
    "level": "N5"
  },
  {
    "id": "s837",
    "jp": "新しい服を買いました।",
    "romaji": "Atarashii fuku wo kaimashita.",
    "en": "I bought new clothes.",
    "bn": "আমি নতুন পোশাক কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s838",
    "jp": "これを二つください।",
    "romaji": "Kore wo futatsu kudasai.",
    "en": "Give me two of these, please.",
    "bn": "দয়া করে এরকম দুটি দিন।",
    "level": "N5"
  },
  {
    "id": "s839",
    "jp": "豚肉は食べません।",
    "romaji": "Butaniku wa tabemasen.",
    "en": "I don't eat pork.",
    "bn": "আমি শূকরের মাংস খাই না।",
    "level": "N5"
  },
  {
    "id": "s840",
    "jp": "二人の関係はいいです।",
    "romaji": "Futari no kankei wa ii desu.",
    "en": "The relationship between the two is good.",
    "bn": "দুজনের মধ্যে সম্পর্ক খুব ভালো।",
    "level": "N5"
  },
  {
    "id": "s841",
    "jp": "二日休みました।",
    "romaji": "Futsuka yasumimashita.",
    "en": "I took two days off.",
    "bn": "আমি দুদিন ছুটি নিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s842",
    "jp": "足が太いです।",
    "romaji": "Ashi ga futoi desu.",
    "en": "My legs are thick.",
    "bn": "আমার পাগুলো খুব মোটা।",
    "level": "N5"
  },
  {
    "id": "s843",
    "jp": "冬は寒いです।",
    "romaji": "Fuyu wa samui desu.",
    "en": "Winter is cold.",
    "bn": "শীতকালে খুব ঠান্ডা লাগে।",
    "level": "N5"
  },
  {
    "id": "s844",
    "jp": "雨が降っています।",
    "romaji": "Ame ga futte imasu.",
    "en": "It is raining.",
    "bn": "বৃষ্টি পড়ছে।",
    "level": "N5"
  },
  {
    "id": "s845",
    "jp": "古い本を読みました।",
    "romaji": "Furui hon wo yomimashita.",
    "en": "I read an old book.",
    "bn": "আমি একটি পুরানো বই পড়েছি।",
    "level": "N5"
  },
  {
    "id": "s846",
    "jp": "お風呂に入りました।",
    "romaji": "O-furo ni hairimashita.",
    "en": "I took a bath.",
    "bn": "আমি গোসল করেছি।",
    "level": "N5"
  },
  {
    "id": "s847",
    "jp": "十分分かります।",
    "romaji": "Juubun wakarimasu.",
    "en": "I understand perfectly.",
    "bn": "আমি পুরোপুরি বুঝতে পেরেছি।",
    "level": "N5"
  },
  {
    "id": "s848",
    "jp": "文章を読んでください।",
    "romaji": "Bunshou wo yonde kudasai.",
    "en": "Please read the sentence.",
    "bn": "দয়া করে বাক্যটি পড়ুন।",
    "level": "N5"
  },
  {
    "id": "s849",
    "jp": "ページをめくってください।",
    "romaji": "Peeji wo mekutte kudasai.",
    "en": "Please turn the page.",
    "bn": "দয়া করে পৃষ্ঠা উল্টান।",
    "level": "N5"
  },
  {
    "id": "s850",
    "jp": "下手な絵を描きました।",
    "romaji": "Heta na e wo kakimashita.",
    "en": "I drew a poor picture.",
    "bn": "আমি একটি বাজে ছবি এঁকেছি।",
    "level": "N5"
  },
  {
    "id": "s851",
    "jp": "ベッドで寝ます。",
    "romaji": "Beddo de nemasu.",
    "en": "I sleep in a bed.",
    "bn": "আমি বিছানায় ঘুমাই।",
    "level": "N5"
  },
  {
    "id": "s852",
    "jp": "ペットを飼いたいです।",
    "romaji": "Petto wo kaitai desu.",
    "en": "I want to have a pet.",
    "bn": "আমি একটি পোষা প্রাণী রাখতে চাই।",
    "level": "N5"
  },
  {
    "id": "s853",
    "jp": "部屋を掃除しました。",
    "romaji": "Heya wo souji shimashita.",
    "en": "I cleaned the room.",
    "bn": "আমি ঘরটি পরিষ্কার করেছি।",
    "level": "N5"
  },
  {
    "id": "s854",
    "jp": "この辺にコンビニはありますか？",
    "romaji": "Kono hen ni konbini wa arimasu ka?",
    "en": "Is there a convenience store around here?",
    "bn": "আশেপাশে কি কোনো দোকান আছে?",
    "level": "N5"
  },
  {
    "id": "s855",
    "jp": "ペンで書いてください।",
    "romaji": "Pen de kaite kudasai.",
    "en": "Please write with a pen.",
    "bn": "দয়া করে কলম দিয়ে লিখুন।",
    "level": "N5"
  },
  {
    "id": "s856",
    "jp": "勉強が楽しいです。",
    "romaji": "Benkyou ga tanoshii desu.",
    "en": "Studying is fun.",
    "bn": "পড়াশোনা খুব মজার।",
    "level": "N5"
  },
  {
    "id": "s857",
    "jp": "駅の近くは便利です।",
    "romaji": "Eki no chikaku wa benri desu.",
    "en": "The vicinity of the station is convenient.",
    "bn": "স্টেশনের কাছাকাছি এলাকা সুবিধাজনক।",
    "level": "N5"
  },
  {
    "id": "s858",
    "jp": "あの方を知っていますか？",
    "romaji": "Ano hou wo shitte imasu ka?",
    "en": "Do you know that person?",
    "bn": "আপনি কি ওই ব্যক্তিকে চেনেন?",
    "level": "N5"
  },
  {
    "id": "s859",
    "jp": "帽子を被ります।",
    "romaji": "Boushi wo kaburimasu.",
    "en": "I wear a hat.",
    "bn": "আমি টুপি পরি।",
    "level": "N5"
  },
  {
    "id": "s860",
    "jp": "ボールペンを貸してください。",
    "romaji": "Boorupen wo kashite kudasai.",
    "en": "Please lend me a ballpoint pen.",
    "bn": "দয়া করে আমাকে একটি বলপেন ধার দিন।",
    "level": "N5"
  },
  {
    "id": "s861",
    "jp": "外には他にお客さんがいます।",
    "romaji": "Soto ni wa hoka ni o-kyakusan ga imasu.",
    "en": "There are other customers outside.",
    "bn": "বাইরে অন্য গ্রাহকরা বসে আছেন।",
    "level": "N5"
  },
  {
    "id": "s862",
    "jp": "ポケットに鍵を入れました。",
    "romaji": "Poketto ni kagi wo iremashita.",
    "en": "I put the key in my pocket.",
    "bn": "আমি পকেটে চাবিটি রেখেছি।",
    "level": "N5"
  },
  {
    "id": "s863",
    "jp": "新しい靴が欲しいです।",
    "romaji": "Atarashii kutsu ga hoshii desu.",
    "en": "I want new shoes.",
    "bn": "আমি নতুন জুতো চাই।",
    "level": "N5"
  },
  {
    "id": "s864",
    "jp": "ポストにハガキを出しました。",
    "romaji": "Posuto ni hagaki wo dashimashita.",
    "en": "I posted a postcard in the postbox.",
    "bn": "আমি ডাকবাক্সে একটি পোস্টকার্ড ফেলেছি।",
    "level": "N5"
  },
  {
    "id": "s865",
    "jp": "細い道を通ります।",
    "romaji": "Hosoi michi wo toorimasu.",
    "en": "I pass through a narrow road.",
    "bn": "আমি একটি সরু রাস্তা দিয়ে যাই।",
    "level": "N5"
  },
  {
    "id": "s866",
    "jp": "ボタンを押してください。",
    "romaji": "Botan wo oshite kudasai.",
    "en": "Please press the button.",
    "bn": "দয়া করে বোতামটি টিপুন।",
    "level": "N5"
  },
  {
    "id": "s867",
    "jp": "ホテルに泊まります।",
    "romaji": "Hoteru ni tomarimasu.",
    "en": "I stay at a hotel.",
    "bn": "আমি একটি হোটেলে থাকি।",
    "level": "N5"
  },
  {
    "id": "s868",
    "jp": "本を読みましょう。",
    "romaji": "Hon wo yomimashou.",
    "en": "Let's read a book.",
    "bn": "চলুন একটি বই পড়ি।",
    "level": "N5"
  },
  {
    "id": "s869",
    "jp": "鉛筆を三本買いました।",
    "romaji": "Enpitsu wo sanbon kaimashita.",
    "en": "I bought three pencils.",
    "bn": "আমি তিনটি পেন্সিল কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s870",
    "jp": "本棚を整理しましょう。",
    "romaji": "Hondana wo seiri shimashou.",
    "en": "Let's organize the bookshelf.",
    "bn": "চলুন বইয়ের তাকটি গুছিয়ে রাখি।",
    "level": "N5"
  },
  {
    "id": "s871",
    "jp": "本当の話をしてください।",
    "romaji": "Hontou no hanashi wo shite kudasai.",
    "en": "Please tell the true story.",
    "bn": "দয়া করে সত্যি কথা বলুন।",
    "level": "N5"
  },
  {
    "id": "s872",
    "jp": "毎朝六時に起きます。",
    "romaji": "Maiasa rokuji ni okimasu.",
    "en": "I get up at six every morning.",
    "bn": "আমি প্রতিদিন সকাল ছ’টায় উঠি।",
    "level": "N5"
  },
  {
    "id": "s873",
    "jp": "切手を三枚買いました।",
    "romaji": "Kitte wo sanmai kaimashita.",
    "en": "I bought three stamps.",
    "bn": "আমি তিনটি ডাকটিকিট কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s874",
    "jp": "毎朝パンを食べます。",
    "romaji": "Maiasa pan wo tabemasu.",
    "en": "I eat bread every morning.",
    "bn": "আমি প্রতিদিন সকালে রুটি খাই।",
    "level": "N5"
  },
  {
    "id": "s875",
    "jp": "毎月一回旅行します।",
    "romaji": "Maigetsu ikkai ryokou shimasu.",
    "en": "I travel once a month.",
    "bn": "আমি প্রতি মাসে একবার ভ্রমণে বের হই।",
    "level": "N5"
  },
  {
    "id": "s876",
    "jp": "毎週日曜日は休みです。",
    "romaji": "Maishuu nichiyoubi wa yasumi desu.",
    "en": "Every Sunday is a holiday.",
    "bn": "প্রতি রবিবার ছুটি থাকে।",
    "level": "N5"
  },
  {
    "id": "s877",
    "jp": "毎日日本語を勉強します।",
    "romaji": "Mainichi nihongo wo benkyou shimasu.",
    "en": "I study Japanese every day.",
    "bn": "আমি প্রতিদিন জাপানি ভাষা পড়ি।",
    "level": "N5"
  },
  {
    "id": "s878",
    "jp": "毎年日本に行きます。",
    "romaji": "Mainen nihon ni ikimasu.",
    "en": "I go to Japan every year.",
    "bn": "আমি প্রতি বছর জাপানে যাই।",
    "level": "N5"
  },
  {
    "id": "s879",
    "jp": "毎晩テレビを見ます।",
    "romaji": "Maiban terebi wo mimasu.",
    "en": "I watch TV every night.",
    "bn": "আমি প্রতি রাতে টিভি দেখি।",
    "level": "N5"
  },
  {
    "id": "s880",
    "jp": "机の前に椅子があります。",
    "romaji": "Tsukue no mae ni isu ga arimasu.",
    "en": "There is a chair in front of the desk.",
    "bn": "টেবিলের সামনে একটি চেয়ার আছে।",
    "level": "N5"
  },
  {
    "id": "s881",
    "jp": "三十分前に着きました।",
    "romaji": "Sanjuppun mae ni tsukimashita.",
    "en": "I arrived 30 minutes ago.",
    "bn": "আমি ৩০ মিনিট আগে পৌঁছেছি।",
    "level": "N5"
  },
  {
    "id": "s882",
    "jp": "右に曲がってください。",
    "romaji": "Migi ni magatte kudasai.",
    "en": "Please turn right.",
    "bn": "দয়া করে ডানে মোড় নিন।",
    "level": "N5"
  },
  {
    "id": "s883",
    "jp": "この料理はまずいですね।",
    "romaji": "Kono ryouri wa mazui desu ne.",
    "en": "This food tastes bad, doesn't it?",
    "bn": "এই খাবারটি বিস্বাদ, তাই না?",
    "level": "N5"
  },
  {
    "id": "s884",
    "jp": "また明日会いましょう。",
    "romaji": "Mata ashita aimashou.",
    "en": "Let's meet again tomorrow.",
    "bn": "কাল আবার দেখা হবে।",
    "level": "N5"
  },
  {
    "id": "s885",
    "jp": "まだ終わっていません।",
    "romaji": "Mada owatte imasen.",
    "en": "It is not finished yet.",
    "bn": "এটি এখনো শেষ হয়নি।",
    "level": "N5"
  },
  {
    "id": "s886",
    "jp": "賑やかな町ですね。",
    "romaji": "Nigiyaka na machi desu ne.",
    "en": "It is a lively town, isn't it?",
    "bn": "এটি একটি ব্যস্ত শহর, তাই না?",
    "level": "N5"
  },
  {
    "id": "s887",
    "jp": "ここで待ってください।",
    "romaji": "Koko de matte kudasai.",
    "en": "Please wait here.",
    "bn": "দয়া করে এখানে অপেক্ষা করুন।",
    "level": "N5"
  },
  {
    "id": "s888",
    "jp": "まっすぐ行ってください。",
    "romaji": "Massugu itte kudasai.",
    "en": "Please go straight ahead.",
    "bn": "দয়া করে সরাসরি সামনে যান।",
    "level": "N5"
  },
  {
    "id": "s889",
    "jp": "マッチを擦りました।",
    "romaji": "Matchi wo surimashita.",
    "en": "I struck a match.",
    "bn": "আমি দিয়াশলাই জ্বালিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s890",
    "jp": "窓を開けてください。",
    "romaji": "Mado wo akete kudasai.",
    "en": "Please open the window.",
    "bn": "জানালাটি খুলে দিন।",
    "level": "N5"
  },
  {
    "id": "s891",
    "jp": "地球は丸いです।",
    "romaji": "Chikyuu wa marui desu.",
    "en": "The earth is round.",
    "bn": "পৃথিবী বৃত্তাকার।",
    "level": "N5"
  },
  {
    "id": "s892",
    "jp": "一万円あります。",
    "romaji": "Ichiman-en arimasu.",
    "en": "I have 10,000 yen.",
    "bn": "আমার কাছে দশ হাজার ইয়েন আছে।",
    "level": "N5"
  },
  {
    "id": "s893",
    "jp": "万年筆で書きます।",
    "romaji": "Mannenhitsu de kakimasu.",
    "en": "I write with a fountain pen.",
    "bn": "আমি একটি ঝরনা কলম দিয়ে লিখি।",
    "level": "N5"
  },
  {
    "id": "s894",
    "jp": "毎日歯を磨きます。",
    "romaji": "Mainichi ha wo migakimasu.",
    "en": "I brush my teeth every day.",
    "bn": "আমি প্রতিদিন দাঁত মাজি।",
    "level": "N5"
  },
  {
    "id": "s895",
    "jp": "右を見てください।",
    "romaji": "Migi wo mite kudasai.",
    "en": "Please look to the right.",
    "bn": "ডান দিকে তাকান।",
    "level": "N5"
  },
  {
    "id": "s896",
    "jp": "短い鉛筆ですね。",
    "romaji": "Mijikai enpitsu desu ne.",
    "en": "It's a short pencil, isn't it?",
    "bn": "এটি কী ছোট পেন্সিল, তাই না?",
    "level": "N5"
  },
  {
    "id": "s897",
    "jp": "水を飲んでください।",
    "romaji": "Mizu wo nonde kudasai.",
    "en": "Please drink water.",
    "bn": "দয়া করে পানি পান করুন।",
    "level": "N5"
  },
  {
    "id": "s898",
    "jp": "店へ行きましょう。",
    "romaji": "Mise he ikimashou.",
    "en": "Let's go to the shop.",
    "bn": "চলুন দোকানে যাই।",
    "level": "N5"
  },
  {
    "id": "s899",
    "jp": "写真を見せてください।",
    "romaji": "Shashin wo misete kudasai.",
    "en": "Please show me the photo.",
    "bn": "দয়া করে ছবিটি দেখান।",
    "level": "N5"
  },
  {
    "id": "s900",
    "jp": "広い道ですね。",
    "romaji": "Hiroi michi desu ne.",
    "en": "It is a wide road, isn't it?",
    "bn": "রাস্তাটি অনেক চওড়া, তাই না?",
    "level": "N5"
  },
  {
    "id": "s901",
    "jp": "美味しいものを食べたいです。",
    "romaji": "Oishii mono wo tabetai desu.",
    "en": "I want to eat delicious things.",
    "bn": "আমি সুস্বাদু কিছু খেতে চাই।",
    "level": "N5"
  },
  {
    "id": "s902",
    "jp": "大きい家ですね।",
    "romaji": "Ookii ie desu ne.",
    "en": "It's a big house, isn't it?",
    "bn": "এটি অনেক বড় বাড়ি, তাই না?",
    "level": "N5"
  },
  {
    "id": "s903",
    "jp": "大勢の人がいます。",
    "romaji": "Oozei no hito ga imasu.",
    "en": "There are many people.",
    "bn": "সেখানে অনেক মানুষ আছে।",
    "level": "N5"
  },
  {
    "id": "s904",
    "jp": "お母さんはどこですか？",
    "romaji": "O-kaasan wa doko desu ka?",
    "en": "Where is your mother?",
    "bn": "আপনার মা কোথায়?",
    "level": "N5"
  },
  {
    "id": "s905",
    "jp": "お菓子を食べました।",
    "romaji": "O-kashi wo tabemashita.",
    "en": "I ate sweets.",
    "bn": "আমি মিষ্টি খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s906",
    "jp": "お金がありません。",
    "romaji": "O-kane ga arimasen.",
    "en": "I have no money.",
    "bn": "আমার কাছে টাকা নেই।",
    "level": "N5"
  },
  {
    "id": "s907",
    "jp": "起きる時間ですよ।",
    "romaji": "Okiru jikan desu yo.",
    "en": "It's time to wake up.",
    "bn": "ওঠার সময় হয়েছে কিন্তু।",
    "level": "N5"
  },
  {
    "id": "s908",
    "jp": "荷物を置きました。",
    "romaji": "Nimotsu wo okimashita.",
    "en": "I put down the luggage.",
    "bn": "আমি মালামালগুলো নামিয়ে রেখেছি।",
    "level": "N5"
  },
  {
    "id": "s909",
    "jp": "奥さんはお元気ですか？",
    "romaji": "Oku-san wa o-genki desu ka?",
    "en": "How is your wife?",
    "bn": "আপনার স্ত্রী কেমন আছেন?",
    "level": "N5"
  },
  {
    "id": "s910",
    "jp": "お酒は飲みません।",
    "romaji": "O-sake wa nomimasen.",
    "en": "I don't drink sake.",
    "bn": "আমি মদ পান করি না।",
    "level": "N5"
  },
  {
    "id": "s911",
    "jp": "お皿を洗ってください。",
    "romaji": "O-sara wo aratte kudasai.",
    "en": "Please wash the plates.",
    "bn": "দয়া করে থালাগুলো ধুয়ে দিন।",
    "level": "N5"
  },
  {
    "id": "s912",
    "jp": "おじいさんはお元気ですか？",
    "romaji": "Ojiisan wa o-genki desu ka?",
    "en": "How is your grandfather?",
    "bn": "আপনার দাদা কেমন আছেন?",
    "level": "N5"
  },
  {
    "id": "s913",
    "jp": "お教えるのが上手ですね।",
    "romaji": "O-oshieru no ga jouzu desu ne.",
    "en": "You are good at teaching, aren't you?",
    "bn": "আপনি তো খুব ভালো শেখাতে পারেন, তাই না?",
    "level": "N5"
  },
  {
    "id": "s914",
    "jp": "おじさんは優しいです。",
    "romaji": "Ojisan wa yasashii desu.",
    "en": "My uncle is kind.",
    "bn": "আমার চাচা খুব দয়ালু।",
    "level": "N5"
  },
  {
    "id": "s915",
    "jp": "お茶を飲みましょう।",
    "romaji": "O-cha wo nomimashou.",
    "en": "Let's drink tea.",
    "bn": "চলুন চা পান করি।",
    "level": "N5"
  },
  {
    "id": "s916",
    "jp": "お手洗いはどこですか？",
    "romaji": "O-tearai wa doko desu ka?",
    "en": "Where is the restroom?",
    "bn": "শৌচাগারটি কোথায়?",
    "level": "N5"
  },
  {
    "id": "s917",
    "jp": "お父さんはどこですか？",
    "romaji": "O-tousan wa doko desu ka?",
    "en": "Where is your father?",
    "bn": "আপনার বাবা কোথায়?",
    "level": "N5"
  },
  {
    "id": "s918",
    "jp": "弟がいます।",
    "romaji": "Otouto ga imasu.",
    "en": "I have a younger brother.",
    "bn": "আমার একজন ছোট ভাই আছে।",
    "level": "N5"
  },
  {
    "id": "s919",
    "jp": "一昨日、雨が降りました。",
    "romaji": "Ototoi, ame ga furimashita.",
    "en": "It rained the day before yesterday.",
    "bn": "গত পরশু বৃষ্টি হয়েছিল।",
    "level": "N5"
  },
  {
    "id": "s920",
    "jp": "男の人がいます।",
    "romaji": "Otoko no hito ga imasu.",
    "en": "There is a man.",
    "bn": "সেখানে একজন পুরুষ আছেন।",
    "level": "N5"
  },
  {
    "id": "s921",
    "jp": "男の子が遊んでいます。",
    "romaji": "Otoko no ko ga asonde imasu.",
    "en": "The boy is playing.",
    "bn": "ছেলেটি খেলা করছে।",
    "level": "N5"
  },
  {
    "id": "s922",
    "jp": "お寺に行きました।",
    "romaji": "O-tera ni ikimashita.",
    "en": "I went to the temple.",
    "bn": "আমি মন্দিরে গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s923",
    "jp": "お弁当を食べました。",
    "romaji": "O-bentou wo tabemashita.",
    "en": "I ate a lunch box pack.",
    "bn": "আমি লাঞ্চ বক্স খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s924",
    "jp": "覚えるのが大変です।",
    "romaji": "Oboeru no ga taihen desu.",
    "en": "Memorizing is hard.",
    "bn": "মনে রাখা বা মুখস্থ করা বেশ কঠিন।",
    "level": "N5"
  },
  {
    "id": "s925",
    "jp": "重い荷物を持ちました。",
    "romaji": "Omoi nimotsu wo mochimashita.",
    "en": "I carried heavy luggage.",
    "bn": "আমি ভারি মালামাল বহন করেছি।",
    "level": "N5"
  },
  {
    "id": "s926",
    "jp": "面白い本ですね।",
    "romaji": "Omoshiroi hon desu ne.",
    "en": "It's an interesting book, isn't it?",
    "bn": "বইটি খুব মজার, তাই না?",
    "level": "N5"
  },
  {
    "id": "s927",
    "jp": "お婆さんはお元気ですか？",
    "romaji": "Obaasan wa o-genki desu ka?",
    "en": "How is your grandmother?",
    "bn": "আপনার দাদি কেমন আছেন?",
    "level": "N5"
  },
  {
    "id": "s928",
    "jp": "お風呂に入りましょう।",
    "romaji": "O-furo ni hairimashou.",
    "en": "Let's take a bath.",
    "bn": "চলুন গোসল করি।",
    "level": "N5"
  },
  {
    "id": "s929",
    "jp": "お弁当を持ってきました。",
    "romaji": "O-bentou wo motte kimashita.",
    "en": "I brought a lunch box pack.",
    "bn": "আমি লাঞ্চ বক্স নিয়ে এসেছি।",
    "level": "N5"
  },
  {
    "id": "s930",
    "jp": "覚えていますか？",
    "romaji": "Oboete imasu ka?",
    "en": "Do you remember?",
    "bn": "আপনার কি মনে আছে?",
    "level": "N5"
  },
  {
    "id": "s931",
    "jp": "思い出しました।",
    "romaji": "Omoidashimashita.",
    "en": "I remembered.",
    "bn": "আমার মনে পড়েছে।",
    "level": "N5"
  },
  {
    "id": "s932",
    "jp": "おもちゃで遊んでいます。",
    "romaji": "Omocha de asonde imasu.",
    "en": "I am playing with toys.",
    "bn": "আমি খেলনা দিয়ে খেলছি।",
    "level": "N5"
  },
  {
    "id": "s933",
    "jp": "親を大切にしてください।",
    "romaji": "Oya wo taisetsu ni shite kudasai.",
    "en": "Please value your parents.",
    "bn": "দয়া করে মা-বাবাকে সম্মান করবেন।",
    "level": "N5"
  },
  {
    "id": "s934",
    "jp": "泳ぐのが好きです。",
    "romaji": "Oyogu no ga suki desu.",
    "en": "I like swimming.",
    "bn": "আমি সাঁতার কাটতে পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s935",
    "jp": "降ります।",
    "romaji": "Orimasu.",
    "en": "I get off (the bus, train).",
    "bn": "আমি নামছি।",
    "level": "N5"
  },
  {
    "id": "s936",
    "jp": "終わりました。",
    "romaji": "Owarimashita.",
    "en": "It is finished.",
    "bn": "শেষ হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s937",
    "jp": "音楽を聞きます।",
    "romaji": "Ongaku wo kikimasu.",
    "en": "I listen to music.",
    "bn": "আমি গান শুনি।",
    "level": "N5"
  },
  {
    "id": "s938",
    "jp": "女の人がいます。",
    "romaji": "Onna no hito ga imasu.",
    "en": "There is a woman.",
    "bn": "সেখানে একজন নারী আছেন।",
    "level": "N5"
  },
  {
    "id": "s939",
    "jp": "女の子が泣いています।",
    "romaji": "Onna no ko ga naite imasu.",
    "en": "The girl is crying.",
    "bn": "মেয়েটি কাঁদছে।",
    "level": "N5"
  },
  {
    "id": "s940",
    "jp": "外国へ行きたいです。",
    "romaji": "Gaikoku he ikitai desu.",
    "en": "I want to go to a foreign country.",
    "bn": "আমি বিদেশ যেতে চাই।",
    "level": "N5"
  },
  {
    "id": "s941",
    "jp": "外国人が多いですね।",
    "romaji": "Gaikokujin ga ooi desu ne.",
    "en": "There are many foreigners, aren't there?",
    "bn": "সেখানে অনেক বিদেশী লোক আছেন, তাই না?",
    "level": "N5"
  },
  {
    "id": "s942",
    "jp": "会社へ行きます。",
    "romaji": "Kaisha he ikimasu.",
    "en": "I go to the company.",
    "bn": "আমি অফিসে যাচ্ছি।",
    "level": "N5"
  },
  {
    "id": "s943",
    "jp": "階段を登ります।",
    "romaji": "Kaidan wo noborimasu.",
    "en": "I climb the stairs.",
    "bn": "আমি সিঁড়ি দিয়ে উঠছি।",
    "level": "N5"
  },
  {
    "id": "s944",
    "jp": "買い物をしましょう。",
    "romaji": "Kaimono wo shimashou.",
    "en": "Let's go shopping.",
    "bn": "চলুন কেনাকাটা করি।",
    "level": "N5"
  },
  {
    "id": "s945",
    "jp": "買う前に考えてください।",
    "romaji": "Kau mae ni kangaete kudasai.",
    "en": "Please think before buying.",
    "bn": "কেনার আগে দয়া করে ভেবে নিন।",
    "level": "N5"
  },
  {
    "id": "s946",
    "jp": "帰ります。",
    "romaji": "Kaerimasu.",
    "en": "I return home.",
    "bn": "আমি বাড়ি ফিরে যাচ্ছি।",
    "level": "N5"
  },
  {
    "id": "s947",
    "jp": "顔を洗ってください।",
    "romaji": "Kao wo aratte kudasai.",
    "en": "Please wash your face.",
    "bn": "দয়া করে মুখ ধুয়ে নিন।",
    "level": "N5"
  },
  {
    "id": "s948",
    "jp": "鍵を失くしました。",
    "romaji": "Kagi wo nakushimashita.",
    "en": "I lost the key.",
    "bn": "আমি চাবিটি হারিয়ে ফেলেছি।",
    "level": "N5"
  },
  {
    "id": "s949",
    "jp": "書くのが上手ですね।",
    "romaji": "Kaku no ga jouzu desu ne.",
    "en": "You are good at writing, aren't you?",
    "bn": "আপনি তো খুব ভালো লেখেন, তাই না?",
    "level": "N5"
  },
  {
    "id": "s950",
    "jp": "学生です。",
    "romaji": "Gakusei desu.",
    "en": "I am a student.",
    "bn": "আমি একজন ছাত্র।",
    "level": "N5"
  },
  {
    "id": "s951",
    "jp": "一ヶ月に一回映画を見ます。",
    "romaji": "Ikkagetsu ni ikkai eiga wo mimasu.",
    "en": "I watch a movie once a month.",
    "bn": "আমি মাসে একবার সিনেমা দেখি।",
    "level": "N5"
  },
  {
    "id": "s952",
    "jp": "五階にあります।",
    "romaji": "Gokai ni arimasu.",
    "en": "It is on the fifth floor.",
    "bn": "এটি পাঁচতলায় আছে।",
    "level": "N5"
  },
  {
    "id": "s953",
    "jp": "傘を差します。",
    "romaji": "Kasa wo sashimasu.",
    "en": "I put up an umbrella.",
    "bn": "আমি ছাতা ধরছি।",
    "level": "N5"
  },
  {
    "id": "s954",
    "jp": "お菓子を貸してください？",
    "romaji": "O-kashi wo kashite kudasai?",
    "en": "Please lend me some sweets?",
    "bn": "দয়া করে আমাকে কিছু মিষ্টি দিন?",
    "level": "N5"
  },
  {
    "id": "s955",
    "jp": "風邪を引きました।",
    "romaji": "Kaze wo hikimashita.",
    "en": "I caught a cold.",
    "bn": "আমার ঠান্ডা লেগেছে।",
    "level": "N5"
  },
  {
    "id": "s956",
    "jp": "家族は元気です。",
    "romaji": "Kazoku wa genki desu.",
    "en": "My family is doing well.",
    "bn": "আমার পরিবারের সবাই ভালো আছে।",
    "level": "N5"
  },
  {
    "id": "s957",
    "jp": "片仮名を覚えましょう।",
    "romaji": "Katakana wo oboemashou.",
    "en": "Let's memorize katakana.",
    "bn": "চলুন কাতাকানা মুখস্থ করি।",
    "level": "N5"
  },
  {
    "id": "s958",
    "jp": "一ヶ月休みがほしいです。",
    "romaji": "Ikkagetsu yasumi ga hoshii desu.",
    "en": "I want a month-long holiday.",
    "bn": "আমি এক মাসের ছুটি চাই।",
    "level": "N5"
  },
  {
    "id": "s959",
    "jp": "コップが割れました।",
    "romaji": "Koppu ga waremashita.",
    "en": "The cup broke.",
    "bn": "কাপটি ভেঙে গেছে।",
    "level": "N5"
  },
  {
    "id": "s960",
    "jp": "体を大切にしてください。",
    "romaji": "Karada wo taisetsu ni shite kudasai.",
    "en": "Please take care of your body.",
    "bn": "দয়া করে নিজের শরীরের যত্ন নিন।",
    "level": "N5"
  },
  {
    "id": "s961",
    "jp": "本を貸してください।",
    "romaji": "Hon wo kashite kudasai.",
    "en": "Please lend me the book.",
    "bn": "দয়া করে আমাকে বইটি ধার দিন।",
    "level": "N5"
  },
  {
    "id": "s962",
    "jp": "靴を履きました。",
    "romaji": "Kutsu wo hakimashita.",
    "en": "I put on shoes.",
    "bn": "আমি জুতো পরেছি।",
    "level": "N5"
  },
  {
    "id": "s963",
    "jp": "軽い鞄がほしいです।",
    "romaji": "Karui kaban ga hoshii desu.",
    "en": "I want a light bag.",
    "bn": "আমি একটি হালকা ব্যাগ চাই।",
    "level": "N5"
  },
  {
    "id": "s964",
    "jp": "カレンダーを見てください。",
    "romaji": "Karendaa wo mite kudasai.",
    "en": "Please look at the calendar.",
    "bn": "দয়া করে ক্যালেন্ডারটি দেখুন।",
    "level": "N5"
  },
  {
    "id": "s965",
    "jp": "川で泳ぎます।",
    "romaji": "Kawa de oyogimasu.",
    "en": "I swim in the river.",
    "bn": "আমি নদীতে সাঁতার কাটি।",
    "level": "N5"
  },
  {
    "id": "s966",
    "jp": "可愛い猫ですね。",
    "romaji": "Kawaii neko desu ne.",
    "en": "It's a cute cat, isn't it?",
    "bn": "বিড়ালটি খুব কিউট, তাই না?",
    "level": "N5"
  },
  {
    "id": "s967",
    "jp": "漢字を書けますか？",
    "romaji": "Kanji wo kakemasu ka?",
    "en": "Can you write kanji?",
    "bn": "আপনি কি কাঞ্জি লিখতে পারেন?",
    "level": "N5"
  },
  {
    "id": "s968",
    "jp": "木の下で休みましょう।",
    "romaji": "Ki no shita de yasumimashou.",
    "en": "Let's rest under the tree.",
    "bn": "চলুন গাছের নিচে বিশ্রাম করি।",
    "level": "N5"
  },
  {
    "id": "s969",
    "jp": "黄色い花が咲きました。",
    "romaji": "Kiiroi hana ga sakimashita.",
    "en": "A yellow flower bloomed.",
    "bn": "একটি হলুদ ফুল ফুটেছে।",
    "level": "N5"
  },
  {
    "id": "s970",
    "jp": "消えそうです।",
    "romaji": "Kiesou desu.",
    "en": "It seems like it will go out.",
    "bn": "মনে হচ্ছে এটি নিভে যাবে।",
    "level": "N5"
  },
  {
    "id": "s971",
    "jp": "北は寒いです。",
    "romaji": "Kita wa samui desu.",
    "en": "The north is cold.",
    "bn": "উত্তর দিক খুব ঠান্ডা।",
    "level": "N5"
  },
  {
    "id": "s972",
    "jp": "ギターを弾きたいです।",
    "romaji": "Gitaa wo hikitai desu.",
    "en": "I want to play the guitar.",
    "bn": "আমি গিটার বাজাতে চাই।",
    "level": "N5"
  },
  {
    "id": "s973",
    "jp": "汚い部屋を掃除しましょう。",
    "romaji": "Kitanai heya wo souji shimashou.",
    "en": "Let's clean the dirty room.",
    "bn": "চলুন নোংরা ঘরটি পরিষ্কার করি।",
    "level": "N5"
  },
  {
    "id": "s974",
    "jp": "喫茶店でお茶を飲みました।",
    "romaji": "Kissaten de o-cha wo nomimashita.",
    "en": "I drank tea at the cafe.",
    "bn": "আমি ক্যাফেতে চা খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s975",
    "jp": "切手を貼りました。",
    "romaji": "Kitte wo harimashita.",
    "en": "I pasted a stamp.",
    "bn": "আমি ডাকটিকিট লাগিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s976",
    "jp": "切符を買いました।",
    "romaji": "Kippu wo kaimashita.",
    "en": "I bought a ticket.",
    "bn": "আমি একটি টিকিট কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s977",
    "jp": "昨日、銀座へ行きました。",
    "romaji": "Kinou, Ginza he ikimashita.",
    "en": "I went to Ginza yesterday.",
    "bn": "আমি গতকাল গিনজাতে গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s978",
    "jp": "九時に寝ました।",
    "romaji": "Kuji ni nemashita.",
    "en": "I went to bed at nine.",
    "bn": "আমি ন’টায় ঘুমানো গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s979",
    "jp": "牛乳を飲みました。",
    "romaji": "Gyuunyuu wo nomimashita.",
    "en": "I drank milk.",
    "bn": "আমি দুধ খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s980",
    "jp": "今日もいい天気ですね।",
    "romaji": "Kyou mo ii tenki desu ne.",
    "en": "It's nice weather today as well, isn't it?",
    "bn": "আজকেও বেশ রৌদ্রোজ্জ্বল দিন, তাই না?",
    "level": "N5"
  },
  {
    "id": "s981",
    "jp": "教室で勉強します。",
    "romaji": "Kyoushitsu de benkyou shimasu.",
    "en": "I study in the classroom.",
    "bn": "আমি ক্লাসরুমে পড়াশোনা করি।",
    "level": "N5"
  },
  {
    "id": "s982",
    "jp": "兄弟がいますか？",
    "romaji": "Kyoudai ga imasu ka?",
    "en": "Do you have siblings?",
    "bn": "আপনার কি কোনো ভাইবোন আছে?",
    "level": "N5"
  },
  {
    "id": "s983",
    "jp": "去年、日本へ来ました।",
    "romaji": "Kyonen, Nihon he kimashita.",
    "en": "I came to Japan last year.",
    "bn": "আমি গত বছর জাপানে এসেছি।",
    "level": "N5"
  },
  {
    "id": "s984",
    "jp": "嫌いな食べ物はありますか？",
    "romaji": "Kirai na tabemono wa arimasu ka?",
    "en": "Is there any food you dislike?",
    "bn": "আপনার কি অপছন্দের কোনো খাবার আছে?",
    "level": "N5"
  },
  {
    "id": "s985",
    "jp": "髪を切りました।",
    "romaji": "Kami wo kirimashita.",
    "en": "I cut my hair.",
    "bn": "আমি চুল কাটিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s986",
    "jp": "静かな場所が好きです。",
    "romaji": "Shizuka na basho ga suki desu.",
    "en": "I like quiet places.",
    "bn": "আমি শান্ত জায়গা পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s987",
    "jp": "銀行はどこですか？",
    "romaji": "Ginkou wa doko desu ka?",
    "en": "Where is the bank?",
    "bn": "ব্যাংকটি কোথায়?",
    "level": "N5"
  },
  {
    "id": "s988",
    "jp": "金曜日、会いましょう।",
    "romaji": "Kinyoubi, aimashou.",
    "en": "Let's meet on Friday.",
    "bn": "শুক্রবারে দেখা করা যাক।",
    "level": "N5"
  },
  {
    "id": "s989",
    "jp": "九月の初めに行きました。",
    "romaji": "Kugatsu no hajime ni ikimashita.",
    "en": "I went at the beginning of September.",
    "bn": "আমি সেপ্টেম্বরের শুরুতে গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s990",
    "jp": "薬を飲みました।",
    "romaji": "Kusuri wo nomimashita.",
    "en": "I took medicine.",
    "bn": "আমি ওষুধ খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s991",
    "jp": "下さい。",
    "romaji": "Kudasai.",
    "en": "Give me, please.",
    "bn": "দয়া করে দিন।",
    "level": "N5"
  },
  {
    "id": "s992",
    "jp": "果物を食べましょう।",
    "romaji": "Kudamono wo tabemashou.",
    "en": "Let's eat fruit.",
    "bn": "চলুন ফল খাই।",
    "level": "N5"
  },
  {
    "id": "s993",
    "jp": "口を開けてください。",
    "romaji": "Kuchi wo akete kudasai.",
    "en": "Please open your mouth.",
    "bn": "দয়া করে মুখ খুলুন।",
    "level": "N5"
  },
  {
    "id": "s994",
    "jp": "靴下を履きました।",
    "romaji": "Kutsushita wo hakimashita.",
    "en": "I put on socks.",
    "bn": "আমি মোজা পরেছি।",
    "level": "N5"
  },
  {
    "id": "s995",
    "jp": "国へ帰りたいです。",
    "romaji": "Kuni he kaeritai desu.",
    "en": "I want to return to my country.",
    "bn": "আমি নিজের দেশে ফিরতে চাই।",
    "level": "N5"
  },
  {
    "id": "s996",
    "jp": "曇っています।",
    "romaji": "Kumotte imasu.",
    "en": "It is cloudy.",
    "bn": "আকাশ মেঘলা হয়ে আছে।",
    "level": "N5"
  },
  {
    "id": "s997",
    "jp": "暗い部屋ですね।",
    "romaji": "Kurai heya desu ne.",
    "en": "It's a dark room, isn't it?",
    "bn": "ঘরটি বেশ অন্ধকার, তাই না?",
    "level": "N5"
  },
  {
    "id": "s998",
    "jp": "クラスで日本語を話します。",
    "romaji": "Kurasu de nihongo wo hanashimasu.",
    "en": "I speak Japanese in class.",
    "bn": "আমি ক্লাসে জাপানি ভাষায় কথা বলি।",
    "level": "N5"
  },
  {
    "id": "s999",
    "jp": "車を運転したいです।",
    "romaji": "Kuruma wo unten shitai desu.",
    "en": "I want to drive a car.",
    "bn": "আমি গাড়ি চালাতে চাই।",
    "level": "N5"
  },
  {
    "id": "s1000",
    "jp": "黒いシャツですね。",
    "romaji": "Kuroi shatsu desu ne.",
    "en": "It's a black shirt, isn't it?",
    "bn": "শার্টটি কালো রঙের, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1001",
    "jp": "警官に道を聞きました。",
    "romaji": "Keikan ni michi wo kikimashita.",
    "en": "I asked the policeman for directions.",
    "bn": "আমি পুলিশ সদস্যের কাছ থেকে ঠিকানা জেনে নিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1002",
    "jp": "今朝、六時に起きました।",
    "romaji": "Kesa, rokuji ni okimashita.",
    "en": "I woke up at six this morning.",
    "bn": "আজ সকালে আমি ছয়টায় উঠেছি।",
    "level": "N5"
  },
  {
    "id": "s1003",
    "jp": "消しゴムを貸してください।",
    "romaji": "Keshigomu wo kashite kudasai.",
    "en": "Please lend me an eraser.",
    "bn": "দয়া করে আমাকে একটি রবার দিন।",
    "level": "N5"
  },
  {
    "id": "s1004",
    "jp": "景色が綺麗です।",
    "romaji": "Keshiki ga kirei desu.",
    "en": "The scenery is beautiful.",
    "bn": "প্রকৃতির দৃশ্যটি খুব সুন্দর।",
    "level": "N5"
  },
  {
    "id": "s1005",
    "jp": "消していいですか？",
    "romaji": "Keshite ii desu ka?",
    "en": "May I turn it off?",
    "bn": "আমি কি এটি নিভিয়ে বা বন্ধ করে দিতে পারি?",
    "level": "N5"
  },
  {
    "id": "s1006",
    "jp": "結構です।",
    "romaji": "Kekkou desu.",
    "en": "No, thank you / Fine.",
    "bn": "ঠিক আছে / লাগবে না।",
    "level": "N5"
  },
  {
    "id": "s1007",
    "jp": "結婚おめでとう।",
    "romaji": "Kekkon omedetou.",
    "en": "Happy wedding!",
    "bn": "শুভ বিবাহ!",
    "level": "N5"
  },
  {
    "id": "s1008",
    "jp": "月曜日ですね।",
    "romaji": "Getsuyoubi desu ne.",
    "en": "It's Monday, isn't it?",
    "bn": "আজ সোমবার, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1009",
    "jp": "玄関で待っています।",
    "romaji": "Genkan de matte imasu.",
    "en": "I am waiting at the entrance.",
    "bn": "আমি প্রবেশপথে অপেক্ষা করছি।",
    "level": "N5"
  },
  {
    "id": "s1010",
    "jp": "元気を出してください।",
    "romaji": "Genki wo dashite kudasai.",
    "en": "Please cheer up.",
    "bn": "দয়া করে সাহস হারাবেন না।",
    "level": "N5"
  },
  {
    "id": "s1011",
    "jp": "五円あります।",
    "romaji": "Goen arimasu.",
    "en": "I have five yen.",
    "bn": "আমার কাছে পাঁচ ইয়েন আছে।",
    "level": "N5"
  },
  {
    "id": "s1012",
    "jp": "公園で遊びましょう।",
    "romaji": "Kouen de asobimashou.",
    "en": "Let's play in the park.",
    "bn": "চলুন পার্কে খেলা করি।",
    "level": "N5"
  },
  {
    "id": "s1013",
    "jp": "交番へ行きましたが।",
    "romaji": "Kouban he ikimashita ga.",
    "en": "I went to the police box, but...",
    "bn": "আমি পুলিশ ফাঁড়িতে গিয়েছিলাম কিন্তু...",
    "level": "N5"
  },
  {
    "id": "s1014",
    "jp": "紅茶をください।",
    "romaji": "Koucha wo kudasai.",
    "en": "Please give me black tea.",
    "bn": "দয়া করে আমাকে লিকার চা দিন।",
    "level": "N5"
  },
  {
    "id": "s1015",
    "jp": "工場で働いています।",
    "romaji": "Koujou de hataraite imasu.",
    "en": "I am working in a factory.",
    "bn": "আমি কারখানায় কাজ করছি।",
    "level": "N5"
  },
  {
    "id": "s1016",
    "jp": "校長先生です।",
    "romaji": "Kouchousensei desu.",
    "en": "He is the principal.",
    "bn": "তিনি স্কুলের প্রধান শিক্ষক।",
    "level": "N5"
  },
  {
    "id": "s1017",
    "jp": "交差点にあります।",
    "romaji": "Kousaten ni arimasu.",
    "en": "It is at the intersection.",
    "bn": "এটি চৌরাস্তার মোড়ে আছে।",
    "level": "N5"
  },
  {
    "id": "s1018",
    "jp": "講堂で話します।",
    "romaji": "Koudou de hanashimasu.",
    "en": "I speak in the auditorium.",
    "bn": "আমি অডিটোরিয়ামে কথা বলব।",
    "level": "N5"
  },
  {
    "id": "s1019",
    "jp": "高等学校へ行きます।",
    "romaji": "Koutougakkou he ikimasu.",
    "en": "I go to high school.",
    "bn": "আমি উচ্চ বিদ্যালয়ে পড়ছি।",
    "level": "N5"
  },
  {
    "id": "s1020",
    "jp": "公務員です।",
    "romaji": "Koumuin desu.",
    "en": "I am a public servant.",
    "bn": "আমি একজন সরকারি চাকুরিজীবী।",
    "level": "N5"
  },
  {
    "id": "s1021",
    "jp": "声が聞こえます।",
    "romaji": "Koe ga kikoemasu.",
    "en": "I hear a voice.",
    "bn": "আমি কণ্ঠস্বর শুনতে পাচ্ছি।",
    "level": "N5"
  },
  {
    "id": "s1022",
    "jp": "コートを着ます।",
    "romaji": "Kooto wo kimasu.",
    "en": "I put on a coat.",
    "bn": "আমি কোট পরছি।",
    "level": "N5"
  },
  {
    "id": "s1023",
    "jp": "コーヒーを飲みましょう।",
    "romaji": "Koohii wo nomimashou.",
    "en": "Let's drink coffee.",
    "bn": "চলুন কফি পান করি।",
    "level": "N5"
  },
  {
    "id": "s1024",
    "jp": "ここへ来てください।",
    "romaji": "Koko he kite kudasai.",
    "en": "Please come here.",
    "bn": "দয়া করে এখানে আসুন।",
    "level": "N5"
  },
  {
    "id": "s1025",
    "jp": "午後から雨が降ります।",
    "romaji": "Gogo kara ame ga furimasu.",
    "en": "It will rain from the afternoon.",
    "bn": "বিকাল থেকে বৃষ্টি শুরু হবে।",
    "level": "N5"
  },
  {
    "id": "s1026",
    "jp": "九日ですね।",
    "romaji": "Kokonoka desu ne.",
    "en": "It's the ninth, isn't it?",
    "bn": "আজ ৯ তারিখ, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1027",
    "jp": "九つあります।",
    "romaji": "Kokonotsu arimasu.",
    "en": "I have nine things.",
    "bn": "আমার নয়টি আছে।",
    "level": "N5"
  },
  {
    "id": "s1028",
    "jp": "御主人はお元気ですか？",
    "romaji": "Go-shujin wa o-genki desu ka?",
    "en": "How is your husband?",
    "bn": "আপনার স্বামী কেমন আছেন?",
    "level": "N5"
  },
  {
    "id": "s1029",
    "jp": "午前中に終わります।",
    "romaji": "Gozenchuu ni owarimasu.",
    "en": "It finishes during the morning.",
    "bn": "সকালের মধ্যে এটি শেষ হয়ে যাবে।",
    "level": "N5"
  },
  {
    "id": "s1030",
    "jp": "答えてください।",
    "romaji": "Kotaete kudasai.",
    "en": "Please answer.",
    "bn": "দয়া করে উত্তর দিন।",
    "level": "N5"
  },
  {
    "id": "s1031",
    "jp": "こちらこそよろしくお願いします।",
    "romaji": "Kochira koso yoroshiku onegaishimasu.",
    "en": "I am the one who should say that.",
    "bn": "আমার দিক থেকেও অনেক শুভকামনা রইল।",
    "level": "N5"
  },
  {
    "id": "s1032",
    "jp": "コップが割れました।",
    "romaji": "Koppu ga waremashita.",
    "en": "The cup broke.",
    "bn": "কাপটি ভেঙে গেছে।",
    "level": "N5"
  },
  {
    "id": "s1033",
    "jp": "今年はいい年ですね।",
    "romaji": "Kotoshi wa ii toshi desu ne.",
    "en": "This year is a good year, isn't it?",
    "bn": "এই বছরটি খুব ভালো, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1034",
    "jp": "言葉がわかりません।",
    "romaji": "Kotoba ga wakarimasen.",
    "en": "I don't understand the words.",
    "bn": "আমি ভাষা বুঝতে পারছি না।",
    "level": "N5"
  },
  {
    "id": "s1035",
    "jp": "子供がいます।",
    "romaji": "Kodomo ga imasu.",
    "en": "I have children.",
    "bn": "আমার সন্তান আছে।",
    "level": "N5"
  },
  {
    "id": "s1036",
    "jp": "御飯を食べましょう।",
    "romaji": "Gohan wo tabemashou.",
    "en": "Let's eat rice/meal.",
    "bn": "চলুন ভাত বা খাবার খাই।",
    "level": "N5"
  },
  {
    "id": "s1037",
    "jp": "困りましたね।",
    "romaji": "Komarimashita ne.",
    "en": "That's a problem, isn't it?",
    "bn": "ঝামেলা হয়ে গেল তো, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1038",
    "jp": "頃、会いましょう।",
    "romaji": "Koro, aimashou.",
    "en": "Let's meet around...",
    "bn": "আসুন সেই সময়ের আশেপাশে দেখা করি।",
    "level": "N5"
  },
  {
    "id": "s1039",
    "jp": "今晩、忙しいですか？",
    "romaji": "Konban, isogashii desu ka?",
    "en": "Are you busy tonight?",
    "bn": "আপনি কি আজ রাতে ব্যস্ত?",
    "level": "N5"
  },
  {
    "id": "s1040",
    "jp": "今日、会いましょう।",
    "romaji": "Kyou, aimashou.",
    "en": "Let's meet today.",
    "bn": "চলুন আজ দেখা করি।",
    "level": "N5"
  },
  {
    "id": "s1041",
    "jp": "昨日の夜、雨が降りました।",
    "romaji": "Kinou no yoru, ame ga furimashita.",
    "en": "It rained last night.",
    "bn": "গতকাল রাতে বৃষ্টি হয়েছিল।",
    "level": "N5"
  },
  {
    "id": "s1042",
    "jp": "今月、行きます।",
    "romaji": "Kongetsu, ikimasu.",
    "en": "I will go this month.",
    "bn": "আমি এই মাসে যাব।",
    "level": "N5"
  },
  {
    "id": "s1043",
    "jp": "今週、忙しいです।",
    "romaji": "Konshuu, isogashii desu.",
    "en": "I am busy this week.",
    "bn": "আমি এই সপ্তাহে ব্যস্ত আছি।",
    "level": "N5"
  },
  {
    "id": "s1044",
    "jp": "こんな本を読みました।",
    "romaji": "Konna hon wo yomimashita.",
    "en": "I read this kind of book.",
    "bn": "আমি এই ধরনের একটি বই পড়েছি।",
    "level": "N5"
  },
  {
    "id": "s1045",
    "jp": "さあ、行きましょう।",
    "romaji": "Saa, ikimashou.",
    "en": "Well, let's go.",
    "bn": "ওহে, চলুন যাওয়া যাক।",
    "level": "N5"
  },
  {
    "id": "s1046",
    "jp": "〜歳です।",
    "romaji": "~ sai desu.",
    "en": "I am ~ years old.",
    "bn": "আমার বয়স ... বছর।",
    "level": "N5"
  },
  {
    "id": "s1047",
    "jp": "魚が好きです।",
    "romaji": "Sakana ga suki desu.",
    "en": "I like fish.",
    "bn": "আমি মাছ পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s1048",
    "jp": "お酒を飲みます।",
    "romaji": "O-sake wo nomimasu.",
    "en": "I drink sake.",
    "bn": "আমি মদ পান করি।",
    "level": "N5"
  },
  {
    "id": "s1049",
    "jp": "先に帰ります।",
    "romaji": "Saki ni kaerimasu.",
    "en": "I am returning home first.",
    "bn": "আমি আগেই বাড়ি ফিরে যাচ্ছি।",
    "level": "N5"
  },
  {
    "id": "s1050",
    "jp": "咲きました।",
    "romaji": "Sakimashita.",
    "en": "It bloomed.",
    "bn": "ফুটেছে।",
    "level": "N5"
  },
  {
    "id": "s1051",
    "jp": "作文を書きました。",
    "romaji": "Sakubun wo kakimashita.",
    "en": "I wrote an essay.",
    "bn": "আমি একটি প্রবন্ধ লিখেছি।",
    "level": "N5"
  },
  {
    "id": "s1052",
    "jp": "差しました।",
    "romaji": "Sashimashita.",
    "en": "I put up (umbrella).",
    "bn": "আমি (ছাতা) ধরেছি।",
    "level": "N5"
  },
  {
    "id": "s1053",
    "jp": "雑誌を読みます。",
    "romaji": "Zasshi wo yomimasu.",
    "en": "I read magazines.",
    "bn": "আমি ম্যাগাজিন পড়ি।",
    "level": "N5"
  },
  {
    "id": "s1054",
    "jp": "散歩しましょう।",
    "romaji": "Sanpo shimashou.",
    "en": "Let's take a walk.",
    "bn": "চলুন একটু হেঁটে আসি।",
    "level": "N5"
  },
  {
    "id": "s1055",
    "jp": "三時です。",
    "romaji": "Sanji desu.",
    "en": "It is three o'clock.",
    "bn": "এখন ৩টে বাজে।",
    "level": "N5"
  },
  {
    "id": "s1056",
    "jp": "仕事は忙しいですか？",
    "romaji": "Shigoto wa isogashii desu ka?",
    "en": "Is your work busy?",
    "bn": "আপনি কি কাজে খুব ব্যস্ত?",
    "level": "N5"
  },
  {
    "id": "s1057",
    "jp": "四時ですね।",
    "romaji": "Yoji desu ne.",
    "en": "It's four o'clock, isn't it?",
    "bn": "এখন ৪টে বাজে, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1058",
    "jp": "辞書を引きます。",
    "romaji": "Jisho wo hikimasu.",
    "en": "I look up in the dictionary.",
    "bn": "আমি ডিকশনারিতে শব্দ খুঁজছি।",
    "level": "N5"
  },
  {
    "id": "s1059",
    "jp": "静かにしてください।",
    "romaji": "Shizuka ni shite kudasai.",
    "en": "Please be quiet.",
    "bn": "দয়া করে শান্ত থাকুন।",
    "level": "N5"
  },
  {
    "id": "s1060",
    "jp": "舌が痛いです。",
    "romaji": "Shita ga itai desu.",
    "en": "My tongue hurts.",
    "bn": "আমার জিভ ব্যথা করছে।",
    "level": "N5"
  },
  {
    "id": "s1061",
    "jp": "七時、起きましょう।",
    "romaji": "Nanaji, okimashou.",
    "en": "Let's wake up at seven.",
    "bn": "চলুন ৭টায় উঠি।",
    "level": "N5"
  },
  {
    "id": "s1062",
    "jp": "質問はありますか？",
    "romaji": "Shitsumon wa arimasu ka?",
    "en": "Do you have any questions?",
    "bn": "আপনার কি কোনো প্রশ্ন আছে?",
    "level": "N5"
  },
  {
    "id": "s1063",
    "jp": "自転車で行きます।",
    "romaji": "Jitensha de ikimasu.",
    "en": "I go by bicycle.",
    "bn": "আমি সাইকেলে করে যাব।",
    "level": "N5"
  },
  {
    "id": "s1064",
    "jp": "自動車を借りました。",
    "romaji": "Jidousha wo karimashita.",
    "en": "I borrowed a car.",
    "bn": "আমি একটি গাড়ি ধার নিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1065",
    "jp": "死にました।",
    "romaji": "Shinimashita.",
    "en": "He/it died.",
    "bn": "মারা গেছে।",
    "level": "N5"
  },
  {
    "id": "s1066",
    "jp": "自分を信じてください。",
    "romaji": "Jibun wo shinjite kudasai.",
    "en": "Please believe in yourself.",
    "bn": "দয়া করে নিজের উপর বিশ্বাস রাখুন।",
    "level": "N5"
  },
  {
    "id": "s1067",
    "jp": "字が綺麗ですね।",
    "romaji": "Ji ga kirei desu ne.",
    "en": "Your handwriting is beautiful, isn't it?",
    "bn": "আপনার হাতের লেখা খুব সুন্দর, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1068",
    "jp": "時間がありますか？",
    "romaji": "Jikan ga arimasu ka?",
    "en": "Do you have time?",
    "bn": "আপনার কি সময় হবে?",
    "level": "N5"
  },
  {
    "id": "s1069",
    "jp": "仕事を辞めました।",
    "romaji": "Shigoto wo yamemashita.",
    "en": "I quit my job.",
    "bn": "আমি চাকরি ছেড়ে দিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1070",
    "jp": "辞書を貸してください।",
    "romaji": "Jisho wo kashite kudasai.",
    "en": "Please lend me a dictionary.",
    "bn": "দয়া করে আমাকে একটি ডিকশনারি ধার দিন।",
    "level": "N5"
  },
  {
    "id": "s1071",
    "jp": "下を見てください।",
    "romaji": "Shita wo mite kudasai.",
    "en": "Please look down.",
    "bn": "দয়া করে নিচে দেখুন।",
    "level": "N5"
  },
  {
    "id": "s1072",
    "jp": "品物がいいですね。",
    "romaji": "Shinamono ga ii desu ne.",
    "en": "The goods are good, aren't they?",
    "bn": "জিনিসগুলো বেশ ভালো, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1073",
    "jp": "死ぬのは怖いです।",
    "romaji": "Shinu no wa kowai desu.",
    "en": "Dying is scary.",
    "bn": "মৃত্যু খুব ভয়ংকর।",
    "level": "N5"
  },
  {
    "id": "s1074",
    "jp": "自分で行きます।",
    "romaji": "Jibun de ikimasu.",
    "en": "I will go by myself.",
    "bn": "আমি একাই যাব।",
    "level": "N5"
  },
  {
    "id": "s1075",
    "jp": "辞書を読みました।",
    "romaji": "Jisho wo yomimashita.",
    "en": "I read the dictionary.",
    "bn": "আমি ডিকশনারি পড়েছি।",
    "level": "N5"
  },
  {
    "id": "s1076",
    "jp": "昨日、銀座へ行きました।",
    "romaji": "Kinou, Ginza he ikimashita.",
    "en": "I went to Ginza yesterday.",
    "bn": "আমি গতকাল গিনজাতে গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s1077",
    "jp": "九時に寝ました।",
    "romaji": "Kuji ni nemashita.",
    "en": "I went to bed at nine.",
    "bn": "আমি ন’টায় ঘুমানো গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s1078",
    "jp": "牛乳を飲みました।",
    "romaji": "Gyuunyuu wo nomimashita.",
    "en": "I drank milk.",
    "bn": "আমি দুধ খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1079",
    "jp": "今日、会いましょう।",
    "romaji": "Kyou, aimashou.",
    "en": "Let's meet today.",
    "bn": "চলুন আজ দেখা করি।",
    "level": "N5"
  },
  {
    "id": "s1080",
    "jp": "教室で勉強します।",
    "romaji": "Kyoushitsu de benkyou shimasu.",
    "en": "I study in the classroom.",
    "bn": "আমি ক্লাসরুমে পড়াশোনা করি।",
    "level": "N5"
  },
  {
    "id": "s1081",
    "jp": "兄弟がいますか？",
    "romaji": "Kyoudai ga imasu ka?",
    "en": "Do you have siblings?",
    "bn": "আপনার কি কোনো ভাইবোন আছে?",
    "level": "N5"
  },
  {
    "id": "s1082",
    "jp": "去年、日本へ来ました।",
    "romaji": "Kyonen, Nihon he kimashita.",
    "en": "I came to Japan last year.",
    "bn": "আমি গত বছর জাপানে এসেছি।",
    "level": "N5"
  },
  {
    "id": "s1083",
    "jp": "嫌いな食べ物はありますか？",
    "romaji": "Kirai na tabemono wa arimasu ka?",
    "en": "Is there any food you dislike?",
    "bn": "আপনার কি অপছন্দের কোনো খাবার আছে?",
    "level": "N5"
  },
  {
    "id": "s1084",
    "jp": "髪を切りました।",
    "romaji": "Kami wo kirimashita.",
    "en": "I cut my hair.",
    "bn": "আমি চুল কাটিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1085",
    "jp": "静かな場所が好きです।",
    "romaji": "Shizuka na basho ga suki desu.",
    "en": "I like quiet places.",
    "bn": "আমি শান্ত জায়গা পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s1086",
    "jp": "銀行はどこですか？",
    "romaji": "Ginkou wa doko desu ka?",
    "en": "Where is the bank?",
    "bn": "ব্যাংকটি কোথায়?",
    "level": "N5"
  },
  {
    "id": "s1087",
    "jp": "金曜日、会いましょう।",
    "romaji": "Kinyoubi, aimashou.",
    "en": "Let's meet on Friday.",
    "bn": "শুক্রবারে দেখা করা যাক।",
    "level": "N5"
  },
  {
    "id": "s1088",
    "jp": "九月の初めに行きました।",
    "romaji": "Kugatsu no hajime ni ikimashita.",
    "en": "I went at the beginning of September.",
    "bn": "আমি সেপ্টেম্বরের শুরুতে গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s1089",
    "jp": "薬を飲みました।",
    "romaji": "Kusuri wo nomimashita.",
    "en": "I took medicine.",
    "bn": "আমি ওষুধ খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1090",
    "jp": "下さい।",
    "romaji": "Kudasai.",
    "en": "Give me, please.",
    "bn": "দয়া করে দিন।",
    "level": "N5"
  },
  {
    "id": "s1091",
    "jp": "果物を食べましょう।",
    "romaji": "Kudamono wo tabemashou.",
    "en": "Let's eat fruit.",
    "bn": "চলুন ফল খাই।",
    "level": "N5"
  },
  {
    "id": "s1092",
    "jp": "口を開けてください।",
    "romaji": "Kuchi wo akete kudasai.",
    "en": "Please open your mouth.",
    "bn": "দয়া করে মুখ খুলুন।",
    "level": "N5"
  },
  {
    "id": "s1093",
    "jp": "靴下を履きました।",
    "romaji": "Kutsushita wo hakimashita.",
    "en": "I put on socks.",
    "bn": "আমি মোজা পরেছি।",
    "level": "N5"
  },
  {
    "id": "s1094",
    "jp": "国へ帰りたいです।",
    "romaji": "Kuni he kaeritai desu.",
    "en": "I want to return to my country.",
    "bn": "আমি নিজের দেশে ফিরতে চাই।",
    "level": "N5"
  },
  {
    "id": "s1095",
    "jp": "曇っています।",
    "romaji": "Kumotte imasu.",
    "en": "It is cloudy.",
    "bn": "আকাশ মেঘলা হয়ে আছে।",
    "level": "N5"
  },
  {
    "id": "s1096",
    "jp": "暗い部屋ですね।",
    "romaji": "Kurai heya desu ne.",
    "en": "It's a dark room, isn't it?",
    "bn": "ঘরটি বেশ অন্ধকার, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1097",
    "jp": "クラスで日本語を話します।",
    "romaji": "Kurasu de nihongo wo hanashimasu.",
    "en": "I speak Japanese in class.",
    "bn": "আমি ক্লাসে জাপানি ভাষায় কথা বলি।",
    "level": "N5"
  },
  {
    "id": "s1098",
    "jp": "車を運転したいです।",
    "romaji": "Kuruma wo unten shitai desu.",
    "en": "I want to drive a car.",
    "bn": "আমি গাড়ি চালাতে চাই।",
    "level": "N5"
  },
  {
    "id": "s1099",
    "jp": "黒いシャツですね।",
    "romaji": "Kuroi shatsu desu ne.",
    "en": "It's a black shirt, isn't it?",
    "bn": "শার্টটি কালো রঙের, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1100",
    "jp": "警官に道を聞きました।",
    "romaji": "Keikan ni michi wo kikimashita.",
    "en": "I asked the policeman for directions.",
    "bn": "আমি পুলিশ সদস্যের কাছ থেকে ঠিকানা জেনে নিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1101",
    "jp": "紅茶をください。",
    "romaji": "Koucha wo kudasai.",
    "en": "Please give me black tea.",
    "bn": "দয়া করে আমাকে লিকার চা দিন।",
    "level": "N5"
  },
  {
    "id": "s1102",
    "jp": "交番はどこですか？",
    "romaji": "Kouban wa doko desu ka?",
    "en": "Where is the police box?",
    "bn": "পুলিশ ফাঁড়িটি কোথায়?",
    "level": "N5"
  },
  {
    "id": "s1103",
    "jp": "声が大きすぎます।",
    "romaji": "Koe ga ookisugimasu.",
    "en": "The voice is too loud.",
    "bn": "গলার আওয়াজ বড্ড বেশি।",
    "level": "N5"
  },
  {
    "id": "s1104",
    "jp": "コートはあそこです。",
    "romaji": "Kooto wa asoko desu.",
    "en": "The coat is over there.",
    "bn": "কোটটি ওখানে আছে।",
    "level": "N5"
  },
  {
    "id": "s1105",
    "jp": "コーヒーを飲みました।",
    "romaji": "Koohii wo nomimashita.",
    "en": "I drank coffee.",
    "bn": "আমি কফি পান করেছি।",
    "level": "N5"
  },
  {
    "id": "s1106",
    "jp": "ここへ来てください。",
    "romaji": "Koko he kite kudasai.",
    "en": "Please come here.",
    "bn": "দয়া করে এখানে আসুন।",
    "level": "N5"
  },
  {
    "id": "s1107",
    "jp": "五十円あります।",
    "romaji": "Gojuuen arimasu.",
    "en": "I have fifty yen.",
    "bn": "আমার কাছে ৫০ ইয়েন আছে।",
    "level": "N5"
  },
  {
    "id": "s1108",
    "jp": "午前中に終わります。",
    "romaji": "Gozenchuu ni owarimasu.",
    "en": "It finishes during the morning.",
    "bn": "সকালের মধ্যে এটি শেষ হয়ে যাবে।",
    "level": "N5"
  },
  {
    "id": "s1109",
    "jp": "答えてください।",
    "romaji": "Kotaete kudasai.",
    "en": "Please answer.",
    "bn": "দয়া করে উত্তর দিন।",
    "level": "N5"
  },
  {
    "id": "s1110",
    "jp": "こちらへどうぞ。",
    "romaji": "Kochira he douzo.",
    "en": "This way, please.",
    "bn": "দয়া করে এই দিকে আসুন।",
    "level": "N5"
  },
  {
    "id": "s1111",
    "jp": "コップがあります।",
    "romaji": "Koppu ga arimasu.",
    "en": "There is a cup.",
    "bn": "সেখানে একটি কাপ আছে।",
    "level": "N5"
  },
  {
    "id": "s1112",
    "jp": "子供がいます。",
    "romaji": "Kodomo ga imasu.",
    "en": "I have children.",
    "bn": "আমার সন্তান আছে।",
    "level": "N5"
  },
  {
    "id": "s1113",
    "jp": "御飯を食べましょう।",
    "romaji": "Gohan wo tabemashou.",
    "en": "Let's eat a meal.",
    "bn": "চলুন খাবার খাই।",
    "level": "N5"
  },
  {
    "id": "s1114",
    "jp": "コピーをしてください。",
    "romaji": "Kopii wo shite kudasai.",
    "en": "Please make a copy.",
    "bn": "দয়া করে ফটোকপি করুন।",
    "level": "N5"
  },
  {
    "id": "s1115",
    "jp": "困っています।",
    "romaji": "Komatte imasu.",
    "en": "I am in trouble.",
    "bn": "আমি সমস্যায় পড়েছি।",
    "level": "N5"
  },
  {
    "id": "s1116",
    "jp": "今月、行きます。",
    "romaji": "Kongetsu, ikimasu.",
    "en": "I will go this month.",
    "bn": "আমি এই মাসে যাব।",
    "level": "N5"
  },
  {
    "id": "s1117",
    "jp": "今週、忙しいです।",
    "romaji": "Konshuu, isogashii desu.",
    "en": "I am busy this week.",
    "bn": "আমি এই সপ্তাহে ব্যস্ত আছি।",
    "level": "N5"
  },
  {
    "id": "s1118",
    "jp": "こんな本を読みました。",
    "romaji": "Konna hon wo yomimashita.",
    "en": "I read this kind of book.",
    "bn": "আমি এই ধরনের একটি বই পড়েছি।",
    "level": "N5"
  },
  {
    "id": "s1119",
    "jp": "さあ、行きましょう।",
    "romaji": "Saa, ikimashou.",
    "en": "Well, let's go.",
    "bn": "ওহে, চলুন যাওয়া যাক।",
    "level": "N5"
  },
  {
    "id": "s1120",
    "jp": "魚が好きです。",
    "romaji": "Sakana ga suki desu.",
    "en": "I like fish.",
    "bn": "আমি মাছ পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s1121",
    "jp": "お酒を飲みました।",
    "romaji": "O-sake wo nomimashita.",
    "en": "I drank sake.",
    "bn": "আমি মদ পান করেছি।",
    "level": "N5"
  },
  {
    "id": "s1122",
    "jp": "先に帰ります。",
    "romaji": "Saki ni kaerimasu.",
    "en": "I am returning home first.",
    "bn": "আমি আগেই বাড়ি ফিরে যাচ্ছি।",
    "level": "N5"
  },
  {
    "id": "s1123",
    "jp": "咲きそうです।",
    "romaji": "Sakisou desu.",
    "en": "It seems about to bloom.",
    "bn": "মনে হচ্ছে ফুটে যাবে।",
    "level": "N5"
  },
  {
    "id": "s1124",
    "jp": "作文を書きました。",
    "romaji": "Sakubun wo kakimashita.",
    "en": "I wrote an essay.",
    "bn": "আমি একটি প্রবন্ধ লিখেছি।",
    "level": "N5"
  },
  {
    "id": "s1125",
    "jp": "差しました।",
    "romaji": "Sashimashita.",
    "en": "I put up an umbrella.",
    "bn": "আমি ছাতা ধরেছি।",
    "level": "N5"
  },
  {
    "id": "s1126",
    "jp": "雑誌を買いました。",
    "romaji": "Zasshi wo kaimashita.",
    "en": "I bought a magazine.",
    "bn": "আমি একটি ম্যাগাজিন কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s1127",
    "jp": "砂糖を入れます।",
    "romaji": "Satou wo iremasu.",
    "en": "I put in sugar.",
    "bn": "আমি চিনি দিচ্ছি।",
    "level": "N5"
  },
  {
    "id": "s1128",
    "jp": "寒いですね。",
    "romaji": "Samui desu ne.",
    "en": "It's cold, isn't it?",
    "bn": "আজ বেশ ঠান্ডা, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1129",
    "jp": "さようなら।",
    "romaji": "Sayounara.",
    "en": "Goodbye.",
    "bn": "বিদায়।",
    "level": "N5"
  },
  {
    "id": "s1130",
    "jp": "三月に行きます。",
    "romaji": "Sangatsu ni ikimasu.",
    "en": "I will go in March.",
    "bn": "আমি মার্চ মাসে যাব।",
    "level": "N5"
  },
  {
    "id": "s1131",
    "jp": "散歩しましょう।",
    "romaji": "Sanpo shimashou.",
    "en": "Let's take a walk.",
    "bn": "চলুন একটু হেঁটে আসি।",
    "level": "N5"
  },
  {
    "id": "s1132",
    "jp": "四時です。",
    "romaji": "Yoji desu.",
    "en": "It is four o'clock.",
    "bn": "এখন চারটে বাজে।",
    "level": "N5"
  },
  {
    "id": "s1133",
    "jp": "塩をください।",
    "romaji": "Shio wo kudasai.",
    "en": "Please give me salt.",
    "bn": "দয়া করে আমাকে লবণ দিন।",
    "level": "N5"
  },
  {
    "id": "s1134",
    "jp": "しかし、高いです。",
    "romaji": "Shikashi, takai desu.",
    "en": "But it is expensive.",
    "bn": "কিন্তু এটি বেশ দামি।",
    "level": "N5"
  },
  {
    "id": "s1135",
    "jp": "時間がありますか？",
    "romaji": "Jikan ga arimasu ka?",
    "en": "Do you have time?",
    "bn": "আপনার কি সময় হবে?",
    "level": "N5"
  },
  {
    "id": "s1136",
    "jp": "仕事は忙しいです。",
    "romaji": "Shigoto wa isogashii desu.",
    "en": "Work is busy.",
    "bn": "কাজ খুব ব্যস্ততাপূর্ণ।",
    "level": "N5"
  },
  {
    "id": "s1137",
    "jp": "辞書を引きました।",
    "romaji": "Jisho wo hikimashita.",
    "en": "I looked it up in the dictionary.",
    "bn": "আমি ডিকশনারিতে এটি খুঁজেছি।",
    "level": "N5"
  },
  {
    "id": "s1138",
    "jp": "静かにしてください。",
    "romaji": "Shizuka ni shite kudasai.",
    "en": "Please be quiet.",
    "bn": "দয়া করে শান্ত থাকুন।",
    "level": "N5"
  },
  {
    "id": "s1139",
    "jp": "下がってください।",
    "romaji": "Sagatte kudasai.",
    "en": "Please step back.",
    "bn": "দয়া করে পেছনে সরুন।",
    "level": "N5"
  },
  {
    "id": "s1140",
    "jp": "質問はありますか？",
    "romaji": "Shitsumon wa arimasu ka?",
    "en": "Do you have any questions?",
    "bn": "আপনার কি কোনো প্রশ্ন আছে?",
    "level": "N5"
  },
  {
    "id": "s1141",
    "jp": "自転車で行きます।",
    "romaji": "Jitensha de ikimasu.",
    "en": "I go by bicycle.",
    "bn": "আমি সাইকেলে করে যাব।",
    "level": "N5"
  },
  {
    "id": "s1142",
    "jp": "自動車を借りました。",
    "romaji": "Jidousha wo karimashita.",
    "en": "I borrowed a car.",
    "bn": "আমি একটি গাড়ি ধার নিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1143",
    "jp": "死にませんでした।",
    "romaji": "Shinimasendeshita.",
    "en": "It did not die.",
    "bn": "মারা যায়নি।",
    "level": "N5"
  },
  {
    "id": "s1144",
    "jp": "自分で行きます。",
    "romaji": "Jibun de ikimasu.",
    "en": "I will go by myself.",
    "bn": "আমি নিজেই যাব।",
    "level": "N5"
  },
  {
    "id": "s1145",
    "jp": "辞書を読みました।",
    "romaji": "Jisho wo yomimashita.",
    "en": "I read the dictionary.",
    "bn": "আমি ডিকশনারি পড়েছি।",
    "level": "N5"
  },
  {
    "id": "s1146",
    "jp": "昨日、銀座へ行きました。",
    "romaji": "Kinou, Ginza he ikimashita.",
    "en": "I went to Ginza yesterday.",
    "bn": "আমি গতকাল গিনজাতে গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s1147",
    "jp": "九時に寝ました।",
    "romaji": "Kuji ni nemashita.",
    "en": "I went to bed at nine.",
    "bn": "আমি ন’টায় ঘুমানো গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s1148",
    "jp": "牛乳を飲みましょう。",
    "romaji": "Gyuunyuu wo nomimashou.",
    "en": "Let's drink milk.",
    "bn": "চলুন দুধ খাই।",
    "level": "N5"
  },
  {
    "id": "s1149",
    "jp": "今日もいい天気ですね।",
    "romaji": "Kyou mo ii tenki desu ne.",
    "en": "It's nice weather today as well, isn't it?",
    "bn": "আজকেও বেশ রৌদ্রোজ্জ্বল দিন, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1150",
    "jp": "教室で勉強しましょう。",
    "romaji": "Kyoushitsu de benkyou shimashou.",
    "en": "Let's study in the classroom.",
    "bn": "চলুন ক্লাসরুমে পড়াশোনা করি।",
    "level": "N5"
  },
  {
    "id": "s1201",
    "jp": "九時に会いましょう。",
    "romaji": "Kuji ni aimashou.",
    "en": "Let's meet at nine.",
    "bn": "চলুন নটায় দেখা করি।",
    "level": "N5"
  },
  {
    "id": "s1202",
    "jp": "果物を買いました।",
    "romaji": "Kudamono wo kaimashita.",
    "en": "I bought fruit.",
    "bn": "আমি ফল কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s1203",
    "jp": "口を閉じてください।",
    "romaji": "Kuchi wo tojite kudasai.",
    "en": "Please close your mouth.",
    "bn": "দয়া করে মুখ বন্ধ করুন।",
    "level": "N5"
  },
  {
    "id": "s1204",
    "jp": "靴を履きました।",
    "romaji": "Kutsu wo hakimashita.",
    "en": "I put on shoes.",
    "bn": "আমি জুতো পরেছি।",
    "level": "N5"
  },
  {
    "id": "s1205",
    "jp": "国はどこですか？",
    "romaji": "Kuni wa doko desu ka?",
    "en": "Where is your country?",
    "bn": "আপনার দেশ কোথায়?",
    "level": "N5"
  },
  {
    "id": "s1206",
    "jp": "曇っていますね।",
    "romaji": "Kumotte imasu ne.",
    "en": "It's cloudy, isn't it?",
    "bn": "আকাশ মেঘলা, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1207",
    "jp": "暗いですね।",
    "romaji": "Kurai desu ne.",
    "en": "It's dark, isn't it?",
    "bn": "বেশ অন্ধকার, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1208",
    "jp": "九月は暑いです।",
    "romaji": "Kugatsu wa atsui desu.",
    "en": "September is hot.",
    "bn": "সেপ্টেম্বর মাস বেশ গরম।",
    "level": "N5"
  },
  {
    "id": "s1209",
    "jp": "薬は飲みましたか？",
    "romaji": "Kusuri wa nomimashita ka?",
    "en": "Did you take your medicine?",
    "bn": "আপনি কি ওষুধ খেয়েছেন?",
    "level": "N5"
  },
  {
    "id": "s1210",
    "jp": "下さい।",
    "romaji": "Kudasai.",
    "en": "Please.",
    "bn": "দয়া করে।",
    "level": "N5"
  },
  {
    "id": "s1211",
    "jp": "果物は美味しいです।",
    "romaji": "Kudamono wa oishii desu.",
    "en": "Fruit is delicious.",
    "bn": "ফল খুব সুস্বাদু হয়।",
    "level": "N5"
  },
  {
    "id": "s1212",
    "jp": "車で行きましょう।",
    "romaji": "Kuruma de ikimashou.",
    "en": "Let's go by car.",
    "bn": "চলুন গাড়িতে যাই।",
    "level": "N5"
  },
  {
    "id": "s1213",
    "jp": "黒いペンです।",
    "romaji": "Kuroi pen desu.",
    "en": "It's a black pen.",
    "bn": "এটি একটি কালো কলম।",
    "level": "N5"
  },
  {
    "id": "s1214",
    "jp": "警官が見えました।",
    "romaji": "Keikan ga miemashita.",
    "en": "I saw a policeman.",
    "bn": "আমি একজন পুলিশকে দেখেছি।",
    "level": "N5"
  },
  {
    "id": "s1215",
    "jp": "今朝は寒いです।",
    "romaji": "Kesa wa samui desu.",
    "en": "It's cold this morning.",
    "bn": "আজ সকালে বেশ ঠান্ডা।",
    "level": "N5"
  },
  {
    "id": "s1216",
    "jp": "消しゴムがありました।",
    "romaji": "Keshigomu ga arimashita.",
    "en": "There was an eraser.",
    "bn": "সেখানে একটি রবার ছিল।",
    "level": "N5"
  },
  {
    "id": "s1217",
    "jp": "景色が良いですね।",
    "romaji": "Keshiki ga ii desu ne.",
    "en": "The scenery is good, isn't it?",
    "bn": "প্রকৃতি খুব সুন্দর, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1218",
    "jp": "テレビを消しました।",
    "romaji": "Terebi wo keshimashita.",
    "en": "I turned off the TV.",
    "bn": "আমি টিভি বন্ধ করে দিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1219",
    "jp": "結構な品ですね।",
    "romaji": "Kekkou na shina desu ne.",
    "en": "It's a fine item, isn't it?",
    "bn": "জিনিসটি বেশ ভালো, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1220",
    "jp": "結婚しました।",
    "romaji": "Kekkon shimashita.",
    "en": "I got married.",
    "bn": "আমি বিয়ে করেছি।",
    "level": "N5"
  },
  {
    "id": "s1221",
    "jp": "月曜日に会いましょう।",
    "romaji": "Getsuyoubi ni aimashou.",
    "en": "Let's meet on Monday.",
    "bn": "চলুন সোমবারে দেখা করি।",
    "level": "N5"
  },
  {
    "id": "s1222",
    "jp": "玄関はあちらです।",
    "romaji": "Genkan wa achira desu.",
    "en": "The entrance is that way.",
    "bn": "প্রবেশপথটি ওই দিকে।",
    "level": "N5"
  },
  {
    "id": "s1223",
    "jp": "元気になりました।",
    "romaji": "Genki ni narimashita.",
    "en": "I became energetic.",
    "bn": "আমি সতেজ বোধ করছি।",
    "level": "N5"
  },
  {
    "id": "s1224",
    "jp": "五円ください।",
    "romaji": "Goen kudasai.",
    "en": "Five yen, please.",
    "bn": "দয়া করে পাঁচ ইয়েন দিন।",
    "level": "N5"
  },
  {
    "id": "s1225",
    "jp": "公園へ行きましょう।",
    "romaji": "Kouen he ikimashou.",
    "en": "Let's go to the park.",
    "bn": "চলুন পার্কে যাই।",
    "level": "N5"
  },
  {
    "id": "s1226",
    "jp": "交番がありました।",
    "romaji": "Kouban ga arimashita.",
    "en": "There was a police box.",
    "bn": "সেখানে একটি পুলিশ বক্স ছিল।",
    "level": "N5"
  },
  {
    "id": "s1227",
    "jp": "紅茶を飲みましょう।",
    "romaji": "Koucha wo nomimashou.",
    "en": "Let's drink black tea.",
    "bn": "চলুন লিকার চা পান করি।",
    "level": "N5"
  },
  {
    "id": "s1228",
    "jp": "工場が見えます।",
    "romaji": "Koujou ga miemasu.",
    "en": "The factory is visible.",
    "bn": "কারখানাটি দেখা যাচ্ছে।",
    "level": "N5"
  },
  {
    "id": "s1229",
    "jp": "校長先生が来ました।",
    "romaji": "Kouchousensei ga kimashita.",
    "en": "The principal came.",
    "bn": "প্রধান শিক্ষক এসেছেন।",
    "level": "N5"
  },
  {
    "id": "s1230",
    "jp": "交差点で止まりました।",
    "romaji": "Kousaten de tomarimashita.",
    "en": "I stopped at the intersection.",
    "bn": "আমি মোড়ে দাঁড়িয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1231",
    "jp": "講堂へ行きました।",
    "romaji": "Koudou he ikimashita.",
    "en": "I went to the auditorium.",
    "bn": "আমি অডিটোরিয়ামে গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s1232",
    "jp": "高等学校の学生です।",
    "romaji": "Koutougakkou no gakusei desu.",
    "en": "I am a high school student.",
    "bn": "আমি একজন উচ্চ বিদ্যালয়ের ছাত্র।",
    "level": "N5"
  },
  {
    "id": "s1233",
    "jp": "公務員になりたいです।",
    "romaji": "Koumuin ni naritai desu.",
    "en": "I want to be a public servant.",
    "bn": "আমি সরকারি চাকুরিজীবী হতে চাই।",
    "level": "N5"
  },
  {
    "id": "s1234",
    "jp": "声を出さないでください।",
    "romaji": "Koe wo dasanaide kudasai.",
    "en": "Please don't make a sound.",
    "bn": "দয়া করে কোনো শব্দ করবেন না।",
    "level": "N5"
  },
  {
    "id": "s1235",
    "jp": "コートを買いました।",
    "romaji": "Kooto wo kaimashita.",
    "en": "I bought a coat.",
    "bn": "আমি একটি কোট কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s1236",
    "jp": "コップが割れました।",
    "romaji": "Koppu ga waremashita.",
    "en": "The glass broke.",
    "bn": "গ্লাসটি ভেঙে গেল।",
    "level": "N5"
  },
  {
    "id": "s1237",
    "jp": "今年は暑いですね।",
    "romaji": "Kotoshi wa atsui desu ne.",
    "en": "This year is hot, isn't it?",
    "bn": "এই বছর খুব গরম, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1238",
    "jp": "言葉を覚えましょう।",
    "romaji": "Kotoba wo oboemashou.",
    "en": "Let's memorize the words.",
    "bn": "চলুন শব্দগুলো মুখস্থ করি।",
    "level": "N5"
  },
  {
    "id": "s1239",
    "jp": "子供たちが遊びます।",
    "romaji": "Kodomotachi ga asobimasu.",
    "en": "The children play.",
    "bn": "শিশুরা খেলা করছে।",
    "level": "N5"
  },
  {
    "id": "s1240",
    "jp": "御飯はまだですか？",
    "romaji": "Gohan wa mada desu ka?",
    "en": "Is the meal not ready yet?",
    "bn": "খাবার কি এখনো তৈরি হয়নি?",
    "level": "N5"
  },
  {
    "id": "s1241",
    "jp": "困ったことになりました।",
    "romaji": "Komatta koto ni narimashita.",
    "en": "It has become a problem.",
    "bn": "বিপদ হয়ে গেল তো।",
    "level": "N5"
  },
  {
    "id": "s1242",
    "jp": "〜頃、来てください।",
    "romaji": "~ koro, kite kudasai.",
    "en": "Please come around...",
    "bn": "সেই সময়ের আশেপাশে চলে আসুন।",
    "level": "N5"
  },
  {
    "id": "s1243",
    "jp": "今晩、月が綺麗です।",
    "romaji": "Konban, tsuki ga kirei desu.",
    "en": "The moon is beautiful tonight.",
    "bn": "আজ রাতে চাঁদ খুব সুন্দর।",
    "level": "N5"
  },
  {
    "id": "s1244",
    "jp": "今日、暇ですか？",
    "romaji": "Kyou, hima desu ka?",
    "en": "Are you free today?",
    "bn": "আজ আপনি ফ্রি আছেন?",
    "level": "N5"
  },
  {
    "id": "s1245",
    "jp": "昨日の夕食は肉でした।",
    "romaji": "Kinou no yuushoku wa niku deshita.",
    "en": "Yesterday's dinner was meat.",
    "bn": "গতকালের ডিনারে মাংস ছিল।",
    "level": "N5"
  },
  {
    "id": "s1246",
    "jp": "今月、引っ越します।",
    "romaji": "Kongetsu, hikkoshimasu.",
    "en": "I am moving this month.",
    "bn": "আমি এই মাসেই বাসা পাল্টাব।",
    "level": "N5"
  },
  {
    "id": "s1247",
    "jp": "今週、テストがあります।",
    "romaji": "Konshuu, tesuto ga arimasu.",
    "en": "There is a test this week.",
    "bn": "এই সপ্তাহে একটি পরীক্ষা আছে।",
    "level": "N5"
  },
  {
    "id": "s1248",
    "jp": "こんな話を聞きました।",
    "romaji": "Konna hanashi wo kikimashita.",
    "en": "I heard this kind of story.",
    "bn": "আমি এই ধরনের একটি গল্প শুনেছি।",
    "level": "N5"
  },
  {
    "id": "s1249",
    "jp": "さあ、食べましょう।",
    "romaji": "Saa, tabemashou.",
    "en": "Well, let's eat.",
    "bn": "ওহে, ভাত খাওয়া যাক।",
    "level": "N5"
  },
  {
    "id": "s1250",
    "jp": "〜歳になりました।",
    "romaji": "~ sai ni narimashita.",
    "en": "I turned ~ years old.",
    "bn": "আমার বয়স ... বছর হলো।",
    "level": "N5"
  },
  {
    "id": "s1251",
    "jp": "財布を忘れました।",
    "romaji": "Saifu wo wasuremashita.",
    "en": "I forgot my wallet.",
    "bn": "আমি আমার মানিব্যাগ ভুলে গেছি।",
    "level": "N5"
  },
  {
    "id": "s1252",
    "jp": "魚を買いに行きましょう।",
    "romaji": "Sakana wo kai ni ikimashou.",
    "en": "Let's go buy fish.",
    "bn": "চলুন মাছ কিনতে যাই।",
    "level": "N5"
  },
  {
    "id": "s1253",
    "jp": "先を歩いてください।",
    "romaji": "Saki wo aruite kudasai.",
    "en": "Please walk ahead.",
    "bn": "দয়া করে সামনে এগিয়ে যান।",
    "level": "N5"
  },
  {
    "id": "s1254",
    "jp": "花が咲きました।",
    "romaji": "Hana ga sakimashita.",
    "en": "The flowers bloomed.",
    "bn": "ফুল ফুটেছে।",
    "level": "N5"
  },
  {
    "id": "s1255",
    "jp": "作文を書いてください।",
    "romaji": "Sakubun wo kaite kudasai.",
    "en": "Please write an essay.",
    "bn": "দয়া করে একটি প্রবন্ধ লিখুন।",
    "level": "N5"
  },
  {
    "id": "s1256",
    "jp": "傘を差します।",
    "romaji": "Kasa wo sashimasu.",
    "en": "I will put up an umbrella.",
    "bn": "আমি ছাতা ধরব।",
    "level": "N5"
  },
  {
    "id": "s1257",
    "jp": "雑誌を読みましょう।",
    "romaji": "Zasshi wo yomimashou.",
    "en": "Let's read a magazine.",
    "bn": "চলুন একটি ম্যাগাজিন পড়ি।",
    "level": "N5"
  },
  {
    "id": "s1258",
    "jp": "砂糖は甘いです।",
    "romaji": "Satou wa amai desu.",
    "en": "Sugar is sweet.",
    "bn": "চিনি মিষ্টি হয়।",
    "level": "N5"
  },
  {
    "id": "s1259",
    "jp": "寒い部屋ですね।",
    "romaji": "Samui heya desu ne.",
    "en": "It's a cold room, isn't it?",
    "bn": "ঘরটি বেশ ঠান্ডা, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1260",
    "jp": "さよならを言いました।",
    "romaji": "Sayonara wo iimashita.",
    "en": "I said goodbye.",
    "bn": "আমি বিদায় জানালাম।",
    "level": "N5"
  },
  {
    "id": "s1261",
    "jp": "三日は休みです।",
    "romaji": "Mikka wa yasumi desu.",
    "en": "The third is a holiday.",
    "bn": "তিন তারিখ ছুটি।",
    "level": "N5"
  },
  {
    "id": "s1262",
    "jp": "散歩へ行きましょう।",
    "romaji": "Sanpo he ikimashou.",
    "en": "Let's go for a walk.",
    "bn": "চলুন একটু হেঁটে আসি।",
    "level": "N5"
  },
  {
    "id": "s1263",
    "jp": "四時になりました।",
    "romaji": "Yoji ni narimashita.",
    "en": "It became four o'clock.",
    "bn": "এখন চারটে বেজেছে।",
    "level": "N5"
  },
  {
    "id": "s1264",
    "jp": "塩分を控えてください।",
    "romaji": "Enbun wo hikaete kudasai.",
    "en": "Please cut down on salt.",
    "bn": "দয়া করে লবণের পরিমাণ কমান।",
    "level": "N5"
  },
  {
    "id": "s1265",
    "jp": "しかし、頑張ります।",
    "romaji": "Shikashi, ganbarimasu.",
    "en": "However, I will do my best.",
    "bn": "যাই হোক, আমি আমার সেরাটা দেব।",
    "level": "N5"
  },
  {
    "id": "s1266",
    "jp": "時間がないです।",
    "romaji": "Jikan ga nai desu.",
    "en": "There is no time.",
    "bn": "সময় নেই।",
    "level": "N5"
  },
  {
    "id": "s1267",
    "jp": "仕事が終わりました।",
    "romaji": "Shigoto ga owarimashita.",
    "en": "Work is finished.",
    "bn": "কাজ শেষ হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s1268",
    "jp": "辞書を引いてください।",
    "romaji": "Jisho wo hiite kudasai.",
    "en": "Please check the dictionary.",
    "bn": "দয়া করে ডিকশনারি দেখুন।",
    "level": "N5"
  },
  {
    "id": "s1269",
    "jp": "静かな夜ですね।",
    "romaji": "Shizuka na yoru desu ne.",
    "en": "It's a quiet night, isn't it?",
    "bn": "রাতটি খুব শান্ত, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1270",
    "jp": "下に降りましょう।",
    "romaji": "Shita ni orimashou.",
    "en": "Let's go downstairs.",
    "bn": "চলুন নিচে যাই।",
    "level": "N5"
  },
  {
    "id": "s1271",
    "jp": "質問してください।",
    "romaji": "Shitsumon shite kudasai.",
    "en": "Please ask a question.",
    "bn": "দয়া করে প্রশ্ন করুন।",
    "level": "N5"
  },
  {
    "id": "s1272",
    "jp": "自転車に乗ります।",
    "romaji": "Jitensha ni norimasu.",
    "en": "I ride a bicycle.",
    "bn": "আমি সাইকেল চালাই।",
    "level": "N5"
  },
  {
    "id": "s1273",
    "jp": "自動車が行きました।",
    "romaji": "Jidousha ga ikimashita.",
    "en": "The car went by.",
    "bn": "গাড়িটি চলে গেল।",
    "level": "N5"
  },
  {
    "id": "s1274",
    "jp": "死なないでください।",
    "romaji": "Shinanaide kudasai.",
    "en": "Please don't die.",
    "bn": "দয়া করে মরবেন না।",
    "level": "N5"
  },
  {
    "id": "s1275",
    "jp": "自分でやりました।",
    "romaji": "Jibun de yarimashita.",
    "en": "I did it by myself.",
    "bn": "আমি নিজেই এটি করেছি।",
    "level": "N5"
  },
  {
    "id": "s1276",
    "jp": "辞書を持ってきましたか？",
    "romaji": "Jisho wo mottekimashita ka?",
    "en": "Did you bring the dictionary?",
    "bn": "আপনি কি ডিকশনারিটি এনেছেন?",
    "level": "N5"
  },
  {
    "id": "s1277",
    "jp": "昨日、テレビを見ました।",
    "romaji": "Kinou, terebi wo mimashita.",
    "en": "I watched TV yesterday.",
    "bn": "আমি গতকাল টিভি দেখেছি।",
    "level": "N5"
  },
  {
    "id": "s1278",
    "jp": "九時に寝てください।",
    "romaji": "Kuji ni nete kudasai.",
    "en": "Please go to bed at nine.",
    "bn": "দয়া করে নটায় ঘুমানো যান।",
    "level": "N5"
  },
  {
    "id": "s1279",
    "jp": "牛乳は体に良いです।",
    "romaji": "Gyuunyuu wa karada ni ii desu.",
    "en": "Milk is good for the body.",
    "bn": "দুধ স্বাস্থ্যের জন্য ভালো।",
    "level": "N5"
  },
  {
    "id": "s1280",
    "jp": "今日のお天気はどうですか？",
    "romaji": "Kyou no otenki wa dou desu ka?",
    "en": "How is the weather today?",
    "bn": "আজকের আবহাওয়া কেমন?",
    "level": "N5"
  },
  {
    "id": "s1281",
    "jp": "教室はどこですか？",
    "romaji": "Kyoushitsu wa doko desu ka?",
    "en": "Where is the classroom?",
    "bn": "ক্লাসরুমটি কোথায়?",
    "level": "N5"
  },
  {
    "id": "s1282",
    "jp": "兄弟は何人いますか？",
    "romaji": "Kyoudai wa nannin imasu ka?",
    "en": "How many siblings do you have?",
    "bn": "আপনার কতজন ভাইবোন আছে?",
    "level": "N5"
  },
  {
    "id": "s1283",
    "jp": "去年、アメリカへ行きました।",
    "romaji": "Kyonen, Amerika he ikimashita.",
    "en": "I went to America last year.",
    "bn": "আমি গত বছর আমেরিকায় গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s1284",
    "jp": "嫌いにならないでください।",
    "romaji": "Kirai ni naranaide kudasai.",
    "en": "Please don't hate me.",
    "bn": "দয়া করে আমাকে ঘৃণা করবেন না।",
    "level": "N5"
  },
  {
    "id": "s1285",
    "jp": "髪を洗いました।",
    "romaji": "Kami wo araimashita.",
    "en": "I washed my hair.",
    "bn": "আমি আমার চুল ধুয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1286",
    "jp": "静かにしてください।",
    "romaji": "Shizuka ni shite kudasai.",
    "en": "Please be quiet.",
    "bn": "দয়া করে শান্ত থাকুন।",
    "level": "N5"
  },
  {
    "id": "s1287",
    "jp": "銀行員になりました।",
    "romaji": "Ginkouin ni narimashita.",
    "en": "I became a bank employee.",
    "bn": "আমি একজন ব্যাংক চাকুরিজীবী হয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1288",
    "jp": "金曜日は休みです।",
    "romaji": "Kinyoubi wa yasumi desu.",
    "en": "Friday is a holiday.",
    "bn": "শুক্রবার ছুটির দিন।",
    "level": "N5"
  },
  {
    "id": "s1289",
    "jp": "九月から始めましょう।",
    "romaji": "Kugatsu kara hajimemashou.",
    "en": "Let's start from September.",
    "bn": "চলুন সেপ্টেম্বর থেকে শুরু করি।",
    "level": "N5"
  },
  {
    "id": "s1290",
    "jp": "薬のおかげです।",
    "romaji": "Kusuri no okage desu.",
    "en": "It's thanks to the medicine.",
    "bn": "এটি ওষুধের জন্য সম্ভব হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s1291",
    "jp": "下さいました।",
    "romaji": "Kudasaimashita.",
    "en": "He gave it to me (polite).",
    "bn": "তিনি আমাকে দিয়েছেন (বিনম্র)।",
    "level": "N5"
  },
  {
    "id": "s1292",
    "jp": "果物を食べたいです।",
    "romaji": "Kudamono wo tabetai desu.",
    "en": "I want to eat fruit.",
    "bn": "আমি ফল খেতে চাই।",
    "level": "N5"
  },
  {
    "id": "s1293",
    "jp": "口から話します।",
    "romaji": "Kuchi kara hanashimasu.",
    "en": "I speak from my mouth.",
    "bn": "আমি মুখ দিয়ে কথা বলি।",
    "level": "N5"
  },
  {
    "id": "s1294",
    "jp": "靴下を買いましょう।",
    "romaji": "Kutsushita wo kaimashou.",
    "en": "Let's buy socks.",
    "bn": "চলুন মোজা কিনি।",
    "level": "N5"
  },
  {
    "id": "s1295",
    "jp": "国は広いですか？",
    "romaji": "Kuni wa hiroi desu ka?",
    "en": "Is your country wide?",
    "bn": "আপনার দেশ কি বড়?",
    "level": "N5"
  },
  {
    "id": "s1296",
    "jp": "曇りの日ですね।",
    "romaji": "Kumori no hi desu ne.",
    "en": "It's a cloudy day, isn't it?",
    "bn": "আজ বেশ মেঘলা দিন, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1297",
    "jp": "暗い道は怖いです।",
    "romaji": "Kurai michi wa kowai desu.",
    "en": "I am afraid of dark roads.",
    "bn": "আমি অন্ধকার রাস্তা ভয় পাই।",
    "level": "N5"
  },
  {
    "id": "s1298",
    "jp": "クラスは楽しいです।",
    "romaji": "Kurasu wa tanoshii desu.",
    "en": "The class is fun.",
    "bn": "ক্লাসটি বেশ মজার।",
    "level": "N5"
  },
  {
    "id": "s1299",
    "jp": "新車を買いました।",
    "romaji": "Shinsha wo kaimashita.",
    "en": "I bought a new car.",
    "bn": "আমি একটি নতুন গাড়ি কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s1300",
    "jp": "黒い瞳が好きです।",
    "romaji": "Kuroi hitomi ga suki desu.",
    "en": "I like black eyes.",
    "bn": "আমি কলো চোখ পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s1301",
    "jp": "けさ、コーヒーを飲みました।",
    "romaji": "Kesa, koohii wo nomimashita.",
    "en": "I drank coffee this morning.",
    "bn": "আজ সকালে আমি কফি খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1302",
    "jp": "結婚しましたか？",
    "romaji": "Kekkon shimashita ka?",
    "en": "Are you married?",
    "bn": "আপনি কি বিবাহিত?",
    "level": "N5"
  },
  {
    "id": "s1303",
    "jp": "月曜日は忙しいです।",
    "romaji": "Getsuyoubi wa isogashii desu.",
    "en": "Monday is busy.",
    "bn": "সোমবার খুব ব্যস্ত থাকি।",
    "level": "N5"
  },
  {
    "id": "s1304",
    "jp": "玄関で待ってください।",
    "romaji": "Genkan de matte kudasai.",
    "en": "Please wait at the entrance.",
    "bn": "দয়া করে প্রবেশপথে অপেক্ষা করুন।",
    "level": "N5"
  },
  {
    "id": "s1305",
    "jp": "元気を出してください।",
    "romaji": "Genki wo dashite kudasai.",
    "en": "Please cheer up.",
    "bn": "দয়া করে মন খারাপ করবেন না।",
    "level": "N5"
  },
  {
    "id": "s1306",
    "jp": "公園で遊びましょう।",
    "romaji": "Kouen de asobimashou.",
    "en": "Let's play in the park.",
    "bn": "চলুন পার্কে খেলি।",
    "level": "N5"
  },
  {
    "id": "s1307",
    "jp": "交番はどこですか？",
    "romaji": "Kouban wa doko desu ka?",
    "en": "Where is the police box?",
    "bn": "পুলিশ বক্সটি কোথায়?",
    "level": "N5"
  },
  {
    "id": "s1308",
    "jp": "声が聞こえます।",
    "romaji": "Koe ga kikoemasu.",
    "en": "I can hear a voice.",
    "bn": "আমি একটি কণ্ঠস্বর শুনতে পাচ্ছি।",
    "level": "N5"
  },
  {
    "id": "s1309",
    "jp": "午後、会いましょう।",
    "romaji": "Gogo, aimashou.",
    "en": "Let's meet in the afternoon.",
    "bn": "চলুন বিকেলে দেখা করি।",
    "level": "N5"
  },
  {
    "id": "s1310",
    "jp": "九日になりました।",
    "romaji": "Kokonoka ni narimashita.",
    "en": "It became the ninth.",
    "bn": "নয় তারিখ হলো।",
    "level": "N5"
  },
  {
    "id": "s1311",
    "jp": "午前中に終わります।",
    "romaji": "Gozenchuu ni owarimasu.",
    "en": "It will finish in the morning.",
    "bn": "এটি সকালেই শেষ হবে।",
    "level": "N5"
  },
  {
    "id": "s1312",
    "jp": "答えを教えてください।",
    "romaji": "Kotae wo oshiete kudasai.",
    "en": "Please tell me the answer.",
    "bn": "দয়া করে আমাকে উত্তরটি বলুন।",
    "level": "N5"
  },
  {
    "id": "s1313",
    "jp": "こちらへ来てください।",
    "romaji": "Kochira he kite kudasai.",
    "en": "Please come this way.",
    "bn": "দয়া করে এই দিকে আসুন।",
    "level": "N5"
  },
  {
    "id": "s1314",
    "jp": "コップが割れました।",
    "romaji": "Koppu ga waremashita.",
    "en": "The glass broke.",
    "bn": "গ্লাসটি ভেঙে গেছে।",
    "level": "N5"
  },
  {
    "id": "s1315",
    "jp": "今月も忙しいです।",
    "romaji": "Kongetsu mo isogashii desu.",
    "en": "This month is also busy.",
    "bn": "এই মাসটিও খুব ব্যস্ত।",
    "level": "N5"
  },
  {
    "id": "s1316",
    "jp": "今夜、電話します।",
    "romaji": "Konya, denwa shimasu.",
    "en": "I will call tonight.",
    "bn": "আমি আজ রাতে ফোন করব।",
    "level": "N5"
  },
  {
    "id": "s1317",
    "jp": "困ったことがありました।",
    "romaji": "Komatta koto ga arimashita.",
    "en": "Something troublesome happened.",
    "bn": "একটি ঝামেলা হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s1318",
    "jp": "御飯を食べましょう।",
    "romaji": "Gohan wo tabemashou.",
    "en": "Let's eat a meal.",
    "bn": "চলুন ভাত খাই।",
    "level": "N5"
  },
  {
    "id": "s1319",
    "jp": "五日かかります।",
    "romaji": "Itsuka kakarimasu.",
    "en": "It takes five days.",
    "bn": "এটি করতে পাঁচ দিন লাগবে।",
    "level": "N5"
  },
  {
    "id": "s1320",
    "jp": "コピーをしてください।",
    "romaji": "Kopii wo shite kudasai.",
    "en": "Please make a copy.",
    "bn": "দয়া করে একটি কপি করুন।",
    "level": "N5"
  },
  {
    "id": "s1321",
    "jp": "子供が生まれました।",
    "romaji": "Kodomo ga umaremashita.",
    "en": "A child was born.",
    "bn": "একটি সন্তান জন্মেছে।",
    "level": "N5"
  },
  {
    "id": "s1322",
    "jp": "ご飯をたくさん食べました।",
    "romaji": "Gohan wo takusan tabemashita.",
    "en": "I ate a lot of rice.",
    "bn": "আমি অনেক ভাত খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1323",
    "jp": "今朝、雨が降りました।",
    "romaji": "Kesa, ame ga furimashita.",
    "en": "It rained this morning.",
    "bn": "আজ সকালে বৃষ্টি হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s1324",
    "jp": "言葉を覚えてください।",
    "romaji": "Kotoba wo oboete kudasai.",
    "en": "Please remember the words.",
    "bn": "দয়া করে কথাগুলো মনে রাখবেন।",
    "level": "N5"
  },
  {
    "id": "s1325",
    "jp": "去年、日本へ行きました।",
    "romaji": "Kyonen, Nihon he ikimashita.",
    "en": "I went to Japan last year.",
    "bn": "আমি গত বছর জাপানে গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s1326",
    "jp": "教科書を開いてください।",
    "romaji": "Kyoukasho wo hiraite kudasai.",
    "en": "Please open the textbook.",
    "bn": "দয়া করে পাঠ্যবইটি খুলুন।",
    "level": "N5"
  },
  {
    "id": "s1327",
    "jp": "兄弟はいますか？",
    "romaji": "Kyoudai wa imasu ka?",
    "en": "Do you have siblings?",
    "bn": "আপনার কি কোনো ভাইবোন আছে?",
    "level": "N5"
  },
  {
    "id": "s1328",
    "jp": "教室へ行きましょう।",
    "romaji": "Kyoushitsu he ikimashou.",
    "en": "Let's go to the classroom.",
    "bn": "চলুন ক্লাসরুমে যাই।",
    "level": "N5"
  },
  {
    "id": "s1329",
    "jp": "昨日、たくさん寝ました।",
    "romaji": "Kinou, takusan nemashita.",
    "en": "I slept a lot yesterday.",
    "bn": "আমি গতকাল অনেক ঘুমিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1330",
    "jp": "今日の夕飯は何ですか？",
    "romaji": "Kyou no yuuhan wa nan desu ka?",
    "en": "What is today's dinner?",
    "bn": "আজকের ডিনারে কি আছে?",
    "level": "N5"
  },
  {
    "id": "s1331",
    "jp": "牛乳を買ってきてください।",
    "romaji": "Gyuunyuu wo kattekite kudasai.",
    "en": "Please go buy milk.",
    "bn": "দয়া করে দুধ কিনে আনুন।",
    "level": "N5"
  },
  {
    "id": "s1332",
    "jp": "九時に会いましょう।",
    "romaji": "Kuji ni aimashou.",
    "en": "Let's meet at nine.",
    "bn": "চলুন নটায় দেখা করি।",
    "level": "N5"
  },
  {
    "id": "s1333",
    "jp": "薬を飲みましたか？",
    "romaji": "Kusuri wo nomimashita ka?",
    "en": "Did you take the medicine?",
    "bn": "আপনি কি ওষুধ খেয়েছেন?",
    "level": "N5"
  },
  {
    "id": "s1334",
    "jp": "暗い部屋ですね।",
    "romaji": "Kurai heya desu ne.",
    "en": "It's a dark room, isn't it?",
    "bn": "ঘরটি বেশ অন্ধকার, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1335",
    "jp": "果物が好きです।",
    "romaji": "Kudamono ga suki desu.",
    "en": "I like fruit.",
    "bn": "আমি ফল পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s1336",
    "jp": "口を閉じてください।",
    "romaji": "Kuchi wo tojite kudasai.",
    "en": "Please close your mouth.",
    "bn": "দয়া করে মুখ বন্ধ রাখুন।",
    "level": "N5"
  },
  {
    "id": "s1337",
    "jp": "靴を磨きました।",
    "romaji": "Kutsu wo migakimashita.",
    "en": "I polished my shoes.",
    "bn": "আমি আমার জুতো পালিশ করেছি।",
    "level": "N5"
  },
  {
    "id": "s1338",
    "jp": "国へ帰ります।",
    "romaji": "Kuni he kaerimasu.",
    "en": "I will return to my country.",
    "bn": "আমি দেশে ফিরে যাব।",
    "level": "N5"
  },
  {
    "id": "s1339",
    "jp": "曇ってきましたね।",
    "romaji": "Kumotte kimashita ne.",
    "en": "It's getting cloudy, isn't it?",
    "bn": "আকাশ মেঘলা হয়ে আসছে, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1340",
    "jp": "車を洗いました।",
    "romaji": "Kuruma wo araimashita.",
    "en": "I washed the car.",
    "bn": "আমি গাড়িটি ধুয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1341",
    "jp": "九月になりました।",
    "romaji": "Kugatsu ni narimashita.",
    "en": "It became September.",
    "bn": "সেপ্টেম্বর মাস হলো।",
    "level": "N5"
  },
  {
    "id": "s1342",
    "jp": "薬のおかげで治りました।",
    "romaji": "Kusuri no okage de naorimashita.",
    "en": "I recovered thanks to the medicine.",
    "bn": "ওষুধের গুণে আমি সুস্থ হয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1343",
    "jp": "下さい।",
    "romaji": "Kudasai.",
    "en": "Please give it to me.",
    "bn": "দয়া করে দিন।",
    "level": "N5"
  },
  {
    "id": "s1344",
    "jp": "果物を食べましょう।",
    "romaji": "Kudamono wo tabemashou.",
    "en": "Let's eat fruit.",
    "bn": "চলুন ফল খাই।",
    "level": "N5"
  },
  {
    "id": "s1345",
    "jp": "大きな口ですね।",
    "romaji": "Ookina kuchi desu ne.",
    "en": "It's a big mouth, isn't it?",
    "bn": "মুখটি বেশ বড়, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1346",
    "jp": "新しい靴を買いました।",
    "romaji": "Atarashii kutsu wo kaimashita.",
    "en": "I bought new shoes.",
    "bn": "আমি নতুন জুতো কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s1347",
    "jp": "外国から来ました।",
    "romaji": "Gaikoku kara kimashita.",
    "en": "I came from abroad.",
    "bn": "আমি বিদেশ থেকে এসেছি।",
    "level": "N5"
  },
  {
    "id": "s1348",
    "jp": "今日は曇りです।",
    "romaji": "Kyou wa kumori desu.",
    "en": "Today is cloudy.",
    "bn": "আজ আকাশ মেঘলা।",
    "level": "N5"
  },
  {
    "id": "s1349",
    "jp": "車で行きましょう।",
    "romaji": "Kuruma de ikimashou.",
    "en": "Let's go by car.",
    "bn": "চলুন কারে করে যাই।",
    "level": "N5"
  },
  {
    "id": "s1350",
    "jp": "黒い服を着ています।",
    "romaji": "Kuroi fuku wo kite imasu.",
    "en": "I am wearing black clothes.",
    "bn": "আমি কালো পোশাক পরে আছি।",
    "level": "N5"
  },
  {
    "id": "s1351",
    "jp": "警官に会いました।",
    "romaji": "Keikan ni aimashita.",
    "en": "I met a police officer.",
    "bn": "আমি একজন পুলিশ অফিসারের সাথে দেখা করেছি।",
    "level": "N5"
  },
  {
    "id": "s1352",
    "jp": "今朝、六時に起きました।",
    "romaji": "Kesa, rokuji ni okimashita.",
    "en": "I woke up at six this morning.",
    "bn": "আজ সকালে আমি ছটায় উঠেছি।",
    "level": "N5"
  },
  {
    "id": "s1353",
    "jp": "消しゴムを貸してください।",
    "romaji": "Keshigomu wo kashite kudasai.",
    "en": "Please lend me an eraser.",
    "bn": "দয়া করে আমাকে একটি রাবার ধার দিন।",
    "level": "N5"
  },
  {
    "id": "s1354",
    "jp": "景色が綺麗ですね।",
    "romaji": "Keshiki ga kirei desu ne.",
    "en": "The scenery is beautiful, isn't it?",
    "bn": "দৃশ্যটি কি দারুণ, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1355",
    "jp": "結婚おめでとうございます।",
    "romaji": "Kekkon omedetou gozaimasu.",
    "en": "Congratulations on your marriage.",
    "bn": "আপনার বিবাহের জন্য অভিনন্দন।",
    "level": "N5"
  },
  {
    "id": "s1356",
    "jp": "月曜日はテストがあります।",
    "romaji": "Getsuyoubi wa tesuto ga arimasu.",
    "en": "There is a test on Monday.",
    "bn": "সোমবার পরীক্ষা আছে।",
    "level": "N5"
  },
  {
    "id": "s1357",
    "jp": "玄関を閉めてください।",
    "romaji": "Genkan wo shimete kudasai.",
    "en": "Please close the entrance.",
    "bn": "দয়া করে প্রবেশপথ বন্ধ করুন।",
    "level": "N5"
  },
  {
    "id": "s1358",
    "jp": "元気な子供ですね।",
    "romaji": "Genki na kodomo desu ne.",
    "en": "It's a healthy child, isn't it?",
    "bn": "বাচ্চাটি খুব চনমনে, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1359",
    "jp": "公園へ散歩に行きます।",
    "romaji": "Kouen he sanpo ni ikimasu.",
    "en": "I go for a walk in the park.",
    "bn": "আমি পার্কে বেড়াতে যাই।",
    "level": "N5"
  },
  {
    "id": "s1360",
    "jp": "交番で聞いてください।",
    "romaji": "Kouban de kiite kudasai.",
    "en": "Please ask at the police station.",
    "bn": "দয়া করে পুলিশ স্টেশনে জিজ্ঞাসা করুন।",
    "level": "N5"
  },
  {
    "id": "s1361",
    "jp": "声が小さいです।",
    "romaji": "Koe ga chiisai desu.",
    "en": "The voice is small.",
    "bn": "গলার স্বর খুব নিচু।",
    "level": "N5"
  },
  {
    "id": "s1362",
    "jp": "午後から雨が降ります।",
    "romaji": "Gogo kara ame ga furimasu.",
    "en": "It will rain from the afternoon.",
    "bn": "বিকেল থেকে বৃষ্টি হবে।",
    "level": "N5"
  },
  {
    "id": "s1363",
    "jp": "九日に出発します।",
    "romaji": "Kokonoka ni shuppatsu shimasu.",
    "en": "Depart on the ninth.",
    "bn": "নয় তারিখ রওনা হব।",
    "level": "N5"
  },
  {
    "id": "s1364",
    "jp": "午前中は忙しいです।",
    "romaji": "Gozenchuu wa isogashii desu.",
    "en": "I am busy in the morning.",
    "bn": "আমি সকালে ব্যস্ত থাকি।",
    "level": "N5"
  },
  {
    "id": "s1365",
    "jp": "答えがわかりません।",
    "romaji": "Kotae ga wakarimasen.",
    "en": "I don't know the answer.",
    "bn": "আমি উত্তরটি জানি না।",
    "level": "N5"
  },
  {
    "id": "s1366",
    "jp": "こちらでお待ちください।",
    "romaji": "Kochira de omachi kudasai.",
    "en": "Please wait here.",
    "bn": "দয়া করে এখানে অপেক্ষা করুন।",
    "level": "N5"
  },
  {
    "id": "s1367",
    "jp": "コップが汚れました।",
    "romaji": "Koppu ga yogoremashita.",
    "en": "The glass got dirty.",
    "bn": "গ্লাসটি নোংরা হয়ে গেছে।",
    "level": "N5"
  },
  {
    "id": "s1368",
    "jp": "今月は旅行へ行きます।",
    "romaji": "Kongetsu wa ryokou he ikimasu.",
    "en": "I will go on a trip this month.",
    "bn": "এই মাসে আমি ভ্রমণে যাব।",
    "level": "N5"
  },
  {
    "id": "s1369",
    "jp": "今夜は月が綺麗です।",
    "romaji": "Konya wa tsuki ga kirei desu.",
    "en": "The moon is beautiful tonight.",
    "bn": "আজ রাতে চাঁদ খুব সুন্দর।",
    "level": "N5"
  },
  {
    "id": "s1370",
    "jp": "困った時は相談してください।",
    "romaji": "Komatta toki wa soudan shite kudasai.",
    "en": "Please consult when in trouble.",
    "bn": "সমস্যায় পড়লে দয়া করে পরামর্শ নিন।",
    "level": "N5"
  },
  {
    "id": "s1371",
    "jp": "御飯が美味しいですね।",
    "romaji": "Gohan ga oishii desu ne.",
    "en": "The food is delicious, isn't it?",
    "bn": "খাবারটি খুব সুস্বাদু, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1372",
    "jp": "五日間働きました।",
    "romaji": "Itsukakan hatarakimashita.",
    "en": "Worked for five days.",
    "bn": "পাঁচ দিন কাজ করেছি।",
    "level": "N5"
  },
  {
    "id": "s1373",
    "jp": "コピーを取りましたか？",
    "romaji": "Kopii wo torimashita ka?",
    "en": "Did you make a copy?",
    "bn": "আপনি কি একটি কপি করেছেন?",
    "level": "N5"
  },
  {
    "id": "s1374",
    "jp": "子供たちが遊んでいます।",
    "romaji": "Kodomotachi ga asonde imasu.",
    "en": "The children are playing.",
    "bn": "বাচ্চারা খেলছে।",
    "level": "N5"
  },
  {
    "id": "s1375",
    "jp": "ご飯を用意してください।",
    "romaji": "Gohan wo youi shite kudasai.",
    "en": "Please prepare the meal.",
    "bn": "দয়া করে খাবার তৈরি করুন।",
    "level": "N5"
  },
  {
    "id": "s1376",
    "jp": "今朝、新聞を読みました।",
    "romaji": "Kesa, shinbun wo yomimashita.",
    "en": "I read the newspaper this morning.",
    "bn": "আজ সকালে আমি নিউজপেপার পড়েছি।",
    "level": "N5"
  },
  {
    "id": "s1377",
    "jp": "言葉に注意してください।",
    "romaji": "Kotoba ni chuui shite kudasai.",
    "en": "Please watch your language.",
    "bn": "দয়া করে কথা বলার সময় সাবধান থাকুন।",
    "level": "N5"
  },
  {
    "id": "s1378",
    "jp": "去年、高校を卒業しました।",
    "romaji": "Kyonen, koukou wo sotsugyou shimashita.",
    "en": "Graduated from high school last year.",
    "bn": "গত বছর আমি হাই স্কুল শেষ করেছি।",
    "level": "N5"
  },
  {
    "id": "s1379",
    "jp": "教科書を閉じてください।",
    "romaji": "Kyoukasho wo tojite kudasai.",
    "en": "Please close the textbook.",
    "bn": "দয়া করে পাঠ্যবইটি বন্ধ করুন।",
    "level": "N5"
  },
  {
    "id": "s1380",
    "jp": "兄弟みたいですね।",
    "romaji": "Kyoudai mitai desu ne.",
    "en": "It's like siblings, isn't it?",
    "bn": "এটি ভাইবোনদের মতো, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1381",
    "jp": "教室は二階です।",
    "romaji": "Kyoushitsu wa nikai desu.",
    "en": "The classroom is on the second floor.",
    "bn": "ক্লাসরুমটি দোতলায়।",
    "level": "N5"
  },
  {
    "id": "s1382",
    "jp": "昨日のお昼は何でしたか？",
    "romaji": "Kinou no ohiru wa nan deshita ka?",
    "en": "What was lunch yesterday?",
    "bn": "গতকাল দুপুরে খাবারে কি ছিলো?",
    "level": "N5"
  },
  {
    "id": "s1383",
    "jp": "今日の晩ご飯はどうしますか？",
    "romaji": "Kyou no bangohan wa dou shimasu ka?",
    "en": "What will you do for dinner today?",
    "bn": "আজকের রাতের খাবারের জন্য আপনি কি করবেন?",
    "level": "N5"
  },
  {
    "id": "s1384",
    "jp": "牛乳は冷蔵庫にあります।",
    "romaji": "Gyuunyuu wa reizouko ni arimasu.",
    "en": "The milk is in the refrigerator.",
    "bn": "দুধ ফ্রিজে আছে।",
    "level": "N5"
  },
  {
    "id": "s1385",
    "jp": "九時に出発しましょう।",
    "romaji": "Kuji ni shuppatsu shimashou.",
    "en": "Let's depart at nine.",
    "bn": "চলুন নটায় রওনা দিই।",
    "level": "N5"
  },
  {
    "id": "s1386",
    "jp": "薬を忘れないでください।",
    "romaji": "Kusuri wo wasurenaide kudasai.",
    "en": "Please don't forget the medicine.",
    "bn": "দয়া করে ওষুধ খেতে ভুলবেন না।",
    "level": "N5"
  },
  {
    "id": "s1387",
    "jp": "暗いから気をつけてください।",
    "romaji": "Kurai kara ki wo tsukete kudasai.",
    "en": "Be careful because it's dark.",
    "bn": "অন্ধকার হওয়ার কারণে দয়া করে সাবধান থাকুন।",
    "level": "N5"
  },
  {
    "id": "s1388",
    "jp": "果物を買いたいですね।",
    "romaji": "Kudamono wo kaitai desu ne.",
    "en": "Want to buy fruit, don't you?",
    "bn": "ফল কিনতে ইচ্ছে করছে, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1389",
    "jp": "口をゆすいでください।",
    "romaji": "Kuchi wo yusuide kudasai.",
    "en": "Please rinse your mouth.",
    "bn": "দয়া করে মুখ ধুয়ে নিন।",
    "level": "N5"
  },
  {
    "id": "s1390",
    "jp": "靴を脱いでください।",
    "romaji": "Kutsu wo nuide kudasai.",
    "en": "Please take off your shoes.",
    "bn": "দয়া করে আপনার জুতো খুলুন।",
    "level": "N5"
  },
  {
    "id": "s1391",
    "jp": "国旗が揺れています।",
    "romaji": "Kokki ga yurete imasu.",
    "en": "The national flag is waving.",
    "bn": "জাতীয় পতাকা উড়ছে।",
    "level": "N5"
  },
  {
    "id": "s1392",
    "jp": "曇り空ですね।",
    "romaji": "Kumorizora desu ne.",
    "en": "It's a cloudy sky, isn't it?",
    "bn": "আকাশ বেশ মেঘলা, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1393",
    "jp": "車を運転しますか？",
    "romaji": "Kuruma wo unten shimasu ka?",
    "en": "Do you drive a car?",
    "bn": "আপনি কি গাড়ি চালান?",
    "level": "N5"
  },
  {
    "id": "s1394",
    "jp": "九月はもう秋ですね।",
    "romaji": "Kugatsu wa mou aki desu ne.",
    "en": "September is already autumn, isn't it?",
    "bn": "সেপ্টেম্বর মাস মানেই তো শরৎকাল, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1395",
    "jp": "薬が効きました।",
    "romaji": "Kusuri ga kikimashita.",
    "en": "The medicine worked.",
    "bn": "ওষুধটি কাজ করেছে।",
    "level": "N5"
  },
  {
    "id": "s1396",
    "jp": "果物ナイフはありますか？",
    "romaji": "Kudamono naifu wa arimasu ka?",
    "en": "Is there a fruit knife?",
    "bn": "ফল কাটার ছুরি কি আছে?",
    "level": "N5"
  },
  {
    "id": "s1397",
    "jp": "口紅を塗りました।",
    "romaji": "Kuchibeni wo nurimashita.",
    "en": "I applied lipstick.",
    "bn": "আমি লিপস্টিক লাগিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1398",
    "jp": "靴磨きをしましょう।",
    "romaji": "Kutsumigaki wo shimashou.",
    "en": "Let's polish shoes.",
    "bn": "চলুন জুতো পালিশ করি।",
    "level": "N5"
  },
  {
    "id": "s1399",
    "jp": "国境を越えました।",
    "romaji": "Kokkyou wo koemashita.",
    "en": "Crossed the border.",
    "bn": "সীমানা অতিক্রম করা হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s1400",
    "jp": "車椅子はどこですか？",
    "romaji": "Kurumaisu wa doko desu ka?",
    "en": "Where is the wheelchair?",
    "bn": "হুইলচেয়ারটি কোথায়?",
    "level": "N5"
  },
  {
    "id": "s1401",
    "jp": "月曜日から始めます।",
    "romaji": "Getsuyoubi kara hajimemasu.",
    "en": "Start from Monday.",
    "bn": "সোমবার থেকে শুরু করব।",
    "level": "N5"
  },
  {
    "id": "s1402",
    "jp": "元気を出して、頑張りましょう।",
    "romaji": "Genki wo dashite, ganbarimashou.",
    "en": "Cheer up and let's do our best.",
    "bn": "মন ভালো করুন এবং চলুন আমাদের সেরাটা দিই।",
    "level": "N5"
  },
  {
    "id": "s1403",
    "jp": "玄関に入ってください।",
    "romaji": "Genkan ni haitte kudasai.",
    "en": "Please enter the entrance.",
    "bn": "দয়া করে প্রবেশপথে প্রবেশ করুন।",
    "level": "N5"
  },
  {
    "id": "s1404",
    "jp": "公園で散歩をしました।",
    "romaji": "Kouen de sanpo wo shimashita.",
    "en": "Took a walk in the park.",
    "bn": "পার্কে বেড়িয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1405",
    "jp": "交番に届けてください।",
    "romaji": "Kouban ni todokete kudasai.",
    "en": "Please report it to the police station.",
    "bn": "দয়া করে পুলিশ স্টেশনে রিপোর্ট করুন।",
    "level": "N5"
  },
  {
    "id": "s1406",
    "jp": "声が聞こえないです।",
    "romaji": "Koe ga kikoenai desu.",
    "en": "Cannot hear the voice.",
    "bn": "কণ্ঠস্বর শোনা যাচ্ছে না।",
    "level": "N5"
  },
  {
    "id": "s1407",
    "jp": "午後、天気が良くなります।",
    "romaji": "Gogo, tenki ga yokunarimasu.",
    "en": "The weather will get better in the afternoon.",
    "bn": "বিকেলে আবহাওয়া ভালো হবে।",
    "level": "N5"
  },
  {
    "id": "s1408",
    "jp": "九日に会いに行くつもりです।",
    "romaji": "Kokonoka ni ai ni iku tsumori desu.",
    "en": "Plan to go meet on the ninth.",
    "bn": "নয় তারিখ দেখা করতে যাওয়ার পরিকল্পনা আছে।",
    "level": "N5"
  },
  {
    "id": "s1409",
    "jp": "午前中、掃除をしました।",
    "romaji": "Gozenchuu, souji wo shimashita.",
    "en": "Cleaned during the morning.",
    "bn": "সকালে পরিষ্কার করেছি।",
    "level": "N5"
  },
  {
    "id": "s1410",
    "jp": "答えが見つかりました।",
    "romaji": "Kotae ga mitsukarimashita.",
    "en": "The answer was found.",
    "bn": "উত্তরটি পাওয়া গেছে।",
    "level": "N5"
  },
  {
    "id": "s1411",
    "jp": "こちらでお待ちしております।",
    "romaji": "Kochira de omachi shite orimasu.",
    "en": "Waiting for you here (polite).",
    "bn": "আপনার জন্য এখানে অপেক্ষা করছি (বিনম্র)।",
    "level": "N5"
  },
  {
    "id": "s1412",
    "jp": "コップが綺麗になりました।",
    "romaji": "Koppu ga kirei ni narimashita.",
    "en": "The glass became clean.",
    "bn": "গ্লাসটি পরিষ্কার হয়েছে।",
    "level": "N5"
  },
  {
    "id": "s1413",
    "jp": "今月も頑張りましょう।",
    "romaji": "Kongetsu mo ganbarimashou.",
    "en": "Let's also do our best this month.",
    "bn": "চলুন এই মাসেও আমাদের সেরাটা দিই।",
    "level": "N5"
  },
  {
    "id": "s1414",
    "jp": "今夜は冷えますね।",
    "romaji": "Konya wa hiemasu ne.",
    "en": "It's getting cold tonight, isn't it?",
    "bn": "আজ রাতে বেশ ঠান্ডা পড়ছে, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1415",
    "jp": "困っている人を助けます।",
    "romaji": "Komatte iru hito wo tasukemasu.",
    "en": "Help people in trouble.",
    "bn": "বিপদে পড়া মানুষকে সাহায্য করি।",
    "level": "N5"
  },
  {
    "id": "s1416",
    "jp": "御飯を炊きましたか？",
    "romaji": "Gohan wo takimashita ka?",
    "en": "Did you cook the rice?",
    "bn": "আপনি কি ভাত রান্না করেছেন?",
    "level": "N5"
  },
  {
    "id": "s1417",
    "jp": "五日間、休みが欲しいです।",
    "romaji": "Itsukakan, yasumi ga hoshii desu.",
    "en": "Want a five-day holiday.",
    "bn": "পাঁচ দিনের ছুটি চাই।",
    "level": "N5"
  },
  {
    "id": "s1418",
    "jp": "コピーを取るのを忘れました।",
    "romaji": "Kopii wo toru no wo wasuremashita.",
    "en": "Forgot to make a copy.",
    "bn": "কপি করতে ভুলে গেছি।",
    "level": "N5"
  },
  {
    "id": "s1419",
    "jp": "子供時代を思い出します।",
    "romaji": "Kodomo jidai wo omoidashimasu.",
    "en": "Remember childhood.",
    "bn": "শৈশবের কথা মনে পড়ছে।",
    "level": "N5"
  },
  {
    "id": "s1420",
    "jp": "ご飯ですよ、早く来てください।",
    "romaji": "Gohan desu yo, hayaku kite kudasai.",
    "en": "Meal is ready, please come quickly.",
    "bn": "খাবার তৈরি, দয়া করে তাড়াতাড়ি আসুন।",
    "level": "N5"
  },
  {
    "id": "s1421",
    "jp": "今朝は寒かったですね।",
    "romaji": "Kesa wa samukatta desu ne.",
    "en": "It was cold this morning, wasn't it?",
    "bn": "আজ সকালে বেশ ঠান্ডা ছিলো, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1422",
    "jp": "言葉を大切にしてください।",
    "romaji": "Kotoba wo taisetsu ni shite kudasai.",
    "en": "Please value your words.",
    "bn": "দয়া করে আপনার কথার মর্যাদা রাখুন।",
    "level": "N5"
  },
  {
    "id": "s1423",
    "jp": "去年、初めて雪を見ました।",
    "romaji": "Kyonen, hajimete yuki wo mimashita.",
    "en": "Saw snow for the first time last year.",
    "bn": "গত বছর আমি প্রথমবার বরফ দেখেছি।",
    "level": "N5"
  },
  {
    "id": "s1424",
    "jp": "教科書を持って来ましたか？",
    "romaji": "Kyoukasho wo motte kimashita ka?",
    "en": "Did you bring the textbook?",
    "bn": "আপনি কি পাঠ্যবইটি এনেছেন?",
    "level": "N5"
  },
  {
    "id": "s1425",
    "jp": "兄弟は元気ですか？",
    "romaji": "Kyoudai wa genki desu ka?",
    "en": "Are your siblings healthy?",
    "bn": "আপনার ভাইবোনরা কি ভালো আছে?",
    "level": "N5"
  },
  {
    "id": "s1426",
    "jp": "教室で勉強しましょう।",
    "romaji": "Kyoushitsu de benkyou shimashou.",
    "en": "Let's study in the classroom.",
    "bn": "চলুন ক্লাসরুমে পড়াশোনা করি।",
    "level": "N5"
  },
  {
    "id": "s1427",
    "jp": "昨日のお天気は雨でした।",
    "romaji": "Kinou no otenki wa ame deshita.",
    "en": "Yesterday's weather was rain.",
    "bn": "গতকাল বৃষ্টি হয়েছিলো।",
    "level": "N5"
  },
  {
    "id": "s1428",
    "jp": "今日の夕食は美味しいです।",
    "romaji": "Kyou no yuushoku wa oishii desu.",
    "en": "Today's dinner is delicious.",
    "bn": "আজকের ডিনার খুব সুস্বাদু।",
    "level": "N5"
  },
  {
    "id": "s1429",
    "jp": "牛乳は体に良いですよ।",
    "romaji": "Gyuunyuu wa karada ni ii desu yo.",
    "en": "Milk is good for you, you know.",
    "bn": "দুধ স্বাস্থ্যের জন্য ভালো, জানেন।",
    "level": "N5"
  },
  {
    "id": "s1430",
    "jp": "九時になりました。寝ましょう।",
    "romaji": "Kuji ni narimashita. Nemashou.",
    "en": "It's nine o'clock. Let's sleep.",
    "bn": "নটা বেজে গেছে। চলুন ঘুমাই।",
    "level": "N5"
  },
  {
    "id": "s1431",
    "jp": "薬を飲むのを忘れないでください।",
    "romaji": "Kusuri wo nomu no wo wasurenaide kudasai.",
    "en": "Don't forget to take medicine.",
    "bn": "ওষুধ খেতে ভুলবেন না।",
    "level": "N5"
  },
  {
    "id": "s1432",
    "jp": "暗くて何も見えないです।",
    "romaji": "Kurakute nani mo mienai desu.",
    "en": "Too dark to see anything.",
    "bn": "অত্যধিক অন্ধকারের জন্য কিছুই দেখা যাচ্ছে না।",
    "level": "N5"
  },
  {
    "id": "s1433",
    "jp": "果物をたくさん食べたいね।",
    "romaji": "Kudamono wo takusan tabetai ne.",
    "en": "Want to eat a lot of fruit, right?",
    "bn": "অনেক ফল খেতে ইচ্ছে করছে, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1434",
    "jp": "口を大きく開けてください।",
    "romaji": "Kuchi wo ookiku akete kudasai.",
    "en": "Please open your mouth wide.",
    "bn": "দয়া করে বড় করে হাঁ করুন।",
    "level": "N5"
  },
  {
    "id": "s1435",
    "jp": "新しい靴を履きました।",
    "romaji": "Atarashii kutsu wo hakimashita.",
    "en": "Put on new shoes.",
    "bn": "নতুন জুতো পরেছি।",
    "level": "N5"
  },
  {
    "id": "s1436",
    "jp": "国旗を掲げましょう।",
    "romaji": "Kokki wo kakagemashou.",
    "en": "Let's raise the national flag.",
    "bn": "চলুন জাতীয় পতাকা উত্তোলন করি।",
    "level": "N5"
  },
  {
    "id": "s1437",
    "jp": "曇り空が続いています।",
    "romaji": "Kumorizora ga tsuzuite imasu.",
    "en": "Cloudy sky continues.",
    "bn": "আকাশ মেঘলা হয়েই রয়েছে।",
    "level": "N5"
  },
  {
    "id": "s1438",
    "jp": "車を運転するのが好きです।",
    "romaji": "Kuruma wo unten suru no ga suki desu.",
    "en": "I like driving a car.",
    "bn": "আমি গাড়ি চালাতে পছন্দ করি।",
    "level": "N5"
  },
  {
    "id": "s1439",
    "jp": "九月の風は気持ちいいですね।",
    "romaji": "Kugatsu no kaze wa kimochi ii desu ne.",
    "en": "September wind feels good, right?",
    "bn": "সেপ্টেম্বরের বাতাস বেশ আরামদায়ক, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1440",
    "jp": "薬が効いて、良くなりました।",
    "romaji": "Kusuri ga kiite, yokunarimashita.",
    "en": "Medicine worked, got better.",
    "bn": "ওষুধটি কাজ করেছে, আমি এখন ভালো আছি।",
    "level": "N5"
  },
  {
    "id": "s1441",
    "jp": "果物をナイフで切ります।",
    "romaji": "Kudamono wo naifu de kirimasu.",
    "en": "Cut fruit with a knife.",
    "bn": "ছুরি দিয়ে ফল কাটছি।",
    "level": "N5"
  },
  {
    "id": "s1442",
    "jp": "口紅を忘れてきました।",
    "romaji": "Kuchibeni wo wasurete kimashita.",
    "en": "Forgot to bring lipstick.",
    "bn": "লিপস্টিক আনতে ভুলে গেছি।",
    "level": "N5"
  },
  {
    "id": "s1443",
    "jp": "靴磨きをしてくれました।",
    "romaji": "Kutsumigaki wo shite kuremashita.",
    "en": "Polished my shoes for me.",
    "bn": "সে আমার জুতো পালিশ করে দিয়েছে।",
    "level": "N5"
  },
  {
    "id": "s1444",
    "jp": "国境近くまで行きました।",
    "romaji": "Kokkyou chikaku made ikimashita.",
    "en": "Went near the border.",
    "bn": "সীমানার কাছাকাছি পর্যন্ত গিয়েছিলাম।",
    "level": "N5"
  },
  {
    "id": "s1445",
    "jp": "車椅子が必要です।",
    "romaji": "Kurumaisu ga hitsuyou desu.",
    "en": "Wheelchair is necessary.",
    "bn": "একটি হুইলচেয়ার প্রয়োজন।",
    "level": "N5"
  },
  {
    "id": "s1446",
    "jp": "今朝、早く起きましたか？",
    "romaji": "Kesa, hayaku okimashita ka?",
    "en": "Did you wake up early this morning?",
    "bn": "আপনি কি আজ সকালে তাড়াতাড়ি উঠেছেন?",
    "level": "N5"
  },
  {
    "id": "s1447",
    "jp": "果物を洗ってください।",
    "romaji": "Kudamono wo aratte kudasai.",
    "en": "Please wash the fruit.",
    "bn": "দয়া করে ফলগুলো ধুয়ে নিন।",
    "level": "N5"
  },
  {
    "id": "s1448",
    "jp": "靴を綺麗にしました।",
    "romaji": "Kutsu wo kirei ni shimashita.",
    "en": "Cleaned the shoes.",
    "bn": "জুতো পরিষ্কার করেছি।",
    "level": "N5"
  },
  {
    "id": "s1449",
    "jp": "国を愛しています।",
    "romaji": "Kuni wo ai shite imasu.",
    "en": "I love my country.",
    "bn": "আমি আমার দেশকে ভালোবাসি।",
    "level": "N5"
  },
  {
    "id": "s1450",
    "jp": "車を大切にしてください।",
    "romaji": "Kuruma wo taisetsu ni shite kudasai.",
    "en": "Please take good care of the car.",
    "bn": "দয়া করে গাড়িটির যত্ন নিন।",
    "level": "N5"
  },
  {
    "id": "s1451",
    "jp": "明日、九時に来てください।",
    "romaji": "Ashita, kuji ni kite kudasai.",
    "en": "Please come at nine tomorrow.",
    "bn": "দয়া করে আগামীকাল নটায় আসুন।",
    "level": "N5"
  },
  {
    "id": "s1452",
    "jp": "果物を食べてもいいですか？",
    "romaji": "Kudamono wo tabete mo ii desu ka?",
    "en": "May I eat the fruit?",
    "bn": "আমি কি ফলগুলো খেতে পারি?",
    "level": "N5"
  },
  {
    "id": "s1453",
    "jp": "靴を脱いで入ってください।",
    "romaji": "Kutsu wo nuide haitte kudasai.",
    "en": "Please take off shoes and enter.",
    "bn": "দয়া করে জুতো খুলে প্রবেশ করুন।",
    "level": "N5"
  },
  {
    "id": "s1454",
    "jp": "国旗を見ましたか？",
    "romaji": "Kokki wo mimashita ka?",
    "en": "Did you see the national flag?",
    "bn": "আপনি কি জাতীয় পতাকা দেখেছেন?",
    "level": "N5"
  },
  {
    "id": "s1455",
    "jp": "車を止めてください।",
    "romaji": "Kuruma wo tomete kudasai.",
    "en": "Please stop the car.",
    "bn": "দয়া করে গাড়িটি থামান।",
    "level": "N5"
  },
  {
    "id": "s1456",
    "jp": "今夜、雨が降るそうです।",
    "romaji": "Konya, ame ga furu sou desu.",
    "en": "I heard it will rain tonight.",
    "bn": "শুনেছি আজ রাতে বৃষ্টি হবে।",
    "level": "N5"
  },
  {
    "id": "s1457",
    "jp": "果物がたくさんありますね।",
    "romaji": "Kudamono ga takusan arimasu ne.",
    "en": "There is a lot of fruit, isn't there?",
    "bn": "অনেক ফল আছে, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1458",
    "jp": "靴を履いてください।",
    "romaji": "Kutsu wo haite kudasai.",
    "en": "Please put on shoes.",
    "bn": "দয়া করে জুতো পরুন।",
    "level": "N5"
  },
  {
    "id": "s1459",
    "jp": "国籍を教えてください।",
    "romaji": "Kokuseki wo oshiete kudasai.",
    "en": "Please tell me your nationality.",
    "bn": "দয়া করে আপনার জাতীয়তা বলুন।",
    "level": "N5"
  },
  {
    "id": "s1460",
    "jp": "車を買う予定です।",
    "romaji": "Kuruma wo kau yotei desu.",
    "en": "Plan to buy a car.",
    "bn": "একটি গাড়ি কেনার পরিকল্পনা আছে।",
    "level": "N5"
  },
  {
    "id": "s1461",
    "jp": "今朝は忙しかったですよ।",
    "romaji": "Kesa wa isogashikatta desu yo.",
    "en": "I was busy this morning, you know.",
    "bn": "আজ সকালে আমি খুব ব্যস্ত ছিলাম।",
    "level": "N5"
  },
  {
    "id": "s1462",
    "jp": "果物をナイフで剥きます।",
    "romaji": "Kudamono wo naifu de mukimasu.",
    "en": "Peel fruit with a knife.",
    "bn": "ছুরি দিয়ে ফলের খোসা ছাড়াচ্ছি।",
    "level": "N5"
  },
  {
    "id": "s1463",
    "jp": "靴を買ってくれました।",
    "romaji": "Kutsu wo katte kuremashita.",
    "en": "Bought shoes for me.",
    "bn": "সে আমার জন্য জুতো কিনেছে।",
    "level": "N5"
  },
  {
    "id": "s1464",
    "jp": "国歌を歌いましょう।",
    "romaji": "Kokka wo utaimashou.",
    "en": "Let's sing the national anthem.",
    "bn": "চলুন জাতীয় সঙ্গীত গাই।",
    "level": "N5"
  },
  {
    "id": "s1465",
    "jp": "車で行くのが一番早いです।",
    "romaji": "Kuruma de iku no ga ichiban hayai desu.",
    "en": "Going by car is the fastest.",
    "bn": "কারে করে যাওয়াই সবচেয়ে দ্রুত।",
    "level": "N5"
  },
  {
    "id": "s1466",
    "jp": "今夜、パーティーがあります।",
    "romaji": "Konya, paatii ga arimasu.",
    "en": "There is a party tonight.",
    "bn": "আজ রাতে একটি পার্টি আছে।",
    "level": "N5"
  },
  {
    "id": "s1467",
    "jp": "果物は甘くて美味しいです।",
    "romaji": "Kudamono wa amakute oishii desu.",
    "en": "Fruit is sweet and delicious.",
    "bn": "ফল মিষ্টি এবং সুস্বাদু।",
    "level": "N5"
  },
  {
    "id": "s1468",
    "jp": "靴下が汚れていますよ।",
    "romaji": "Kutsushita ga yogorete imasu yo.",
    "en": "Your socks are dirty, you know.",
    "bn": "আপনার মোজাগুলো নোংরা হয়ে গেছে।",
    "level": "N5"
  },
  {
    "id": "s1469",
    "jp": "国内旅行へ行きましょう।",
    "romaji": "Kokunai ryokou he ikimashou.",
    "en": "Let's go on a domestic trip.",
    "bn": "চলুন দেশের ভেতরে ভ্রমণে যাই।",
    "level": "N5"
  },
  {
    "id": "s1470",
    "jp": "車に荷物を積んでください।",
    "romaji": "Kuruma ni nimotsu wo tsunde kudasai.",
    "en": "Please load the luggage into the car.",
    "bn": "দয়া করে গাড়িতে মালামাল তুলে দিন।",
    "level": "N5"
  },
  {
    "id": "s1471",
    "jp": "今朝、パンを食べました।",
    "romaji": "Kesa, pan wo tabemashita.",
    "en": "I ate bread this morning.",
    "bn": "আজ সকালে আমি পাউরুটি খেয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1472",
    "jp": "果物が好きになりました।",
    "romaji": "Kudamono ga suki ni narimashita.",
    "en": "Came to like fruit.",
    "bn": "আমি ফল পছন্দ করতে শুরু করেছি।",
    "level": "N5"
  },
  {
    "id": "s1473",
    "jp": "靴を新しくしました।",
    "romaji": "Kutsu wo atarashiku shimashita.",
    "en": "Got new shoes (replaced).",
    "bn": "নতুন জুতো নিয়েছি।",
    "level": "N5"
  },
  {
    "id": "s1474",
    "jp": "国境を警備しています।",
    "romaji": "Kokkyou wo keibi shite imasu.",
    "en": "Guarding the border.",
    "bn": "সীমানা পাহারা দেওয়া হচ্ছে।",
    "level": "N5"
  },
  {
    "id": "s1475",
    "jp": "車を貸していただき、感謝します।",
    "romaji": "Kuruma wo kashite itadaki, kansha shimasu.",
    "en": "Thank you for lending me the car.",
    "bn": "গাড়িটি ধার দেওয়ার জন্য আপনাকে ধন্যবাদ।",
    "level": "N5"
  },
  {
    "id": "s1476",
    "jp": "今夜は早く帰りましょう।",
    "romaji": "Konya wa hayaku kaerimashou.",
    "en": "Let's go home early tonight.",
    "bn": "চলুন আজ রাতে তাড়াতাড়ি বাড়ি যাই।",
    "level": "N5"
  },
  {
    "id": "s1477",
    "jp": "果物を買ってきてあげます।",
    "romaji": "Kudamono wo katte kite agemasu.",
    "en": "I will buy some fruit for you.",
    "bn": "আমি আপনার জন্য কিছু ফল কিনে আনব।",
    "level": "N5"
  },
  {
    "id": "s1478",
    "jp": "靴が脱げそうですね।",
    "romaji": "Kutsu ga nugesou desu ne.",
    "en": "The shoe looks like it will come off, doesn't it?",
    "bn": "জুতোটি খুলে যাওয়ার মতো হয়েছে, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1479",
    "jp": "国歌を覚えていますか？",
    "romaji": "Kokka wo oboete imasu ka?",
    "en": "Do you remember the national anthem?",
    "bn": "আপনার কি জাতীয় সঙ্গীত মনে আছে?",
    "level": "N5"
  },
  {
    "id": "s1480",
    "jp": "車が故障しました।",
    "romaji": "Kuruma ga koushou shimashita.",
    "en": "The car broke down.",
    "bn": "গাড়িটি নষ্ট হয়ে গেছে।",
    "level": "N5"
  },
  {
    "id": "s1481",
    "jp": "今朝は早くから働いています।",
    "romaji": "Kesa wa hayaku kara hataraite imasu.",
    "en": "Have been working since early this morning.",
    "bn": "আজ খুব সকাল থেকে কাজ করছি।",
    "level": "N5"
  },
  {
    "id": "s1482",
    "jp": "果物を毎日食べます।",
    "romaji": "Kudamono wo mainichi tabemasu.",
    "en": "Eat fruit every day.",
    "bn": "প্রতিদিন ফল খাই।",
    "level": "N5"
  },
  {
    "id": "s1483",
    "jp": "靴を磨くのが大変です।",
    "romaji": "Kutsu wo migaku no ga taihen desu.",
    "en": "Polishing shoes is hard work.",
    "bn": "জুতো পালিশ করা বেশ খাটুনির কাজ।",
    "level": "N5"
  },
  {
    "id": "s1484",
    "jp": "国際結婚はどう思いますか？",
    "romaji": "Kokusai kekkon wa dou omoimasu ka?",
    "en": "What do you think about international marriage?",
    "bn": "আন্তর্জাতিক বিবাহ সম্পর্কে আপনার মতামত কি?",
    "level": "N5"
  },
  {
    "id": "s1485",
    "jp": "車を中古で買いました।",
    "romaji": "Kuruma wo chuuko de kaimashita.",
    "en": "Bought a used car.",
    "bn": "আমি একটি পুরোনো গাড়ি কিনেছি।",
    "level": "N5"
  },
  {
    "id": "s1486",
    "jp": "今夜はお祝いをしましょう।",
    "romaji": "Konya wa oiwai wo shimashou.",
    "en": "Let's celebrate tonight.",
    "bn": "চলুন আজ রাতে উদযাপন করি।",
    "level": "N5"
  },
  {
    "id": "s1487",
    "jp": "果物を選んでください।",
    "romaji": "Kudamono wo erande kudasai.",
    "en": "Please choose some fruit.",
    "bn": "দয়া করে কিছু ফল বেছে নিন।",
    "level": "N5"
  },
  {
    "id": "s1488",
    "jp": "靴を履き替えました।",
    "romaji": "Kutsu wo hakikaemashita.",
    "en": "Changed shoes.",
    "bn": "জুতো বদলেছি।",
    "level": "N5"
  },
  {
    "id": "s1489",
    "jp": "国防は重要です।",
    "romaji": "Kokubou wa juuyou desu.",
    "en": "National defense is important.",
    "bn": "জাতীয় প্রতিরক্ষা গুরুত্বপূর্ণ।",
    "level": "N5"
  },
  {
    "id": "s1490",
    "jp": "車で行くのをやめましょう।",
    "romaji": "Kuruma de iku no wo yamemashou.",
    "en": "Let's stop going by car.",
    "bn": "চলুন কারে করে যাওয়া বন্ধ করি।",
    "level": "N5"
  },
  {
    "id": "s1491",
    "jp": "今朝は気持ちいい朝ですね।",
    "romaji": "Kesa wa kimochi ii asa desu ne.",
    "en": "It's a pleasant morning, isn't it?",
    "bn": "আজকের সকালটি কি সুন্দর, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1492",
    "jp": "果物屋さんはどこですか？",
    "romaji": "Kudamonoyasan wa doko desu ka?",
    "en": "Where is the fruit shop?",
    "bn": "ফলের দোকানটি কোথায়?",
    "level": "N5"
  },
  {
    "id": "s1493",
    "jp": "靴のサイズは何ですか？",
    "romaji": "Kutsu no saizu wa nan desu ka?",
    "en": "What is your shoe size?",
    "bn": "আপনার জুতোর সাইজ কত?",
    "level": "N5"
  },
  {
    "id": "s1494",
    "jp": "国内旅行が流行っています।",
    "romaji": "Kokunai ryokou ga hayatte imasu.",
    "en": "Domestic travel is popular.",
    "bn": "দেশের ভেতরে ভ্রমণ এখন খুব জনপ্রিয়।",
    "level": "N5"
  },
  {
    "id": "s1495",
    "jp": "車が止まらなくて怖かったです।",
    "romaji": "Kuruma ga tomaranakute kowakatta desu.",
    "en": "It was scary because the car wouldn't stop.",
    "bn": "গাড়িটি থামছিলো না বলে খুব ভয় লাগছিলো।",
    "level": "N5"
  },
  {
    "id": "s1496",
    "jp": "今夜は星が見えますね।",
    "romaji": "Konya wa hoshi ga miemasu ne.",
    "en": "The stars are visible tonight, right?",
    "bn": "আজ রাতে তারা দেখা যাচ্ছে, তাই না?",
    "level": "N5"
  },
  {
    "id": "s1497",
    "jp": "果物をジュースにしましょう।",
    "romaji": "Kudamono wo juusu ni shimashou.",
    "en": "Let's make the fruit into juice.",
    "bn": "চলুন ফল দিয়ে জুস বানাই।",
    "level": "N5"
  },
  {
    "id": "s1498",
    "jp": "靴を揃えてください।",
    "romaji": "Kutsu wo soroete kudasai.",
    "en": "Please align your shoes.",
    "bn": "দয়া করে জুতো জোড়া করে রাখুন।",
    "level": "N5"
  },
  {
    "id": "s1499",
    "jp": "国際交流に参加しましょう।",
    "romaji": "Kokusai kouryuu ni sanka shimashou.",
    "en": "Let's participate in international exchange.",
    "bn": "চলুন আন্তর্জাতিক বিনিময়ে অংশগ্রহণ করি।",
    "level": "N5"
  },
  {
    "id": "s1500",
    "jp": "車の中は涼しいですね।",
    "romaji": "Kuruma no naka wa suzushii desu ne.",
    "en": "It's cool inside the car, isn't it?",
    "bn": "গাড়ির ভেতরটা বেশ ঠান্ডা, তাই না?",
    "level": "N5"
  }
];